import classNames from 'classnames';
import * as React from 'react';
import React__default, {
  Children,
  Fragment as Fragment$1,
  cloneElement,
  createContext as createContext$1,
  forwardRef,
  isValidElement,
  useCallback,
  useEffect,
  useImperativeHandle,
  useLayoutEffect,
  useMemo,
  useReducer,
  useRef,
  useState,
  useSyncExternalStore,
} from 'react';
import ReactDOM__default, * as ReactDOM from 'react-dom';
import { Fragment, jsx, jsxs } from 'react/jsx-runtime';
function forwardRefWithAs(render) {
  return React__default.forwardRef(render);
}
const BADGE_CLASS = 'spot-badge';
const BADGE_COLOR_LIST = ['primary', 'secondary', 'positive', 'negative', 'warning'];
const BADGE_PLACEMENT_LIST = ['top-left', 'top-right', 'bottom-left', 'bottom-right'];
const Badge = forwardRefWithAs(
  (
    {
      as,
      children,
      className,
      badgeContent,
      placement,
      color = 'primary',
      variant,
      size: size2 = 'default',
      textSize,
      hideBadge = false,
      ...rest
    },
    ref,
  ) => {
    const Component = as ?? 'span';
    const isDot = variant === 'dot';
    const isShortText = textSize === 'short';
    return /* @__PURE__ */ React__default.createElement(
      Component,
      { ...rest, className: classNames(`${BADGE_CLASS}-group`, className), ref },
      children,
      !hideBadge
        ? /* @__PURE__ */ React__default.createElement(
            'span',
            {
              className: classNames(BADGE_CLASS, {
                [`${BADGE_CLASS}--${color}`]: color,
                [`${BADGE_CLASS}--dot`]: isDot,
                [`${BADGE_CLASS}--${size2}`]: size2 !== 'default',
                [`${BADGE_CLASS}--short-text`]: !isDot && isShortText,
                [`${BADGE_CLASS}--${placement}`]: placement,
              }),
            },
            isDot
              ? /* @__PURE__ */ React__default.createElement(
                  'span',
                  { className: 'spot--screenreader-only' },
                  badgeContent,
                )
              : badgeContent,
          )
        : null,
    );
  },
);
Badge.displayName = 'Badge';
const SvgAddAUser = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M15.195 0a8.645 8.645 0 0 0-8.643 8.644v1.47c0 2.352.94 4.833 2.429 6.732.342.438.722.854 1.135 1.235-2.21.363-4.129.903-5.594 1.397a5.69 5.69 0 0 0-3.855 5.397V32h16v-2.575H3.24v-4.55c0-1.344.848-2.532 2.104-2.958 2.34-.788 5.88-1.687 9.85-1.687 2.555 0 4.731-1.49 6.215-3.384 1.488-1.899 2.43-4.38 2.43-6.731V8.644A8.645 8.645 0 0 0 15.194 0M9.126 8.644a6.07 6.07 0 0 1 12.138 0v1.47c0 1.712-.706 3.645-1.88 5.144-1.18 1.504-2.68 2.397-4.189 2.397-1.507 0-3.009-.893-4.188-2.397-1.175-1.5-1.88-3.432-1.88-5.143zM1.954 30.713V32z',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      d: 'M27.195 27.586V32h-2.574v-4.414h-4.414v-2.574h4.414v-4.414h2.574v4.414h4.414v2.574z',
    }),
  );
const ForwardRef$33 = forwardRef(SvgAddAUser);
const SvgAddClinic = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M9.333 0a2.667 2.667 0 0 0-2.666 2.667v2.666h-4v22.858h2.666v-20h1.812a2.66 2.66 0 0 0 2.188 1.142h13.334c.906 0 1.706-.452 2.188-1.143h1.812v9.905h2.666V5.333h-4V2.667A2.667 2.667 0 0 0 22.667 0zm13.334 5.333V2.667H9.333v4h13.334zM0 29.46V32h21.333v-2.54zm10.667-11.428h10.666v5.08h-2.666v-2.54h-5.334v7.619h-2.666zM28 30.73v-3.81h4v-2.539h-4v-3.81h-2.667v3.81h-4v2.54h4v3.81z',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$32 = forwardRef(SvgAddClinic);
const SvgAdd = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      d: 'M17.333 8v6.667H24v2.666h-6.667V24h-2.666v-6.667H8v-2.666h6.667V8z',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M16 0C7.163 0 0 7.163 0 16s7.163 16 16 16 16-7.163 16-16S24.837 0 16 0M2.667 16C2.667 8.636 8.637 2.667 16 2.667S29.333 8.637 29.333 16 23.363 29.333 16 29.333 2.667 23.363 2.667 16',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$31 = forwardRef(SvgAdd);
const SvgAiStar = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M16 1.333c.736 0 1.333.597 1.333 1.334 0 6.63 5.37 12 12 12a1.333 1.333 0 1 1 0 2.666c-6.63 0-12 5.37-12 12a1.333 1.333 0 1 1-2.666 0c0-6.63-5.37-12-12-12a1.333 1.333 0 1 1 0-2.666c6.63 0 12-5.37 12-12 0-.737.597-1.334 1.333-1.334m0 7.455A14.72 14.72 0 0 1 8.787 16 14.72 14.72 0 0 1 16 23.212 14.72 14.72 0 0 1 23.212 16 14.7 14.7 0 0 1 16 8.788',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$30 = forwardRef(SvgAiStar);
const SvgAiWand = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      d: 'M12.104.829a.829.829 0 1 0-1.658 0 3.15 3.15 0 0 1-3.15 3.15.829.829 0 0 0 0 1.658 3.15 3.15 0 0 1 3.15 3.15.829.829 0 0 0 1.658 0 3.15 3.15 0 0 1 3.15-3.15.829.829 0 0 0 0-1.658 3.15 3.15 0 0 1-3.15-3.15',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M20.203 7.83a1.326 1.326 0 0 0-1.882-.006L.39 25.756a1.326 1.326 0 0 0 0 1.876l3.979 3.98a1.326 1.326 0 0 0 1.877-.002l13.739-13.779a1.3 1.3 0 0 0 .388-.389l3.754-3.764c.514-.516.516-1.35.005-1.869l-3.928-3.98Zm-.965 6.993 2.08-2.087-2.065-2.092-2.097 2.097zm-3.958-.206L3.202 26.694l2.102 2.102 12.06-12.095z',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      d: 'M27.192 0c.458 0 .829.371.829.829a3.15 3.15 0 0 0 3.15 3.15.829.829 0 0 1 0 1.658 3.15 3.15 0 0 0-3.15 3.15.829.829 0 1 1-1.658 0 3.15 3.15 0 0 0-3.15-3.15.829.829 0 0 1 0-1.658 3.15 3.15 0 0 0 3.15-3.15c0-.458.37-.829.829-.829m0 15.903c.458 0 .829.371.829.83a3.15 3.15 0 0 0 3.15 3.15.83.83 0 0 1 0 1.658 3.15 3.15 0 0 0-3.15 3.15.829.829 0 1 1-1.658 0 3.15 3.15 0 0 0-3.15-3.15.83.83 0 0 1 0-1.659 3.15 3.15 0 0 0 3.15-3.15c0-.458.37-.829.829-.829',
    }),
  );
const ForwardRef$2$ = forwardRef(SvgAiWand);
const SvgAi = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M21.695.169c.593.318.882 1.009.692 1.655l-3.02 10.265H26a1.422 1.422 0 0 1 1.093 2.333L12.87 31.488a1.422 1.422 0 0 1-2.472-1.255l2.403-9.61H6.089a1.422 1.422 0 0 1-1.09-2.338L19.934.508a1.42 1.42 0 0 1 1.762-.339ZM9.14 17.778h5.481a1.422 1.422 0 0 1 1.38 1.767l-1.336 5.346 8.297-9.958h-5.496a1.422 1.422 0 0 1-1.365-1.823l1.638-5.57z',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$2_ = forwardRef(SvgAi);
const SvgAlertNotification = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M17.374 7.581v12.762h-2.733V7.581z',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      d: 'M16.007 24.993a1.504 1.504 0 1 0 0-3.008 1.504 1.504 0 0 0 0 3.008',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M12.364 2.204c1.533-2.939 5.739-2.939 7.272 0L31.529 25c1.425 2.73-.556 5.998-3.635 5.998H4.106c-3.08 0-5.06-3.268-3.635-5.998zm4.848 1.265c-.511-.98-1.913-.98-2.424 0L2.895 26.265a1.366 1.366 0 0 0 1.211 1.999h23.788a1.367 1.367 0 0 0 1.212-2z',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$2Z = forwardRef(SvgAlertNotification);
const SvgAnalyzer = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', { d: 'M23.825 8H17.93V5.333h5.895z' }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M8.345 12.114C7.459 12.435 7 13.371 7 14.15v7.7c0 .957.692 2.15 2.018 2.15h13.298c1.325 0 2.017-1.193 2.017-2.15v-7.7c0-.78-.459-1.715-1.345-2.036a2 2 0 0 0-.672-.114H9.018a2 2 0 0 0-.673.114M9.667 16h12v-1.333h-12zm12 2.667h-12v2.666h12z',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M3.333 0C2.597 0 2 .493 2 1.1V32h7.852c.697 0 1.456-.122 2.142-.43.435-.196 2.006-1.016 2.006-2.903V28h4v.667c0 1.887 1.571 2.707 2.006 2.903.686.308 1.445.43 2.142.43H30V1.1c0-.607-.597-1.1-1.333-1.1zm24 28h-6.666v.667c0 .368.663.666 1.481.666h5.185zM4.667 29.333V28h6.666v.667c0 .368-.663.666-1.481.666zm0-26.666v22.666h22.666V2.667z',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$2Y = forwardRef(SvgAnalyzer);
const SvgAnimalCanine = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      d: 'm28.51 8.4-3.09-.52-.12-.25c-.44-.89-.76-1.55-1.13-2.03-.31-.47-.83-.75-1.39-.75-.64 0-1.24.35-1.62.98l-2.96 5.83c-.23.3-.6.63-1.2.63l-.76.04c-7.33.38-9.77.68-10.73.98-1.03-.9-1.66-2.28-1.66-3.72 0-1.31.49-2.57 1.31-3.39a.996.996 0 1 0-1.41-1.41c-1.2 1.2-1.89 2.96-1.89 4.81s.82 3.81 2.18 5.08c-1.15 1.87-1.11 4.64-1.08 5.96v.35c0 .25.06.71.19 1.64.15 1.15.36 2.73.42 3.86 0 1.54 1.26 2.8 2.8 2.8h2.2c.43 0 .83-.22 1.05-.58.23-.38.25-.85.04-1.27-.07-.14-1.69-3.42 0-4.64l.18-.13c1.14-.82 3.05-2.2 2.93-4.73-.03-.55-.51-.97-1.05-.95-.55.03-.98.5-.95 1.05.06 1.34-.87 2.12-2.1 3.01l-.19.14c-1.93 1.41-1.83 3.97-1.06 6.11H6.37c-.45 0-.8-.35-.8-.85-.06-1.26-.28-2.89-.43-4.08-.08-.58-.16-1.23-.16-1.38v-.4c-.03-1.06-.1-4.24 1.17-5.38.54-.2 2.79-.51 10.22-.89l.71-.04c1.12 0 2.11-.54 2.81-1.52l2.9-5.68c.21.34.45.84.74 1.42l.58 1.18 4.03.66s.04.07.04.14c0 .81-.55 1.92-.83 2.3-.37.1-1.4.1-2.17.1h-.75l-1.39 4.74c-.72 1.49-2.96 7.04-2.96 8.16 0 .44.1.92.2 1.38 0 .04.02.08.03.12h-.72c-.15 0-.3-.15-.3-.3v-7.32l-4.52-.38c-.56-.06-1.03.36-1.08.91s.36 1.03.91 1.08l2.68.22v5.48c0 1.25 1.05 2.3 2.3 2.3h1.3c.46 0 .91-.22 1.19-.59.3-.38.4-.87.29-1.27-.04-.21-.08-.44-.13-.67-.08-.36-.16-.74-.16-.94.07-.73 1.95-5.7 2.8-7.38l1.06-3.55c1.23-.01 2.09-.08 2.65-.5l.11-.09c.54-.54 1.49-2.27 1.49-3.81 0-1.02-.67-1.9-1.64-2.09Z',
    }),
  );
const ForwardRef$2X = forwardRef(SvgAnimalCanine);
const SvgAnimalEquine = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      d: 'm31.49 10.68-4.1-7a1 1 0 0 0-1.37-.36c-.48.28-.64.89-.36 1.37l4.1 7s-.02.11-.03.12l-.67.37-3.12-2-.57.64c-1.85 2.08-1.85 2.82-1.85 3.04-.07 2.96-.72 3.48-1.54 4.14-.18.14-.35.28-.52.44-2.18 1.94-2.6 6.21-2.63 8.85h-.59l.21-8.47-2.67-.7a.997.997 0 1 0-.51 1.93l1.14.3-.18 7.33c0 .85.75 1.6 1.6 1.6h1.4c.85 0 1.6-.75 1.6-1.6 0-3 .5-5.5 1.34-6.93l1.16.72-.48 2.73-.02.17c0 1.55 2.79 1.57 2.9 1.57.25 0 .47-.03.65-.08.45-.14.76-.48.83-.89l1.28-5-.21-.43c-.12-.25-.31-.67-.73-.91L25.1 17c.24-.75.39-1.71.43-3.02.08-.21.41-.68.8-1.18l1.69 1.08c.48.4 1.18.48 1.79.17l.93-.52c.46-.27.8-.74.95-1.27.15-.55.07-1.13-.2-1.59Zm-5.13 9.56-.94 3.69c-.15-.02-.32-.05-.48-.08l.59-3.36-1.96-1.21c.19-.17.37-.34.55-.53z',
    }),
    /* @__PURE__ */ React.createElement('path', {
      d: 'M13.4 16.22c-.53-.15-1.08.16-1.24.69-.37 1.31-1.09 1.8-1.93 2.36-.23.16-.45.31-.66.47-1.58.93-2.79 5.66-3.08 7.24h-.74c.22-3.53 1.58-7.16 2-8.23l.17-.44-.23-.41s-1.12-2.07-.18-3.88c1.03-2.11 3.04-1.72 5.75-.93.9.26 1.68.49 2.35.49 2.9 0 4.4-2.19 5.29-3.5.18-.26.33-.49.48-.67 1.54-1.85 2.39-2.29 3.02-2.48a1.003 1.003 0 0 0-.58-1.92c-1.31.39-2.46 1.3-3.99 3.12-.18.22-.37.5-.58.81-.8 1.17-1.8 2.63-3.64 2.63-.38 0-1.1-.21-1.79-.41-1.63-.47-4.01-1.16-5.93-.28a3.34 3.34 0 0 0-2.6-1.81c-1.71-.12-3.19 1.04-3.66 2.9-.23 1.13 0 2.2.22 3.14.22.98.4 1.82.13 2.6-.22.58-.83 1.07-1.35 1.44-.45.32-.55.95-.23 1.39.2.27.5.42.81.42.2 0 .4-.06.58-.19.74-.53 1.65-1.28 2.06-2.38.47-1.34.19-2.6-.05-3.72-.18-.82-.35-1.6-.22-2.27.17-.69.73-1.41 1.53-1.35.51.05 1.1.54 1.1 1.1 0 .04.02.07.02.1-.18.25-.35.52-.51.83-1.12 2.14-.4 4.37 0 5.3-.59 1.56-1.88 5.31-2.01 8.93-.07.36.01.72.23 1.02.28.39.75.62 1.27.62h1.7c.69 0 1.46-.58 1.5-1.43.21-1.78 1.52-5.49 2.14-6.07l.19-.12c.19-.15.4-.29.61-.44.91-.62 2.15-1.46 2.73-3.47.15-.53-.16-1.08-.69-1.24Z',
    }),
  );
const ForwardRef$2W = forwardRef(SvgAnimalEquine);
const SvgAnimalFeline = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      d: 'M26.17 17.7c3.29-.55 4.04-3.12 3.95-4.48l-.03-.42-1.93-1.69-.96-.8c-.7-2.5-1.33-2.75-1.59-2.85-1.97-.85-3.77 1.89-5.21 4.09-.18.28-.36.54-.53.8-.81 1.3-1.96 1.82-2.97 2.27l-.31.15c-2.8 1.3-9.16 4.27-7.19 12.51h-.98c-2.1 0-3.96-1.36-4.43-3.24-.3-1.25-.05-2.47.72-3.45.76-.96 1.89-1.52 3.11-1.52.55 0 1-.45 1-1s-.45-1-1-1c-1.83 0-3.54.83-4.68 2.28s-1.54 3.33-1.09 5.16c.7 2.8 3.32 4.76 6.37 4.76h10.1c1.44 0 2.6-2.35 2.6-4.3 0-1.7-.79-3.15-2.12-3.88-.49-.26-1.09-.09-1.36.4a.997.997 0 0 0 .4 1.36c.68.37 1.08 1.16 1.08 2.12 0 1.07-.51 2.02-.78 2.3h-6.86c-1.93-7.01 2.97-9.31 5.95-10.7l.3-.14c1.14-.52 2.71-1.23 3.81-3 .16-.23.34-.51.53-.8.55-.84 1.97-3 2.65-3.3.18.36.44 1.1.62 1.79l.08.31 2.67 2.28c-.09.65-.56 1.89-2.76 2.06l-.66.05-.21.63s-.9 2.69-1.89 5.06c-.9 2.36-.3 5.13.75 6.66.63.91 1.26 1.1 1.69 1.1h.5c.55 0 1-.45 1-1s-.45-1-1-1h-.35c-.54-.47-1.51-2.94-.72-5.02.73-1.75 1.4-3.63 1.72-4.57Z',
    }),
  );
const ForwardRef$2V = forwardRef(SvgAnimalFeline);
const SvgAnimalOther = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'm8.347 3.762-3.27 4.15 1.631.117c.483-.005 1.007-.117 1.386-.385.325-.23.666-.656.666-1.614V4.365a.9.9 0 0 0-.056-.335.2.2 0 0 0-.04-.064L8.552 3.9l-.156-.157-.039.01zM3.483 9.937l-1.578 2.008a1.067 1.067 0 0 1-1.677-1.318L6.75 2.342l.045-.045.026-.026c.14-.144.553-.572 1.195-.63.667-.132 1.2.072 1.614.348l.088.058.172.172c.793.553 1.003 1.478 1.003 2.146V6.03c0 1.582-.623 2.689-1.568 3.356-.882.624-1.918.776-2.652.776h-.038z',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', { d: 'm11.754 4.54-1.402.964V3.577z' }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M16.007 6.795a1.2 1.2 0 0 1 1.66-.35l7.479 4.878-1.95 4.064-3.206-.183-2.183 7.213H8.333l-3.16 2.398-.721-.524c-.263-.19-.67-.31-1.132-.286s-.852.186-1.088.399L.229 26.206v-9.673c0-2.069 1.657-3.877 3.877-3.877h6.118c.974 0 1.426-.075 1.742-.201.29-.116.567-.316 1.085-.828l1.577-2.042a1.2 1.2 0 0 1 1.9 1.467l-1.673 2.164-.054.055c-.595.595-1.168 1.102-1.944 1.412-.76.305-1.598.373-2.633.373H4.106c-.84 0-1.477.678-1.477 1.477v5.14a5 5 0 0 1 .565-.065 4.4 4.4 0 0 1 1.85.293l2.482-1.884h8.5L18.24 12.7l3.487.199.344-.716-5.715-3.727a1.2 1.2 0 0 1-.35-1.66',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M1.333 19.061a1.2 1.2 0 0 1 1.2 1.2v6.406a1.2 1.2 0 1 1-2.4 0V20.26a1.2 1.2 0 0 1 1.2-1.2m3.824 2.87a1.2 1.2 0 0 1 1.2 1.2v3.537a1.2 1.2 0 0 1-2.4 0v-3.538a1.2 1.2 0 0 1 1.2-1.2m11.663-2.007a1.2 1.2 0 0 1 1.2 1.2v5.545a1.2 1.2 0 1 1-2.4 0v-5.545a1.2 1.2 0 0 1 1.2-1.2m-3.18.211a1.2 1.2 0 0 1 1.2 1.2v5.334a1.2 1.2 0 1 1-2.4 0v-5.334a1.2 1.2 0 0 1 1.2-1.2m13.496 5.217a.954.954 0 0 1 1.325.03l1.968 2.01a.897.897 0 0 1-.03 1.29.954.954 0 0 1-1.326-.03l-1.968-2.009a.897.897 0 0 1 .031-1.291m-4.038 2.67c0-.505.42-.913.937-.913h2.343c.517 0 .937.409.937.913s-.42.913-.937.913h-2.343a.925.925 0 0 1-.937-.913',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M23.384 17.838a.95.95 0 0 1 1.258-.408l5.997 2.923c.947.462 1.36 1.374 1.36 2.278 0 1.244-.866 2.274-2.16 2.45l-.015.01-.018.013-.056.036-.067.042-1.736 1.797-.474-.063h-.007a3 3 0 0 0-.227-.014c-.162-.006-.37 0-.581.033-.474.075-.653.232-.71.387l-.019.052-.014.03a8 8 0 0 0-.115.405 18 18 0 0 0-.093.377l-.006.024-.002.008-.163.715h-4.85l-.236-.57c-1.412-3.387.621-7.193 4.428-7.193.443 0 .895.053 1.22.102a11 11 0 0 1 .527.092l.034.007.01.002h.004c0 .001.002.001-.202.893l.203-.892c.505.11.824.597.712 1.09a.94.94 0 0 1-1.117.694l-.005-.002-.022-.004-.092-.018a9 9 0 0 0-.336-.057 7 7 0 0 0-.936-.08c-2.019 0-3.474 1.889-2.886 4.11h2.058q.016-.059.033-.113c.024-.08.063-.21.115-.326.423-1.091 1.49-1.43 2.157-1.536a5 5 0 0 1 .86-.059l1.312-1.36.148-.072s.012-.006.046-.028l.025-.016.134-.085a1.5 1.5 0 0 1 .7-.24c.335-.045.546-.275.546-.64 0-.375-.149-.56-.326-.645l-5.997-2.923a.903.903 0 0 1-.419-1.226',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$2U = forwardRef(SvgAnimalOther);
const SvgAppMenu = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M14.667 0H0v14.667h14.667zm-12 12V2.667H12V12zm14.666 2.667H32V0H17.333zm12-12V12H20V2.667zM0 17.333h14.667V32H0zM2.667 20v9.333H12V20zm14.666 12H32V17.333H17.333zm12-12v9.333H20V20z',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$2T = forwardRef(SvgAppMenu);
const SvgArchive = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M6.67 0h18.66L32 6.67v20.966A4.363 4.363 0 0 1 27.636 32H4.364A4.363 4.363 0 0 1 0 27.636V6.67zm1.205 2.91L2.91 7.874v19.761a1.455 1.455 0 0 0 1.455 1.455h23.272a1.455 1.455 0 0 0 1.455-1.455V7.876l-4.966-4.967z',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M17.455 11.636v13.091h-2.91v-13.09z',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M10.182 16.852 16 22.67l5.818-5.818 2.057 2.057L16 26.784 8.125 18.91zm20.364-8.125H1.454V5.818h29.09z',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$2S = forwardRef(SvgArchive);
const SvgBack = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      d: 'm4.82 15.098 9.318-9.317L12.358 4 0 16.357l12.357 12.358 1.781-1.78-9.317-9.318H32v-2.519z',
    }),
  );
const ForwardRef$2R = forwardRef(SvgBack);
const SvgBackward = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'm1 16 24 16V0zm21.23 11.077L5.616 16 22.231 4.923z',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', { d: 'M27.667 32h2.666V0h-2.666z' }),
  );
const ForwardRef$2Q = forwardRef(SvgBackward);
const SvgBarcode = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', { d: 'M10.667 8.667v14.666H8V8.667z' }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M32 2v6.667h-2.667v-4h-4V2zM6.667 4.667V2H0v6.667h2.667v-4zm-4 18.666H0V30h6.667v-2.667h-4zm22.666 4V30H32v-6.667h-2.667v4z',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      d: 'M17.333 8.667v14.666h-2.666V8.667zm6.667 0v14.666h-2.667V8.667z',
    }),
  );
const ForwardRef$2P = forwardRef(SvgBarcode);
const SvgBeginning = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', { d: 'M4 32V0H1.333v32z' }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'm30.667 32-24-16 24-16zM11.282 16l16.615 11.077V4.923z',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$2O = forwardRef(SvgBeginning);
const SvgBell = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M8.457 3.124a10.667 10.667 0 0 1 18.21 7.543v6.658c.038 3.053.892 6.04 2.473 8.65L30.366 28H1.634l1.225-2.024a17.1 17.1 0 0 0 2.474-8.65v-6.66a10.67 10.67 0 0 1 3.124-7.542M16 2.667a8 8 0 0 0-8 8v6.682a19.8 19.8 0 0 1-1.789 7.984H25.79A19.8 19.8 0 0 1 24 17.35v-6.682a8 8 0 0 0-8-8',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      d: 'M13.06 30.703a4 4 0 0 0 5.913-.036l.018-.02c.34-.382.604-.828.777-1.314h-7.536c.176.495.447.948.795 1.334',
    }),
  );
const ForwardRef$2N = forwardRef(SvgBell);
const SvgBlocked = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'm4.657 25.457 20.8-20.8 1.886 1.886-20.8 20.8z',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M16 2.667C8.636 2.667 2.667 8.637 2.667 16S8.637 29.333 16 29.333 29.333 23.363 29.333 16 23.363 2.667 16 2.667M0 16C0 7.163 7.163 0 16 0s16 7.163 16 16-7.163 16-16 16S0 24.837 0 16',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$2M = forwardRef(SvgBlocked);
const SvgBook = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M2.869 2.642c1.564-.84 3.624-1.309 5.798-1.309s4.233.468 5.798 1.31A6.9 6.9 0 0 1 16 3.746a6.9 6.9 0 0 1 1.535-1.105c1.565-.84 3.624-1.309 5.798-1.309s4.234.468 5.798 1.31C30.65 3.457 32 4.813 32 6.666v22.666h-2.667c0-.414-.316-1.058-1.464-1.675-1.102-.593-2.71-.991-4.536-.991s-3.433.398-4.535.99c-1.148.618-1.465 1.262-1.465 1.676h-2.666c0-.414-.317-1.058-1.465-1.675-1.102-.593-2.71-.991-4.535-.991s-3.434.398-4.536.99c-1.148.618-1.464 1.262-1.464 1.676H0V6.667c0-1.853 1.35-3.209 2.869-4.025m-.202 22.78q.1-.06.202-.113C4.433 24.468 6.493 24 8.667 24s4.233.468 5.798 1.309q.101.055.202.112V6.667c0-.415-.317-1.059-1.465-1.676C12.1 4.4 10.492 4 8.667 4s-3.434.399-4.536.991c-1.148.617-1.464 1.261-1.464 1.676zM17.333 6.666V25.42q.101-.058.202-.112C19.1 24.468 21.16 24 23.333 24s4.234.468 5.798 1.309q.102.055.202.112V6.667c0-.415-.316-1.059-1.464-1.676C26.767 4.4 25.159 4 23.333 4s-3.433.399-4.535.991c-1.148.617-1.465 1.261-1.465 1.676',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$2L = forwardRef(SvgBook);
const SvgBookmark = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M6.667 2.7c-.354 0-.693.143-.943.396s-.39.597-.39.955v23.36L16 21.409l10.667 6.002V4.05c0-.358-.14-.702-.39-.955a1.33 1.33 0 0 0-.944-.396zM3.838 1.186A3.98 3.98 0 0 1 6.667 0h18.666c1.061 0 2.079.427 2.829 1.186.75.76 1.171 1.79 1.171 2.865V32L16 24.499 2.667 32V4.05c0-1.074.421-2.104 1.171-2.864',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$2K = forwardRef(SvgBookmark);
const SvgBottle = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      d: 'M5.33 0h21.33v2.67H5.33zm21.66 11.68a8 8 0 0 0-4.32-2.23V5.34H20v6.67h1.33c1.41 0 2.77.56 3.77 1.56s1.56 2.36 1.56 3.77v12H5.33v-12c0-1.41.56-2.77 1.56-3.77s2.36-1.56 3.77-1.56h1.33V5.34H9.32v4.11A8 8 0 0 0 5 11.68a8 8 0 0 0-2.34 5.66v14.67h26.67V17.34c0-2.12-.84-4.16-2.34-5.66',
    }),
    /* @__PURE__ */ React.createElement('path', {
      d: 'M14.67 16v4h-4v2.67h4v4h2.66v-4h4V20h-4v-4z',
    }),
  );
const ForwardRef$2J = forwardRef(SvgBottle);
const SvgBrightness = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M0 14.667h4v2.666H0zM5.6 3.714l2.819 2.82-1.886 1.885L3.714 5.6zM17.333 0v4h-2.666V0zm10.953 5.6-2.82 2.819-1.885-1.886L26.4 3.714zM28 14.667h4v2.666h-4zm-2.533 8.914 2.819 2.819-1.886 1.886-2.819-2.82zM17.333 28v4h-2.666v-4zm-8.914-2.533L5.6 28.286 3.714 26.4l2.82-2.819zM16 9.333a6.667 6.667 0 1 0 0 13.334 6.667 6.667 0 0 0 0-13.334M6.667 16a9.333 9.333 0 1 1 18.666 0A9.333 9.333 0 0 1 16 25.333 9.333 9.333 0 0 1 6.667 16',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$2I = forwardRef(SvgBrightness);
const SvgBuilding = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', { d: 'M16 17v-2h-5v2zm0 8v2h-5v-2zm0-3v-2h-5v2z' }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M16 0v8h2V3l12 3.5V30h-9V10H6v5H0v17h32V5zm3 12v18H8V12zM6 17v13H2V17z',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', { d: 'M24 10h3v17h-3z' }),
  );
const ForwardRef$2H = forwardRef(SvgBuilding);
const SvgCalculator = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M2 0h28v32H2zm2.667 2.667v26.666h22.666V2.667zm2.666 4h17.334v8H7.333zM10 9.333V12h12V9.333zm-2.667 8h4V20h-4zm6.667 0h4V20h-4zm6.667 0h4V20h-4zM7.333 22.667h4v2.666h-4zm6.667 0h4v2.666h-4zm6.667 0h4v2.666h-4z',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$2G = forwardRef(SvgCalculator);
const SvgCalendar = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M8 0h2.667v4h10.666V0H24v4h8v28H0V4h8zM2.667 29.333h26.666V12H2.667zM29.333 6.667v2.666H2.667V6.667z',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$2F = forwardRef(SvgCalendar);
const SvgCamera = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      d: 'M5.333 9a1.333 1.333 0 1 1 0 2.667 1.333 1.333 0 0 1 0-2.667',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M16 9a8 8 0 1 0 0 16 8 8 0 0 0 0-16m-5.333 8a5.333 5.333 0 1 1 10.666 0 5.333 5.333 0 0 1-10.666 0',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M20.714 1h-9.428L8.62 5H4a4 4 0 0 0-4 4v17.333a4 4 0 0 0 4 4h24a4 4 0 0 0 4-4V9a4 4 0 0 0-4-4h-4.62zM3.057 27.276c-.25-.25-.39-.59-.39-.943V9A1.333 1.333 0 0 1 4 7.667h6.047l2.667-4h6.572l2.667 4H28A1.333 1.333 0 0 1 29.333 9v17.333A1.333 1.333 0 0 1 28 27.667H4c-.354 0-.693-.14-.943-.39Z',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$2E = forwardRef(SvgCamera);
const SvgCancel = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      d: 'M14.129 16 2.667 4.538l1.871-1.871L16 14.129 27.462 2.667l1.871 1.871L17.871 16l11.462 11.462-1.871 1.871L16 17.871 4.538 29.333l-1.871-1.871z',
    }),
  );
const ForwardRef$2D = forwardRef(SvgCancel);
const SvgCaretDown = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M2.667 7.448 16 20.78 29.333 7.448l1.886 1.885L16 24.553.781 9.332z',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$2C = forwardRef(SvgCaretDown);
const SvgCaretUp = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'm16 7.448 15.219 15.219-1.886 1.885L16 11.22 2.667 24.552.78 22.667z',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$2B = forwardRef(SvgCaretUp);
const SvgCart = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      d: 'M8.242 30.388a1.384 1.384 0 1 0 0-2.768 1.384 1.384 0 0 0 0 2.768',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M8.242 29.067a.063.063 0 1 0 0-.126.063.063 0 0 0 0 .126m1.384-.063a1.384 1.384 0 1 1-2.768 0 1.384 1.384 0 0 1 2.768 0',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      d: 'M27.62 30.388a1.384 1.384 0 1 0 0-2.768 1.384 1.384 0 0 0 0 2.768',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M27.62 29.067a.063.063 0 1 0 0-.126.063.063 0 0 0 0 .126m1.384-.063a1.384 1.384 0 1 1-2.768 0 1.384 1.384 0 0 1 2.768 0m-20.762-.063a.063.063 0 1 0 0 .126.063.063 0 0 0 0-.126m-2.705.063a2.705 2.705 0 1 1 5.41 0 2.705 2.705 0 0 1-5.41 0',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M27.62 28.941a.063.063 0 1 0 0 .126.063.063 0 0 0 0-.126m-2.705.063a2.705 2.705 0 1 1 5.41 0 2.705 2.705 0 0 1-5.41 0M0 0h6.63l.923 6.92H32l-3.297 16.485H7.085L4.317 2.642H0zm7.906 9.563 1.493 11.2h17.138l2.24-11.2z',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$2A = forwardRef(SvgCart);
const SvgChat2 = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M13.333 2.667A1.333 1.333 0 0 0 12 4v11.176l3.685-1.843h10.982A1.333 1.333 0 0 0 28 12V4a1.334 1.334 0 0 0-1.333-1.333zm-2.828-1.495A4 4 0 0 1 13.333 0h13.334a4 4 0 0 1 4 4v8a4 4 0 0 1-4 4H16.315l-6.982 3.49V4a4 4 0 0 1 1.172-2.828',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M1.172 3.838A4 4 0 0 1 4 2.667h4v2.666H4a1.333 1.333 0 0 0-1.333 1.334V28A1.333 1.333 0 0 0 4 29.333h14.667A1.333 1.333 0 0 0 20 28V17.333h2.667V28a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V6.667a4 4 0 0 1 1.172-2.829',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$2z = forwardRef(SvgChat2);
const SvgChat = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M0 12C0 5.11 6.86 0 14.667 0s14.666 5.11 14.666 12-6.859 12-14.666 12a17.7 17.7 0 0 1-4.069-.474L2.667 27.49v-8.6C1.017 16.97 0 14.6 0 12m14.667-9.333c-6.92 0-12 4.44-12 9.333 0 2.007.834 3.896 2.306 5.469l.36.384v5.323l4.967-2.483.488.13c1.22.327 2.522.51 3.879.51 6.92 0 12-4.44 12-9.333s-5.08-9.333-12-9.333m16.854 13.07.296 1.3q.182.796.183 1.63c0 2.285-1.047 4.314-2.667 5.87v6.954l-7.264-3.633a15.3 15.3 0 0 1-6.457-.5l-1.276-.388.777-2.551 1.275.388c1.108.337 2.326.526 3.612.526.71 0 1.401-.061 2.072-.171l.426-.07 4.169 2.084v-3.845l.468-.4c1.426-1.214 2.198-2.71 2.198-4.264q-.001-.532-.116-1.038l-.296-1.3z',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$2y = forwardRef(SvgChat);
const SvgCheckboxIndeterminate = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M0 15.333c0-1.104.827-2 1.846-2h28.308c1.02 0 1.846.896 1.846 2s-.826 2-1.846 2H1.846c-1.02 0-1.846-.895-1.846-2',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$2x = forwardRef(SvgCheckboxIndeterminate);
const SvgCheckmark = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M32 2.583 10.455 30.284 0 19.83l1.824-1.824 8.389 8.39L29.964 1z',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$2w = forwardRef(SvgCheckmark);
const SvgClipboardMedicalNotes = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 30 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M5.289 4.622a.62.62 0 0 0-.622.622v23.467a.62.62 0 0 0 .622.622H26.8a.62.62 0 0 0 .622-.622V5.244a.62.62 0 0 0-.622-.622h-1.956a1.333 1.333 0 0 1 0-2.666H26.8a3.29 3.29 0 0 1 3.289 3.288v23.467A3.29 3.29 0 0 1 26.8 32H5.289A3.29 3.29 0 0 1 2 28.711V5.244a3.29 3.29 0 0 1 3.289-3.288h1.955a1.333 1.333 0 1 1 0 2.666z',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M9.822 1.333C9.822.597 10.42 0 11.156 0h9.777c.737 0 1.334.597 1.334 1.333v3.911c0 .737-.597 1.334-1.334 1.334h-9.777a1.333 1.333 0 0 1-1.334-1.334zm2.667 1.334V3.91H19.6V2.667z',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      d: 'M17.333 16.667v-5.334h-2.666v5.334H9.333v2.666h5.334v5.334h2.666v-5.334h5.334v-2.666z',
    }),
  );
const ForwardRef$2v = forwardRef(SvgClipboardMedicalNotes);
const SvgClipboardPatient = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M5.29 4.622a.62.62 0 0 0-.623.622v23.467a.62.62 0 0 0 .622.622H26.8a.62.62 0 0 0 .622-.622V5.244a.62.62 0 0 0-.622-.622h-1.955a1.333 1.333 0 1 1 0-2.666H26.8a3.29 3.29 0 0 1 3.29 3.288v23.467A3.29 3.29 0 0 1 26.8 32H5.29A3.29 3.29 0 0 1 2 28.711V5.244a3.29 3.29 0 0 1 3.29-3.288h1.955a1.333 1.333 0 1 1 0 2.666z',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M9.822 1.333C9.822.597 10.42 0 11.156 0h9.777c.737 0 1.334.597 1.334 1.333v3.911c0 .737-.597 1.334-1.334 1.334h-9.777a1.333 1.333 0 0 1-1.334-1.334zm2.667 1.334V3.91H19.6V2.667z',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      d: 'M12.617 10.718c.24-.059.491-.067.735-.024.513.144.955.46 1.248.889.292.43.415.945.347 1.454a1.6 1.6 0 0 1-.175.686c-.11.213-.265.402-.458.552-.192.15-.416.259-.656.318s-.491.067-.735.024a2.24 2.24 0 0 1-1.248-.89 2.1 2.1 0 0 1-.347-1.453 1.6 1.6 0 0 1 .175-.686 1.7 1.7 0 0 1 .458-.552c.192-.15.416-.259.656-.318m9.674 3.972a1.77 1.77 0 0 1 1.392.343c.192.15.348.338.457.552s.169.448.175.686a2.1 2.1 0 0 1-.347 1.454c-.292.43-.735.745-1.248.889a1.8 1.8 0 0 1-.735-.024 1.7 1.7 0 0 1-.656-.318 1.7 1.7 0 0 1-.458-.552 1.6 1.6 0 0 1-.174-.686 2.1 2.1 0 0 1 .347-1.454c.292-.43.734-.745 1.247-.89m-12.582 0a1.8 1.8 0 0 0-.735.025c-.24.06-.464.168-.657.318-.192.15-.348.338-.457.552s-.169.448-.175.686a2.1 2.1 0 0 0 .347 1.454c.292.43.735.745 1.248.889a1.76 1.76 0 0 0 1.391-.342 1.7 1.7 0 0 0 .458-.552c.109-.214.168-.448.174-.686a2.1 2.1 0 0 0-.347-1.454 2.24 2.24 0 0 0-1.247-.89m8.939-3.996a1.78 1.78 0 0 1 1.392.342c.192.15.348.338.457.552s.169.448.175.686a2.1 2.1 0 0 1-.347 1.454c-.293.43-.735.745-1.248.889a1.8 1.8 0 0 1-.735-.024 1.7 1.7 0 0 1-.656-.318 1.7 1.7 0 0 1-.458-.552 1.6 1.6 0 0 1-.175-.686 2.1 2.1 0 0 1 .347-1.454c.293-.43.735-.745 1.248-.89m-8.373 12.954c0-2.997 2.602-6.994 5.725-6.994s5.725 3.997 5.725 6.994c0 .796-.329 1.558-.915 2.12a3.2 3.2 0 0 1-2.208.878c-.97 0-1.343-.316-1.669-.593-.253-.215-.478-.406-.933-.406-.49 0-.807.222-1.141.457-.374.263-.771.542-1.461.542a3.2 3.2 0 0 1-2.208-.878 2.94 2.94 0 0 1-.915-2.12',
    }),
  );
const ForwardRef$2u = forwardRef(SvgClipboardPatient);
const SvgClipboard = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M5.289 4.622a.62.62 0 0 0-.622.622v23.467a.62.62 0 0 0 .622.622H26.8a.62.62 0 0 0 .622-.622V5.244a.62.62 0 0 0-.622-.622h-1.956a1.333 1.333 0 0 1 0-2.666H26.8a3.29 3.29 0 0 1 3.289 3.288v23.467A3.29 3.29 0 0 1 26.8 32H5.289A3.29 3.29 0 0 1 2 28.711V5.244a3.29 3.29 0 0 1 3.289-3.288h1.955a1.333 1.333 0 1 1 0 2.666z',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M9.822 1.333C9.822.597 10.42 0 11.156 0h9.777c.737 0 1.334.597 1.334 1.333v3.911c0 .737-.597 1.334-1.334 1.334h-9.777a1.333 1.333 0 0 1-1.334-1.334zm2.667 1.334V3.91H19.6V2.667zm10.365 10.435c.52.52.52 1.365 0 1.885l-7.822 7.823c-.521.52-1.365.52-1.886 0l-3.911-3.912a1.333 1.333 0 0 1 1.886-1.885l2.968 2.968 6.88-6.88c.52-.52 1.364-.52 1.885 0',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$2t = forwardRef(SvgClipboard);
const SvgClose = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'm23.752 10.133-13.619 13.62-1.885-1.886 13.619-13.62z',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'm10.133 8.248 13.62 13.619-1.886 1.885-13.62-13.619z',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M16 2.667C8.636 2.667 2.667 8.637 2.667 16S8.637 29.333 16 29.333 29.333 23.363 29.333 16 23.363 2.667 16 2.667M0 16C0 7.163 7.163 0 16 0s16 7.163 16 16-7.163 16-16 16S0 24.837 0 16',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$2s = forwardRef(SvgClose);
const SvgCloudConnected = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      d: 'M16 5.333c-4.741 0-8.762 2.999-10.385 7.169C2.43 13.375 0 16.355 0 19.856c0 3.997 3.058 7.276 7.03 7.626l.054.005h18.828l.065-.007C29.33 27.121 32 24.355 32 20.841c0-3.17-2.174-5.733-5.063-6.467l-.054-.267-2.187 2.187.025.249.994.106c2.161.232 3.823 1.995 3.823 4.192 0 2.176-1.63 3.927-3.762 4.185h-9.812l-.078.079-.08-.08h-8.61c-2.698-.263-4.734-2.487-4.734-5.169 0-2.536 1.915-4.692 4.288-5.087l.743-.124.228-.718C8.847 10.374 12.134 7.795 16 7.795a8.68 8.68 0 0 1 6.598 3.055l-7.265 7.264L12 14.781l-1.886 1.886 5.22 5.219L29.218 8l-1.886-1.886-2.99 2.991C22.3 6.801 19.315 5.333 16 5.333',
    }),
  );
const ForwardRef$2r = forwardRef(SvgCloudConnected);
const SvgCloudOffline = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M28.652 31.654 1.542 2.188 3.506.383 9.07 6.43A11.1 11.1 0 0 1 16 4c4.741 0 8.762 2.998 10.385 7.168C29.57 12.042 32 15.022 32 18.523c0 3.34-2.137 6.18-5.157 7.227l3.771 4.099zm-3.715-7.976c2.632-.322 4.601-2.517 4.601-5.155 0-2.537-1.915-4.692-4.288-5.087l-.743-.124-.228-.718C23.152 9.04 19.866 6.462 16 6.462c-1.974 0-3.798.67-5.258 1.786zm-17.2-11.19-1.85-2.013a11 11 0 0 0-.824 2.566C2.175 13.775 0 16.337 0 19.508c0 3.513 2.67 6.28 6.023 6.639l.065.007H20.31l-2.264-2.462H6.224c-2.132-.258-3.762-2.008-3.762-4.184 0-2.197 1.662-3.96 3.823-4.192l.994-.106.1-.995q.09-.893.359-1.727Z',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$2q = forwardRef(SvgCloudOffline);
const SvgCloud = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      d: 'M16 5.333c-4.741 0-8.762 2.999-10.385 7.169C2.43 13.375 0 16.355 0 19.856c0 3.997 3.058 7.276 7.03 7.626l.054.005H20v-2.461H7.195c-2.697-.264-4.733-2.488-4.733-5.17 0-2.536 1.915-4.692 4.288-5.087l.743-.124.228-.718C8.847 10.374 12.134 7.795 16 7.795c4.483 0 8.192 3.454 8.622 7.753l.099.995.994.106c2.161.232 3.823 1.995 3.823 4.192 0 2.176-1.63 3.927-3.762 4.185h-7.068H20v2.461h-1.292 7.204l.065-.007C29.33 27.121 32 24.355 32 20.841c0-3.17-2.174-5.733-5.063-6.467-.962-5.104-5.505-9.04-10.937-9.04Z',
    }),
  );
const ForwardRef$2p = forwardRef(SvgCloud);
const SvgCollapse = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M0 0h32v32H0zm2.667 2.667v26.666h26.666V2.667z',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M7.333 14.667h17.334v2.666H7.333z',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$2o = forwardRef(SvgCollapse);
const SvgCommunicate = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M0 13.333C0 5.692 7.394 0 16 0s16 5.692 16 13.333c0 3.136-1.334 5.95-3.404 8.203l.986 8.547-9.53-3.876c-1.337.346-2.663.46-4.052.46-8.606 0-16-5.692-16-13.334M16 2.667c-7.66 0-13.333 4.975-13.333 10.666S8.339 24 16 24c1.384 0 2.58-.126 3.75-.477l.45-.135 6.218 2.529-.616-5.338.455-.455c1.94-1.94 3.076-4.284 3.076-6.79 0-5.692-5.672-10.667-13.333-10.667',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$2n = forwardRef(SvgCommunicate);
const SvgContrast = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      d: 'M16 0C7.178 0 0 7.178 0 16s7.178 16 16 16 16-7.178 16-16S24.822 0 16 0M2.91 16C2.91 8.781 8.782 2.91 16 2.91v26.18C8.783 29.09 2.91 23.22 2.91 16',
    }),
  );
const ForwardRef$2m = forwardRef(SvgContrast);
const SvgContribute = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M16.77 17.846v-4.923h-2.462v4.923H9.385v2.462h4.923v4.923h2.461v-4.923h4.923v-2.462z',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M2 1.23C2 .552 2.551 0 3.23 0h15.755c.326 0 .64.13.87.36l9.846 9.847c.23.23.36.543.36.87v19.692c0 .68-.55 1.231-1.23 1.231H3.23A1.23 1.23 0 0 1 2 30.77zm2.462 1.232v27.077H27.6V11.586l-9.125-9.125z',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M18.985 0c.68 0 1.23.551 1.23 1.23v8.616h8.616a1.23 1.23 0 0 1 0 2.462h-9.846a1.23 1.23 0 0 1-1.231-1.231V1.23c0-.68.55-1.231 1.23-1.231',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$2l = forwardRef(SvgContribute);
const SvgControls = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M17.333 4H32v2.667H17.333zM0 4h6.667v2.667H0zm28 10.667h4v2.666h-4zm-28 0h17.333v2.666H0zm17.333 10.666H32V28H17.333zM0 25.333h6.667V28H0z',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M9.333 2.667a2.667 2.667 0 1 0 0 5.333 2.667 2.667 0 0 0 0-5.333M4 5.333a5.333 5.333 0 1 1 10.667 0A5.333 5.333 0 0 1 4 5.333m16 8a2.667 2.667 0 1 0 0 5.334 2.667 2.667 0 0 0 0-5.334M14.667 16a5.333 5.333 0 1 1 10.666 0 5.333 5.333 0 0 1-10.666 0m-5.334 8a2.667 2.667 0 1 0 0 5.333 2.667 2.667 0 0 0 0-5.333M4 26.667a5.333 5.333 0 1 1 10.667 0 5.333 5.333 0 0 1-10.667 0',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$2k = forwardRef(SvgControls);
const SvgCopy = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M20.533 8.8H32V32H8.8V20.533h2.667v8.8h17.866V11.467h-8.8z',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M0 0h23.2v23.2H0zm2.667 2.667v17.866h17.866V2.667z',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$2j = forwardRef(SvgCopy);
const SvgCrop = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M9.175 0v10.518H6.713V0zm16.112 26.853V32h-2.462v-5.147z',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M0 8.056h25.287v15.888h-2.462V10.518H0z',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M9.175 13.427v8.056H32v2.461H6.713V13.427z',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$2i = forwardRef(SvgCrop);
const SvgCry = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M16 2.667C8.636 2.667 2.667 8.637 2.667 16S8.637 29.333 16 29.333 29.333 23.363 29.333 16 23.363 2.667 16 2.667M0 16C0 7.163 7.163 0 16 0s16 7.163 16 16-7.163 16-16 16S0 24.837 0 16',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      d: 'M10 16a2 2 0 1 0 0-4 2 2 0 0 0 0 4m12 0a2 2 0 1 0 0-4 2 2 0 0 0 0 4',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M16.41 21.365A2.667 2.667 0 0 0 13.334 24h-2.666a5.333 5.333 0 0 1 8.889-3.975l-1.778 1.988a2.67 2.67 0 0 0-1.367-.648Z',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      d: 'M20 22.667c0-1.474 2.667-5.334 2.667-5.334s2.666 3.86 2.666 5.334a2.667 2.667 0 1 1-5.333 0',
    }),
  );
const ForwardRef$2h = forwardRef(SvgCry);
const SvgCut = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M21.509-.007 22.742.5a6.667 6.667 0 0 1 3.636 8.698l-2.864 6.981a5.334 5.334 0 0 1-5.706 3.253h-.001l-1.317-.192-3.256 7.933-2.467-1.013zm-3.975 16.704.66.096a2.67 2.67 0 0 0 2.853-1.626l2.863-6.981a4 4 0 0 0-1.034-4.501z',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M10.491-.006 21.233 26.16l-2.466 1.013-3.257-7.933-1.317.191h-.001a5.334 5.334 0 0 1-5.705-3.251L5.623 9.2A6.67 6.67 0 0 1 7.09 1.94 6.7 6.7 0 0 1 9.258.499zm3.975 16.703L9.124 3.685a4 4 0 0 0-1.026 1.44 4 4 0 0 0-.009 3.063l2.864 6.979a2.67 2.67 0 0 0 2.854 1.626z',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M24 24a2.667 2.667 0 1 0 0 5.333A2.667 2.667 0 0 0 24 24m-5.333 2.667a5.333 5.333 0 1 1 10.666 0 5.333 5.333 0 0 1-10.666 0M8 24a2.667 2.667 0 1 0 0 5.333A2.667 2.667 0 0 0 8 24m-5.333 2.667a5.333 5.333 0 1 1 10.666 0 5.333 5.333 0 0 1-10.666 0',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$2g = forwardRef(SvgCut);
const SvgDashboard = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M30.133 21.333H1.867v-2.666h28.266z',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'm14.835 20.648-6.667-12 2.33-1.296 6.668 12-2.332 1.296Z',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M16 2.667C8.636 2.667 2.667 8.637 2.667 16S8.637 29.333 16 29.333 29.333 23.363 29.333 16 23.363 2.667 16 2.667M0 16C0 7.163 7.163 0 16 0s16 7.163 16 16-7.163 16-16 16S0 24.837 0 16',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$2f = forwardRef(SvgDashboard);
const SvgDelete = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M10.223 2.667c0-.737.597-1.334 1.333-1.334h8.89c.735 0 1.332.597 1.332 1.334v4h7.555a1.333 1.333 0 1 1 0 2.666H2.667a1.333 1.333 0 1 1 0-2.666h7.556zM19.112 4v2.667H12.89V4z',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      d: 'M7.11 11.953c-.086-.785-.85-1.358-1.707-1.28-.856.08-1.48.78-1.395 1.565l1.59 14.57c.238 2.19 2.25 3.859 4.651 3.859h11.502c2.402 0 4.413-1.669 4.652-3.86l1.59-14.57c.085-.785-.54-1.485-1.396-1.563-.857-.079-1.62.494-1.706 1.28l-1.59 14.57c-.08.73-.75 1.285-1.55 1.285H10.249c-.8 0-1.47-.556-1.55-1.286l-1.59-14.57Z',
    }),
  );
const ForwardRef$2e = forwardRef(SvgDelete);
const SvgDeliveryTime = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      d: 'm32 20.45-3.04-9.12h-7.63V6.66h-5.45C15.24 2.88 11.96 0 8 0 3.58 0 0 3.58 0 8s3.58 8 8 8c3.96 0 7.24-2.88 7.88-6.67h2.79v12h2.67V14h5.71l2.29 6.88v4.45h-1.13c-.75-1.57-2.34-2.67-4.2-2.67s-3.45 1.09-4.2 2.67h-6.77C12.35 23.39 10.52 22 8.35 22s-4.01 1.4-4.69 3.33h-.97V16H0v12h3.43a5 5 0 0 0 9.8 0h6.17c.33 2.26 2.25 4 4.6 4s4.27-1.74 4.6-4H32zM8 13.33c-2.95 0-5.33-2.39-5.33-5.33S5.06 2.67 8 2.67 13.33 5.06 13.33 8 10.94 13.33 8 13.33m.33 16C7.04 29.33 6 28.29 6 27s1.04-2.33 2.33-2.33 2.33 1.04 2.33 2.33-1.04 2.33-2.33 2.33m15.67 0c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2',
    }),
    /* @__PURE__ */ React.createElement('path', { d: 'M9.33 4H6.67v5.33H12V6.67H9.33z' }),
  );
const ForwardRef$2d = forwardRef(SvgDeliveryTime);
const SvgDelivery = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      d: 'm32 15.66-4.54-8.33h-6.79V2H0v24.67h3.55C4.13 28.59 5.89 30 8 30s3.87-1.41 4.45-3.33h7.1C20.13 28.59 21.89 30 24 30s3.87-1.41 4.45-3.33H32zM8 27.33c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2m16 0c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2M29.33 24h-.88c-.58-1.92-2.34-3.33-4.45-3.33s-3.87 1.41-4.45 3.33h-7.1c-.58-1.92-2.34-3.33-4.45-3.33S4.13 22.08 3.55 24h-.88V4.67H18V20h2.67V10h5.21l3.46 6.34V24Z',
    }),
    /* @__PURE__ */ React.createElement('path', { d: 'M24 10.67h-2.67v6.66H28v-2.66h-4z' }),
  );
const ForwardRef$2c = forwardRef(SvgDelivery);
const SvgDiamond = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M6.013 0h19.974L32 10.197 16 32 0 10.197zm.603 3.98L3.922 8.547h4.803zm3.127 7.258H3.94l9.121 12.43zm9.197 12.43 9.121-12.43h-5.804zm4.335-15.12h4.803L25.384 3.98zM23.2 2.69h-4.91l2.775 4.622zm-9.491 0H8.8l2.134 4.622zm-.552 5.856h5.684L16 3.814zm-.827 2.691h7.339L16 24.99z',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$2b = forwardRef(SvgDiamond);
const SvgDirection = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      d: 'M16.95.95 16 0l-.95.95L8 8l-.95.95 1.9 1.9.95-.95 4.76-4.76v21.72L9.9 22.1l-.95-.95-1.9 1.9L8 24l7.05 7.05.95.95.95-.95L24 24l.95-.95-1.9-1.9-.95.95-4.76 4.76V5.14L22.1 9.9l.95.95 1.9-1.9L24 8z',
    }),
  );
const ForwardRef$2a = forwardRef(SvgDirection);
const SvgDisgusted = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M16 2.667C8.636 2.667 2.667 8.637 2.667 16S8.637 29.333 16 29.333 29.333 23.363 29.333 16 23.363 2.667 16 2.667M0 16C0 7.163 7.163 0 16 0s16 7.163 16 16-7.163 16-16 16S0 24.837 0 16',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      d: 'M10 16a2 2 0 1 0 0-4 2 2 0 0 0 0 4m12 0a2 2 0 1 0 0-4 2 2 0 0 0 0 4',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'm16 18.398 4.096 2.73 3.167-1.584 1.192 2.386-4.55 2.275L16 21.603l-3.904 2.602-4.552-2.275 1.193-2.386 3.167 1.584z',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$29 = forwardRef(SvgDisgusted);
const SvgDoctor = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M12 20v9.333h13.333v-8H28V32H9.333V20z',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M26.667 16a2.667 2.667 0 1 0 0 5.333 2.667 2.667 0 0 0 0-5.333m-5.334 2.667a5.333 5.333 0 1 1 10.667 0 5.333 5.333 0 0 1-10.667 0M2.927 4H8V1.333H2.933c-.791 0-1.546.291-2.07.889-.517.591-.7 1.361-.582 2.107l2.003 14.825.009.04c.38 1.907 1.955 3.34 3.974 3.34h8.666c1.9 0 3.763-1.337 3.99-3.436l2.128-14.762c.28-1.738-1.173-3.003-2.651-3.003h-5.067V4h5.073l-2.13 14.772-.003.029c-.055.549-.583 1.066-1.34 1.066H6.267c-.638 0-1.19-.421-1.352-1.16z',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M8 0v5.333H5.333V0zm8 0v5.333h-2.667V0z',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$28 = forwardRef(SvgDoctor);
const SvgDocument = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      d: 'M8 10a1 1 0 1 0 0 2h5a1 1 0 1 0 0-2zm-1 7a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1m1 5a1 1 0 1 0 0 2h16a1 1 0 1 0 0-2z',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M2 2a1 1 0 0 1 1-1h17a1 1 0 0 1 .707.293l9 9A1 1 0 0 1 30 11v19a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1zm2 1v26h24V12h-8a1 1 0 0 1-1-1V3zm17 1.414L26.586 10H21z',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$27 = forwardRef(SvgDocument);
const SvgDoubleLeft = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M28.438 2.667 15.105 16l13.333 13.333-1.886 1.886L11.333 16 26.553.781z',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M20.438 2.667 7.105 16l13.333 13.333-1.886 1.886L3.333 16 18.553.781z',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$26 = forwardRef(SvgDoubleLeft);
const SvgDoubleRight = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M5.619.781 20.838 16 5.619 31.219l-1.886-1.886L17.067 16 3.733 2.667 5.62.78Z',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M13.619.781 28.838 16 13.619 31.219l-1.886-1.886L25.067 16 11.733 2.667 13.62.78Z',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$25 = forwardRef(SvgDoubleRight);
const SvgDown = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      d: 'm17.26 27.18 9.32-9.32 1.78 1.78L16 32 3.64 19.64l1.78-1.78 9.32 9.32V0h2.52z',
    }),
  );
const ForwardRef$24 = forwardRef(SvgDown);
const SvgDownload = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M15.876.667c.737 0 1.333.597 1.333 1.333v23.467a1.333 1.333 0 0 1-2.666 0V2c0-.736.597-1.333 1.333-1.333',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M5.333 14.924a1.335 1.335 0 0 1 1.886 0l8.657 8.657 8.657-8.657a1.333 1.333 0 0 1 1.886 1.886l-9.6 9.6c-.52.52-1.365.52-1.886 0l-9.6-9.6a1.333 1.333 0 0 1 0-1.886M0 30.667c0-.737.597-1.334 1.333-1.334h29.334a1.333 1.333 0 0 1 0 2.667H1.333A1.333 1.333 0 0 1 0 30.667',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$23 = forwardRef(SvgDownload);
const SvgDrag2 = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      d: 'M8 14.667A2.675 2.675 0 0 1 5.333 12c0-1.467 1.2-2.667 2.667-2.667s2.667 1.2 2.667 2.667-1.2 2.667-2.667 2.667M18.667 12c0-1.467-1.2-2.667-2.667-2.667A2.674 2.674 0 0 0 13.333 12c0 1.467 1.2 2.667 2.667 2.667s2.667-1.2 2.667-2.667m8 0c0-1.467-1.2-2.667-2.667-2.667A2.674 2.674 0 0 0 21.333 12c0 1.467 1.2 2.667 2.667 2.667s2.667-1.2 2.667-2.667m-5.334 8c0 1.467 1.2 2.667 2.667 2.667s2.667-1.2 2.667-2.667-1.2-2.667-2.667-2.667A2.674 2.674 0 0 0 21.333 20m-2.666 0c0-1.467-1.2-2.667-2.667-2.667A2.674 2.674 0 0 0 13.333 20c0 1.467 1.2 2.667 2.667 2.667s2.667-1.2 2.667-2.667m-8 0c0-1.467-1.2-2.667-2.667-2.667A2.675 2.675 0 0 0 5.333 20c0 1.467 1.2 2.667 2.667 2.667s2.667-1.2 2.667-2.667',
    }),
  );
const ForwardRef$22 = forwardRef(SvgDrag2);
const SvgDrag = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      d: 'M14.667 24c0 1.467-1.2 2.667-2.667 2.667A2.675 2.675 0 0 1 9.333 24c0-1.467 1.2-2.667 2.667-2.667s2.667 1.2 2.667 2.667M12 13.333A2.675 2.675 0 0 0 9.333 16c0 1.467 1.2 2.667 2.667 2.667s2.667-1.2 2.667-2.667-1.2-2.667-2.667-2.667m0-8A2.675 2.675 0 0 0 9.333 8c0 1.467 1.2 2.667 2.667 2.667s2.667-1.2 2.667-2.667-1.2-2.667-2.667-2.667m8 5.334c1.467 0 2.667-1.2 2.667-2.667S21.467 5.333 20 5.333A2.675 2.675 0 0 0 17.333 8c0 1.467 1.2 2.667 2.667 2.667m0 2.666A2.675 2.675 0 0 0 17.333 16c0 1.467 1.2 2.667 2.667 2.667s2.667-1.2 2.667-2.667-1.2-2.667-2.667-2.667m0 8A2.675 2.675 0 0 0 17.333 24c0 1.467 1.2 2.667 2.667 2.667s2.667-1.2 2.667-2.667-1.2-2.667-2.667-2.667',
    }),
  );
const ForwardRef$21 = forwardRef(SvgDrag);
const SvgDrawerClose = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      d: 'M19.707 20.707a1 1 0 0 1-1.414 0l-4-4a1 1 0 0 1 0-1.414l4-4a1 1 0 0 1 1.414 1.414L17.414 15h7.67c.506 0 .916.448.916 1s-.41 1-.917 1h-7.669l2.293 2.293a1 1 0 0 1 0 1.414',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M1 7.072C1 4.912 2.616 3 4.8 3h22.4C29.384 3 31 4.912 31 7.072v17.856C31 27.088 29.384 29 27.2 29H4.8C2.616 29 1 27.088 1 24.928zM4.8 5C3.891 5 3 5.838 3 7.072v17.856C3 26.162 3.891 27 4.8 27H10V5zm22.4 22H12V5h15.2c.909 0 1.8.838 1.8 2.072v17.856C29 26.162 28.109 27 27.2 27',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$20 = forwardRef(SvgDrawerClose);
const SvgDrawerOpen = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      d: 'M20.293 11.293a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414-1.414L22.586 17h-7.67c-.506 0-.916-.448-.916-1s.41-1 .917-1h7.669l-2.293-2.293a1 1 0 0 1 0-1.414',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M1 7.072C1 4.912 2.616 3 4.8 3h22.4C29.384 3 31 4.912 31 7.072v17.856C31 27.088 29.384 29 27.2 29H4.8C2.616 29 1 27.088 1 24.928zM4.8 5C3.891 5 3 5.838 3 7.072v17.856C3 26.162 3.891 27 4.8 27H10V5zm22.4 22H12V5h15.2c.909 0 1.8.838 1.8 2.072v17.856C29 26.162 28.109 27 27.2 27',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$1$ = forwardRef(SvgDrawerOpen);
const SvgEcg = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'm13.573 6.342 5.333 13.334 3.006-5.01H32v2.667h-8.578l-4.995 8.325-5.333-13.334-3.006 5.01H0v-2.667h8.578z',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M6.667 20v7.998a1.34 1.34 0 0 0 1.335 1.335h15.996a1.34 1.34 0 0 0 1.335-1.335V20H28v8.004A4.01 4.01 0 0 1 24.004 32H7.996A4.01 4.01 0 0 1 4 28.004V20zM8 0h16.004A4.01 4.01 0 0 1 28 3.996V12h-2.667V4.002a1.34 1.34 0 0 0-1.335-1.335H8.002a1.34 1.34 0 0 0-1.335 1.335V12H4V3.996A4.01 4.01 0 0 1 7.996 0z',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$1_ = forwardRef(SvgEcg);
const SvgEdit = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'm24.098-.552 7.536 7.536-22.58 22.58-9.42 1.884 1.884-9.42zM3.906 23.306l-.968 4.837 4.838-.967L27.968 6.984l-3.87-3.87z',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$1Z = forwardRef(SvgEdit);
const SvgEmailRead = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      d: 'm.55 13.24 1.57-2.16L16 21.18l13.88-10.1 1.57 2.16L16 24.48z',
    }),
    /* @__PURE__ */ React.createElement('path', {
      d: 'M16 0 0 11.64V28c0 2.21 1.79 4 4 4h24c2.21 0 4-1.79 4-4V11.64zm13.33 28c0 .74-.6 1.33-1.33 1.33H4c-.74 0-1.33-.6-1.33-1.33V12.99L16 3.3 29.33 13v15.01Z',
    }),
  );
const ForwardRef$1Y = forwardRef(SvgEmailRead);
const SvgEmail = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M1.255 5.73 3.05 3.758 16 15.531 28.95 3.76l1.794 1.973L16 19.135z',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M4 5.333c-.736 0-1.333.597-1.333 1.334v18.666c0 .737.597 1.334 1.333 1.334h24c.736 0 1.333-.597 1.333-1.334V6.667c0-.737-.597-1.334-1.333-1.334zM0 6.667a4 4 0 0 1 4-4h24a4 4 0 0 1 4 4v18.666a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4z',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$1X = forwardRef(SvgEmail);
const SvgEnd = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M24 16 2.667 0v32zm-4.102 0L5.128 27.077V4.923z',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', { d: 'M29.333 0h-2.666v32h2.666z' }),
  );
const ForwardRef$1W = forwardRef(SvgEnd);
const SvgEuro = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M19.975.667a12.36 12.36 0 0 1 8.941 3.37l.969.917-1.832 1.938-.969-.916a9.7 9.7 0 0 0-7.033-2.644l-.025.001H20c-3.97 0-6.565 1.626-8.214 3.94C10.094 9.65 9.333 12.852 9.333 16c0 3.15.76 6.351 2.453 8.726 1.65 2.315 4.244 3.94 8.214 3.94h.026l.025.002a9.7 9.7 0 0 0 7.033-2.644l.969-.916 1.832 1.938-.969.916a12.36 12.36 0 0 1-8.941 3.371c-4.817-.007-8.214-2.046-10.36-5.06C7.505 23.317 6.666 19.519 6.666 16s.84-7.316 2.947-10.274C11.76 2.713 15.157.674 19.973.666Z',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M2.667 12H20v2.667H2.667zm0 5.333H20V20H2.667z',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$1V = forwardRef(SvgEuro);
const SvgExpand = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M0 0h32v32H0zm2.667 2.667v26.666h26.666V2.667z',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M17.333 7.333v17.334h-2.666V7.333z',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M7.333 14.667h17.334v2.666H7.333z',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$1U = forwardRef(SvgExpand);
const SvgExport = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      d: 'M20.79 25.756a1.455 1.455 0 0 1 0-2.057l6.244-6.245H9.212a1.455 1.455 0 1 1 0-2.909h17.822L20.79 8.301a1.455 1.455 0 0 1 2.057-2.057l8.725 8.726.018.018a1.45 1.45 0 0 1 .311 1.54 1.45 1.45 0 0 1-.327.5l-8.727 8.728a1.455 1.455 0 0 1-2.057 0M2.91 1.455a1.455 1.455 0 1 0-2.91 0v29.09a1.455 1.455 0 0 0 2.91 0z',
    }),
  );
const ForwardRef$1T = forwardRef(SvgExport);
const SvgFavoriteFeatured = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'm15.802.988 4.944 10.016 11.056 1.606-8 7.799 1.887 11.01-9.887-5.197-9.888 5.197L7.8 20.41l-8-7.799 11.056-1.606zm0 5.498-3.329 6.742-7.442 1.081 5.385 5.25-1.27 7.412 6.655-3.498 6.657 3.498-1.271-7.412 5.385-5.25-7.442-1.08z',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$1S = forwardRef(SvgFavoriteFeatured);
const SvgFeedback = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M4 4c-.737 0-1.333.596-1.333 1.333V20c0 .737.596 1.333 1.333 1.333h5.333v5.41l7.573-5.41H28c.737 0 1.333-.596 1.333-1.333V5.333C29.333 4.596 28.737 4 28 4zM0 5.333a4 4 0 0 1 4-4h24a4 4 0 0 1 4 4V20a4 4 0 0 1-4 4H17.76L6.668 31.924V24H4a4 4 0 0 1-4-4z',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$1R = forwardRef(SvgFeedback);
const SvgFileExcel = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M2 1.23C2 .552 2.551 0 3.23 0h15.755c.326 0 .64.13.87.36l9.846 9.847c.23.23.36.543.36.87v19.692c0 .68-.55 1.231-1.23 1.231H3.23A1.23 1.23 0 0 1 2 30.77zm2.462 1.232v27.076H27.6V11.587l-9.125-9.125z',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      d: 'm14.558 13.016 1.614 2.965 1.659-2.965h2.767l-2.758 4.768 2.884 4.985h-2.776l-1.758-3.137-1.758 3.137h-2.776l2.884-4.985-2.758-4.768z',
    }),
  );
const ForwardRef$1Q = forwardRef(SvgFileExcel);
const SvgFileImage = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M2 1.23C2 .552 2.551 0 3.23 0h15.755c.326 0 .64.13.87.36l9.846 9.847c.23.23.36.543.36.87v19.692c0 .68-.55 1.231-1.23 1.231H3.23A1.23 1.23 0 0 1 2 30.77zm2.462 1.232v27.076H27.6V11.587l-9.125-9.125z',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      d: 'm7.333 24 4-6.667 4 4 5.334-8L26 24zm6-10.667a2 2 0 1 0 0-4 2 2 0 0 0 0 4',
    }),
  );
const ForwardRef$1P = forwardRef(SvgFileImage);
const SvgFilePdf = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M2 1.23C2 .552 2.551 0 3.23 0h15.755c.326 0 .64.13.87.36l9.846 9.847c.23.23.36.543.36.87v19.692c0 .68-.55 1.231-1.23 1.231H3.23A1.23 1.23 0 0 1 2 30.77zm2.462 1.232v27.076H27.6V11.587l-9.125-9.125z',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M12.682 22.92c-.174.336-.328.636-.454.89l-.07.14c-.31.622-.7 1.401-1.176 2.063-.505.702-1.237 1.455-2.278 1.663-1.065.213-2.271-.304-2.79-1.255a2 2 0 0 1-.057-1.814c.274-.598.81-1.077 1.505-1.456a35 35 0 0 1 3.893-1.828c.794-1.535 1.82-3.527 2.68-5.465-.557-1.366-.92-2.71-1.007-3.862-.06-.783 0-1.575.301-2.236.326-.716.928-1.248 1.787-1.385.706-.114 1.467-.01 2.003.587.482.537.571 1.255.554 1.846-.035 1.205-.547 2.797-1.18 4.372q-.134.335-.278.676a18.5 18.5 0 0 0 2.228 3.648c2.453-.278 4.427-.107 5.74.221 1.499.375 2.363 1.596 2.368 2.833a2.43 2.43 0 0 1-.688 1.728c-.483.489-1.157.743-1.922.743-2.02 0-3.873-1.057-5.4-2.469q-.473-.436-.915-.926a26.4 26.4 0 0 0-4.844 1.285Zm1.299-2.53a28 28 0 0 1 2.137-.53 21 21 0 0 1-1.054-1.675c-.36.759-.73 1.505-1.083 2.205m6.136.986c1.24 1.06 2.515 1.653 3.724 1.653.315 0 .448-.097.5-.15a.43.43 0 0 0 .11-.313c-.001-.297-.217-.742-.852-.9-.806-.202-1.991-.342-3.482-.29m-5.026-8.443c.296-.898.467-1.646.483-2.183a1.4 1.4 0 0 0-.036-.417c-.04-.002-.106 0-.205.016-.128.02-.204.066-.283.24-.104.227-.175.635-.128 1.256.025.332.082.698.169 1.088m.504-2.59s-.006 0-.015-.005zM9.801 24.144q-.73.354-1.481.763c-.48.261-.615.469-.645.534l-.007.017.004.007a.53.53 0 0 0 .245.193.7.7 0 0 0 .395.057c.292-.059.64-.306 1.047-.871.156-.216.302-.452.442-.7',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$1O = forwardRef(SvgFilePdf);
const SvgFileTxt = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M2 1.23C2 .552 2.551 0 3.23 0h15.755c.326 0 .64.13.87.36l9.846 9.847c.23.23.36.543.36.87v19.692c0 .68-.55 1.231-1.23 1.231H3.23A1.23 1.23 0 0 1 2 30.77zm2.462 1.232v27.076H27.6V11.587l-9.125-9.125z',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      d: 'M18.813 13.016v1.839h-5.679v-1.84h5.68Zm-4.273-2.407h2.596v9.222q0 .423.109.649a.65.65 0 0 0 .342.315q.226.081.568.081.243 0 .433-.018.198-.027.333-.054l.01 1.911q-.334.109-.722.171a5.4 5.4 0 0 1-.856.064q-.857 0-1.497-.28a2.06 2.06 0 0 1-.973-.92q-.343-.63-.343-1.658z',
    }),
  );
const ForwardRef$1N = forwardRef(SvgFileTxt);
const SvgFileWord = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M2 1.23C2 .552 2.551 0 3.23 0h15.755c.326 0 .64.13.87.36l9.846 9.847c.23.23.36.543.36.87v19.692c0 .68-.55 1.231-1.23 1.231H3.23A1.23 1.23 0 0 1 2 30.77zm2.462 1.232v27.076H27.6V11.587l-9.125-9.125z',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      d: 'm13.17 20.245 2.028-7.23h1.65l-.532 2.84-2.028 6.914h-1.38zm-1.028-7.23 1.452 7.221.135 2.533h-1.623l-2.47-9.753h2.506Zm6.563 7.104 1.415-7.103h2.515l-2.47 9.753h-1.613zm-1.632-7.103 2.02 7.175.279 2.578h-1.388l-2.029-6.905-.513-2.848z',
    }),
  );
const ForwardRef$1M = forwardRef(SvgFileWord);
const SvgFileZip = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M2 1.23C2 .552 2.551 0 3.23 0h15.755c.326 0 .64.13.87.36l9.846 9.847c.23.23.36.543.36.87v19.692c0 .68-.55 1.231-1.23 1.231H3.23A1.23 1.23 0 0 1 2 30.77zm2.462 1.232v27.076H27.6V11.587l-9.125-9.125z',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      d: 'M20.228 20.741v2.028h-7.41v-2.028zm-.144-6.229-6.22 8.257h-1.74v-1.541l6.193-8.212h1.767zm-.92-1.496v2.037H12.27v-2.037h6.896Z',
    }),
  );
const ForwardRef$1L = forwardRef(SvgFileZip);
const SvgFilter = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      d: 'M-.333 3.667v2.666h32.666V3.667zm4 8v2.666h24.666v-2.666zm4 8h16.666v2.666H7.667zm4 8v2.666h8.666v-2.666z',
    }),
  );
const ForwardRef$1K = forwardRef(SvgFilter);
const SvgFitWindow = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M0 0h10v2.667H2.667V10H0zm22 0h10v10h-2.667V2.667H22zm10 22v10H22v-2.667h7.333V22zM2.667 22v7.333H10V32H0V22zM7.333 7.333h17.334v17.334H7.333zM10 10v12h12V10z',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$1J = forwardRef(SvgFitWindow);
const SvgFlag = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M5.333 0v32H2.667V0zM8 .583l21.484 9.915L8 23.72zm2.667 4.168v14.196l13.182-8.112L10.667 4.75Z',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$1I = forwardRef(SvgFlag);
const SvgFolderHistory = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M0 2.564c0-.68.551-1.23 1.23-1.23h9.847c.411 0 .796.205 1.024.547l3.573 5.36H30.77c.68 0 1.231.551 1.231 1.23v16.74a4.185 4.185 0 0 1-4.185 4.184H4.185A4.185 4.185 0 0 1 0 25.21zm2.462 1.23V25.21a1.723 1.723 0 0 0 1.723 1.723h23.63a1.723 1.723 0 0 0 1.723-1.723V9.703H15.015a1.23 1.23 0 0 1-1.024-.548l-3.573-5.36z',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$1H = forwardRef(SvgFolderHistory);
const SvgForward2 = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      d: 'm27.18 15.098-9.318-9.317L19.642 4 32 16.357 19.643 28.715l-1.781-1.78 9.318-9.318H0v-2.519z',
    }),
  );
const ForwardRef$1G = forwardRef(SvgForward2);
const SvgForward = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', { d: 'M4.5 31V1H2v30z' }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M30 16 8 1v30zm-4.23 0L10.538 26.385V5.615L25.769 16Z',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$1F = forwardRef(SvgForward);
const SvgFullscreen = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M20.364 0H32v11.636h-2.91v-6.67l-7.698 7.699-2.057-2.057 7.699-7.699h-6.67zM4.966 29.09h6.67V32H0V20.364h2.91v6.67l7.698-7.699 2.057 2.057-7.699 7.699Zm22.068 0-7.699-7.698 2.057-2.057 7.699 7.699v-6.67H32V32H20.364v-2.91zM11.636 2.91h-6.67l7.699 7.698-2.057 2.057-7.699-7.699v6.67H0V0h11.636z',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$1E = forwardRef(SvgFullscreen);
const SvgGlobe = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M14.667 30.667V1.333h2.666v29.334z',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M30.667 17.333H1.333v-2.666h29.334z',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M12.007 6.225C10.791 8.658 10 12.112 10 16s.79 7.342 2.007 9.775c1.256 2.512 2.745 3.558 3.993 3.558s2.737-1.046 3.993-3.558C21.209 23.342 22 19.888 22 16s-.79-7.342-2.007-9.775C18.737 3.713 17.248 2.667 16 2.667s-2.737 1.046-3.993 3.558M9.622 5.033C11.02 2.237 13.198 0 16 0s4.98 2.237 6.378 5.033c1.438 2.875 2.289 6.755 2.289 10.967s-.851 8.091-2.289 10.967C20.98 29.763 18.802 32 16 32s-4.98-2.237-6.378-5.033C8.184 24.092 7.333 20.212 7.333 16s.851-8.092 2.289-10.967',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M16 2.667C8.636 2.667 2.667 8.637 2.667 16S8.637 29.333 16 29.333 29.333 23.363 29.333 16 23.363 2.667 16 2.667M0 16C0 7.163 7.163 0 16 0s16 7.163 16 16-7.163 16-16 16S0 24.837 0 16',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$1D = forwardRef(SvgGlobe);
const SvgHeart = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'm13.333 8.02 5.334 8 1.953-2.93H32v2.667h-9.953l-3.38 5.07-5.334-8-1.953 2.93H0V13.09h9.953z',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'm6.935 16.824.8 1.067A77 77 0 0 0 16 27.253a77 77 0 0 0 8.266-9.362l.799-1.067L27.2 18.42l-.8 1.068a80 80 0 0 1-9.49 10.576l-.91.848-.91-.848A80 80 0 0 1 5.6 19.49l-.8-1.068zM22.06 1.09a8.61 8.61 0 0 1 8.607 8.565l.007 1.333-2.667.014L28 9.67a5.944 5.944 0 0 0-5.936-5.912 6.03 6.03 0 0 0-4.957 2.667L16 8.072l-1.107-1.648a6.03 6.03 0 0 0-4.957-2.667A5.944 5.944 0 0 0 4 9.669l-.007 1.333-2.667-.014.007-1.333A8.61 8.61 0 0 1 9.94 1.09h.01A8.7 8.7 0 0 1 16 3.6a8.7 8.7 0 0 1 6.05-2.51z',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$1C = forwardRef(SvgHeart);
const SvgHelp2 = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M16 2.667C8.636 2.667 2.667 8.637 2.667 16S8.637 29.333 16 29.333 29.333 23.363 29.333 16 23.363 2.667 16 2.667M0 16C0 7.163 7.163 0 16 0s16 7.163 16 16-7.163 16-16 16S0 24.837 0 16',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      d: 'M16 25.333a1.333 1.333 0 1 0 0-2.666 1.333 1.333 0 0 0 0 2.666',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M17.177 9.359c-1.088-.102-2.375.11-3.5.607l-1.22.54-1.078-2.44 1.22-.539c1.513-.669 3.255-.97 4.827-.823 1.539.144 3.175.756 4.068 2.202 1.672 2.705.322 5.605-1.91 7.497-2.025 1.715-2.25 2.273-2.25 2.93v1.334h-2.667v-1.334c0-2.01 1.216-3.29 3.192-4.965 1.767-1.497 2.028-2.99 1.367-4.06-.274-.443-.929-.844-2.05-.95Z',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$1B = forwardRef(SvgHelp2);
const SvgHelp = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      d: 'M15.333 0H15.3c-2.786.07-5.513.814-7.948 2.168l-1.165.648 1.296 2.33L8.648 4.5a14.6 14.6 0 0 1 6.702-1.832c2.074.003 3.547.594 4.49 1.474.937.875 1.493 2.165 1.493 3.859 0 2.647-1.49 3.95-3.52 5.642l-.088.074c-1.956 1.629-4.392 3.657-4.392 7.617v1.334H16v-1.334c0-2.647 1.49-3.95 3.52-5.642l.089-.074C21.564 13.99 24 11.96 24 8c0-2.306-.777-4.349-2.34-5.808C20.106.742 17.917 0 15.333 0m1.999 28a2.667 2.667 0 1 1-5.333 0 2.667 2.667 0 0 1 5.333 0',
    }),
  );
const ForwardRef$1A = forwardRef(SvgHelp);
const SvgHide = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M2.922 15.189a1.42 1.42 0 0 0 0 1.622c1.008 1.427 2.737 3.586 5.014 5.377 2.28 1.794 5.014 3.145 8.064 3.145s5.784-1.351 8.064-3.145c2.276-1.791 4.006-3.95 5.014-5.377a1.42 1.42 0 0 0 0-1.622c-1.008-1.428-2.738-3.586-5.014-5.377C21.784 8.018 19.05 6.667 16 6.667s-5.784 1.351-8.064 3.145c-2.277 1.791-4.006 3.95-5.014 5.377m3.365-7.472C8.84 5.708 12.142 4 16 4s7.16 1.708 9.713 3.717c2.555 2.01 4.456 4.394 5.545 5.936l.004.005a4.09 4.09 0 0 1 0 4.684l-.004.005c-1.089 1.541-2.99 3.926-5.545 5.936C23.16 26.292 19.858 28 16 28s-7.16-1.708-9.713-3.717C3.73 22.273 1.83 19.888.74 18.347l-.003-.006a4.085 4.085 0 0 1 0-4.683l.003-.005c1.09-1.542 2.99-3.926 5.546-5.936Z',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M16 12a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-6.667 4a6.667 6.667 0 1 1 13.334 0 6.667 6.667 0 0 1-13.334 0',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M31.219 2.667 2.667 31.219.78 29.333 29.333.781z',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$1z = forwardRef(SvgHide);
const SvgHistorical = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M20.684 3.51A13.33 13.33 0 0 0 6.196 6.956L11.5 5.48l.715 2.569-10.804 3.01L2.798.018 5.444.35l-.515 4.091a15.998 15.998 0 0 1 25.216 4.074A16 16 0 1 1 0 16.001l2.667-.002A13.333 13.333 0 1 0 20.684 3.51M17.334 8v7.448l5.885 5.885-1.886 1.886-6.666-6.667V8z',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$1y = forwardRef(SvgHistorical);
const SvgHome = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M15.797-.003 31.13 13.14l-1.713 1.998-13.62-11.674L2.178 15.137.466 13.14zM11.85 21.094h7.895v9.587h-2.632v-6.955h-2.631v6.955H11.85z',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M6.586 15.58v13.785h18.423V15.58h2.632v16.418H3.954V15.58z',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$1x = forwardRef(SvgHome);
const SvgImage = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M20.057 12.24a1.343 1.343 0 0 1 1.9 0l9.77 9.77a1.343 1.343 0 1 1-1.9 1.9l-8.82-8.82-8.821 8.82a1.343 1.343 0 0 1-1.9 0l-2.959-2.957-4.912 4.912a1.343 1.343 0 1 1-1.9-1.9l5.862-5.863a1.343 1.343 0 0 1 1.9 0l2.959 2.959 8.82-8.821Z',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M4.396 2.808a1.59 1.59 0 0 0-1.588 1.588v23.45a1.59 1.59 0 0 0 1.588 1.588h23.45a1.59 1.59 0 0 0 1.588-1.588V4.396a1.59 1.59 0 0 0-1.588-1.588zm23.45 29.313H4.396a4.275 4.275 0 0 1-4.275-4.275V4.396A4.275 4.275 0 0 1 4.396.121h23.45a4.275 4.275 0 0 1 4.275 4.275v23.45a4.275 4.275 0 0 1-4.275 4.275',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M10.259 8.67a1.588 1.588 0 1 0 0 3.176 1.588 1.588 0 0 0 0-3.175Zm-4.275 1.59a4.275 4.275 0 1 1 8.55 0 4.275 4.275 0 0 1-8.55 0',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$1w = forwardRef(SvgImage);
const SvgImaging = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M22.186 27.811 17.5 19.655l2.313-1.329 5.972 10.396-1.057.688a16 16 0 0 1-17.452.002l-1.058-.688 5.97-10.397 2.312 1.327-4.684 8.159a13.34 13.34 0 0 0 12.37-.002m-.061-26.646 1.125.572a16 16 0 0 1 8.727 15.113l-.067 1.26-11.989.029-.006-2.667 9.407-.023a13.34 13.34 0 0 0-6.186-10.712l-4.721 8.136-2.307-1.338zm-12.25 0 6.017 10.37-2.307 1.338-4.72-8.136a13.34 13.34 0 0 0-6.187 10.712l9.407.023-.006 2.667-11.99-.03-.066-1.26A16 16 0 0 1 8.75 1.738z',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M16 13.333a2.667 2.667 0 1 0 0 5.334 2.667 2.667 0 0 0 0-5.334M10.667 16a5.333 5.333 0 1 1 10.666 0 5.333 5.333 0 0 1-10.666 0',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$1v = forwardRef(SvgImaging);
const SvgImport = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M32 16c0 .803-.651 1.454-1.454 1.454H9.212a1.455 1.455 0 1 1 0-2.909h21.334c.803 0 1.454.652 1.454 1.455',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M18.968 6.244a1.455 1.455 0 0 1 0 2.057L11.269 16l7.699 7.699a1.455 1.455 0 0 1-2.057 2.057l-8.727-8.727a1.455 1.455 0 0 1 0-2.057l8.727-8.728a1.455 1.455 0 0 1 2.057 0M1.455 0c.803 0 1.454.651 1.454 1.455v29.09a1.455 1.455 0 0 1-2.909 0V1.456C0 .65.651 0 1.455 0',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$1u = forwardRef(SvgImport);
const SvgInProgress = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M2.667 0h26.666v2.667H2.667zm0 29.333h26.666V32H2.667z',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      d: 'M10.667 26.667v-1.052c0-.263.077-.52.222-.738l4-6a1.333 1.333 0 0 1 2.219 0l4 6c.146.22.224.477.224.74v1.05z',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M8 1.333v5.052a4 4 0 0 0 .672 2.22L13.602 16l-4.93 7.396A4 4 0 0 0 8 25.615v5.052H5.333v-5.052c0-1.317.39-2.603 1.12-3.699L10.398 16l-3.945-5.916a6.67 6.67 0 0 1-1.12-3.699V1.333zm16 5.052V1.333h2.667v5.052c0 1.317-.39 2.603-1.12 3.699L21.602 16l3.945 5.916a6.67 6.67 0 0 1 1.12 3.699v5.052H24v-5.052a4 4 0 0 0-.672-2.22L18.398 16l4.93-7.396A4 4 0 0 0 24 6.385',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$1t = forwardRef(SvgInProgress);
const SvgInbox = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M8.763 20.25H1.33v-2.661h10.093v4.381h9.022v-4.381H30.54v2.66h-7.433v4.382H8.763z',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M4.251 2.724a1.59 1.59 0 0 0-1.59 1.59v23.368a1.59 1.59 0 0 0 1.59 1.59H27.62a1.59 1.59 0 0 0 1.59-1.59V4.315a1.59 1.59 0 0 0-1.59-1.59h-5.712V.062h5.712a4.25 4.25 0 0 1 4.251 4.252v23.367a4.25 4.25 0 0 1-4.251 4.251H4.25A4.25 4.25 0 0 1 0 27.682V4.315A4.25 4.25 0 0 1 4.251.063h5.712v2.661z',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M14.604 14.538V-.067h2.662v14.605z',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'm10.093 6.814 5.842 5.842 5.842-5.842 1.882 1.882-7.724 7.723-7.723-7.723z',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$1s = forwardRef(SvgInbox);
const SvgInfo2 = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M16 2.667C8.636 2.667 2.667 8.637 2.667 16S8.637 29.333 16 29.333 29.333 23.363 29.333 16 23.363 2.667 16 2.667M0 16C0 7.163 7.163 0 16 0s16 7.163 16 16-7.163 16-16 16S0 24.837 0 16',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M17.333 13.333V24h-2.666V13.333z',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      d: 'M16 10.667A1.333 1.333 0 1 0 16 8a1.333 1.333 0 0 0 0 2.667',
    }),
  );
const ForwardRef$1r = forwardRef(SvgInfo2);
const SvgInfo = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M17.333 12v16h-2.666V12zm-4-6.667a2.667 2.667 0 1 1 5.334 0 2.667 2.667 0 0 1-5.334 0',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      d: 'M16 6.667A1.333 1.333 0 1 0 16 4a1.333 1.333 0 0 0 0 2.667',
    }),
  );
const ForwardRef$1q = forwardRef(SvgInfo);
const SvgInverse = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      d: 'm12.552 10.667-4 4h6.955v2.666H8.552l4 4-1.885 1.886L3.447 16l7.22-7.219z',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M0 4a4 4 0 0 1 4-4h24a4 4 0 0 1 4 4v24a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4zm28.552 12-7.219-7.219-1.885 1.886 4 4h-6.781v2.666h6.78l-4 4 1.886 1.886L28.553 16ZM4 2.667h11.507v26.666H4A1.333 1.333 0 0 1 2.667 28V4c0-.736.597-1.333 1.333-1.333',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$1p = forwardRef(SvgInverse);
const SvgLaugh = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M16 2.667C8.636 2.667 2.667 8.637 2.667 16S8.637 29.333 16 29.333 29.333 23.363 29.333 16 23.363 2.667 16 2.667M0 16C0 7.163 7.163 0 16 0s16 7.163 16 16-7.163 16-16 16S0 24.837 0 16',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M6.667 16h18.666v1.333a9.333 9.333 0 1 1-18.666 0zm2.801 2.667a6.667 6.667 0 0 0 13.064 0zm9.037-9.495A4 4 0 0 1 25.333 12v1.333h-2.666V12A1.333 1.333 0 1 0 20 12v1.333h-2.667V12a4 4 0 0 1 1.172-2.828m-10.667 0A4 4 0 0 1 14.667 12v1.333H12V12a1.333 1.333 0 0 0-2.667 0v1.333H6.667V12a4 4 0 0 1 1.171-2.828',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$1o = forwardRef(SvgLaugh);
const SvgLibrary = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M0 28.485h32v2.909H0v-2.91ZM0 2.788c0-.803.651-1.455 1.455-1.455h5.818c.803 0 1.454.652 1.454 1.455V24.12c0 .804-.65 1.455-1.454 1.455H1.455A1.455 1.455 0 0 1 0 24.12zm2.91 1.454v18.425h2.908V4.242zm6.787-1.454c0-.803.652-1.455 1.455-1.455h5.818c.803 0 1.455.652 1.455 1.455V24.12c0 .804-.652 1.455-1.455 1.455h-5.818a1.455 1.455 0 0 1-1.455-1.455zm2.91 1.454v18.425h2.909V4.242h-2.91Z',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M15.693 5.531a1.455 1.455 0 0 1 .799-1.896l5.389-2.194a1.455 1.455 0 0 1 1.895.799l8.046 19.758a1.455 1.455 0 0 1-.799 1.895l-5.388 2.195a1.455 1.455 0 0 1-1.896-.799zm3.243.25 6.949 17.064 2.694-1.097L21.63 4.684l-2.695 1.097Z',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$1n = forwardRef(SvgLibrary);
const SvgLink = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'm19.247 4.372-4.714 4.714L12.648 7.2l4.73-4.73a8.683 8.683 0 0 1 12.13 0l-.931.953.954-.931a8.683 8.683 0 0 1 0 12.13l-.011.011-4.72 4.72-1.885-1.886 4.713-4.714a6.016 6.016 0 0 0 .006-8.387 6.016 6.016 0 0 0-8.387.006M9.086 14.533l-4.714 4.714a6.016 6.016 0 0 0-.006 8.387 6.016 6.016 0 0 0 8.387-.006l4.714-4.713 1.885 1.885-4.73 4.731a8.683 8.683 0 0 1-12.13 0l.931-.954-.954.931a8.683 8.683 0 0 1 0-12.13l.011-.01 4.72-4.72z',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'm23.752 10.133-13.619 13.62-1.885-1.886 13.619-13.62z',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$1m = forwardRef(SvgLink);
const SvgList = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      d: 'M2.667 14c-1.107 0-2 .893-2 2s.893 2 2 2 2-.893 2-2-.894-2-2-2m0-8c-1.107 0-2 .893-2 2s.893 2 2 2 2-.893 2-2-.894-2-2-2m0 16c-1.107 0-2 .907-2 2s.906 2 2 2 2-.907 2-2-.894-2-2-2M8 25.333h23.333v-2.666H8zm0-8h23.333v-2.666H8zM8 6.667v2.666h23.333V6.667z',
    }),
  );
const ForwardRef$1l = forwardRef(SvgList);
const SvgLockPrivate = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M10.685 8.262c0-3.203 2.5-5.702 5.701-5.702 3.202 0 5.7 2.499 5.7 5.702v3.21a11 11 0 0 0-5.7-1.581 11 11 0 0 0-5.7 1.582zM8.125 13.6V8.26C8.125 3.646 11.77 0 16.386 0s8.26 3.645 8.26 8.262V13.6a11 11 0 0 1 2.793 7.344C27.439 27.05 22.49 32 16.386 32S5.333 27.05 5.333 20.945a11 11 0 0 1 2.792-7.344Zm-.232 7.344a8.494 8.494 0 1 1 16.986 0 8.494 8.494 0 1 1-16.986 0m8.493-2.909a1.513 1.513 0 0 0-.016 3.026h.033a1.513 1.513 0 0 0-.017-3.026m1.28 5.38a4.074 4.074 0 0 0-1.28-7.94 4.072 4.072 0 0 0-1.28 7.94v2.998h2.56v-2.997Z',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$1k = forwardRef(SvgLockPrivate);
const SvgMeasure = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M22.293 1.293a1 1 0 0 1 1.414 0l7 7a1 1 0 0 1 0 1.414l-21 21a1 1 0 0 1-1.414 0l-7-7a1 1 0 0 1 0-1.414zM3.414 23 9 28.586 28.586 9 23 3.414l-2.396 2.397 1.853 1.853-1.414 1.414-1.854-1.853-3.085 3.086.853.853-1.414 1.415-.854-.854-2.585 2.586 1.853 1.853-1.414 1.414-1.854-1.853-3.085 3.086.853.853-1.414 1.414-.854-.853z',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$1j = forwardRef(SvgMeasure);
const SvgMedicine = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M24.009 2.079a2.06 2.06 0 0 0-2.058 1.016l-6.852 11.87-1.788-1.031 6.851-11.87a4.13 4.13 0 1 1 7.156 4.129l-5.068 8.773-1.788-1.032L25.53 5.16a2.064 2.064 0 0 0-.757-2.821 2.1 2.1 0 0 0-.764-.26',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M0 13.418h30.965v1.032a15.47 15.47 0 0 1-7.225 13.085v4.462H7.225v-4.462A15.47 15.47 0 0 1 0 14.45zm28.861 2.064H2.104a13.4 13.4 0 0 0 6.669 10.575l.517.298v3.578h12.386v-3.578l.516-.298a13.4 13.4 0 0 0 6.669-10.575',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M16.515 17.546v8.258H14.45v-8.258z',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M11.354 20.643h8.257v2.064h-8.257z',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$1i = forwardRef(SvgMedicine);
const SvgMenu = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M32 5.333H0V8h32zM0 14.667h32v2.666H0zM0 24h32v2.667H0z',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$1h = forwardRef(SvgMenu);
const SvgMicrochip = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M11-.333c.736 0 1.333.597 1.333 1.333v4a1.333 1.333 0 0 1-2.666 0V1c0-.736.597-1.333 1.333-1.333m10 0c.736 0 1.333.597 1.333 1.333v4a1.333 1.333 0 0 1-2.666 0V1c0-.736.597-1.333 1.333-1.333M25.667 21c0-.736.597-1.333 1.333-1.333h4a1.333 1.333 0 1 1 0 2.666h-4A1.333 1.333 0 0 1 25.667 21m0-10c0-.736.597-1.333 1.333-1.333h4a1.333 1.333 0 1 1 0 2.666h-4A1.333 1.333 0 0 1 25.667 11m-26 10c0-.736.597-1.333 1.333-1.333h4a1.333 1.333 0 1 1 0 2.666H1A1.333 1.333 0 0 1-.333 21m0-10c0-.736.597-1.333 1.333-1.333h4a1.333 1.333 0 1 1 0 2.666H1A1.333 1.333 0 0 1-.333 11M11 25.667c.736 0 1.333.597 1.333 1.333v4a1.333 1.333 0 0 1-2.666 0v-4c0-.736.597-1.333 1.333-1.333m10 0c.736 0 1.333.597 1.333 1.333v4a1.333 1.333 0 0 1-2.666 0v-4c0-.736.597-1.333 1.333-1.333',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M7.2 6.333a.867.867 0 0 0-.867.867v17.6c0 .479.388.867.867.867h17.6a.867.867 0 0 0 .867-.867V7.2a.867.867 0 0 0-.867-.867zM3.667 7.2A3.533 3.533 0 0 1 7.2 3.667h17.6A3.533 3.533 0 0 1 28.333 7.2v17.6a3.533 3.533 0 0 1-3.533 3.533H7.2A3.533 3.533 0 0 1 3.667 24.8z',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M20.333 11.667h-8.666v8.666h8.666zM23 9v14H9V9z',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$1g = forwardRef(SvgMicrochip);
const SvgMicrophoneOff = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      d: 'm17.6 18.4.77 2.55a7.76 7.76 0 0 0 3.29-1.97c.92-.92 1.59-2.05 1.97-3.29l-2.55-.77c-.25.82-.69 1.57-1.3 2.17-.61.61-1.35 1.05-2.17 1.3Z',
    }),
    /* @__PURE__ */ React.createElement('path', {
      d: 'M25.44 18.22c-.76 1.5-1.85 2.79-3.19 3.75a9.65 9.65 0 0 1-4.49 1.75c-1.61.19-3.24-.03-4.75-.66L12 25.74c.86.36 1.76.59 2.67.74v2.85H8V32h16v-2.67h-6.67v-2.71c.24-.01.49-.01.73-.04a12.3 12.3 0 0 0 5.73-2.23c1.71-1.22 3.11-2.87 4.07-4.79s1.47-4.06 1.46-6.23h-2.75c0 1.71-.39 3.38-1.15 4.88ZM28 2.11l-4.18 4.18c-.1-.46-.23-.92-.41-1.36a8 8 0 0 0-1.73-2.61A7.7 7.7 0 0 0 19.07.59 8.1 8.1 0 0 0 16 0a8.1 8.1 0 0 0-3.07.59c-.98.4-1.86.99-2.61 1.73a7.9 7.9 0 0 0-1.74 2.61c-.39.96-.59 2-.59 3.04v5.36c0 1.44.38 2.86 1.12 4.09a8 8 0 0 0 1.64 1.93l-1.9 1.9c-.97-.87-1.77-1.91-2.37-3.07-.76-1.5-1.16-3.16-1.15-4.85H2.66c0 2.1.49 4.18 1.44 6.06.72 1.42 1.69 2.69 2.85 3.75L2.1 27.99l1.89 1.89L29.89 4zM11.41 16.06c-.49-.82-.75-1.76-.74-2.72V8c0-1.41.56-2.77 1.56-3.77a5.337 5.337 0 0 1 7.54 0c1 1 1.56 2.36 1.56 3.77v.78l-8.68 8.68a5.1 5.1 0 0 1-1.24-1.41Z',
    }),
  );
const ForwardRef$1f = forwardRef(SvgMicrophoneOff);
const SvgMicrophone = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M16 2.667A5.334 5.334 0 0 0 10.667 8v5.333a5.334 5.334 0 0 0 10.666 0V8A5.334 5.334 0 0 0 16 2.667M8 8a8 8 0 0 1 16 0v5.333a8 8 0 0 1-16 0z',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M5.333 12v1.333C5.333 19.225 10.108 24 16 24s10.667-4.775 10.667-10.667V12h2.666v1.333c0 7.365-5.969 13.334-13.333 13.334S2.667 20.697 2.667 13.333V12z',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M17.333 24v8h-2.666v-8z',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$1e = forwardRef(SvgMicrophone);
const SvgMicroscope = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      d: 'm14.89 21.154 10.929-6.312 1.335 2.312-10.928 6.312z',
    }),
    /* @__PURE__ */ React.createElement('path', {
      d: 'M16 29.33V28c0-1.77-.7-3.47-1.95-4.72a6.67 6.67 0 0 0-4.71-1.95c-.7 0-1.38.14-2.03.35l-.74-1.18-.02-.03c-.52-.74-.88-1.58-1.07-2.47-.18-.89-.19-1.8 0-2.69.18-.89.54-1.73 1.06-2.47.51-.74 1.17-1.36 1.94-1.84l2.12-1.23 3.33 5.77 2.16-1.25 1.48 2.56 2.31-1.33-1.48-2.56 2.45-1.42L14.18 0 7.25 4l2 3.47-2.16 1.25h-.02a9.6 9.6 0 0 0-2.74 2.6 9.4 9.4 0 0 0-1.49 3.46 9.6 9.6 0 0 0 0 3.77c.26 1.23.76 2.4 1.48 3.43l.64 1.01c-.12.1-.25.18-.36.29A6.68 6.68 0 0 0 2.65 28v4h26.67v-2.67H15.99ZM13.2 3.64l4 6.93-2.31 1.33-4-6.93zm.13 25.69h-8V28c0-1.06.42-2.08 1.17-2.83a4.004 4.004 0 0 1 5.66 0c.75.75 1.17 1.77 1.17 2.83z',
    }),
  );
const ForwardRef$1d = forwardRef(SvgMicroscope);
const SvgMinus = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M0 14.667h32v2.666H0z',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$1c = forwardRef(SvgMinus);
const SvgMobile = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M8 2.667A1.333 1.333 0 0 0 6.667 4v24A1.333 1.333 0 0 0 8 29.333h16A1.333 1.333 0 0 0 25.333 28V4A1.333 1.333 0 0 0 24 2.667zM5.172 1.172A4 4 0 0 1 8 0h16a4 4 0 0 1 4 4v24a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4V4a4 4 0 0 1 1.172-2.828',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M8 6.667a2.667 2.667 0 1 1 5.333 0 2.667 2.667 0 0 1-5.333 0',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$1b = forwardRef(SvgMobile);
const SvgMoney = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M0 0h26.667v12.228H24V2.667H2.667V16h6.666v2.667H0z',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M13.333 21.333V16H16v5.333c0 .328.3.983 1.606 1.636 1.226.613 3.013 1.031 5.06 1.031 2.048 0 3.835-.418 5.061-1.03 1.306-.654 1.606-1.309 1.606-1.637V16H32v5.333c0 1.882-1.49 3.227-3.08 4.021-1.67.835-3.882 1.313-6.253 1.313s-4.584-.478-6.254-1.313c-1.59-.794-3.08-2.139-3.08-4.02Z',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M13.333 26.667v-5.334H16v5.334c0 .327.3.983 1.606 1.636 1.226.613 3.013 1.03 5.06 1.03 2.048 0 3.835-.417 5.061-1.03 1.306-.653 1.606-1.309 1.606-1.636v-5.334H32v5.334c0 1.881-1.49 3.226-3.08 4.02-1.67.835-3.882 1.313-6.253 1.313s-4.584-.478-6.254-1.312c-1.59-.795-3.08-2.14-3.08-4.021m4.273-12.303C16.3 15.017 16 15.672 16 16s.3.983 1.606 1.636c1.226.613 3.014 1.03 5.06 1.03 2.048 0 3.835-.417 5.061-1.03 1.306-.653 1.606-1.308 1.606-1.636s-.3-.983-1.606-1.636c-1.226-.613-3.013-1.03-5.06-1.03s-3.835.417-5.06 1.03Zm-1.193-2.385c1.67-.835 3.882-1.312 6.254-1.312 2.37 0 4.584.477 6.253 1.312C30.51 12.774 32 14.119 32 16c0 1.882-1.49 3.226-3.08 4.021-1.67.835-3.882 1.312-6.253 1.312s-4.584-.477-6.254-1.312c-1.589-.795-3.08-2.14-3.08-4.021 0-1.882 1.491-3.226 3.08-4.021m-5.746-2.646a2.667 2.667 0 1 1 5.333 0 2.667 2.667 0 0 1-5.333 0',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      d: 'M13.333 10.667a1.333 1.333 0 1 0 0-2.667 1.333 1.333 0 0 0 0 2.667',
    }),
  );
const ForwardRef$1a = forwardRef(SvgMoney);
const SvgMoon = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'm14.29-.059-.881 2.35c-.365.973-.505 2.122-.505 3.361 0 7.359 6.026 13.385 13.385 13.385 1.24 0 2.388-.14 3.361-.504l2.35-.881-.622 2.431c-1.764 6.896-8.015 11.858-15.375 11.858C7.198 31.941 0 24.743 0 15.938 0 8.578 4.962 2.328 11.858.563zm-3.906 3.902C5.77 5.92 2.618 10.568 2.618 15.938c0 7.359 6.027 13.385 13.385 13.385 5.37 0 10.019-3.153 12.095-7.765-.608.07-1.216.098-1.809.098-8.805 0-16.003-7.199-16.003-16.004 0-.592.027-1.2.098-1.809',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$19 = forwardRef(SvgMoon);
const SvgMore2 = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      d: 'M16 10.667c1.467 0 2.667-1.2 2.667-2.667S17.467 5.333 16 5.333A2.675 2.675 0 0 0 13.333 8c0 1.467 1.2 2.667 2.667 2.667m0 2.666A2.675 2.675 0 0 0 13.333 16c0 1.467 1.2 2.667 2.667 2.667s2.667-1.2 2.667-2.667-1.2-2.667-2.667-2.667m0 8A2.675 2.675 0 0 0 13.333 24c0 1.467 1.2 2.667 2.667 2.667s2.667-1.2 2.667-2.667-1.2-2.667-2.667-2.667',
    }),
  );
const ForwardRef$18 = forwardRef(SvgMore2);
const SvgMore = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      d: 'M8 13.333A2.675 2.675 0 0 0 5.333 16c0 1.467 1.2 2.667 2.667 2.667s2.667-1.2 2.667-2.667-1.2-2.667-2.667-2.667m16 0A2.675 2.675 0 0 0 21.333 16c0 1.467 1.2 2.667 2.667 2.667s2.667-1.2 2.667-2.667-1.2-2.667-2.667-2.667m-8 0A2.675 2.675 0 0 0 13.333 16c0 1.467 1.2 2.667 2.667 2.667s2.667-1.2 2.667-2.667-1.2-2.667-2.667-2.667',
    }),
  );
const ForwardRef$17 = forwardRef(SvgMore);
const SvgNext = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M9.333.781 24.553 16 9.332 31.219l-1.885-1.886L20.78 16 7.448 2.667 9.333.78Z',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$16 = forwardRef(SvgNext);
const SvgOpenNewWindow = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M31.61 2.276 15.476 18.41l-1.886-1.886L29.724.39z',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M17.6 0H32v14.4h-2.667V2.667H17.6zM1.25 4.183c.8-.8 1.885-1.25 3.017-1.25h8.666V5.6H4.267a1.6 1.6 0 0 0-1.6 1.6v20.533a1.6 1.6 0 0 0 1.6 1.6H24.8a1.6 1.6 0 0 0 1.6-1.6v-8.666h2.667v8.666A4.267 4.267 0 0 1 24.8 32H4.267A4.266 4.266 0 0 1 0 27.733V7.2c0-1.132.45-2.217 1.25-3.017',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$15 = forwardRef(SvgOpenNewWindow);
const SvgOwner = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M3.937 19.478c2.557-.844 6.469-1.823 10.9-1.823v2.575c-4.053 0-7.67.899-10.059 1.687a3.12 3.12 0 0 0-2.149 2.958v4.55h13.71L16.34 32H1.315v-1.287V32H0v-7.125c0-2.432 1.57-4.613 3.937-5.397',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M14.838 2.575c-3.423 0-6.198 2.718-6.198 6.069v1.47c0 1.712.72 3.645 1.92 5.144 1.204 1.504 2.738 2.397 4.278 2.397s3.073-.893 4.277-2.397c1.2-1.5 1.92-3.432 1.92-5.143V8.644c0-3.351-2.775-6.07-6.197-6.07ZM6.01 8.644C6.01 3.87 9.963 0 14.838 0c4.874 0 8.827 3.87 8.827 8.644v1.47c0 2.352-.96 4.833-2.48 6.732-1.516 1.894-3.738 3.384-6.347 3.384s-4.832-1.49-6.347-3.384c-1.52-1.899-2.48-4.38-2.48-6.731z',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      d: 'M20.649 23.018a1.4 1.4 0 0 0-.57.018c-.187.045-.36.126-.51.239s-.27.254-.355.414-.131.336-.136.514c-.053.382.043.768.27 1.09.226.323.57.56.968.668a1.42 1.42 0 0 0 1.08-.257c.15-.113.27-.254.355-.414s.13-.336.136-.514a1.52 1.52 0 0 0-.27-1.091 1.74 1.74 0 0 0-.968-.667m9.766 0c.19-.032.384-.026.57.018.187.045.36.126.51.239s.27.254.355.414.131.336.136.514c.053.382-.043.768-.27 1.09s-.57.56-.968.668a1.4 1.4 0 0 1-.57-.019 1.4 1.4 0 0 1-.51-.238 1.25 1.25 0 0 1-.355-.414 1.2 1.2 0 0 1-.136-.514 1.52 1.52 0 0 1 .27-1.091c.227-.322.57-.559.968-.667m-6.939-2.998a1.4 1.4 0 0 0-.57.019c-.186.044-.36.125-.51.238-.149.112-.27.254-.355.414s-.13.336-.135.514c-.053.382.042.769.27 1.09.226.323.57.56.968.668a1.42 1.42 0 0 0 1.08-.257c.149-.112.27-.254.355-.414s.13-.336.135-.514a1.52 1.52 0 0 0-.27-1.09 1.74 1.74 0 0 0-.968-.668m4.111 0a1.42 1.42 0 0 1 1.08.257c.15.112.27.254.355.414s.131.336.136.514c.053.382-.043.769-.27 1.09a1.73 1.73 0 0 1-.968.668 1.4 1.4 0 0 1-.57-.019 1.4 1.4 0 0 1-.51-.238 1.26 1.26 0 0 1-.355-.414 1.16 1.16 0 0 1-.136-.514 1.52 1.52 0 0 1 .27-1.09c.227-.323.57-.56.968-.668m-2.055 4.47c-2.424 0-4.444 2.997-4.444 5.246 0 .596.256 1.168.71 1.59a2.52 2.52 0 0 0 1.714.658c1.014 0 1.212-.75 2.02-.75s.68.75 2.02.75c.643 0 1.259-.237 1.713-.659.455-.421.71-.993.71-1.59 0-2.248-2.02-5.246-4.443-5.246Z',
    }),
  );
const ForwardRef$14 = forwardRef(SvgOwner);
const SvgPanelLeftClose = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M4.267 4.333c-.926 0-1.6.674-1.6 1.6V25.49c0 .926.674 1.6 1.6 1.6h4.337V4.333zm7.004 0V27.09h16.462c.926 0 1.6-.674 1.6-1.6V5.933c0-.926-.674-1.6-1.6-1.6zM0 5.933c0-2.398 1.868-4.266 4.267-4.266h23.466C30.132 1.667 32 3.535 32 5.933V25.49c0 2.398-1.868 4.267-4.267 4.267H4.267C1.868 29.756 0 27.887 0 25.489zm21.699 4.89-3.556 3.555h7.537v2.666h-7.537L21.7 20.6l-1.886 1.886-6.774-6.775 6.774-6.774z',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$13 = forwardRef(SvgPanelLeftClose);
const SvgPanelLeftOpen = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M4.267 4.333c-.926 0-1.6.674-1.6 1.6V25.49c0 .926.674 1.6 1.6 1.6h4.337V4.333zm7.004 0V27.09h16.462c.926 0 1.6-.674 1.6-1.6V5.933c0-.926-.674-1.6-1.6-1.6zM0 5.933c0-2.398 1.868-4.266 4.267-4.266h23.466C30.132 1.667 32 3.535 32 5.933V25.49c0 2.398-1.868 4.267-4.267 4.267H4.267C1.868 29.756 0 27.887 0 25.489zm20.791 3.004 6.775 6.774-6.775 6.775-1.885-1.886 3.555-3.556h-7.536v-2.666h7.536l-3.555-3.556z',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$12 = forwardRef(SvgPanelLeftOpen);
const SvgPanelRightClose = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M4.267 4.333c-.897 0-1.6.743-1.6 1.6V25.49c0 .926.674 1.6 1.6 1.6h16.462V4.333zm19.129 0V27.09h4.337c.926 0 1.6-.674 1.6-1.6V5.933c0-.926-.674-1.6-1.6-1.6zM0 5.933c0-2.271 1.84-4.266 4.267-4.266h23.466C30.132 1.667 32 3.535 32 5.933V25.49c0 2.398-1.868 4.267-4.267 4.267H4.267C1.868 29.756 0 27.887 0 25.489zm12.187 3.004 6.774 6.774-6.774 6.775L10.3 20.6l3.556-3.556H6.32v-2.666h7.537L10.3 10.822z',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$11 = forwardRef(SvgPanelRightClose);
const SvgPanelRightOpen = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M4.267 4.333c-.897 0-1.6.743-1.6 1.6V25.49c0 .926.674 1.6 1.6 1.6h16.462V4.333zm19.129 0V27.09h4.337c.926 0 1.6-.674 1.6-1.6V5.933c0-.926-.674-1.6-1.6-1.6zM0 5.933c0-2.271 1.84-4.266 4.267-4.266h23.466C30.132 1.667 32 3.535 32 5.933V25.49c0 2.398-1.868 4.267-4.267 4.267H4.267C1.868 29.756 0 27.887 0 25.489zm13.094 4.89L9.54 14.377h7.536v2.666H9.54l3.555 3.556-1.885 1.886-6.775-6.775 6.775-6.774 1.885 1.885Z',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$10 = forwardRef(SvgPanelRightOpen);
const SvgPaperclip = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M23.567 4.402c-2.03-2.03-5.15-2.03-7.179 0l-11.23 11.23c-3.038 3.037-3.038 8.173 0 11.21s8.173 3.038 11.21 0l12.67-12.67a1.44 1.44 0 0 1 2.036 2.036l-12.67 12.67c-4.162 4.163-11.12 4.163-15.283 0-4.161-4.161-4.161-11.12 0-15.282l11.231-11.23c3.154-3.154 8.097-3.154 11.251 0s3.154 8.097 0 11.25l-.007.008-10.36 10.215-.004.004c-1.962 1.958-5.2 2.046-7.098-.03-1.935-1.964-2.015-5.182.051-7.074L16.8 8.125a1.44 1.44 0 1 1 2.036 2.036l-8.666 8.666-.028.025c-.773.695-.854 2.042.055 2.951l.027.027.025.028c.696.773 2.042.854 2.951-.055l.007-.007 10.363-10.22c2.026-2.029 2.025-5.146-.003-7.174',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$$ = forwardRef(SvgPaperclip);
const SvgPatientHistory = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      d: 'M0 2.788c0-.803.651-1.455 1.455-1.455h9.697c.486 0 .94.243 1.21.648l3.447 5.17h14.737c.803 0 1.454.652 1.454 1.455v16.485a4.364 4.364 0 0 1-4.364 4.364H13.2a8.7 8.7 0 0 0 1.068-2.91h13.37a1.455 1.455 0 0 0 1.454-1.454V10.06H15.03c-.487 0-.941-.243-1.21-.648l-3.448-5.17H2.91v12.39A8.8 8.8 0 0 0 0 18.224z',
    }),
    /* @__PURE__ */ React.createElement('path', {
      d: 'M4.364 18.303c.173-.042.354-.047.53-.017.369.101.687.323.898.625s.299.665.25 1.023a1.1 1.1 0 0 1-.126.483 1.2 1.2 0 0 1-.33.388 1.3 1.3 0 0 1-.472.224 1.3 1.3 0 0 1-.53.017 1.6 1.6 0 0 1-.898-.626 1.45 1.45 0 0 1-.25-1.023 1.1 1.1 0 0 1 .126-.482c.079-.15.191-.283.33-.389.138-.105.3-.182.472-.223M2.27 21.098a1.3 1.3 0 0 0-.529.017 1.3 1.3 0 0 0-.473.224c-.138.105-.25.238-.33.388a1.1 1.1 0 0 0-.125.482c-.049.358.04.721.25 1.024.21.302.53.524.898.625a1.28 1.28 0 0 0 1.002-.24c.139-.106.251-.239.33-.389a1.1 1.1 0 0 0 .125-.482 1.44 1.44 0 0 0-.25-1.023 1.6 1.6 0 0 0-.898-.626m9.06 0c.175-.03.356-.024.529.017.173.042.334.118.472.224.139.105.251.238.33.388s.121.315.126.482c.049.358-.04.721-.25 1.024a1.6 1.6 0 0 1-.899.625c-.175.03-.356.024-.529-.017a1.3 1.3 0 0 1-.472-.223 1.2 1.2 0 0 1-.33-.389 1.1 1.1 0 0 1-.126-.482c-.049-.358.04-.721.25-1.023.21-.303.53-.525.899-.626m-2.623-2.812a1.3 1.3 0 0 1 .529.017c.173.041.334.118.472.223.139.106.251.239.33.389a1.1 1.1 0 0 1 .126.482c.049.358-.04.721-.25 1.023-.21.303-.53.524-.899.626-.175.03-.356.024-.529-.017a1.3 1.3 0 0 1-.472-.224 1.2 1.2 0 0 1-.33-.388 1.1 1.1 0 0 1-.125-.483c-.05-.358.039-.72.25-1.023.21-.302.528-.524.898-.625M2.678 27.4c0-2.11 1.874-4.922 4.122-4.922s4.122 2.812 4.122 4.921c0 .56-.237 1.096-.659 1.492a2.33 2.33 0 0 1-1.59.618c-.698 0-.967-.223-1.201-.418-.182-.151-.344-.285-.672-.285-.354 0-.581.156-.822.321-.27.185-.555.382-1.052.382a2.33 2.33 0 0 1-1.59-.618 2.05 2.05 0 0 1-.658-1.492Z',
    }),
  );
const ForwardRef$_ = forwardRef(SvgPatientHistory);
const SvgPatientList = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M17.63 3.093c.362-.1.742-.12 1.112-.058q.08.015.16.04a3.1 3.1 0 0 1 2.109 3.3 2.57 2.57 0 0 1-2.994 2.474 1 1 0 0 1-.16-.04 3.104 3.104 0 0 1-2.109-3.3 2.57 2.57 0 0 1 1.883-2.416Zm.684 2.058a.42.42 0 0 0-.415.422q0 .08-.01.158a.95.95 0 0 0 .556 1.002.42.42 0 0 0 .415-.422q0-.078.01-.158a.95.95 0 0 0-.556-1.002m6.401 0a.95.95 0 0 0-.556 1.002q.01.08.01.158a.42.42 0 0 0 .415.422.95.95 0 0 0 .556-1.002 1 1 0 0 1-.01-.158.42.42 0 0 0-.415-.422m-.428-2.116a2.57 2.57 0 0 1 2.994 2.475 3.1 3.1 0 0 1-2.11 3.3q-.078.026-.16.039a2.57 2.57 0 0 1-2.993-2.475 3.1 3.1 0 0 1 2.11-3.3 1 1 0 0 1 .16-.039ZM12.933 7.48a2.6 2.6 0 0 1 1.113-.055q.08.014.158.04a3.104 3.104 0 0 1 2.104 3.299 2.57 2.57 0 0 1-3 2.474 1 1 0 0 1-.159-.04 3.104 3.104 0 0 1-2.103-3.3 2.57 2.57 0 0 1 1.887-2.418m.68 2.06a.42.42 0 0 0-.417.421q0 .08-.01.16a.95.95 0 0 0 .555 1.002.417.417 0 0 0 .416-.422q0-.08.01-.16a.95.95 0 0 0-.555-1.001Zm15.803 0a.95.95 0 0 0-.551 1.001q.01.08.01.16a.417.417 0 0 0 .413.421.95.95 0 0 0 .551-1 1 1 0 0 1-.01-.16.417.417 0 0 0-.413-.422m-.43-2.116a2.57 2.57 0 0 1 2.994 2.474 3.1 3.1 0 0 1-2.099 3.3 1 1 0 0 1-.163.04 2.568 2.568 0 0 1-2.993-2.474 3.1 3.1 0 0 1 2.098-3.299 1 1 0 0 1 .163-.04Zm-12.074 4.547c1.176-1.47 2.863-2.715 4.602-2.715s3.427 1.246 4.602 2.715c1.209 1.511 2.117 3.543 2.117 5.57a3.9 3.9 0 0 1-3.897 3.898 3.7 3.7 0 0 1-1.294-.213 4 4 0 0 1-.827-.437l-.03-.02c-.329-.22-.406-.27-.67-.27-.265 0-.342.05-.672.27l-.03.02a4 4 0 0 1-.827.437c-.37.136-.79.213-1.293.213a3.897 3.897 0 0 1-3.897-3.897c0-2.028.908-4.06 2.116-5.57Zm1.68 1.344c-.986 1.233-1.645 2.806-1.645 4.227a1.746 1.746 0 0 0 1.746 1.746c.275 0 .441-.04.55-.081.117-.043.217-.101.38-.21l.064-.043c.355-.238.903-.607 1.827-.607.925 0 1.473.369 1.828.607l.064.043c.163.109.263.167.38.21.108.04.274.08.55.08a1.746 1.746 0 0 0 1.746-1.745c0-1.421-.66-2.994-1.646-4.227-1.018-1.273-2.153-1.908-2.922-1.908-.768 0-1.903.635-2.922 1.908M8.067 12.143H0v-2.69h8.067zm2.689 8.067H0v-2.689h10.756v2.69Zm10.757 8.067H0v-2.689h21.513v2.69Z',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$Z = forwardRef(SvgPatientList);
const SvgPatient = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M10.03 1.463a3.6 3.6 0 0 1 1.546-.08q.093.015.183.045a4.41 4.41 0 0 1 2.997 4.712 3.573 3.573 0 0 1-4.166 3.464 1 1 0 0 1-.182-.046A4.41 4.41 0 0 1 7.41 4.846a3.57 3.57 0 0 1 2.62-3.383M11.082 3.8a1.113 1.113 0 0 0-1.21 1.119q.001.09-.011.18a1.95 1.95 0 0 0 1.225 2.09 1.114 1.114 0 0 0 1.21-1.12q-.001-.09.011-.18A1.95 1.95 0 0 0 11.082 3.8M2.657 8.348a3.6 3.6 0 0 1 1.549-.077q.092.015.181.045a4.41 4.41 0 0 1 2.99 4.712 3.574 3.574 0 0 1-4.175 3.463 1 1 0 0 1-.182-.046 4.41 4.41 0 0 1-2.989-4.712 3.575 3.575 0 0 1 2.626-3.385m1.048 2.338a1.11 1.11 0 0 0-1.213 1.119q0 .091-.012.182a1.95 1.95 0 0 0 1.223 2.088 1.11 1.11 0 0 0 1.212-1.118q0-.092.012-.183a1.95 1.95 0 0 0-1.222-2.088m5.433 4.554c1.812-2.265 4.342-4.09 6.865-4.09s5.053 1.825 6.865 4.09c1.849 2.312 3.221 5.403 3.221 8.456a5.66 5.66 0 0 1-5.658 5.658c-.742 0-1.347-.113-1.872-.306a5.6 5.6 0 0 1-1.203-.637l-.068-.045c-.507-.338-.731-.488-1.285-.488s-.778.15-1.286.488l-.067.045a5.6 5.6 0 0 1-1.203.637c-.525.193-1.13.306-1.872.306a5.66 5.66 0 0 1-5.658-5.658c0-3.053 1.372-6.145 3.221-8.456m1.922 1.538c-1.594 1.993-2.682 4.559-2.682 6.918a3.197 3.197 0 0 0 3.197 3.197c.481 0 .795-.072 1.022-.155.235-.087.429-.204.69-.378l.099-.066c.547-.367 1.308-.877 2.617-.877s2.07.51 2.617.877l.099.066c.261.174.455.291.69.378.227.083.54.155 1.022.155a3.197 3.197 0 0 0 3.197-3.197c0-2.36-1.088-4.925-2.683-6.918-1.632-2.04-3.53-3.167-4.942-3.167s-3.31 1.127-4.943 3.167M27.803 8.27l-.187.047a4.41 4.41 0 0 0-2.98 4.711 3.573 3.573 0 0 0 4.165 3.463q.095-.015.187-.047a4.41 4.41 0 0 0 2.98-4.711 3.574 3.574 0 0 0-4.165-3.463m-.446 3.205c.222-.358.553-.635.943-.789a1.11 1.11 0 0 1 1.207 1.12q0 .09.012.182a1.95 1.95 0 0 1-1.216 2.087 1.11 1.11 0 0 1-1.207-1.119q0-.091-.012-.182a1.95 1.95 0 0 1 .273-1.299M20.43 1.383l-.183.045A4.41 4.41 0 0 0 17.25 6.14a3.576 3.576 0 0 0 4.165 3.464q.093-.015.183-.046a4.41 4.41 0 0 0 2.997-4.712 3.576 3.576 0 0 0-4.165-3.463m-.455 3.204c.223-.36.557-.635.95-.788a1.113 1.113 0 0 1 1.209 1.119q0 .09.012.18a1.95 1.95 0 0 1-1.226 2.09 1.113 1.113 0 0 1-1.209-1.12q0-.09-.012-.18a1.95 1.95 0 0 1 .276-1.3Z',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$Y = forwardRef(SvgPatient);
const SvgPause = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M1.333 0H12v32H1.333zM4 2.91v26.18h5.333V2.91zM20 0h10.667v32H20zm2.667 2.91v26.18H28V2.91z',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$X = forwardRef(SvgPause);
const SvgPhoneContact = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M7.918.092a2.68 2.68 0 0 1 3.147 1.533l3.228 7.523a2.68 2.68 0 0 1-.555 2.934l-2.351 2.386a24.5 24.5 0 0 0 2.733 3.413 24 24 0 0 0 3.409 2.732l2.386-2.354a2.68 2.68 0 0 1 2.942-.55h.003l7.52 3.224a2.68 2.68 0 0 1 1.53 3.147m0 .002-1.56 5.908-.002.006a2.675 2.675 0 0 1-2.68 2.003h-.014l-.014-.002a29.8 29.8 0 0 1-19.186-8.43l-.012-.012-.01-.01A29.8 29.8 0 0 1 .001 4.362v-.018L0 4.328a2.68 2.68 0 0 1 2.003-2.671L7.918.092m13.87 20.067-3.878 3.824-.887-.535a26.8 26.8 0 0 1-4.772-3.666l-.018-.017-.018-.018a27.2 27.2 0 0 1-3.663-4.77l-.536-.888 3.822-3.878.004-.007-.001-.007-3.226-7.52A.013.013 0 0 0 8.6 2.67L2.677 4.237a.02.02 0 0 0-.01.011 27.12 27.12 0 0 0 7.661 17.422 27.12 27.12 0 0 0 17.435 7.662l.003-.005.002-.009 1.564-5.92v-.002a.01.01 0 0 0-.006-.013l-7.521-3.225-.005-.002a.01.01 0 0 0-.013.003Z',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$W = forwardRef(SvgPhoneContact);
const SvgPill = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M21.524 23.41 8.59 10.475l1.886-1.885L23.41 21.524z',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M27.078 4.942c-3.192-3.048-8.206-3.017-11.213-.01L4.943 15.855c-3.046 3.188-3.018 8.195-.02 11.203 3.19 3.048 8.205 3.017 11.212.01l10.922-10.923c3.046-3.188 3.018-8.195.02-11.203ZM13.979 3.047c4.073-4.073 10.754-4.045 14.954-.02l.01.01.01.01C33.026 7.12 32.998 13.8 28.973 18l-.01.01-10.942 10.943c-4.073 4.073-10.754 4.045-14.954.02l-.01-.01-.01-.01C-1.026 24.88-.998 18.2 3.027 14l.01-.01L13.979 3.046Z',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$V = forwardRef(SvgPill);
const SvgPin2 = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M23.515 5.368 5.142 15.622 3.98 13.539 22.352 3.285zm5.2 4.28L18.461 28.02l-2.083-1.162L26.632 8.485z',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M20.294 0 32 11.706l-1.687 1.687L18.607 1.687zm-7.617 21.01L1.687 32 0 30.313l10.99-10.99z',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M1.687 10.02 21.98 30.312 20.294 32 0 11.706z',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$U = forwardRef(SvgPin2);
const SvgPin = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M16 2.422c-4.74 0-9.634 3.588-9.634 9.862 0 1.404.573 3.168 1.558 5.115.971 1.92 2.28 3.897 3.61 5.693A72 72 0 0 0 16 28.518a72 72 0 0 0 4.466-5.427c1.33-1.795 2.639-3.771 3.61-5.692.985-1.947 1.558-3.71 1.558-5.115 0-6.274-4.895-9.862-9.634-9.862m0 27.855-.842.85-.01-.01-.025-.026a70 70 0 0 1-1.694-1.863 75 75 0 0 1-3.78-4.673c-1.374-1.855-2.77-3.953-3.826-6.042C4.779 16.45 4 14.27 4 12.283 4 4.44 10.193 0 16 0s12 4.44 12 12.284c0 1.986-.78 4.166-1.823 6.229-1.056 2.089-2.452 4.187-3.826 6.042a75 75 0 0 1-5.474 6.536l-.025.026-.007.008-.002.002zm0 0 .842.85L16 32l-.842-.873z',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M16 9.342c-1.587 0-2.873 1.317-2.873 2.942 0 1.624 1.286 2.94 2.873 2.94s2.873-1.316 2.873-2.94c0-1.625-1.286-2.942-2.873-2.942m-5.24 2.942c0-2.962 2.346-5.364 5.24-5.364s5.24 2.402 5.24 5.364-2.346 5.363-5.24 5.363-5.24-2.401-5.24-5.363',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$T = forwardRef(SvgPin);
const SvgPlay = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'm5.333 0 21.334 16L5.333 32zm2.462 4.923v22.154L22.565 16z',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$S = forwardRef(SvgPlay);
const SvgPlus = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M17.333 14.667V0h-2.666v14.667H0v2.666h14.667V32h2.666V17.333H32v-2.666z',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$R = forwardRef(SvgPlus);
const SvgPower = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'm11.163 6.19-1.144.687C6.392 9.053 4 12.902 4 17.333c0 6.597 5.403 12 12 12s12-5.403 12-12c0-4.452-2.408-8.41-5.99-10.44l-1.16-.657 1.314-2.32 1.16.657c4.417 2.503 7.343 7.346 7.343 12.76C30.667 25.403 24.07 32 16 32S1.333 25.403 1.333 17.333c0-5.435 2.942-10.12 7.314-12.743l1.144-.686z',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M17.333 0v12h-2.666V0z',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$Q = forwardRef(SvgPower);
const SvgPrevious = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M22.667 31.219 7.447 16 22.668.781l1.885 1.886L11.22 16l13.333 13.333z',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$P = forwardRef(SvgPrevious);
const SvgPrice = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M16 2.667C8.636 2.667 2.667 8.637 2.667 16S8.637 29.333 16 29.333 29.333 23.363 29.333 16 23.363 2.667 16 2.667M0 16C0 7.163 7.163 0 16 0s16 7.163 16 16-7.163 16-16 16S0 24.837 0 16',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M17.333 5.333v21.334h-2.666V5.333z',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M15.11 7.324c2.189-.157 4.695.398 6.032 1.133l1.169.642-1.285 2.337-1.168-.642c-.824-.453-2.803-.936-4.558-.81-.866.062-1.51.263-1.904.54-.321.227-.532.534-.532 1.119 0 .735.282 1.17.806 1.554.614.45 1.49.771 2.605 1.143l.238.079c.97.32 2.125.703 3.034 1.29 1.08.695 1.962 1.773 1.962 3.426 0 1.396-.467 2.555-1.356 3.395-.853.806-1.97 1.202-3.075 1.367-2.19.329-4.804-.172-6.864-.915L8.96 22.53l.905-2.509 1.254.453c1.831.66 3.972 1.025 5.564.786.785-.118 1.317-.364 1.638-.668.287-.27.522-.693.522-1.457 0-.51-.199-.836-.74-1.185-.613-.395-1.46-.677-2.55-1.04l-.121-.04c-1.047-.35-2.332-.784-3.339-1.523-1.097-.804-1.896-1.99-1.896-3.704 0-1.462.64-2.578 1.663-3.299.95-.67 2.144-.94 3.25-1.02',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$O = forwardRef(SvgPrice);
const SvgPrint = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M5.908 1.23c0-.679.55-1.23 1.23-1.23h17.724c.68 0 1.23.551 1.23 1.23v5.908a1.23 1.23 0 0 1-2.461 0V2.462H8.369v4.676a1.23 1.23 0 1 1-2.461 0zM0 11.077c0-.68.551-1.23 1.23-1.23h29.54c.679 0 1.23.55 1.23 1.23V24.86a1.23 1.23 0 0 1-1.23 1.231h-5.91a1.23 1.23 0 0 1 0-2.461h4.677V12.308H2.462V23.63h4.676a1.23 1.23 0 1 1 0 2.461H1.231A1.23 1.23 0 0 1 0 24.862z',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M5.908 18.954c0-.68.55-1.23 1.23-1.23h17.724c.68 0 1.23.55 1.23 1.23v11.815c0 .68-.55 1.231-1.23 1.231H7.139a1.23 1.23 0 0 1-1.231-1.23V18.953Zm2.461 1.23v9.354h15.262v-9.353H8.369Z',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$N = forwardRef(SvgPrint);
const SvgReassign = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M12.778 14.111h6.918l2.556 2.556h8.415V32h-17.89zm2.555 2.556v12.777h12.778V19.223h-6.918l-2.556-2.555z',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M0 1.333h6.918L9.474 3.89h8.415v7.667h-2.556V6.444H8.415L5.86 3.89H2.556v12.778h7.666v2.555H0zm20.445 1.278h1.277a7.667 7.667 0 0 1 7.667 7.667v1.278h-2.556v-1.278a5.11 5.11 0 0 0-5.11-5.111h-1.278V2.61ZM3.833 21.778v1.278a5.11 5.11 0 0 0 5.112 5.11h1.277v2.556H8.945a7.667 7.667 0 0 1-7.667-7.666v-1.278z',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$M = forwardRef(SvgReassign);
const SvgRecentlySearched = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', { d: 'M20 7.333h2.667v4h4V14H20z' }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M10.667 12.667C10.667 6.8 15.467 2 21.333 2S32 6.8 32 12.667c0 5.866-4.8 10.666-10.667 10.666-5.866 0-10.666-4.8-10.666-10.666m10.666 8c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      d: 'M8.667 10.666H0v2.667h8.667zm2 8H0v2.667h10.667zM0 26.666h21.333v2.667H0z',
    }),
  );
const ForwardRef$L = forwardRef(SvgRecentlySearched);
const SvgRedo = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M10.667 5.333a8 8 0 1 0 0 16h18.666V24H10.667C4.776 24 0 19.224 0 13.333 0 7.443 4.776 2.667 10.667 2.667H20v2.666z',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'm22.667 14.114 8.552 8.553-8.552 8.552-1.886-1.886 6.667-6.666L20.78 16l1.886-1.886Z',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$K = forwardRef(SvgRedo);
const SvgRefreshRedo = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'm1.41 20.94 10.804 3.009-.716 2.567-6.942-1.933.888 7.06-2.646.333L1.41 20.939Z',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M26.49 24.234a13.32 13.32 0 0 0 2.843-8.233L32 15.999A16 16 0 0 1 9.386 30.57a16 16 0 0 1-7.587-7.194l2.367-1.228a13.33 13.33 0 0 0 14.999 6.807 13.33 13.33 0 0 0 7.324-4.72ZM29.202.024 30.59 11.06 19.786 8.051l.715-2.567 6.943 1.933-.888-7.06z',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M21.512 3.858A13.34 13.34 0 0 0 5.51 7.766a13.32 13.32 0 0 0-2.844 8.233L0 16.001A15.99 15.99 0 0 1 12.202.457a16.006 16.006 0 0 1 17.999 8.168l-2.367 1.228a13.33 13.33 0 0 0-6.322-5.995',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$J = forwardRef(SvgRefreshRedo);
const SvgReplyAll = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M21.333 9.392V.782L7.448 14.666l13.885 13.885v-8.448c2.274.357 4.17 1.58 5.604 2.883.844.767 1.5 1.538 1.942 2.116a14 14 0 0 1 .615.869l.026.042.004.006v.002l2.1 3.5.37-4.07.001-.005.001-.012.004-.04a12 12 0 0 0 .033-.649c.014-.43.02-1.038-.014-1.765-.065-1.446-.285-3.404-.915-5.385-.63-1.979-1.693-4.053-3.494-5.639-1.572-1.383-3.633-2.328-6.277-2.565Zm9.334 15.941 1.328.12zm-2.104-6.929c.334 1.049.536 2.107.655 3.07a18 18 0 0 0-.488-.46c-1.962-1.784-4.935-3.68-8.73-3.68h-1.333v4.78l-7.448-7.447 7.448-7.448V12H20c2.704 0 4.55.817 5.848 1.96 1.324 1.164 2.178 2.756 2.715 4.444',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      d: 'M4.552 14.667 15.22 4l-1.886-1.886L.781 14.667l12.552 12.552 1.886-1.886z',
    }),
  );
const ForwardRef$I = forwardRef(SvgReplyAll);
const SvgReply = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M14.667-.552V8.03c3.57.163 7.599 1.015 10.895 3.309C29.357 13.981 32 18.411 32 25.333v4.906l-2.483-4.23c-1.724-2.938-3.383-4.691-5.683-5.768-2.14-1.002-4.963-1.482-9.167-1.562v8.54L.78 13.333zM4.552 13.333 12 20.781V16h1.333c5.047 0 8.724.464 11.632 1.826 1.473.69 2.71 1.59 3.81 2.714-.855-3.328-2.618-5.538-4.737-7.012-3.086-2.149-7.108-2.861-10.705-2.861H12V5.886z',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$H = forwardRef(SvgReply);
const SvgReports = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      d: 'M28 0h-9.333v2.667h4.78L16 10.114l-5.333-5.333-7.61 7.61 1.886 1.885 5.724-5.724L16 13.886l9.333-9.334v4.781H28z',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M32 32V12h-8v20zm-5.333-2.667V14.667h2.666v14.666zM12 17.333h8V32h-8zM14.667 20v9.333h2.666V20zM0 22.667h8V32H0zm2.667 2.666v4h2.666v-4z',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$G = forwardRef(SvgReports);
const SvgRequest = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M32 6.179 25.82 0 8.778 17.043l-2.06 8.239 8.239-2.06zm-21.679 15.5.824-3.296L25.82 3.707l2.472 2.472-14.676 14.676z',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      d: 'M12.714 4.868H0V32h27.132V19.286H24.51V29.38H2.621V7.489h10.093V4.87Z',
    }),
  );
const ForwardRef$F = forwardRef(SvgRequest);
const SvgRotateImageLeft = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement(
      'g',
      { transform: 'translate(.5 .5)' },
      /* @__PURE__ */ React.createElement('path', {
        d: 'M24 4h-4V0l-6 5 6 5V6h4c2.757 0 5 2.243 5 5v5h2v-5c0-3.86-3.141-7-7-7',
      }),
      /* @__PURE__ */ React.createElement('path', {
        d: 'M23 12H1a1 1 0 0 0-1 1v17a1 1 0 0 0 1 1h22a1 1 0 0 0 1-1V13a1 1 0 0 0-1-1m-1 17H2V14h20z',
      }),
      /* @__PURE__ */ React.createElement('circle', { cx: 6, cy: 18, r: 2 }),
      /* @__PURE__ */ React.createElement('path', {
        d: 'M4.036 26.267A1 1 0 0 0 5 27h14a1 1 0 0 0 .832-1.554l-4-6a1 1 0 0 0-1.347-.303l-10 6a1 1 0 0 0-.449 1.124',
      }),
    ),
  );
const ForwardRef$E = forwardRef(SvgRotateImageLeft);
const SvgRotateImageRight = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement(
      'g',
      { transform: 'matrix(-1 0 0 1 31.5 .5)' },
      /* @__PURE__ */ React.createElement('path', {
        d: 'M24 4h-4V0l-6 5 6 5V6h4c2.757 0 5 2.243 5 5v5h2v-5c0-3.86-3.141-7-7-7',
      }),
      /* @__PURE__ */ React.createElement('path', {
        d: 'M23 12H1a1 1 0 0 0-1 1v17a1 1 0 0 0 1 1h22a1 1 0 0 0 1-1V13a1 1 0 0 0-1-1m-1 17H2V14h20z',
      }),
      /* @__PURE__ */ React.createElement('circle', { cx: 6, cy: 18, r: 2 }),
      /* @__PURE__ */ React.createElement('path', {
        d: 'M4.036 26.267A1 1 0 0 0 5 27h14a1 1 0 0 0 .832-1.554l-4-6a1 1 0 0 0-1.347-.303l-10 6a1 1 0 0 0-.449 1.124',
      }),
    ),
  );
const ForwardRef$D = forwardRef(SvgRotateImageRight);
const SvgRotate = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      d: 'M21.333 0h1.334A9.333 9.333 0 0 1 32 9.333v1.334h-2.667V9.333a6.666 6.666 0 0 0-6.666-6.666h-1.334zm.324 21.657a1.333 1.333 0 1 0-1.885-1.886 1.333 1.333 0 0 0 1.886 1.886Z',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M10.687 2.457a4 4 0 0 1 5.656 0L29.54 15.656a4 4 0 0 1 .002 5.658l-8.23 8.229a4 4 0 0 1-5.656 0l-13.2-13.2a4 4 0 0 1 0-5.656zm3.77 1.886a1.333 1.333 0 0 0-1.885 0l-8.23 8.23c-.52.52-.52 1.364 0 1.884l13.2 13.2c.521.52 1.365.52 1.886 0l8.23-8.23c.52-.52.52-1.363-.002-1.886z',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      d: 'M2.667 22.667v-1.334H0v1.334A9.333 9.333 0 0 0 9.333 32h1.334v-2.667H9.333a6.666 6.666 0 0 1-6.666-6.666',
    }),
  );
const ForwardRef$C = forwardRef(SvgRotate);
const SvgSad = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M16 2.667C8.636 2.667 2.667 8.637 2.667 16S8.637 29.333 16 29.333 29.333 23.363 29.333 16 23.363 2.667 16 2.667M0 16C0 7.163 7.163 0 16 0s16 7.163 16 16-7.163 16-16 16S0 24.837 0 16',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      d: 'M10 16a2 2 0 1 0 0-4 2 2 0 0 0 0 4m12 0a2 2 0 1 0 0-4 2 2 0 0 0 0 4',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M16 21.333A2.667 2.667 0 0 0 13.333 24h-2.666a5.333 5.333 0 1 1 10.666 0h-2.666A2.667 2.667 0 0 0 16 21.333',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$B = forwardRef(SvgSad);
const SvgSample2 = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      d: 'M32 0H0v9.33h2.67v20A2.67 2.67 0 0 0 5.34 32h21.33a2.67 2.67 0 0 0 2.67-2.67v-20h2.67V0Zm-5.33 29.33H5.33v-20h21.33v20Zm2.66-22.66h-4V4h-2.67v2.67h-2.67V4h-2.67v2.67h-2.67V4h-2.67v2.67H9.31V4H6.64v2.67H2.67v-4h26.67v4Z',
    }),
    /* @__PURE__ */ React.createElement('path', {
      d: 'M17.33 14.67h-2.66v4h-4v2.66h4v4h2.66v-4h4v-2.66h-4z',
    }),
  );
const ForwardRef$A = forwardRef(SvgSample2);
const SvgSample = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M20.667 9.333C21.403 9.333 22 8.736 22 8V1.333C22 .597 21.403 0 20.667 0h-9.334C10.597 0 10 .597 10 1.333V8c0 .736.597 1.333 1.333 1.333v18a4.667 4.667 0 1 0 9.334 0zm-8-6.666v4h6.666v-4zM18 9.333h-4v5.106q.078-.024.156-.052c.607-.214 1.122-.536 1.444-.965.406-.54 1.23-1.063 2.4-1.296zm0 5.563a1.3 1.3 0 0 0-.29.16l-.005.004c-.743.97-1.769 1.527-2.661 1.842-.357.126-.71.22-1.044.287v10.144a2 2 0 1 0 4 0z',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$z = forwardRef(SvgSample);
const SvgSave = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      d: 'M5.867 14.667h20.266v11.466h-2.666v-8.8H8.533v8.8H5.867zm15.866-3.2v-5.6h-2.666v5.6z',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M1.25 1.25C2.05.45 3.135 0 4.267 0h19.619L32 8.114v19.62A4.266 4.266 0 0 1 27.733 32H4.267A4.266 4.266 0 0 1 0 27.733V4.267C0 3.135.45 2.05 1.25 1.25m3.017 1.417a1.6 1.6 0 0 0-1.6 1.6v23.466a1.6 1.6 0 0 0 1.6 1.6h23.466a1.6 1.6 0 0 0 1.6-1.6V9.22l-6.552-6.552H4.267Z',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$y = forwardRef(SvgSave);
const SvgSearch = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M20.954 22.807a12.8 12.8 0 0 1-8.109 2.883C5.751 25.69 0 19.939 0 12.845S5.75 0 12.845 0C19.939 0 25.69 5.75 25.69 12.845c0 3.075-1.08 5.897-2.883 8.109L32 30.146 30.146 32zM2.62 12.845c0-5.646 4.578-10.224 10.224-10.224S23.068 7.2 23.068 12.845a10.2 10.2 0 0 1-2.864 7.097l-.262.262a10.2 10.2 0 0 1-7.097 2.864c-5.646 0-10.224-4.577-10.224-10.223Z',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$x = forwardRef(SvgSearch);
const SvgSend = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M25.6 32 32 0 0 12.8l8.23 6.172v12.902l6.635-7.925zm-12.757-9.567-2.09-1.569v4.066zm-1.069-3.956 12.137 9.102 4.48-22.394-16.616 13.292ZM9.69 16.914 22.87 6.369 5.106 13.475z',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$w = forwardRef(SvgSend);
const SvgSettings = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M16 10.667a5.333 5.333 0 1 0 0 10.666 5.333 5.333 0 0 0 0-10.666M13.333 16a2.667 2.667 0 1 1 5.334 0 2.667 2.667 0 0 1-5.334 0',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M19.164 0h-6.328l-.631 4.628a12 12 0 0 0-1.565.65l-3.716-2.83-4.475 4.475 2.825 3.717a12 12 0 0 0-.65 1.565L0 12.836v6.328l4.628.631q.269.806.65 1.565l-2.825 3.717 4.474 4.474 3.717-2.825q.759.38 1.564.65L12.835 32h6.329l.631-4.628q.806-.269 1.565-.65l3.717 2.825 4.474-4.474-2.825-3.717q.38-.759.65-1.564L32 19.165v-6.329l-4.628-.631a12 12 0 0 0-.65-1.565l2.825-3.716-4.47-4.476-3.717 2.826a12 12 0 0 0-1.565-.65zm-4.556 6.738.556-4.071h1.672l.556 4.067.875.22a9.2 9.2 0 0 1 2.522 1.048l.775.467 3.273-2.488 1.179 1.18-2.489 3.275.467.775a9.2 9.2 0 0 1 1.049 2.522l.219.875 4.071.556v1.671l-4.067.552-.22.876a9.2 9.2 0 0 1-1.048 2.522l-.467.775 2.489 3.274-1.182 1.181-3.274-2.488-.775.467a9.2 9.2 0 0 1-2.522 1.049l-.875.219-.556 4.071h-1.671l-.552-4.067-.876-.22a9.2 9.2 0 0 1-2.522-1.048l-.775-.467-3.274 2.489-1.181-1.182 2.488-3.274-.467-.775a9.2 9.2 0 0 1-1.049-2.522l-.219-.875-4.071-.556v-1.672l4.067-.556.22-.875a9.2 9.2 0 0 1 1.048-2.522l.467-.775-2.488-3.274 1.18-1.18 3.274 2.491.776-.467a9.2 9.2 0 0 1 2.522-1.049z',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$v = forwardRef(SvgSettings);
const SvgShare = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M21.793.36a1.23 1.23 0 0 0-2.1.87v4.722c-2.994.214-6.193 1.22-8.771 3.325-2.976 2.43-5.014 6.237-5.014 11.646a1.23 1.23 0 0 0 2.277.647c2.476-4.007 7.02-5.14 11.507-5.302v4.655a1.23 1.23 0 0 0 2.101.87l9.847-9.846c.48-.48.48-1.26 0-1.74zm.36 6.778V4.202l6.876 6.875-6.875 6.875v-2.937c0-.68-.551-1.23-1.23-1.23-3.87 0-8.607.56-12.14 3.422.653-2.705 2.019-4.655 3.695-6.023 2.403-1.962 5.554-2.815 8.444-2.815.68 0 1.23-.55 1.23-1.23Z',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      d: 'M2.966 6.905A1.72 1.72 0 0 1 4.185 6.4h2.953a1.23 1.23 0 0 0 0-2.462H4.185A4.185 4.185 0 0 0 0 8.123v19.692A4.185 4.185 0 0 0 4.185 32h23.63A4.185 4.185 0 0 0 32 27.815v-6.892a1.23 1.23 0 0 0-2.462 0v6.892a1.723 1.723 0 0 1-1.723 1.723H4.185a1.723 1.723 0 0 1-1.723-1.723V8.123c0-.457.181-.895.504-1.218',
    }),
  );
const ForwardRef$u = forwardRef(SvgShare);
const SvgShow = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M16 9.333a6.667 6.667 0 1 0 0 13.334 6.667 6.667 0 0 0 0-13.334M12 16a4 4 0 1 1 8 0 4 4 0 0 1-8 0',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M16 4c-3.858 0-7.16 1.708-9.713 3.717C3.73 9.727 1.83 12.11.742 13.653l-.004.005a4.085 4.085 0 0 0 0 4.684l.004.005c1.089 1.541 2.99 3.926 5.545 5.936C8.84 26.292 12.142 28 16 28s7.16-1.708 9.713-3.717c2.556-2.01 4.456-4.395 5.545-5.936l.004-.006a4.085 4.085 0 0 0 0-4.683l-.004-.005c-1.089-1.542-2.99-3.926-5.545-5.936C23.16 5.708 19.858 4 16 4M2.667 16c0-.29.089-.573.255-.811 1.008-1.427 2.737-3.586 5.014-5.377C10.216 8.018 12.95 6.667 16 6.667s5.784 1.351 8.064 3.145c2.277 1.791 4.006 3.95 5.014 5.377a1.42 1.42 0 0 1 0 1.622c-1.008 1.427-2.738 3.586-5.014 5.377-2.28 1.794-5.014 3.145-8.064 3.145s-5.784-1.351-8.064-3.145c-2.277-1.791-4.006-3.95-5.014-5.377A1.4 1.4 0 0 1 2.667 16',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$t = forwardRef(SvgShow);
const SvgSignIn = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M21.333 17.333h-20v-2.666h20z',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M14.667 7.448 23.219 16l-8.552 8.552-1.886-1.885L19.448 16 12.78 9.333l1.886-1.885Z',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M12 0h14.667a4 4 0 0 1 4 4v24a4 4 0 0 1-4 4H12v-2.667h14.667A1.333 1.333 0 0 0 28 28V4a1.334 1.334 0 0 0-1.333-1.333H12z',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$s = forwardRef(SvgSignIn);
const SvgSignOut = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M19.448 0H4.78a4 4 0 0 0-4 4v24a4 4 0 0 0 4 4h14.667v-2.667H4.78A1.333 1.333 0 0 1 3.448 28V4A1.333 1.333 0 0 1 4.78 2.667h14.667V0Zm.78 9.333 5.334 5.334H8.782v2.666h16.78l-5.333 5.334 1.885 1.885L30.667 16l-8.553-8.552z',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$r = forwardRef(SvgSignOut);
const SvgSleepy = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M16 2.667C8.636 2.667 2.667 8.637 2.667 16S8.637 29.333 16 29.333 29.333 23.363 29.333 16 23.363 2.667 16 2.667M0 16C0 7.163 7.163 0 16 0s16 7.163 16 16-7.163 16-16 16S0 24.837 0 16',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M20 10.667V12a1.333 1.333 0 0 0 2.667 0v-1.333h2.666V12a4 4 0 1 1-8 0v-1.333zm-10.667 0V12A1.333 1.333 0 1 0 12 12v-1.333h2.667V12a4 4 0 0 1-8 0v-1.333zM16 20a1.333 1.333 0 1 0 0 2.667A1.333 1.333 0 0 0 16 20m-4 1.333a4 4 0 1 1 8 0 4 4 0 0 1-8 0',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$q = forwardRef(SvgSleepy);
const SvgSmile = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M16 2.667C8.636 2.667 2.667 8.637 2.667 16S8.637 29.333 16 29.333 29.333 23.363 29.333 16 23.363 2.667 16 2.667M0 16C0 7.163 7.163 0 16 0s16 7.163 16 16-7.163 16-16 16S0 24.837 0 16',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      d: 'M10 16a2 2 0 1 0 0-4 2 2 0 0 0 0 4m12 0a2 2 0 1 0 0-4 2 2 0 0 0 0 4',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M12.229 23.771c-1-1-1.562-2.357-1.562-3.771h2.666a2.667 2.667 0 0 0 5.334 0h2.666a5.333 5.333 0 0 1-9.104 3.771',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$p = forwardRef(SvgSmile);
const SvgSpeechless = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M16 2.667C8.636 2.667 2.667 8.637 2.667 16S8.637 29.333 16 29.333 29.333 23.363 29.333 16 23.363 2.667 16 2.667M0 16C0 7.163 7.163 0 16 0s16 7.163 16 16-7.163 16-16 16S0 24.837 0 16',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      d: 'M10 16a2 2 0 1 0 0-4 2 2 0 0 0 0 4m12 0a2 2 0 1 0 0-4 2 2 0 0 0 0 4',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M9.333 20h13.334v2.667H9.333z',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$o = forwardRef(SvgSpeechless);
const SvgSpinner = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M16 2.667C8.636 2.667 2.667 8.637 2.667 16S8.637 29.333 16 29.333 29.333 23.363 29.333 16 23.363 2.667 16 2.667M0 16C0 7.163 7.163 0 16 0s16 7.163 16 16-7.163 16-16 16S0 24.837 0 16',
      clipRule: 'evenodd',
      opacity: 0.4,
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M25.428 6.572A13.33 13.33 0 0 0 16 2.667V0a16 16 0 0 1 16 16h-2.667a13.33 13.33 0 0 0-3.905-9.428',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$n = forwardRef(SvgSpinner);
const SvgSpotIcons = ({ titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement('svg', {
    xmlns: 'http://www.w3.org/2000/svg',
    width: '1em',
    height: '1em',
    ref,
    'aria-labelledby': titleId,
    ...props,
  });
const ForwardRef$m = forwardRef(SvgSpotIcons);
const SvgStop = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M0 0h32v32H0zm2.462 2.462v27.076h27.076V2.462z',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$l = forwardRef(SvgStop);
const SvgSun = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M0 14.667h4v2.666H0zM5.6 3.714l2.819 2.82-1.886 1.885L3.714 5.6zM17.333 0v4h-2.666V0zm10.953 5.6-2.82 2.819-1.885-1.886L26.4 3.714zM28 14.667h4v2.666h-4zm-2.533 8.914 2.819 2.819-1.886 1.886-2.819-2.82zM17.333 28v4h-2.666v-4zm-8.914-2.533L5.6 28.286 3.714 26.4l2.82-2.819zM16 9.333a6.667 6.667 0 1 0 0 13.334 6.667 6.667 0 0 0 0-13.334M6.667 16a9.333 9.333 0 1 1 18.666 0A9.333 9.333 0 0 1 16 25.333 9.333 9.333 0 0 1 6.667 16',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$k = forwardRef(SvgSun);
const SvgSupport = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M4 25.333v-1.888h2.667v1.888a4 4 0 0 0 4 4H16V32h-5.333A6.667 6.667 0 0 1 4 25.333M14.667 2.667a8 8 0 0 0-8 8v.541H4v-.541C4 4.776 8.776 0 14.667 0h2.666C23.224 0 28 4.776 28 10.667v.562h-2.667v-.562a8 8 0 0 0-8-8z',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M0 17.333a8 8 0 0 1 9.6-7.838l1.067.218v15.24l-1.067.219A8 8 0 0 1 0 17.334ZM8 12a5.334 5.334 0 0 0 0 10.667zm14.4-2.505a8 8 0 1 1 0 15.677l-1.067-.218V9.713zM24 12v10.667A5.334 5.334 0 0 0 24 12',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$j = forwardRef(SvgSupport);
const SvgTestLab = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M25.333 0H6.667v8h18.666zm-16 5.333V2.667h13.334v2.666z',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      d: 'M13.333 17.801V9.333h-2.666v7.533l-6.043 7.552A4.666 4.666 0 0 0 8.267 32h15.466a4.666 4.666 0 0 0 3.645-7.582l-6.045-7.553V9.333h-2.666v8.468l6.63 8.283a2 2 0 0 1-1.564 3.25H8.267a2 2 0 0 1-1.56-3.25z',
    }),
  );
const ForwardRef$i = forwardRef(SvgTestLab);
const SvgThumbsDown = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M0 0h24.57a5.33 5.33 0 0 1 5.265 4.523l1.436 9.333A5.335 5.335 0 0 1 26.001 20h-8.668v6.667A5.333 5.333 0 0 1 12 32h-1.018l-4-14.667H0zm9.333 15.821 3.636 13.33a2.67 2.67 0 0 0 1.698-2.484v-9.334H26a2.666 2.666 0 0 0 2.636-3.072L27.2 4.928a2.67 2.67 0 0 0-2.633-2.261H9.333zM6.667 2.667h-4v12h4z',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$h = forwardRef(SvgThumbsDown);
const SvgThumbsUp = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M0 32h8v-2.667H2.667v-12H8v-2.666H0z',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M6.667 32h17.902a5.33 5.33 0 0 0 5.266-4.523l1.436-9.333A5.335 5.335 0 0 0 26.001 12h-8.668V5.333A5.333 5.333 0 0 0 12 0h-1.018L6.667 15.821zm2.666-2.667V16.18l3.636-13.33a2.665 2.665 0 0 1 1.698 2.484v9.334H26a2.666 2.666 0 0 1 2.636 3.072L27.2 27.072a2.67 2.67 0 0 1-2.633 2.261z',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$g = forwardRef(SvgThumbsUp);
const SvgTimeClock = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      d: 'M17.333 14.667v-8h-2.666v10.666h10.666v-2.666z',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M16 0C7.163 0 0 7.163 0 16s7.163 16 16 16 16-7.163 16-16S24.837 0 16 0M2.667 16C2.667 8.636 8.637 2.667 16 2.667S29.333 8.637 29.333 16 23.363 29.333 16 29.333 2.667 23.363 2.667 16',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$f = forwardRef(SvgTimeClock);
const SvgTools = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M25.97.57a6.95 6.95 0 0 0-3.69-.511 8.82 8.82 0 0 0-8.031 8.804L5.604.218.329 5.493l9.43 9.43-7.78 6.854-.006.005a5.89 5.89 0 0 0-.484 8.31c.044.05.093.103.112.123l.006.007.008.009.009.008a5.715 5.715 0 0 0 8.077.179 6 6 0 0 0 .468-.499l11.084-12.46c1.172.239 2.38.273 3.567.097l.038-.005.037-.008a8.92 8.92 0 0 0 6.756-6.24 8.12 8.12 0 0 0-.165-5.208L30.76 4.16l-4.629 4.609-2.908-2.889 4.55-4.528zM11.763 13.156l1.599-1.409L5.604 3.99 4.1 5.493zm10.85-10.452.025-.003-3.196 3.181 6.692 6.648 3.186-3.172a5.5 5.5 0 0 1-.222 1.175l-.005.018a6.25 6.25 0 0 1-4.7 4.373 7.6 7.6 0 0 1-3.225-.233l-.81-.238-12.214 13.73-.016.02q-.12.146-.259.276l-.009.009a3.05 3.05 0 0 1-4.304-.086l-.037-.04-.012-.013-.01-.012-.01-.011a3.225 3.225 0 0 1 .258-4.551l.003-.003 13.844-12.198-.357-.877a4.3 4.3 0 0 1-.318-1.668v-.045a6.153 6.153 0 0 1 5.625-6.272l.035-.003z',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      d: 'm26.667 18.114 3.619 3.62a6 6 0 0 1-.08 8.478l-.073.073a6 6 0 0 1-8.48-.08l-4.872-4.872 1.886-1.885 4.885 4.885a3.33 3.33 0 0 0 4.71.052l.072-.072a3.333 3.333 0 0 0 .051-4.709L24.781 20z',
    }),
  );
const ForwardRef$e = forwardRef(SvgTools);
const SvgUnarchive = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      d: 'M7.2 1.333v-1h-.414l-.293.293zm17.6 0 .707-.707-.293-.293H24.8zM30.667 7.2h1v-.414l-.293-.293zM1.333 27.733h-1zm0-20.533-.707-.707-.293.293V7.2zM16 12.933l.707-.707L16 11.52l-.707.707.707.707Zm5.16 6.574.707.707L23.28 18.8l-.707-.707-1.414 1.414ZM9.426 18.093l-.707.707 1.414 1.414.708-.707zM7.2 2.333h17.6v-2H7.2zm16.893-.293 5.866 5.867 1.415-1.414L25.507.626zm5.574 5.16v20.533h2V7.2zm0 20.533A1.93 1.93 0 0 1 29.1 29.1l1.415 1.415a3.93 3.93 0 0 0 1.152-2.782zM29.1 29.1a1.93 1.93 0 0 1-1.367.567v2a3.93 3.93 0 0 0 2.782-1.152zm-1.367.567H4.267v2h23.466zm-23.466 0A1.93 1.93 0 0 1 2.9 29.1l-1.415 1.415a3.93 3.93 0 0 0 2.782 1.152zM2.9 29.1a1.93 1.93 0 0 1-.567-1.367h-2c0 1.043.415 2.044 1.152 2.782zm-.567-1.367V7.2h-2v20.533zM2.04 7.907 7.907 2.04 6.493.626.626 6.493zM15 12.933v13.2h2v-13.2zm7.574 5.16-5.867-5.867-1.414 1.414 5.867 5.867zm-7.281-5.867-5.867 5.867 1.415 1.414 5.866-5.867zM1.333 8.2h29.334v-2H1.333z',
    }),
  );
const ForwardRef$d = forwardRef(SvgUnarchive);
const SvgUndo = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      d: 'M21.333 2.667H12v2.666h9.333a8 8 0 0 1 0 16H5.886L11.219 16l-1.886-1.886-8.552 8.553 8.552 8.552 1.886-1.886L5.886 24h15.447C27.224 24 32 19.224 32 13.333c0-5.89-4.776-10.666-10.667-10.666',
    }),
  );
const ForwardRef$c = forwardRef(SvgUndo);
const SvgUnlock = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M17.194 23.747a3.918 3.918 0 0 0-1.231-7.635 3.916 3.916 0 0 0-1.231 7.635v2.882h2.462zm-1.231-5.174a1.455 1.455 0 0 0-.009 2.91h.018a1.455 1.455 0 0 0-.01-2.91Z',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M10.48 7.944c0-3.08 2.403-5.482 5.483-5.482s5.482 2.402 5.482 5.482h2.462c0-4.44-3.505-7.944-7.944-7.944-4.44 0-7.944 3.505-7.944 7.944v6.364a10.6 10.6 0 0 0-2.686 7.063c0 5.87 4.76 10.629 10.63 10.629s10.63-4.759 10.63-10.63c0-5.87-4.76-10.629-10.63-10.629a10.6 10.6 0 0 0-5.483 1.521zM7.795 21.371a8.168 8.168 0 1 1 16.336 0 8.168 8.168 0 0 1-16.336 0',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$b = forwardRef(SvgUnlock);
const SvgUp = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      d: 'm14.74 4.82-9.32 9.32-1.78-1.78L16 0l12.36 12.36-1.78 1.78-9.32-9.32V32h-2.52z',
    }),
  );
const ForwardRef$a = forwardRef(SvgUp);
const SvgUpload = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      d: 'M16 2.667c-4.741 0-8.762 2.998-10.385 7.168C2.43 10.709 0 13.688 0 17.19c0 3.996 3.058 7.275 7.03 7.626l.054.005h6.208v-2.462H7.195c-2.697-.264-4.733-2.487-4.733-5.17 0-2.536 1.915-4.691 4.288-5.087l.743-.124.228-.718C8.847 7.707 12.134 5.128 16 5.128c4.483 0 8.192 3.455 8.622 7.753l.099.995.994.107c2.161.231 3.823 1.994 3.823 4.191 0 2.177-1.63 3.927-3.762 4.185h-7.068v2.461h7.204l.065-.006c3.353-.36 6.023-3.126 6.023-6.64 0-3.17-2.174-5.733-5.063-6.466C25.975 6.603 21.432 2.666 16 2.666Z',
    }),
    /* @__PURE__ */ React.createElement('path', {
      d: 'm16 12.988 6.664 6.663-1.74 1.74L17.23 17.7v12.783h-2.462V17.7l-3.692 3.692-1.74-1.74z',
    }),
  );
const ForwardRef$9 = forwardRef(SvgUpload);
const SvgUpset = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'm24.456 13.93-5.052 2.526-1.193-2.386 5.052-2.526 1.192 2.386ZM8.737 11.544l5.052 2.526-1.193 2.386-5.052-2.526z',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M16 2.667C8.636 2.667 2.667 8.637 2.667 16S8.637 29.333 16 29.333 29.333 23.363 29.333 16 23.363 2.667 16 2.667M0 16C0 7.163 7.163 0 16 0s16 7.163 16 16-7.163 16-16 16S0 24.837 0 16',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M16 21.333A2.667 2.667 0 0 0 13.333 24h-2.666a5.333 5.333 0 1 1 10.666 0h-2.666A2.667 2.667 0 0 0 16 21.333',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$8 = forwardRef(SvgUpset);
const SvgUserInfo = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M18.667 13.333h8V16h-8zm0 5.334h8v2.666h-8z',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      d: 'M5.333 22.667a4 4 0 0 1 4-4H12a4 4 0 0 1 4 4z',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M0 2.667h8V4a1.333 1.333 0 1 0 2.667 0V2.667h10.666V4A1.333 1.333 0 1 0 24 4V2.667h8v26.666H0zm2.667 2.666v21.334h26.666V5.333H26.44a4 4 0 0 1-7.545 0h-5.788a4 4 0 0 1-7.545 0z',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      d: 'M10.667 17.333a2.667 2.667 0 1 0 0-5.333 2.667 2.667 0 0 0 0 5.333',
    }),
  );
const ForwardRef$7 = forwardRef(SvgUserInfo);
const SvgUsers = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M17.236 2.45C18.332.96 20.058 0 22 0c3.314 0 6 2.803 6 6.26v1.392c0 .918-.19 1.79-.53 2.576l2.619 1.64c1.187.742 1.911 2.08 1.911 3.52v6.873h-6.058a5.3 5.3 0 0 1 .725 2.684V32H0v-7.055c0-1.81.91-3.486 2.396-4.415l4.62-2.887a8.55 8.55 0 0 1-1.683-5.121V9.739c0-4.61 3.583-8.348 8-8.348 1.417 0 2.748.385 3.903 1.06Zm2.078 1.745c.607-.858 1.584-1.412 2.686-1.412 1.841 0 3.333 1.557 3.333 3.478v1.391c0 1.921-1.492 3.478-3.333 3.478a3 3 0 0 1-.667-.069V9.74c0-2.127-.763-4.07-2.019-5.544Zm-10.232 15.4-5.315 3.322a2.39 2.39 0 0 0-1.1 2.028v4.272H24v-4.272c0-.83-.418-1.6-1.1-2.028l-5.316-3.323a7.72 7.72 0 0 1-8.502 0Zm10.57-1.952 2.936 1.835h6.745v-4.09c0-.465-.233-.895-.614-1.133l-2.872-1.798a5.83 5.83 0 0 1-4.616 1.405 8.5 8.5 0 0 1-1.58 3.78ZM8 9.739c0-3.073 2.388-5.565 5.333-5.565s5.334 2.492 5.334 5.565v2.783c0 3.073-2.389 5.565-5.334 5.565S8 15.595 8 12.522z',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$6 = forwardRef(SvgUsers);
const SvgVideo = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M24.75 16 10.182 7.675v16.65zm-5.864 0-5.795 3.312v-6.624z',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M32 0H0v32h32zM2.91 29.09V2.91h26.18v26.18z',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$5 = forwardRef(SvgVideo);
const SvgWink = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M16 2.667C8.636 2.667 2.667 8.637 2.667 16S8.637 29.333 16 29.333 29.333 23.363 29.333 16 23.363 2.667 16 2.667M0 16C0 7.163 7.163 0 16 0s16 7.163 16 16-7.163 16-16 16S0 24.837 0 16',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', { d: 'M10 16a2 2 0 1 0 0-4 2 2 0 0 0 0 4' }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M12.229 23.771c-1-1-1.562-2.357-1.562-3.771h2.666a2.667 2.667 0 0 0 5.334 0h2.666a5.333 5.333 0 0 1-9.104 3.771M17.333 12H24v2.667h-6.667z',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$4 = forwardRef(SvgWink);
const SvgWorkstation = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M32 0H0v26.133h32zM2.667 23.467v-20.8h26.666v20.8z',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', { d: 'M24 29.333H8V32h16z' }),
  );
const ForwardRef$3 = forwardRef(SvgWorkstation);
const SvgZoomIn = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', {
      d: 'M14.156 11.534V7.21h-2.622v4.325H7.21v2.622h4.325v4.325h2.622v-4.325h4.325v-2.622z',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M20.954 22.807a12.8 12.8 0 0 1-8.109 2.883C5.751 25.69 0 19.939 0 12.845S5.75 0 12.845 0C19.939 0 25.69 5.75 25.69 12.845c0 3.075-1.08 5.897-2.883 8.109L32 30.146 30.146 32zM2.62 12.845c0-5.646 4.578-10.224 10.224-10.224S23.068 7.2 23.068 12.845a10.2 10.2 0 0 1-2.864 7.097l-.262.262a10.2 10.2 0 0 1-7.097 2.864c-5.646 0-10.224-4.577-10.224-10.223Z',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$2 = forwardRef(SvgZoomIn);
const SvgZoomOut = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1em',
      height: '1em',
      viewBox: '0 0 32 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement('path', { d: 'M7.333 14.4v-2.667H18.8V14.4z' }),
    /* @__PURE__ */ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M21.316 23.201a13 13 0 0 1-8.25 2.932C5.85 26.133 0 20.283 0 13.067S5.85 0 13.067 0c7.216 0 13.066 5.85 13.066 13.067a13 13 0 0 1-2.932 8.248l9.351 9.352-1.885 1.885zM2.666 13.067c0-5.744 4.657-10.4 10.4-10.4s10.4 4.656 10.4 10.4c0 2.804-1.109 5.348-2.913 7.219l-.267.267a10.37 10.37 0 0 1-7.22 2.914c-5.743 0-10.4-4.657-10.4-10.4',
      clipRule: 'evenodd',
    }),
  );
const ForwardRef$1 = forwardRef(SvgZoomOut);
const IconNames = [
  'add-a-user',
  'add-clinic',
  'add',
  'ai-star',
  'ai-wand',
  'ai',
  'alert-notification',
  'analyzer',
  'animal-canine',
  'animal-equine',
  'animal-feline',
  'animal-other',
  'app-menu',
  'archive',
  'back',
  'backward',
  'barcode',
  'beginning',
  'bell',
  'blocked',
  'book',
  'bookmark',
  'bottle',
  'brightness',
  'building',
  'calculator',
  'calendar',
  'camera',
  'cancel',
  'caret-down',
  'caret-up',
  'cart',
  'chat-2',
  'chat',
  'checkbox-indeterminate',
  'checkmark',
  'clipboard-medical-notes',
  'clipboard-patient',
  'clipboard',
  'close',
  'cloud-connected',
  'cloud-offline',
  'cloud',
  'collapse',
  'communicate',
  'contrast',
  'contribute',
  'controls',
  'copy',
  'crop',
  'cry',
  'cut',
  'dashboard',
  'delete',
  'delivery-time',
  'delivery',
  'diamond',
  'direction',
  'disgusted',
  'doctor',
  'document',
  'double-left',
  'double-right',
  'down',
  'download',
  'drag-2',
  'drag',
  'drawer-close',
  'drawer-open',
  'ecg',
  'edit',
  'email-read',
  'email',
  'end',
  'euro',
  'expand',
  'export',
  'favorite-featured',
  'feedback',
  'file-excel',
  'file-image',
  'file-pdf',
  'file-txt',
  'file-word',
  'file-zip',
  'filter',
  'fit-window',
  'flag',
  'folder-history',
  'forward-2',
  'forward',
  'fullscreen',
  'globe',
  'heart',
  'help-2',
  'help',
  'hide',
  'historical',
  'home',
  'image',
  'imaging',
  'import',
  'in-progress',
  'inbox',
  'info-2',
  'info',
  'inverse',
  'laugh',
  'library',
  'link',
  'list',
  'lock-private',
  'measure',
  'medicine',
  'menu',
  'microchip',
  'microphone-off',
  'microphone',
  'microscope',
  'minus',
  'mobile',
  'money',
  'moon',
  'more-2',
  'more',
  'next',
  'open-new-window',
  'owner',
  'panel-left-close',
  'panel-left-open',
  'panel-right-close',
  'panel-right-open',
  'paperclip',
  'patient-history',
  'patient-list',
  'patient',
  'pause',
  'phone-contact',
  'pill',
  'pin-2',
  'pin',
  'play',
  'plus',
  'power',
  'previous',
  'price',
  'print',
  'reassign',
  'recently-searched',
  'redo',
  'refresh-redo',
  'reply-all',
  'reply',
  'reports',
  'request',
  'rotate-image-left',
  'rotate-image-right',
  'rotate',
  'sad',
  'sample-2',
  'sample',
  'save',
  'search',
  'send',
  'settings',
  'share',
  'show',
  'sign-in',
  'sign-out',
  'sleepy',
  'smile',
  'speechless',
  'spinner',
  'spot_icons',
  'stop',
  'sun',
  'support',
  'test-lab',
  'thumbs-down',
  'thumbs-up',
  'time-clock',
  'tools',
  'unarchive',
  'undo',
  'unlock',
  'up',
  'upload',
  'upset',
  'user-info',
  'users',
  'video',
  'wink',
  'workstation',
  'zoom-in',
  'zoom-out',
];
const DefaultFactories = {
  'add-a-user': ForwardRef$33,
  'add-clinic': ForwardRef$32,
  add: ForwardRef$31,
  'ai-star': ForwardRef$30,
  'ai-wand': ForwardRef$2$,
  ai: ForwardRef$2_,
  'alert-notification': ForwardRef$2Z,
  analyzer: ForwardRef$2Y,
  'animal-canine': ForwardRef$2X,
  'animal-equine': ForwardRef$2W,
  'animal-feline': ForwardRef$2V,
  'animal-other': ForwardRef$2U,
  'app-menu': ForwardRef$2T,
  archive: ForwardRef$2S,
  back: ForwardRef$2R,
  backward: ForwardRef$2Q,
  barcode: ForwardRef$2P,
  beginning: ForwardRef$2O,
  bell: ForwardRef$2N,
  blocked: ForwardRef$2M,
  book: ForwardRef$2L,
  bookmark: ForwardRef$2K,
  bottle: ForwardRef$2J,
  brightness: ForwardRef$2I,
  building: ForwardRef$2H,
  calculator: ForwardRef$2G,
  calendar: ForwardRef$2F,
  camera: ForwardRef$2E,
  cancel: ForwardRef$2D,
  'caret-down': ForwardRef$2C,
  'caret-up': ForwardRef$2B,
  cart: ForwardRef$2A,
  'chat-2': ForwardRef$2z,
  chat: ForwardRef$2y,
  'checkbox-indeterminate': ForwardRef$2x,
  checkmark: ForwardRef$2w,
  'clipboard-medical-notes': ForwardRef$2v,
  'clipboard-patient': ForwardRef$2u,
  clipboard: ForwardRef$2t,
  close: ForwardRef$2s,
  'cloud-connected': ForwardRef$2r,
  'cloud-offline': ForwardRef$2q,
  cloud: ForwardRef$2p,
  collapse: ForwardRef$2o,
  communicate: ForwardRef$2n,
  contrast: ForwardRef$2m,
  contribute: ForwardRef$2l,
  controls: ForwardRef$2k,
  copy: ForwardRef$2j,
  crop: ForwardRef$2i,
  cry: ForwardRef$2h,
  cut: ForwardRef$2g,
  dashboard: ForwardRef$2f,
  delete: ForwardRef$2e,
  'delivery-time': ForwardRef$2d,
  delivery: ForwardRef$2c,
  diamond: ForwardRef$2b,
  direction: ForwardRef$2a,
  disgusted: ForwardRef$29,
  doctor: ForwardRef$28,
  document: ForwardRef$27,
  'double-left': ForwardRef$26,
  'double-right': ForwardRef$25,
  down: ForwardRef$24,
  download: ForwardRef$23,
  'drag-2': ForwardRef$22,
  drag: ForwardRef$21,
  'drawer-close': ForwardRef$20,
  'drawer-open': ForwardRef$1$,
  ecg: ForwardRef$1_,
  edit: ForwardRef$1Z,
  'email-read': ForwardRef$1Y,
  email: ForwardRef$1X,
  end: ForwardRef$1W,
  euro: ForwardRef$1V,
  expand: ForwardRef$1U,
  export: ForwardRef$1T,
  'favorite-featured': ForwardRef$1S,
  feedback: ForwardRef$1R,
  'file-excel': ForwardRef$1Q,
  'file-image': ForwardRef$1P,
  'file-pdf': ForwardRef$1O,
  'file-txt': ForwardRef$1N,
  'file-word': ForwardRef$1M,
  'file-zip': ForwardRef$1L,
  filter: ForwardRef$1K,
  'fit-window': ForwardRef$1J,
  flag: ForwardRef$1I,
  'folder-history': ForwardRef$1H,
  'forward-2': ForwardRef$1G,
  forward: ForwardRef$1F,
  fullscreen: ForwardRef$1E,
  globe: ForwardRef$1D,
  heart: ForwardRef$1C,
  'help-2': ForwardRef$1B,
  help: ForwardRef$1A,
  hide: ForwardRef$1z,
  historical: ForwardRef$1y,
  home: ForwardRef$1x,
  image: ForwardRef$1w,
  imaging: ForwardRef$1v,
  import: ForwardRef$1u,
  'in-progress': ForwardRef$1t,
  inbox: ForwardRef$1s,
  'info-2': ForwardRef$1r,
  info: ForwardRef$1q,
  inverse: ForwardRef$1p,
  laugh: ForwardRef$1o,
  library: ForwardRef$1n,
  link: ForwardRef$1m,
  list: ForwardRef$1l,
  'lock-private': ForwardRef$1k,
  measure: ForwardRef$1j,
  medicine: ForwardRef$1i,
  menu: ForwardRef$1h,
  microchip: ForwardRef$1g,
  'microphone-off': ForwardRef$1f,
  microphone: ForwardRef$1e,
  microscope: ForwardRef$1d,
  minus: ForwardRef$1c,
  mobile: ForwardRef$1b,
  money: ForwardRef$1a,
  moon: ForwardRef$19,
  'more-2': ForwardRef$18,
  more: ForwardRef$17,
  next: ForwardRef$16,
  'open-new-window': ForwardRef$15,
  owner: ForwardRef$14,
  'panel-left-close': ForwardRef$13,
  'panel-left-open': ForwardRef$12,
  'panel-right-close': ForwardRef$11,
  'panel-right-open': ForwardRef$10,
  paperclip: ForwardRef$$,
  'patient-history': ForwardRef$_,
  'patient-list': ForwardRef$Z,
  patient: ForwardRef$Y,
  pause: ForwardRef$X,
  'phone-contact': ForwardRef$W,
  pill: ForwardRef$V,
  'pin-2': ForwardRef$U,
  pin: ForwardRef$T,
  play: ForwardRef$S,
  plus: ForwardRef$R,
  power: ForwardRef$Q,
  previous: ForwardRef$P,
  price: ForwardRef$O,
  print: ForwardRef$N,
  reassign: ForwardRef$M,
  'recently-searched': ForwardRef$L,
  redo: ForwardRef$K,
  'refresh-redo': ForwardRef$J,
  'reply-all': ForwardRef$I,
  reply: ForwardRef$H,
  reports: ForwardRef$G,
  request: ForwardRef$F,
  'rotate-image-left': ForwardRef$E,
  'rotate-image-right': ForwardRef$D,
  rotate: ForwardRef$C,
  sad: ForwardRef$B,
  'sample-2': ForwardRef$A,
  sample: ForwardRef$z,
  save: ForwardRef$y,
  search: ForwardRef$x,
  send: ForwardRef$w,
  settings: ForwardRef$v,
  share: ForwardRef$u,
  show: ForwardRef$t,
  'sign-in': ForwardRef$s,
  'sign-out': ForwardRef$r,
  sleepy: ForwardRef$q,
  smile: ForwardRef$p,
  speechless: ForwardRef$o,
  spinner: ForwardRef$n,
  spot_icons: ForwardRef$m,
  stop: ForwardRef$l,
  sun: ForwardRef$k,
  support: ForwardRef$j,
  'test-lab': ForwardRef$i,
  'thumbs-down': ForwardRef$h,
  'thumbs-up': ForwardRef$g,
  'time-clock': ForwardRef$f,
  tools: ForwardRef$e,
  unarchive: ForwardRef$d,
  undo: ForwardRef$c,
  unlock: ForwardRef$b,
  up: ForwardRef$a,
  upload: ForwardRef$9,
  upset: ForwardRef$8,
  'user-info': ForwardRef$7,
  users: ForwardRef$6,
  video: ForwardRef$5,
  wink: ForwardRef$4,
  workstation: ForwardRef$3,
  'zoom-in': ForwardRef$2,
  'zoom-out': ForwardRef$1,
};
const IconFactory = ({ iconName, ...additionalProps }) => {
  const IconElement = DefaultFactories[iconName];
  if (!IconElement) {
    console.error(`Invalid icon name [ ${iconName} ]`);
    throw new Error('Invalid Icon Name');
  }
  return /* @__PURE__ */ React__default.createElement(IconElement, { ...additionalProps });
};
const ICON_CLASSNAME = 'spot-icon';
const sizeMap = { xs: '12px', s: '16px', m: '20px', l: '24px' };
const iconSizes = Object.keys(sizeMap);
const Icon = forwardRef(
  ({ className, size: size2, style, title, iconTitle, iconName, ...rest }, ref) => {
    const sizeValue = size2 ? sizeMap[size2] : void 0;
    const iconType = iconName ?? title;
    if (!iconType) {
      throw new Error('Either a title or iconName property must be specified');
    }
    const iconProps = {
      className: classNames(ICON_CLASSNAME, className),
      style: { ...style, width: sizeValue, height: sizeValue },
      width: sizeValue,
      height: sizeValue,
      'aria-labelledby': iconTitle || title,
      ref,
      title: iconTitle || title,
      ...rest,
    };
    return /* @__PURE__ */ React__default.createElement(IconFactory, {
      iconName: iconType,
      ...iconProps,
    });
  },
);
Icon.displayName = 'Icon';
const InteractiveIcon = forwardRefWithAs(
  (
    { as: Component = 'a', variant, className, title, size: size2, iconAttrs = {}, ...props },
    ref,
  ) => {
    return /* @__PURE__ */ React__default.createElement(
      Component,
      {
        className: classNames(
          { [`spot-icon--interactive spot-icon--interactive-${variant}`]: variant },
          className,
        ),
        ref,
        ...props,
      },
      /* @__PURE__ */ React__default.createElement(Icon, { title, size: size2, ...iconAttrs }),
    );
  },
);
InteractiveIcon.displayName = 'InteractiveIcon';
const ICON_NAMES_LIST = IconNames;
function renderIcon(icon, additionalClassName) {
  if (icon === void 0 || icon === null) {
    return null;
  }
  return typeof icon === 'string'
    ? /* @__PURE__ */ React__default.createElement(Icon, {
        title: icon,
        className: additionalClassName,
      })
    : icon({ className: classNames(ICON_CLASSNAME, additionalClassName) });
}
const BUTTON_VARIANT_LIST = ['primary', 'secondary', 'link'];
const BUTTON_SIZE_LIST = ['small', 'default', 'large'];
const Button = forwardRefWithAs(
  (
    {
      as,
      variant = 'primary',
      size: size2 = 'default',
      iconLeft,
      iconRight,
      iconOnly,
      className,
      children,
      ...rest
    },
    ref,
  ) => {
    const Component = as ?? 'button';
    return /* @__PURE__ */ React__default.createElement(
      Component,
      {
        className: classNames('spot-button', className, [`spot-button--${variant}`], {
          [`spot-button--${size2}`]: size2 && size2 !== 'default',
          'spot-button--icon-only spot-button--with-icon': iconOnly,
        }),
        ...rest,
        ref,
      },
      iconOnly
        ? /* @__PURE__ */ React__default.createElement(
            React__default.Fragment,
            null,
            renderIcon(iconOnly, 'spot-button__icon'),
            /* @__PURE__ */ React__default.createElement(
              'span',
              { className: 'spot--screenreader-only' },
              children,
            ),
          )
        : /* @__PURE__ */ React__default.createElement(
            React__default.Fragment,
            null,
            renderIcon(iconLeft, 'spot-button__icon spot-button__icon--left'),
            iconLeft || iconRight
              ? /* @__PURE__ */ React__default.createElement(
                  'span',
                  { className: 'spot-button__text' },
                  children,
                )
              : children,
            renderIcon(iconRight, 'spot-button__icon spot-button__icon--right'),
          ),
    );
  },
);
Button.displayName = 'Button';
const ButtonGroup = forwardRefWithAs(
  ({ as, className, withLines = false, variant, disabled = false, ...rest }, ref) => {
    const Component = as ?? 'div';
    return /* @__PURE__ */ React__default.createElement(Component, {
      className: classNames('spot-button-group', className, {
        'with-lines': withLines,
        'spot-button-group--disabled': disabled,
        'spot-button-group-toggle': variant === 'toggle',
      }),
      ...rest,
      ref,
    });
  },
);
ButtonGroup.displayName = 'ButtonGroup';
const ALIGNMENT_OPTIONS = [
  'top-left',
  'top-center',
  'top-right',
  'center-left',
  'center-center',
  'center-right',
  'bottom-left',
  'bottom-center',
  'bottom-right',
];
function getAlignmentClass(alignment) {
  return alignment ? `align--${alignment}` : '';
}
const Card = forwardRefWithAs(
  (
    {
      as,
      className,
      children,
      variant = 'primary',
      dismissible = false,
      onDismiss,
      isInteractive = false,
      withOutline = false,
      ...props
    },
    ref,
  ) => {
    const [cardState, setCardState] = useState('show');
    const dismissCard = useCallback(async () => {
      setCardState('dismissing');
    }, []);
    useEffect(() => {
      if (cardState === 'dismissing') {
        setTimeout(() => {
          setCardState('dismissed');
          onDismiss?.();
        }, 750);
      }
    }, [cardState, onDismiss]);
    const Component = as ?? 'div';
    return cardState !== 'dismissed'
      ? /* @__PURE__ */ React__default.createElement(
          Component,
          {
            ref,
            className: classNames(
              `spot-card`,
              `spot-card--${variant}`,
              { 'spot-card--with-outline': withOutline },
              className,
              { 'is-interactive': isInteractive, 'animated fadeOut': cardState === 'dismissing' },
            ),
            ...props,
          },
          children,
          dismissible
            ? /* @__PURE__ */ React__default.createElement(
                'button',
                { className: 'dismiss', onClick: dismissCard },
                /* @__PURE__ */ React__default.createElement(Icon, { title: 'cancel' }),
              )
            : null,
        )
      : null;
  },
);
const CardBody = forwardRefWithAs(({ as, className, alignment, ...props }, ref) => {
  const Component = as ?? 'div';
  return /* @__PURE__ */ React__default.createElement(Component, {
    ref,
    className: classNames('spot-card--body', className, {
      [getAlignmentClass(alignment)]: alignment,
    }),
    ...props,
  });
});
const CardImage = forwardRefWithAs(
  ({ as, className, children, src, alt, hasFrame = false, alignment, ...props }, ref) => {
    const Component = as ?? 'figure';
    return /* @__PURE__ */ React__default.createElement(
      Component,
      {
        ref,
        className: classNames('spot-card--img', className, { 'has-frame': hasFrame }),
        ...props,
      },
      children
        ? /* @__PURE__ */ React__default.createElement(
            'div',
            {
              className: classNames('spot-card--img_caption', {
                [getAlignmentClass(alignment)]: alignment,
              }),
            },
            children,
          )
        : null,
      /* @__PURE__ */ React__default.createElement('img', { src, alt }),
    );
  },
);
const CardHeader = forwardRefWithAs(
  (
    { as, className, children, addContrast = false, noBorder = false, alignment, ...props },
    ref,
  ) => {
    const Component = as ?? 'header';
    return /* @__PURE__ */ React__default.createElement(
      Component,
      {
        ref,
        className: classNames('spot-card--header', className, {
          'add-contrast': addContrast,
          'no-border': noBorder,
          [getAlignmentClass(alignment)]: alignment,
        }),
        ...props,
      },
      children,
    );
  },
);
const CardFooter = forwardRefWithAs(
  (
    { as, className, children, addContrast = false, noBorder = false, alignment, ...props },
    ref,
  ) => {
    const Component = as ?? 'footer';
    return /* @__PURE__ */ React__default.createElement(
      Component,
      {
        ref,
        className: classNames('spot-card--footer', className, {
          'add-contrast': addContrast,
          'no-border': noBorder,
          [getAlignmentClass(alignment)]: alignment,
        }),
        ...props,
      },
      children,
    );
  },
);
const COMMON_HEADER_CLASS = 'spot-header';
const CommonHeader = forwardRefWithAs((props, ref) => {
  const {
    as: Component = 'nav',
    persistentMenu = false,
    fluid = false,
    leftAligned = false,
    leftContent,
    rightContent,
    optionalContent,
    className,
    ...htmlProps
  } = props;
  const headerClasses = classNames(COMMON_HEADER_CLASS, className, {
    [`${COMMON_HEADER_CLASS}--persistent-menu`]: persistentMenu,
    [`${COMMON_HEADER_CLASS}--fluid`]: fluid,
    [`${COMMON_HEADER_CLASS}--left-aligned`]: leftAligned,
  });
  return /* @__PURE__ */ React__default.createElement(
    Component,
    { ref, className: headerClasses, ...htmlProps },
    /* @__PURE__ */ React__default.createElement(
      'div',
      { className: 'spot-header__wrapper' },
      /* @__PURE__ */ React__default.createElement(
        'div',
        { className: 'spot-header__left-content' },
        leftContent,
      ),
      optionalContent &&
        /* @__PURE__ */ React__default.createElement(
          'div',
          { className: 'spot-header__optional-content' },
          optionalContent,
        ),
      /* @__PURE__ */ React__default.createElement(
        'div',
        { className: 'spot-header__right-content' },
        /* @__PURE__ */ React__default.createElement(
          'div',
          { className: 'spot-header__nav-items' },
          rightContent,
        ),
      ),
    ),
  );
});
const CommonHeaderNavItem = forwardRefWithAs((props, ref) => {
  const { as: Component = 'div', children, className, ...htmlProps } = props;
  return /* @__PURE__ */ React__default.createElement(
    Component,
    { ref, className: classNames('spot-header__nav-item', className), ...htmlProps },
    children,
  );
});
const CommonHeaderNavLink = forwardRefWithAs((props, ref) => {
  const { children, as: Component = 'a', className, ...htmlProps } = props;
  return /* @__PURE__ */ React__default.createElement(
    Component,
    { ref, className: classNames('spot-header__nav-item-link', className), ...htmlProps },
    children,
  );
});
const CommonHeaderOptionalItems = forwardRefWithAs((props, ref) => {
  const { as: Component = 'ul', itemType, children, className, ...htmlProps } = props;
  const itemsClasses = classNames(
    className,
    'spot-header__nav-items',
    `spot-header__optional-content__${itemType}`,
  );
  return /* @__PURE__ */ React__default.createElement(
    Component,
    { className: itemsClasses, ref, ...htmlProps },
    children,
  );
});
const CommonHeaderProductIdentity = forwardRefWithAs((props, ref) => {
  const { as: Component = 'div', productName, icon, className, ...htmlProps } = props;
  return /* @__PURE__ */ React__default.createElement(
    Component,
    { ref, className: classNames('spot-header__product-identity', className), ...htmlProps },
    /* @__PURE__ */ React__default.createElement(
      'div',
      { className: 'spot-header__product-icon' },
      icon,
    ),
    /* @__PURE__ */ React__default.createElement(
      'div',
      { className: 'spot-header__product-name' },
      /* @__PURE__ */ React__default.createElement(
        'div',
        { className: 'spot-header__product-name' },
        productName,
      ),
    ),
  );
});
const CommonHeaderResponsiveMenu = forwardRefWithAs((props, ref) => {
  const { as: Component = 'a', className, ...htmlProps } = props;
  return /* @__PURE__ */ React__default.createElement(
    Component,
    {
      ref,
      className: classNames('spot-header__responsive-menu', className),
      href: '#',
      ...htmlProps,
    },
    /* @__PURE__ */ React__default.createElement(
      'span',
      null,
      /* @__PURE__ */ React__default.createElement(Icon, { title: 'menu' }),
    ),
  );
});
const CommonHeaderSignOut = forwardRefWithAs((props, ref) => {
  const { as: Component = 'a', children, ...htmlProps } = props;
  return /* @__PURE__ */ React__default.createElement(
    CommonHeaderNavItem,
    { className: 'spot-header__signin' },
    /* @__PURE__ */ React__default.createElement(
      Component,
      { title: 'sign out', ref, className: 'spot-header__nav-item-link', ...htmlProps },
      children,
    ),
  );
});
const CrossProductButton = forwardRefWithAs((props, ref) => {
  const {
    as: Component = 'div',
    label = 'Cross Product Navigation',
    className,
    color = 'lightteal',
    iconName = 'app-menu',
    ...htmlProps
  } = props;
  const cmpClassNames = classNames(
    'spot-crossproduct-icon',
    `spot-crossproduct-icon--${color}`,
    className,
  );
  return /* @__PURE__ */ React__default.createElement(
    Component,
    { ref, className: cmpClassNames, ...htmlProps },
    /* @__PURE__ */ React__default.createElement(
      Icon,
      { title: iconName, 'aria-label': label },
      label,
    ),
  );
});
const CrossProductFooter = forwardRefWithAs((props, ref) => {
  const { as: Component = 'div', className, children, ...htmlProps } = props;
  const cmpClassNames = classNames('spot-crossproduct__footer', className);
  return /* @__PURE__ */ React__default.createElement(
    Component,
    { ref, className: cmpClassNames, ...htmlProps },
    /* @__PURE__ */ React__default.createElement(
      'div',
      { className: 'spot-crossproduct__footer-items' },
      children,
    ),
  );
});
const CrossProductFooterItem = forwardRefWithAs((props, ref) => {
  const { as: Component = 'a', className, title, img, ...htmlProps } = props;
  const { src, alt, ...imgProps } = img;
  const cmpClassNames = classNames('spot-link', className);
  return /* @__PURE__ */ React__default.createElement(
    Component,
    { ref, className: cmpClassNames, ...htmlProps },
    /* @__PURE__ */ React__default.createElement('img', { src, alt, ...imgProps }),
    title,
  );
});
const CrossProductItem = forwardRefWithAs((props, ref) => {
  const { as: Component = 'a', className, href, title, img, ...htmlProps } = props;
  const cmpClassNames = classNames('spot-crossproduct__content-item', className);
  const { src, alt, ...imgProps } = img;
  return /* @__PURE__ */ React__default.createElement(
    Component,
    { ref, className: cmpClassNames, href, ...htmlProps },
    /* @__PURE__ */ React__default.createElement('img', { src, alt, ...imgProps }),
    /* @__PURE__ */ React__default.createElement(
      'span',
      { className: 'spot-crossproduct__content-item-title' },
      title,
    ),
  );
});
const CrossProductItems = forwardRefWithAs((props, ref) => {
  const {
    as: Component = 'div',
    variant = 'affiliated',
    className,
    label,
    children,
    ...htmlProps
  } = props;
  const cmpClassNames = classNames(`spot-crossproduct__content--${variant}-items`, className);
  return /* @__PURE__ */ React__default.createElement(
    Component,
    { ref, className: cmpClassNames, ...htmlProps },
    /* @__PURE__ */ React__default.createElement(
      'span',
      { className: 'spot-crossproduct__content--heading' },
      label,
    ),
    children,
  );
});
function composeEventHandlers(
  originalEventHandler,
  ourEventHandler,
  { checkForDefaultPrevented = true } = {},
) {
  return function handleEvent(event) {
    originalEventHandler?.(event);
    if (checkForDefaultPrevented === false || !event.defaultPrevented) {
      return ourEventHandler?.(event);
    }
  };
}
function setRef(ref, value) {
  if (typeof ref === 'function') {
    return ref(value);
  } else if (ref !== null && ref !== void 0) {
    ref.current = value;
  }
}
function composeRefs(...refs) {
  return node => {
    let hasCleanup = false;
    const cleanups = refs.map(ref => {
      const cleanup = setRef(ref, node);
      if (!hasCleanup && typeof cleanup == 'function') {
        hasCleanup = true;
      }
      return cleanup;
    });
    if (hasCleanup) {
      return () => {
        for (let i = 0; i < cleanups.length; i++) {
          const cleanup = cleanups[i];
          if (typeof cleanup == 'function') {
            cleanup();
          } else {
            setRef(refs[i], null);
          }
        }
      };
    }
  };
}
function useComposedRefs(...refs) {
  return React.useCallback(composeRefs(...refs), refs);
}
function createContext2(rootComponentName, defaultContext) {
  const Context = React.createContext(defaultContext);
  const Provider = props => {
    const { children, ...context } = props;
    const value = React.useMemo(() => context, Object.values(context));
    return /* @__PURE__ */ jsx(Context.Provider, { value, children });
  };
  Provider.displayName = rootComponentName + 'Provider';
  function useContext2(consumerName) {
    const context = React.useContext(Context);
    if (context) return context;
    if (defaultContext !== void 0) return defaultContext;
    throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
  }
  return [Provider, useContext2];
}
function createContextScope(scopeName, createContextScopeDeps = []) {
  let defaultContexts = [];
  function createContext3(rootComponentName, defaultContext) {
    const BaseContext = React.createContext(defaultContext);
    const index2 = defaultContexts.length;
    defaultContexts = [...defaultContexts, defaultContext];
    const Provider = props => {
      const { scope, children, ...context } = props;
      const Context = scope?.[scopeName]?.[index2] || BaseContext;
      const value = React.useMemo(() => context, Object.values(context));
      return /* @__PURE__ */ jsx(Context.Provider, { value, children });
    };
    Provider.displayName = rootComponentName + 'Provider';
    function useContext2(consumerName, scope) {
      const Context = scope?.[scopeName]?.[index2] || BaseContext;
      const context = React.useContext(Context);
      if (context) return context;
      if (defaultContext !== void 0) return defaultContext;
      throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    return [Provider, useContext2];
  }
  const createScope = () => {
    const scopeContexts = defaultContexts.map(defaultContext => {
      return React.createContext(defaultContext);
    });
    return function useScope(scope) {
      const contexts = scope?.[scopeName] || scopeContexts;
      return React.useMemo(
        () => ({ [`__scope${scopeName}`]: { ...scope, [scopeName]: contexts } }),
        [scope, contexts],
      );
    };
  };
  createScope.scopeName = scopeName;
  return [createContext3, composeContextScopes(createScope, ...createContextScopeDeps)];
}
function composeContextScopes(...scopes) {
  const baseScope = scopes[0];
  if (scopes.length === 1) return baseScope;
  const createScope = () => {
    const scopeHooks = scopes.map(createScope2 => ({
      useScope: createScope2(),
      scopeName: createScope2.scopeName,
    }));
    return function useComposedScopes(overrideScopes) {
      const nextScopes = scopeHooks.reduce((nextScopes2, { useScope, scopeName }) => {
        const scopeProps = useScope(overrideScopes);
        const currentScope = scopeProps[`__scope${scopeName}`];
        return { ...nextScopes2, ...currentScope };
      }, {});
      return React.useMemo(() => ({ [`__scope${baseScope.scopeName}`]: nextScopes }), [nextScopes]);
    };
  };
  createScope.scopeName = baseScope.scopeName;
  return createScope;
}
// @__NO_SIDE_EFFECTS__
function createSlot(ownerName) {
  const SlotClone = /* @__PURE__ */ createSlotClone(ownerName);
  const Slot2 = React.forwardRef((props, forwardedRef) => {
    const { children, ...slotProps } = props;
    const childrenArray = React.Children.toArray(children);
    const slottable = childrenArray.find(isSlottable);
    if (slottable) {
      const newElement = slottable.props.children;
      const newChildren = childrenArray.map(child => {
        if (child === slottable) {
          if (React.Children.count(newElement) > 1) return React.Children.only(null);
          return React.isValidElement(newElement) ? newElement.props.children : null;
        } else {
          return child;
        }
      });
      return /* @__PURE__ */ jsx(SlotClone, {
        ...slotProps,
        ref: forwardedRef,
        children: React.isValidElement(newElement)
          ? React.cloneElement(newElement, void 0, newChildren)
          : null,
      });
    }
    return /* @__PURE__ */ jsx(SlotClone, { ...slotProps, ref: forwardedRef, children });
  });
  Slot2.displayName = `${ownerName}.Slot`;
  return Slot2;
}
// @__NO_SIDE_EFFECTS__
function createSlotClone(ownerName) {
  const SlotClone = React.forwardRef((props, forwardedRef) => {
    const { children, ...slotProps } = props;
    if (React.isValidElement(children)) {
      const childrenRef = getElementRef$1(children);
      const props2 = mergeProps(slotProps, children.props);
      if (children.type !== React.Fragment) {
        props2.ref = forwardedRef ? composeRefs(forwardedRef, childrenRef) : childrenRef;
      }
      return React.cloneElement(children, props2);
    }
    return React.Children.count(children) > 1 ? React.Children.only(null) : null;
  });
  SlotClone.displayName = `${ownerName}.SlotClone`;
  return SlotClone;
}
var SLOTTABLE_IDENTIFIER = /* @__PURE__ */ Symbol('radix.slottable');
function isSlottable(child) {
  return (
    React.isValidElement(child) &&
    typeof child.type === 'function' &&
    '__radixId' in child.type &&
    child.type.__radixId === SLOTTABLE_IDENTIFIER
  );
}
function mergeProps(slotProps, childProps) {
  const overrideProps = { ...childProps };
  for (const propName in childProps) {
    const slotPropValue = slotProps[propName];
    const childPropValue = childProps[propName];
    const isHandler = /^on[A-Z]/.test(propName);
    if (isHandler) {
      if (slotPropValue && childPropValue) {
        overrideProps[propName] = (...args) => {
          const result = childPropValue(...args);
          slotPropValue(...args);
          return result;
        };
      } else if (slotPropValue) {
        overrideProps[propName] = slotPropValue;
      }
    } else if (propName === 'style') {
      overrideProps[propName] = { ...slotPropValue, ...childPropValue };
    } else if (propName === 'className') {
      overrideProps[propName] = [slotPropValue, childPropValue].filter(Boolean).join(' ');
    }
  }
  return { ...slotProps, ...overrideProps };
}
function getElementRef$1(element) {
  let getter = Object.getOwnPropertyDescriptor(element.props, 'ref')?.get;
  let mayWarn = getter && 'isReactWarning' in getter && getter.isReactWarning;
  if (mayWarn) {
    return element.ref;
  }
  getter = Object.getOwnPropertyDescriptor(element, 'ref')?.get;
  mayWarn = getter && 'isReactWarning' in getter && getter.isReactWarning;
  if (mayWarn) {
    return element.props.ref;
  }
  return element.props.ref || element.ref;
}
var NODES = [
  'a',
  'button',
  'div',
  'form',
  'h2',
  'h3',
  'img',
  'input',
  'label',
  'li',
  'nav',
  'ol',
  'p',
  'select',
  'span',
  'svg',
  'ul',
];
var Primitive = NODES.reduce((primitive, node) => {
  const Slot2 = /* @__PURE__ */ createSlot(`Primitive.${node}`);
  const Node2 = React.forwardRef((props, forwardedRef) => {
    const { asChild, ...primitiveProps } = props;
    const Comp = asChild ? Slot2 : node;
    if (typeof window !== 'undefined') {
      window[/* @__PURE__ */ Symbol.for('radix-ui')] = true;
    }
    return /* @__PURE__ */ jsx(Comp, { ...primitiveProps, ref: forwardedRef });
  });
  Node2.displayName = `Primitive.${node}`;
  return { ...primitive, [node]: Node2 };
}, {});
function dispatchDiscreteCustomEvent(target, event) {
  if (target) ReactDOM.flushSync(() => target.dispatchEvent(event));
}
function useCallbackRef$1(callback) {
  const callbackRef = React.useRef(callback);
  React.useEffect(() => {
    callbackRef.current = callback;
  });
  return React.useMemo(
    () =>
      (...args) =>
        callbackRef.current?.(...args),
    [],
  );
}
function useEscapeKeydown(onEscapeKeyDownProp, ownerDocument = globalThis?.document) {
  const onEscapeKeyDown = useCallbackRef$1(onEscapeKeyDownProp);
  React.useEffect(() => {
    const handleKeyDown = event => {
      if (event.key === 'Escape') {
        onEscapeKeyDown(event);
      }
    };
    ownerDocument.addEventListener('keydown', handleKeyDown, { capture: true });
    return () => ownerDocument.removeEventListener('keydown', handleKeyDown, { capture: true });
  }, [onEscapeKeyDown, ownerDocument]);
}
var DISMISSABLE_LAYER_NAME = 'DismissableLayer';
var CONTEXT_UPDATE = 'dismissableLayer.update';
var POINTER_DOWN_OUTSIDE = 'dismissableLayer.pointerDownOutside';
var FOCUS_OUTSIDE = 'dismissableLayer.focusOutside';
var originalBodyPointerEvents;
var DismissableLayerContext = React.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set(),
});
var DismissableLayer = React.forwardRef((props, forwardedRef) => {
  const {
    disableOutsidePointerEvents = false,
    onEscapeKeyDown,
    onPointerDownOutside,
    onFocusOutside,
    onInteractOutside,
    onDismiss,
    ...layerProps
  } = props;
  const context = React.useContext(DismissableLayerContext);
  const [node, setNode] = React.useState(null);
  const ownerDocument = node?.ownerDocument ?? globalThis?.document;
  const [, force] = React.useState({});
  const composedRefs = useComposedRefs(forwardedRef, node2 => setNode(node2));
  const layers = Array.from(context.layers);
  const [highestLayerWithOutsidePointerEventsDisabled] = [
    ...context.layersWithOutsidePointerEventsDisabled,
  ].slice(-1);
  const highestLayerWithOutsidePointerEventsDisabledIndex = layers.indexOf(
    highestLayerWithOutsidePointerEventsDisabled,
  );
  const index2 = node ? layers.indexOf(node) : -1;
  const isBodyPointerEventsDisabled = context.layersWithOutsidePointerEventsDisabled.size > 0;
  const isPointerEventsEnabled = index2 >= highestLayerWithOutsidePointerEventsDisabledIndex;
  const pointerDownOutside = usePointerDownOutside(event => {
    const target = event.target;
    const isPointerDownOnBranch = [...context.branches].some(branch => branch.contains(target));
    if (!isPointerEventsEnabled || isPointerDownOnBranch) return;
    onPointerDownOutside?.(event);
    onInteractOutside?.(event);
    if (!event.defaultPrevented) onDismiss?.();
  }, ownerDocument);
  const focusOutside = useFocusOutside(event => {
    const target = event.target;
    const isFocusInBranch = [...context.branches].some(branch => branch.contains(target));
    if (isFocusInBranch) return;
    onFocusOutside?.(event);
    onInteractOutside?.(event);
    if (!event.defaultPrevented) onDismiss?.();
  }, ownerDocument);
  useEscapeKeydown(event => {
    const isHighestLayer = index2 === context.layers.size - 1;
    if (!isHighestLayer) return;
    onEscapeKeyDown?.(event);
    if (!event.defaultPrevented && onDismiss) {
      event.preventDefault();
      onDismiss();
    }
  }, ownerDocument);
  React.useEffect(() => {
    if (!node) return;
    if (disableOutsidePointerEvents) {
      if (context.layersWithOutsidePointerEventsDisabled.size === 0) {
        originalBodyPointerEvents = ownerDocument.body.style.pointerEvents;
        ownerDocument.body.style.pointerEvents = 'none';
      }
      context.layersWithOutsidePointerEventsDisabled.add(node);
    }
    context.layers.add(node);
    dispatchUpdate();
    return () => {
      if (
        disableOutsidePointerEvents &&
        context.layersWithOutsidePointerEventsDisabled.size === 1
      ) {
        ownerDocument.body.style.pointerEvents = originalBodyPointerEvents;
      }
    };
  }, [node, ownerDocument, disableOutsidePointerEvents, context]);
  React.useEffect(() => {
    return () => {
      if (!node) return;
      context.layers.delete(node);
      context.layersWithOutsidePointerEventsDisabled.delete(node);
      dispatchUpdate();
    };
  }, [node, context]);
  React.useEffect(() => {
    const handleUpdate = () => force({});
    document.addEventListener(CONTEXT_UPDATE, handleUpdate);
    return () => document.removeEventListener(CONTEXT_UPDATE, handleUpdate);
  }, []);
  return /* @__PURE__ */ jsx(Primitive.div, {
    ...layerProps,
    ref: composedRefs,
    style: {
      pointerEvents: isBodyPointerEventsDisabled
        ? isPointerEventsEnabled
          ? 'auto'
          : 'none'
        : void 0,
      ...props.style,
    },
    onFocusCapture: composeEventHandlers(props.onFocusCapture, focusOutside.onFocusCapture),
    onBlurCapture: composeEventHandlers(props.onBlurCapture, focusOutside.onBlurCapture),
    onPointerDownCapture: composeEventHandlers(
      props.onPointerDownCapture,
      pointerDownOutside.onPointerDownCapture,
    ),
  });
});
DismissableLayer.displayName = DISMISSABLE_LAYER_NAME;
var BRANCH_NAME = 'DismissableLayerBranch';
var DismissableLayerBranch = React.forwardRef((props, forwardedRef) => {
  const context = React.useContext(DismissableLayerContext);
  const ref = React.useRef(null);
  const composedRefs = useComposedRefs(forwardedRef, ref);
  React.useEffect(() => {
    const node = ref.current;
    if (node) {
      context.branches.add(node);
      return () => {
        context.branches.delete(node);
      };
    }
  }, [context.branches]);
  return /* @__PURE__ */ jsx(Primitive.div, { ...props, ref: composedRefs });
});
DismissableLayerBranch.displayName = BRANCH_NAME;
function usePointerDownOutside(onPointerDownOutside, ownerDocument = globalThis?.document) {
  const handlePointerDownOutside = useCallbackRef$1(onPointerDownOutside);
  const isPointerInsideReactTreeRef = React.useRef(false);
  const handleClickRef = React.useRef(() => {});
  React.useEffect(() => {
    const handlePointerDown = event => {
      if (event.target && !isPointerInsideReactTreeRef.current) {
        let handleAndDispatchPointerDownOutsideEvent2 = function () {
          handleAndDispatchCustomEvent(
            POINTER_DOWN_OUTSIDE,
            handlePointerDownOutside,
            eventDetail,
            { discrete: true },
          );
        };
        const eventDetail = { originalEvent: event };
        if (event.pointerType === 'touch') {
          ownerDocument.removeEventListener('click', handleClickRef.current);
          handleClickRef.current = handleAndDispatchPointerDownOutsideEvent2;
          ownerDocument.addEventListener('click', handleClickRef.current, { once: true });
        } else {
          handleAndDispatchPointerDownOutsideEvent2();
        }
      } else {
        ownerDocument.removeEventListener('click', handleClickRef.current);
      }
      isPointerInsideReactTreeRef.current = false;
    };
    const timerId = window.setTimeout(() => {
      ownerDocument.addEventListener('pointerdown', handlePointerDown);
    }, 0);
    return () => {
      window.clearTimeout(timerId);
      ownerDocument.removeEventListener('pointerdown', handlePointerDown);
      ownerDocument.removeEventListener('click', handleClickRef.current);
    };
  }, [ownerDocument, handlePointerDownOutside]);
  return {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => (isPointerInsideReactTreeRef.current = true),
  };
}
function useFocusOutside(onFocusOutside, ownerDocument = globalThis?.document) {
  const handleFocusOutside = useCallbackRef$1(onFocusOutside);
  const isFocusInsideReactTreeRef = React.useRef(false);
  React.useEffect(() => {
    const handleFocus = event => {
      if (event.target && !isFocusInsideReactTreeRef.current) {
        const eventDetail = { originalEvent: event };
        handleAndDispatchCustomEvent(FOCUS_OUTSIDE, handleFocusOutside, eventDetail, {
          discrete: false,
        });
      }
    };
    ownerDocument.addEventListener('focusin', handleFocus);
    return () => ownerDocument.removeEventListener('focusin', handleFocus);
  }, [ownerDocument, handleFocusOutside]);
  return {
    onFocusCapture: () => (isFocusInsideReactTreeRef.current = true),
    onBlurCapture: () => (isFocusInsideReactTreeRef.current = false),
  };
}
function dispatchUpdate() {
  const event = new CustomEvent(CONTEXT_UPDATE);
  document.dispatchEvent(event);
}
function handleAndDispatchCustomEvent(name, handler, detail, { discrete }) {
  const target = detail.originalEvent.target;
  const event = new CustomEvent(name, { bubbles: false, cancelable: true, detail });
  if (handler) target.addEventListener(name, handler, { once: true });
  if (discrete) {
    dispatchDiscreteCustomEvent(target, event);
  } else {
    target.dispatchEvent(event);
  }
}
var count$2 = 0;
function useFocusGuards() {
  React.useEffect(() => {
    const edgeGuards = document.querySelectorAll('[data-radix-focus-guard]');
    document.body.insertAdjacentElement('afterbegin', edgeGuards[0] ?? createFocusGuard());
    document.body.insertAdjacentElement('beforeend', edgeGuards[1] ?? createFocusGuard());
    count$2++;
    return () => {
      if (count$2 === 1) {
        document.querySelectorAll('[data-radix-focus-guard]').forEach(node => node.remove());
      }
      count$2--;
    };
  }, []);
}
function createFocusGuard() {
  const element = document.createElement('span');
  element.setAttribute('data-radix-focus-guard', '');
  element.tabIndex = 0;
  element.style.outline = 'none';
  element.style.opacity = '0';
  element.style.position = 'fixed';
  element.style.pointerEvents = 'none';
  return element;
}
var AUTOFOCUS_ON_MOUNT = 'focusScope.autoFocusOnMount';
var AUTOFOCUS_ON_UNMOUNT = 'focusScope.autoFocusOnUnmount';
var EVENT_OPTIONS = { bubbles: false, cancelable: true };
var FOCUS_SCOPE_NAME = 'FocusScope';
var FocusScope = React.forwardRef((props, forwardedRef) => {
  const {
    loop = false,
    trapped = false,
    onMountAutoFocus: onMountAutoFocusProp,
    onUnmountAutoFocus: onUnmountAutoFocusProp,
    ...scopeProps
  } = props;
  const [container, setContainer] = React.useState(null);
  const onMountAutoFocus = useCallbackRef$1(onMountAutoFocusProp);
  const onUnmountAutoFocus = useCallbackRef$1(onUnmountAutoFocusProp);
  const lastFocusedElementRef = React.useRef(null);
  const composedRefs = useComposedRefs(forwardedRef, node => setContainer(node));
  const focusScope = React.useRef({
    paused: false,
    pause() {
      this.paused = true;
    },
    resume() {
      this.paused = false;
    },
  }).current;
  React.useEffect(() => {
    if (trapped) {
      let handleFocusIn2 = function (event) {
          if (focusScope.paused || !container) return;
          const target = event.target;
          if (container.contains(target)) {
            lastFocusedElementRef.current = target;
          } else {
            focus(lastFocusedElementRef.current, { select: true });
          }
        },
        handleFocusOut2 = function (event) {
          if (focusScope.paused || !container) return;
          const relatedTarget = event.relatedTarget;
          if (relatedTarget === null) return;
          if (!container.contains(relatedTarget)) {
            focus(lastFocusedElementRef.current, { select: true });
          }
        },
        handleMutations2 = function (mutations) {
          const focusedElement = document.activeElement;
          if (focusedElement !== document.body) return;
          for (const mutation of mutations) {
            if (mutation.removedNodes.length > 0) focus(container);
          }
        };
      document.addEventListener('focusin', handleFocusIn2);
      document.addEventListener('focusout', handleFocusOut2);
      const mutationObserver = new MutationObserver(handleMutations2);
      if (container) mutationObserver.observe(container, { childList: true, subtree: true });
      return () => {
        document.removeEventListener('focusin', handleFocusIn2);
        document.removeEventListener('focusout', handleFocusOut2);
        mutationObserver.disconnect();
      };
    }
  }, [trapped, container, focusScope.paused]);
  React.useEffect(() => {
    if (container) {
      focusScopesStack.add(focusScope);
      const previouslyFocusedElement = document.activeElement;
      const hasFocusedCandidate = container.contains(previouslyFocusedElement);
      if (!hasFocusedCandidate) {
        const mountEvent = new CustomEvent(AUTOFOCUS_ON_MOUNT, EVENT_OPTIONS);
        container.addEventListener(AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
        container.dispatchEvent(mountEvent);
        if (!mountEvent.defaultPrevented) {
          focusFirst(removeLinks(getTabbableCandidates(container)), { select: true });
          if (document.activeElement === previouslyFocusedElement) {
            focus(container);
          }
        }
      }
      return () => {
        container.removeEventListener(AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
        setTimeout(() => {
          const unmountEvent = new CustomEvent(AUTOFOCUS_ON_UNMOUNT, EVENT_OPTIONS);
          container.addEventListener(AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
          container.dispatchEvent(unmountEvent);
          if (!unmountEvent.defaultPrevented) {
            focus(previouslyFocusedElement ?? document.body, { select: true });
          }
          container.removeEventListener(AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
          focusScopesStack.remove(focusScope);
        }, 0);
      };
    }
  }, [container, onMountAutoFocus, onUnmountAutoFocus, focusScope]);
  const handleKeyDown = React.useCallback(
    event => {
      if (!loop && !trapped) return;
      if (focusScope.paused) return;
      const isTabKey = event.key === 'Tab' && !event.altKey && !event.ctrlKey && !event.metaKey;
      const focusedElement = document.activeElement;
      if (isTabKey && focusedElement) {
        const container2 = event.currentTarget;
        const [first, last] = getTabbableEdges(container2);
        const hasTabbableElementsInside = first && last;
        if (!hasTabbableElementsInside) {
          if (focusedElement === container2) event.preventDefault();
        } else {
          if (!event.shiftKey && focusedElement === last) {
            event.preventDefault();
            if (loop) focus(first, { select: true });
          } else if (event.shiftKey && focusedElement === first) {
            event.preventDefault();
            if (loop) focus(last, { select: true });
          }
        }
      }
    },
    [loop, trapped, focusScope.paused],
  );
  return /* @__PURE__ */ jsx(Primitive.div, {
    tabIndex: -1,
    ...scopeProps,
    ref: composedRefs,
    onKeyDown: handleKeyDown,
  });
});
FocusScope.displayName = FOCUS_SCOPE_NAME;
function focusFirst(candidates, { select = false } = {}) {
  const previouslyFocusedElement = document.activeElement;
  for (const candidate of candidates) {
    focus(candidate, { select });
    if (document.activeElement !== previouslyFocusedElement) return;
  }
}
function getTabbableEdges(container) {
  const candidates = getTabbableCandidates(container);
  const first = findVisible(candidates, container);
  const last = findVisible(candidates.reverse(), container);
  return [first, last];
}
function getTabbableCandidates(container) {
  const nodes = [];
  const walker = document.createTreeWalker(container, NodeFilter.SHOW_ELEMENT, {
    acceptNode: node => {
      const isHiddenInput = node.tagName === 'INPUT' && node.type === 'hidden';
      if (node.disabled || node.hidden || isHiddenInput) return NodeFilter.FILTER_SKIP;
      return node.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    },
  });
  while (walker.nextNode()) nodes.push(walker.currentNode);
  return nodes;
}
function findVisible(elements, container) {
  for (const element of elements) {
    if (!isHidden(element, { upTo: container })) return element;
  }
}
function isHidden(node, { upTo }) {
  if (getComputedStyle(node).visibility === 'hidden') return true;
  while (node) {
    if (upTo !== void 0 && node === upTo) return false;
    if (getComputedStyle(node).display === 'none') return true;
    node = node.parentElement;
  }
  return false;
}
function isSelectableInput(element) {
  return element instanceof HTMLInputElement && 'select' in element;
}
function focus(element, { select = false } = {}) {
  if (element && element.focus) {
    const previouslyFocusedElement = document.activeElement;
    element.focus({ preventScroll: true });
    if (element !== previouslyFocusedElement && isSelectableInput(element) && select)
      element.select();
  }
}
var focusScopesStack = createFocusScopesStack();
function createFocusScopesStack() {
  let stack = [];
  return {
    add(focusScope) {
      const activeFocusScope = stack[0];
      if (focusScope !== activeFocusScope) {
        activeFocusScope?.pause();
      }
      stack = arrayRemove(stack, focusScope);
      stack.unshift(focusScope);
    },
    remove(focusScope) {
      stack = arrayRemove(stack, focusScope);
      stack[0]?.resume();
    },
  };
}
function arrayRemove(array, item) {
  const updatedArray = [...array];
  const index2 = updatedArray.indexOf(item);
  if (index2 !== -1) {
    updatedArray.splice(index2, 1);
  }
  return updatedArray;
}
function removeLinks(items) {
  return items.filter(item => item.tagName !== 'A');
}
var useLayoutEffect2 = globalThis?.document ? React.useLayoutEffect : () => {};
var useReactId = React[' useId '.trim().toString()] || (() => void 0);
var count$1 = 0;
function useId$1(deterministicId) {
  const [id2, setId] = React.useState(useReactId());
  useLayoutEffect2(() => {
    setId(reactId => reactId ?? String(count$1++));
  }, [deterministicId]);
  return deterministicId || (id2 ? `radix-${id2}` : '');
}
const sides$1 = ['top', 'right', 'bottom', 'left'];
const min$1 = Math.min;
const max$1 = Math.max;
const round = Math.round;
const floor = Math.floor;
const createCoords = v => ({ x: v, y: v });
const oppositeSideMap = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
const oppositeAlignmentMap = { start: 'end', end: 'start' };
function clamp(start, value, end) {
  return max$1(start, min$1(value, end));
}
function evaluate(value, param) {
  return typeof value === 'function' ? value(param) : value;
}
function getSide(placement) {
  return placement.split('-')[0];
}
function getAlignment(placement) {
  return placement.split('-')[1];
}
function getOppositeAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}
function getAxisLength(axis) {
  return axis === 'y' ? 'height' : 'width';
}
const yAxisSides = /* @__PURE__ */ new Set(['top', 'bottom']);
function getSideAxis(placement) {
  return yAxisSides.has(getSide(placement)) ? 'y' : 'x';
}
function getAlignmentAxis(placement) {
  return getOppositeAxis(getSideAxis(placement));
}
function getAlignmentSides(placement, rects, rtl) {
  if (rtl === void 0) {
    rtl = false;
  }
  const alignment = getAlignment(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const length = getAxisLength(alignmentAxis);
  let mainAlignmentSide =
    alignmentAxis === 'x'
      ? alignment === (rtl ? 'end' : 'start')
        ? 'right'
        : 'left'
      : alignment === 'start'
        ? 'bottom'
        : 'top';
  if (rects.reference[length] > rects.floating[length]) {
    mainAlignmentSide = getOppositePlacement(mainAlignmentSide);
  }
  return [mainAlignmentSide, getOppositePlacement(mainAlignmentSide)];
}
function getExpandedPlacements(placement) {
  const oppositePlacement = getOppositePlacement(placement);
  return [
    getOppositeAlignmentPlacement(placement),
    oppositePlacement,
    getOppositeAlignmentPlacement(oppositePlacement),
  ];
}
function getOppositeAlignmentPlacement(placement) {
  return placement.replace(/start|end/g, alignment => oppositeAlignmentMap[alignment]);
}
const lrPlacement = ['left', 'right'];
const rlPlacement = ['right', 'left'];
const tbPlacement = ['top', 'bottom'];
const btPlacement = ['bottom', 'top'];
function getSideList(side, isStart, rtl) {
  switch (side) {
    case 'top':
    case 'bottom':
      if (rtl) return isStart ? rlPlacement : lrPlacement;
      return isStart ? lrPlacement : rlPlacement;
    case 'left':
    case 'right':
      return isStart ? tbPlacement : btPlacement;
    default:
      return [];
  }
}
function getOppositeAxisPlacements(placement, flipAlignment, direction, rtl) {
  const alignment = getAlignment(placement);
  let list = getSideList(getSide(placement), direction === 'start', rtl);
  if (alignment) {
    list = list.map(side => side + '-' + alignment);
    if (flipAlignment) {
      list = list.concat(list.map(getOppositeAlignmentPlacement));
    }
  }
  return list;
}
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, side => oppositeSideMap[side]);
}
function expandPaddingObject(padding) {
  return { top: 0, right: 0, bottom: 0, left: 0, ...padding };
}
function getPaddingObject(padding) {
  return typeof padding !== 'number'
    ? expandPaddingObject(padding)
    : { top: padding, right: padding, bottom: padding, left: padding };
}
function rectToClientRect(rect) {
  const { x, y, width, height } = rect;
  return { width, height, top: y, left: x, right: x + width, bottom: y + height, x, y };
}
function computeCoordsFromPlacement(_ref, placement, rtl) {
  let { reference, floating } = _ref;
  const sideAxis = getSideAxis(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const alignLength = getAxisLength(alignmentAxis);
  const side = getSide(placement);
  const isVertical = sideAxis === 'y';
  const commonX = reference.x + reference.width / 2 - floating.width / 2;
  const commonY = reference.y + reference.height / 2 - floating.height / 2;
  const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
  let coords;
  switch (side) {
    case 'top':
      coords = { x: commonX, y: reference.y - floating.height };
      break;
    case 'bottom':
      coords = { x: commonX, y: reference.y + reference.height };
      break;
    case 'right':
      coords = { x: reference.x + reference.width, y: commonY };
      break;
    case 'left':
      coords = { x: reference.x - floating.width, y: commonY };
      break;
    default:
      coords = { x: reference.x, y: reference.y };
  }
  switch (getAlignment(placement)) {
    case 'start':
      coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
      break;
    case 'end':
      coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
      break;
  }
  return coords;
}
const computePosition$1 = async (reference, floating, config2) => {
  const {
    placement = 'bottom',
    strategy = 'absolute',
    middleware = [],
    platform: platform2,
  } = config2;
  const validMiddleware = middleware.filter(Boolean);
  const rtl = await (platform2.isRTL == null ? void 0 : platform2.isRTL(floating));
  let rects = await platform2.getElementRects({ reference, floating, strategy });
  let { x, y } = computeCoordsFromPlacement(rects, placement, rtl);
  let statefulPlacement = placement;
  let middlewareData = {};
  let resetCount = 0;
  for (let i = 0; i < validMiddleware.length; i++) {
    const { name, fn } = validMiddleware[i];
    const {
      x: nextX,
      y: nextY,
      data,
      reset,
    } = await fn({
      x,
      y,
      initialPlacement: placement,
      placement: statefulPlacement,
      strategy,
      middlewareData,
      rects,
      platform: platform2,
      elements: { reference, floating },
    });
    x = nextX != null ? nextX : x;
    y = nextY != null ? nextY : y;
    middlewareData = { ...middlewareData, [name]: { ...middlewareData[name], ...data } };
    if (reset && resetCount <= 50) {
      resetCount++;
      if (typeof reset === 'object') {
        if (reset.placement) {
          statefulPlacement = reset.placement;
        }
        if (reset.rects) {
          rects =
            reset.rects === true
              ? await platform2.getElementRects({ reference, floating, strategy })
              : reset.rects;
        }
        ({ x, y } = computeCoordsFromPlacement(rects, statefulPlacement, rtl));
      }
      i = -1;
    }
  }
  return { x, y, placement: statefulPlacement, strategy, middlewareData };
};
async function detectOverflow(state, options) {
  var _await$platform$isEle;
  if (options === void 0) {
    options = {};
  }
  const { x, y, platform: platform2, rects, elements, strategy } = state;
  const {
    boundary = 'clippingAncestors',
    rootBoundary = 'viewport',
    elementContext = 'floating',
    altBoundary = false,
    padding = 0,
  } = evaluate(options, state);
  const paddingObject = getPaddingObject(padding);
  const altContext = elementContext === 'floating' ? 'reference' : 'floating';
  const element = elements[altBoundary ? altContext : elementContext];
  const clippingClientRect = rectToClientRect(
    await platform2.getClippingRect({
      element: (
        (_await$platform$isEle = await (platform2.isElement == null
          ? void 0
          : platform2.isElement(element))) != null
          ? _await$platform$isEle
          : true
      )
        ? element
        : element.contextElement ||
          (await (platform2.getDocumentElement == null
            ? void 0
            : platform2.getDocumentElement(elements.floating))),
      boundary,
      rootBoundary,
      strategy,
    }),
  );
  const rect =
    elementContext === 'floating'
      ? { x, y, width: rects.floating.width, height: rects.floating.height }
      : rects.reference;
  const offsetParent = await (platform2.getOffsetParent == null
    ? void 0
    : platform2.getOffsetParent(elements.floating));
  const offsetScale = (await (platform2.isElement == null
    ? void 0
    : platform2.isElement(offsetParent)))
    ? (await (platform2.getScale == null ? void 0 : platform2.getScale(offsetParent))) || {
        x: 1,
        y: 1,
      }
    : { x: 1, y: 1 };
  const elementClientRect = rectToClientRect(
    platform2.convertOffsetParentRelativeRectToViewportRelativeRect
      ? await platform2.convertOffsetParentRelativeRectToViewportRelativeRect({
          elements,
          rect,
          offsetParent,
          strategy,
        })
      : rect,
  );
  return {
    top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
    bottom:
      (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
    left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
    right:
      (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x,
  };
}
const arrow$3 = options => ({
  name: 'arrow',
  options,
  async fn(state) {
    const { x, y, placement, rects, platform: platform2, elements, middlewareData } = state;
    const { element, padding = 0 } = evaluate(options, state) || {};
    if (element == null) {
      return {};
    }
    const paddingObject = getPaddingObject(padding);
    const coords = { x, y };
    const axis = getAlignmentAxis(placement);
    const length = getAxisLength(axis);
    const arrowDimensions = await platform2.getDimensions(element);
    const isYAxis = axis === 'y';
    const minProp = isYAxis ? 'top' : 'left';
    const maxProp = isYAxis ? 'bottom' : 'right';
    const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
    const endDiff =
      rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
    const startDiff = coords[axis] - rects.reference[axis];
    const arrowOffsetParent = await (platform2.getOffsetParent == null
      ? void 0
      : platform2.getOffsetParent(element));
    let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
    if (
      !clientSize ||
      !(await (platform2.isElement == null ? void 0 : platform2.isElement(arrowOffsetParent)))
    ) {
      clientSize = elements.floating[clientProp] || rects.floating[length];
    }
    const centerToReference = endDiff / 2 - startDiff / 2;
    const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
    const minPadding = min$1(paddingObject[minProp], largestPossiblePadding);
    const maxPadding = min$1(paddingObject[maxProp], largestPossiblePadding);
    const min$1$1 = minPadding;
    const max2 = clientSize - arrowDimensions[length] - maxPadding;
    const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
    const offset2 = clamp(min$1$1, center, max2);
    const shouldAddOffset =
      !middlewareData.arrow &&
      getAlignment(placement) != null &&
      center !== offset2 &&
      rects.reference[length] / 2 -
        (center < min$1$1 ? minPadding : maxPadding) -
        arrowDimensions[length] / 2 <
        0;
    const alignmentOffset = shouldAddOffset
      ? center < min$1$1
        ? center - min$1$1
        : center - max2
      : 0;
    return {
      [axis]: coords[axis] + alignmentOffset,
      data: {
        [axis]: offset2,
        centerOffset: center - offset2 - alignmentOffset,
        ...(shouldAddOffset && { alignmentOffset }),
      },
      reset: shouldAddOffset,
    };
  },
});
const flip$2 = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'flip',
    options,
    async fn(state) {
      var _middlewareData$arrow, _middlewareData$flip;
      const {
        placement,
        middlewareData,
        rects,
        initialPlacement,
        platform: platform2,
        elements,
      } = state;
      const {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = true,
        fallbackPlacements: specifiedFallbackPlacements,
        fallbackStrategy = 'bestFit',
        fallbackAxisSideDirection = 'none',
        flipAlignment = true,
        ...detectOverflowOptions
      } = evaluate(options, state);
      if (
        (_middlewareData$arrow = middlewareData.arrow) != null &&
        _middlewareData$arrow.alignmentOffset
      ) {
        return {};
      }
      const side = getSide(placement);
      const initialSideAxis = getSideAxis(initialPlacement);
      const isBasePlacement = getSide(initialPlacement) === initialPlacement;
      const rtl = await (platform2.isRTL == null ? void 0 : platform2.isRTL(elements.floating));
      const fallbackPlacements =
        specifiedFallbackPlacements ||
        (isBasePlacement || !flipAlignment
          ? [getOppositePlacement(initialPlacement)]
          : getExpandedPlacements(initialPlacement));
      const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
      if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) {
        fallbackPlacements.push(
          ...getOppositeAxisPlacements(
            initialPlacement,
            flipAlignment,
            fallbackAxisSideDirection,
            rtl,
          ),
        );
      }
      const placements2 = [initialPlacement, ...fallbackPlacements];
      const overflow = await detectOverflow(state, detectOverflowOptions);
      const overflows = [];
      let overflowsData =
        ((_middlewareData$flip = middlewareData.flip) == null
          ? void 0
          : _middlewareData$flip.overflows) || [];
      if (checkMainAxis) {
        overflows.push(overflow[side]);
      }
      if (checkCrossAxis) {
        const sides2 = getAlignmentSides(placement, rects, rtl);
        overflows.push(overflow[sides2[0]], overflow[sides2[1]]);
      }
      overflowsData = [...overflowsData, { placement, overflows }];
      if (!overflows.every(side2 => side2 <= 0)) {
        var _middlewareData$flip2, _overflowsData$filter;
        const nextIndex =
          (((_middlewareData$flip2 = middlewareData.flip) == null
            ? void 0
            : _middlewareData$flip2.index) || 0) + 1;
        const nextPlacement = placements2[nextIndex];
        if (nextPlacement) {
          const ignoreCrossAxisOverflow =
            checkCrossAxis === 'alignment' ? initialSideAxis !== getSideAxis(nextPlacement) : false;
          if (
            !ignoreCrossAxisOverflow || // We leave the current main axis only if every placement on that axis
            // overflows the main axis.
            overflowsData.every(d =>
              getSideAxis(d.placement) === initialSideAxis ? d.overflows[0] > 0 : true,
            )
          ) {
            return {
              data: { index: nextIndex, overflows: overflowsData },
              reset: { placement: nextPlacement },
            };
          }
        }
        let resetPlacement =
          (_overflowsData$filter = overflowsData
            .filter(d => d.overflows[0] <= 0)
            .sort((a, b) => a.overflows[1] - b.overflows[1])[0]) == null
            ? void 0
            : _overflowsData$filter.placement;
        if (!resetPlacement) {
          switch (fallbackStrategy) {
            case 'bestFit': {
              var _overflowsData$filter2;
              const placement2 =
                (_overflowsData$filter2 = overflowsData
                  .filter(d => {
                    if (hasFallbackAxisSideDirection) {
                      const currentSideAxis = getSideAxis(d.placement);
                      return (
                        currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                        // reading directions favoring greater width.
                        currentSideAxis === 'y'
                      );
                    }
                    return true;
                  })
                  .map(d => [
                    d.placement,
                    d.overflows
                      .filter(overflow2 => overflow2 > 0)
                      .reduce((acc, overflow2) => acc + overflow2, 0),
                  ])
                  .sort((a, b) => a[1] - b[1])[0]) == null
                  ? void 0
                  : _overflowsData$filter2[0];
              if (placement2) {
                resetPlacement = placement2;
              }
              break;
            }
            case 'initialPlacement':
              resetPlacement = initialPlacement;
              break;
          }
        }
        if (placement !== resetPlacement) {
          return { reset: { placement: resetPlacement } };
        }
      }
      return {};
    },
  };
};
function getSideOffsets(overflow, rect) {
  return {
    top: overflow.top - rect.height,
    right: overflow.right - rect.width,
    bottom: overflow.bottom - rect.height,
    left: overflow.left - rect.width,
  };
}
function isAnySideFullyClipped(overflow) {
  return sides$1.some(side => overflow[side] >= 0);
}
const hide$2 = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'hide',
    options,
    async fn(state) {
      const { rects } = state;
      const { strategy = 'referenceHidden', ...detectOverflowOptions } = evaluate(options, state);
      switch (strategy) {
        case 'referenceHidden': {
          const overflow = await detectOverflow(state, {
            ...detectOverflowOptions,
            elementContext: 'reference',
          });
          const offsets = getSideOffsets(overflow, rects.reference);
          return {
            data: {
              referenceHiddenOffsets: offsets,
              referenceHidden: isAnySideFullyClipped(offsets),
            },
          };
        }
        case 'escaped': {
          const overflow = await detectOverflow(state, {
            ...detectOverflowOptions,
            altBoundary: true,
          });
          const offsets = getSideOffsets(overflow, rects.floating);
          return { data: { escapedOffsets: offsets, escaped: isAnySideFullyClipped(offsets) } };
        }
        default: {
          return {};
        }
      }
    },
  };
};
const originSides = /* @__PURE__ */ new Set(['left', 'top']);
async function convertValueToCoords(state, options) {
  const { placement, platform: platform2, elements } = state;
  const rtl = await (platform2.isRTL == null ? void 0 : platform2.isRTL(elements.floating));
  const side = getSide(placement);
  const alignment = getAlignment(placement);
  const isVertical = getSideAxis(placement) === 'y';
  const mainAxisMulti = originSides.has(side) ? -1 : 1;
  const crossAxisMulti = rtl && isVertical ? -1 : 1;
  const rawValue = evaluate(options, state);
  let { mainAxis, crossAxis, alignmentAxis } =
    typeof rawValue === 'number'
      ? { mainAxis: rawValue, crossAxis: 0, alignmentAxis: null }
      : {
          mainAxis: rawValue.mainAxis || 0,
          crossAxis: rawValue.crossAxis || 0,
          alignmentAxis: rawValue.alignmentAxis,
        };
  if (alignment && typeof alignmentAxis === 'number') {
    crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
  }
  return isVertical
    ? { x: crossAxis * crossAxisMulti, y: mainAxis * mainAxisMulti }
    : { x: mainAxis * mainAxisMulti, y: crossAxis * crossAxisMulti };
}
const offset$2 = function (options) {
  if (options === void 0) {
    options = 0;
  }
  return {
    name: 'offset',
    options,
    async fn(state) {
      var _middlewareData$offse, _middlewareData$arrow;
      const { x, y, placement, middlewareData } = state;
      const diffCoords = await convertValueToCoords(state, options);
      if (
        placement ===
          ((_middlewareData$offse = middlewareData.offset) == null
            ? void 0
            : _middlewareData$offse.placement) &&
        (_middlewareData$arrow = middlewareData.arrow) != null &&
        _middlewareData$arrow.alignmentOffset
      ) {
        return {};
      }
      return { x: x + diffCoords.x, y: y + diffCoords.y, data: { ...diffCoords, placement } };
    },
  };
};
const shift$2 = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'shift',
    options,
    async fn(state) {
      const { x, y, placement } = state;
      const {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = false,
        limiter = {
          fn: _ref => {
            let { x: x2, y: y2 } = _ref;
            return { x: x2, y: y2 };
          },
        },
        ...detectOverflowOptions
      } = evaluate(options, state);
      const coords = { x, y };
      const overflow = await detectOverflow(state, detectOverflowOptions);
      const crossAxis = getSideAxis(getSide(placement));
      const mainAxis = getOppositeAxis(crossAxis);
      let mainAxisCoord = coords[mainAxis];
      let crossAxisCoord = coords[crossAxis];
      if (checkMainAxis) {
        const minSide = mainAxis === 'y' ? 'top' : 'left';
        const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
        const min2 = mainAxisCoord + overflow[minSide];
        const max2 = mainAxisCoord - overflow[maxSide];
        mainAxisCoord = clamp(min2, mainAxisCoord, max2);
      }
      if (checkCrossAxis) {
        const minSide = crossAxis === 'y' ? 'top' : 'left';
        const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
        const min2 = crossAxisCoord + overflow[minSide];
        const max2 = crossAxisCoord - overflow[maxSide];
        crossAxisCoord = clamp(min2, crossAxisCoord, max2);
      }
      const limitedCoords = limiter.fn({
        ...state,
        [mainAxis]: mainAxisCoord,
        [crossAxis]: crossAxisCoord,
      });
      return {
        ...limitedCoords,
        data: {
          x: limitedCoords.x - x,
          y: limitedCoords.y - y,
          enabled: { [mainAxis]: checkMainAxis, [crossAxis]: checkCrossAxis },
        },
      };
    },
  };
};
const limitShift$2 = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    options,
    fn(state) {
      const { x, y, placement, rects, middlewareData } = state;
      const {
        offset: offset2 = 0,
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = true,
      } = evaluate(options, state);
      const coords = { x, y };
      const crossAxis = getSideAxis(placement);
      const mainAxis = getOppositeAxis(crossAxis);
      let mainAxisCoord = coords[mainAxis];
      let crossAxisCoord = coords[crossAxis];
      const rawOffset = evaluate(offset2, state);
      const computedOffset =
        typeof rawOffset === 'number'
          ? { mainAxis: rawOffset, crossAxis: 0 }
          : { mainAxis: 0, crossAxis: 0, ...rawOffset };
      if (checkMainAxis) {
        const len = mainAxis === 'y' ? 'height' : 'width';
        const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
        const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
        if (mainAxisCoord < limitMin) {
          mainAxisCoord = limitMin;
        } else if (mainAxisCoord > limitMax) {
          mainAxisCoord = limitMax;
        }
      }
      if (checkCrossAxis) {
        var _middlewareData$offse, _middlewareData$offse2;
        const len = mainAxis === 'y' ? 'width' : 'height';
        const isOriginSide = originSides.has(getSide(placement));
        const limitMin =
          rects.reference[crossAxis] -
          rects.floating[len] +
          (isOriginSide
            ? ((_middlewareData$offse = middlewareData.offset) == null
                ? void 0
                : _middlewareData$offse[crossAxis]) || 0
            : 0) +
          (isOriginSide ? 0 : computedOffset.crossAxis);
        const limitMax =
          rects.reference[crossAxis] +
          rects.reference[len] +
          (isOriginSide
            ? 0
            : ((_middlewareData$offse2 = middlewareData.offset) == null
                ? void 0
                : _middlewareData$offse2[crossAxis]) || 0) -
          (isOriginSide ? computedOffset.crossAxis : 0);
        if (crossAxisCoord < limitMin) {
          crossAxisCoord = limitMin;
        } else if (crossAxisCoord > limitMax) {
          crossAxisCoord = limitMax;
        }
      }
      return { [mainAxis]: mainAxisCoord, [crossAxis]: crossAxisCoord };
    },
  };
};
const size$2 = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'size',
    options,
    async fn(state) {
      var _state$middlewareData, _state$middlewareData2;
      const { placement, rects, platform: platform2, elements } = state;
      const { apply = () => {}, ...detectOverflowOptions } = evaluate(options, state);
      const overflow = await detectOverflow(state, detectOverflowOptions);
      const side = getSide(placement);
      const alignment = getAlignment(placement);
      const isYAxis = getSideAxis(placement) === 'y';
      const { width, height } = rects.floating;
      let heightSide;
      let widthSide;
      if (side === 'top' || side === 'bottom') {
        heightSide = side;
        widthSide =
          alignment ===
          ((await (platform2.isRTL == null ? void 0 : platform2.isRTL(elements.floating)))
            ? 'start'
            : 'end')
            ? 'left'
            : 'right';
      } else {
        widthSide = side;
        heightSide = alignment === 'end' ? 'top' : 'bottom';
      }
      const maximumClippingHeight = height - overflow.top - overflow.bottom;
      const maximumClippingWidth = width - overflow.left - overflow.right;
      const overflowAvailableHeight = min$1(height - overflow[heightSide], maximumClippingHeight);
      const overflowAvailableWidth = min$1(width - overflow[widthSide], maximumClippingWidth);
      const noShift = !state.middlewareData.shift;
      let availableHeight = overflowAvailableHeight;
      let availableWidth = overflowAvailableWidth;
      if (
        (_state$middlewareData = state.middlewareData.shift) != null &&
        _state$middlewareData.enabled.x
      ) {
        availableWidth = maximumClippingWidth;
      }
      if (
        (_state$middlewareData2 = state.middlewareData.shift) != null &&
        _state$middlewareData2.enabled.y
      ) {
        availableHeight = maximumClippingHeight;
      }
      if (noShift && !alignment) {
        const xMin = max$1(overflow.left, 0);
        const xMax = max$1(overflow.right, 0);
        const yMin = max$1(overflow.top, 0);
        const yMax = max$1(overflow.bottom, 0);
        if (isYAxis) {
          availableWidth =
            width -
            2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : max$1(overflow.left, overflow.right));
        } else {
          availableHeight =
            height -
            2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : max$1(overflow.top, overflow.bottom));
        }
      }
      await apply({ ...state, availableWidth, availableHeight });
      const nextDimensions = await platform2.getDimensions(elements.floating);
      if (width !== nextDimensions.width || height !== nextDimensions.height) {
        return { reset: { rects: true } };
      }
      return {};
    },
  };
};
function hasWindow() {
  return typeof window !== 'undefined';
}
function getNodeName(node) {
  if (isNode(node)) {
    return (node.nodeName || '').toLowerCase();
  }
  return '#document';
}
function getWindow(node) {
  var _node$ownerDocument;
  return (
    (node == null || (_node$ownerDocument = node.ownerDocument) == null
      ? void 0
      : _node$ownerDocument.defaultView) || window
  );
}
function getDocumentElement(node) {
  var _ref;
  return (_ref = (isNode(node) ? node.ownerDocument : node.document) || window.document) == null
    ? void 0
    : _ref.documentElement;
}
function isNode(value) {
  if (!hasWindow()) {
    return false;
  }
  return value instanceof Node || value instanceof getWindow(value).Node;
}
function isElement(value) {
  if (!hasWindow()) {
    return false;
  }
  return value instanceof Element || value instanceof getWindow(value).Element;
}
function isHTMLElement(value) {
  if (!hasWindow()) {
    return false;
  }
  return value instanceof HTMLElement || value instanceof getWindow(value).HTMLElement;
}
function isShadowRoot(value) {
  if (!hasWindow() || typeof ShadowRoot === 'undefined') {
    return false;
  }
  return value instanceof ShadowRoot || value instanceof getWindow(value).ShadowRoot;
}
const invalidOverflowDisplayValues = /* @__PURE__ */ new Set(['inline', 'contents']);
function isOverflowElement(element) {
  const { overflow, overflowX, overflowY, display } = getComputedStyle$1(element);
  return (
    /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) &&
    !invalidOverflowDisplayValues.has(display)
  );
}
const tableElements = /* @__PURE__ */ new Set(['table', 'td', 'th']);
function isTableElement(element) {
  return tableElements.has(getNodeName(element));
}
const topLayerSelectors = [':popover-open', ':modal'];
function isTopLayer(element) {
  return topLayerSelectors.some(selector => {
    try {
      return element.matches(selector);
    } catch (_e) {
      return false;
    }
  });
}
const transformProperties = ['transform', 'translate', 'scale', 'rotate', 'perspective'];
const willChangeValues = ['transform', 'translate', 'scale', 'rotate', 'perspective', 'filter'];
const containValues = ['paint', 'layout', 'strict', 'content'];
function isContainingBlock(elementOrCss) {
  const webkit = isWebKit();
  const css = isElement(elementOrCss) ? getComputedStyle$1(elementOrCss) : elementOrCss;
  return (
    transformProperties.some(value => (css[value] ? css[value] !== 'none' : false)) ||
    (css.containerType ? css.containerType !== 'normal' : false) ||
    (!webkit && (css.backdropFilter ? css.backdropFilter !== 'none' : false)) ||
    (!webkit && (css.filter ? css.filter !== 'none' : false)) ||
    willChangeValues.some(value => (css.willChange || '').includes(value)) ||
    containValues.some(value => (css.contain || '').includes(value))
  );
}
function getContainingBlock(element) {
  let currentNode = getParentNode(element);
  while (isHTMLElement(currentNode) && !isLastTraversableNode(currentNode)) {
    if (isContainingBlock(currentNode)) {
      return currentNode;
    } else if (isTopLayer(currentNode)) {
      return null;
    }
    currentNode = getParentNode(currentNode);
  }
  return null;
}
function isWebKit() {
  if (typeof CSS === 'undefined' || !CSS.supports) return false;
  return CSS.supports('-webkit-backdrop-filter', 'none');
}
const lastTraversableNodeNames = /* @__PURE__ */ new Set(['html', 'body', '#document']);
function isLastTraversableNode(node) {
  return lastTraversableNodeNames.has(getNodeName(node));
}
function getComputedStyle$1(element) {
  return getWindow(element).getComputedStyle(element);
}
function getNodeScroll(element) {
  if (isElement(element)) {
    return { scrollLeft: element.scrollLeft, scrollTop: element.scrollTop };
  }
  return { scrollLeft: element.scrollX, scrollTop: element.scrollY };
}
function getParentNode(node) {
  if (getNodeName(node) === 'html') {
    return node;
  }
  const result =
    // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    (isShadowRoot(node) && node.host) || // Fallback.
    getDocumentElement(node);
  return isShadowRoot(result) ? result.host : result;
}
function getNearestOverflowAncestor(node) {
  const parentNode = getParentNode(node);
  if (isLastTraversableNode(parentNode)) {
    return node.ownerDocument ? node.ownerDocument.body : node.body;
  }
  if (isHTMLElement(parentNode) && isOverflowElement(parentNode)) {
    return parentNode;
  }
  return getNearestOverflowAncestor(parentNode);
}
function getOverflowAncestors(node, list, traverseIframes) {
  var _node$ownerDocument2;
  if (list === void 0) {
    list = [];
  }
  if (traverseIframes === void 0) {
    traverseIframes = true;
  }
  const scrollableAncestor = getNearestOverflowAncestor(node);
  const isBody =
    scrollableAncestor ===
    ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
  const win = getWindow(scrollableAncestor);
  if (isBody) {
    const frameElement = getFrameElement(win);
    return list.concat(
      win,
      win.visualViewport || [],
      isOverflowElement(scrollableAncestor) ? scrollableAncestor : [],
      frameElement && traverseIframes ? getOverflowAncestors(frameElement) : [],
    );
  }
  return list.concat(
    scrollableAncestor,
    getOverflowAncestors(scrollableAncestor, [], traverseIframes),
  );
}
function getFrameElement(win) {
  return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}
function getCssDimensions(element) {
  const css = getComputedStyle$1(element);
  let width = parseFloat(css.width) || 0;
  let height = parseFloat(css.height) || 0;
  const hasOffset = isHTMLElement(element);
  const offsetWidth = hasOffset ? element.offsetWidth : width;
  const offsetHeight = hasOffset ? element.offsetHeight : height;
  const shouldFallback = round(width) !== offsetWidth || round(height) !== offsetHeight;
  if (shouldFallback) {
    width = offsetWidth;
    height = offsetHeight;
  }
  return { width, height, $: shouldFallback };
}
function unwrapElement(element) {
  return !isElement(element) ? element.contextElement : element;
}
function getScale(element) {
  const domElement = unwrapElement(element);
  if (!isHTMLElement(domElement)) {
    return createCoords(1);
  }
  const rect = domElement.getBoundingClientRect();
  const { width, height, $ } = getCssDimensions(domElement);
  let x = ($ ? round(rect.width) : rect.width) / width;
  let y = ($ ? round(rect.height) : rect.height) / height;
  if (!x || !Number.isFinite(x)) {
    x = 1;
  }
  if (!y || !Number.isFinite(y)) {
    y = 1;
  }
  return { x, y };
}
const noOffsets = /* @__PURE__ */ createCoords(0);
function getVisualOffsets(element) {
  const win = getWindow(element);
  if (!isWebKit() || !win.visualViewport) {
    return noOffsets;
  }
  return { x: win.visualViewport.offsetLeft, y: win.visualViewport.offsetTop };
}
function shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
  if (isFixed === void 0) {
    isFixed = false;
  }
  if (!floatingOffsetParent || (isFixed && floatingOffsetParent !== getWindow(element))) {
    return false;
  }
  return isFixed;
}
function getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
  if (includeScale === void 0) {
    includeScale = false;
  }
  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }
  const clientRect = element.getBoundingClientRect();
  const domElement = unwrapElement(element);
  let scale = createCoords(1);
  if (includeScale) {
    if (offsetParent) {
      if (isElement(offsetParent)) {
        scale = getScale(offsetParent);
      }
    } else {
      scale = getScale(element);
    }
  }
  const visualOffsets = shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent)
    ? getVisualOffsets(domElement)
    : createCoords(0);
  let x = (clientRect.left + visualOffsets.x) / scale.x;
  let y = (clientRect.top + visualOffsets.y) / scale.y;
  let width = clientRect.width / scale.x;
  let height = clientRect.height / scale.y;
  if (domElement) {
    const win = getWindow(domElement);
    const offsetWin =
      offsetParent && isElement(offsetParent) ? getWindow(offsetParent) : offsetParent;
    let currentWin = win;
    let currentIFrame = getFrameElement(currentWin);
    while (currentIFrame && offsetParent && offsetWin !== currentWin) {
      const iframeScale = getScale(currentIFrame);
      const iframeRect = currentIFrame.getBoundingClientRect();
      const css = getComputedStyle$1(currentIFrame);
      const left =
        iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
      const top =
        iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
      x *= iframeScale.x;
      y *= iframeScale.y;
      width *= iframeScale.x;
      height *= iframeScale.y;
      x += left;
      y += top;
      currentWin = getWindow(currentIFrame);
      currentIFrame = getFrameElement(currentWin);
    }
  }
  return rectToClientRect({ width, height, x, y });
}
function getWindowScrollBarX(element, rect) {
  const leftScroll = getNodeScroll(element).scrollLeft;
  if (!rect) {
    return getBoundingClientRect(getDocumentElement(element)).left + leftScroll;
  }
  return rect.left + leftScroll;
}
function getHTMLOffset(documentElement, scroll) {
  const htmlRect = documentElement.getBoundingClientRect();
  const x = htmlRect.left + scroll.scrollLeft - getWindowScrollBarX(documentElement, htmlRect);
  const y = htmlRect.top + scroll.scrollTop;
  return { x, y };
}
function convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
  let { elements, rect, offsetParent, strategy } = _ref;
  const isFixed = strategy === 'fixed';
  const documentElement = getDocumentElement(offsetParent);
  const topLayer = elements ? isTopLayer(elements.floating) : false;
  if (offsetParent === documentElement || (topLayer && isFixed)) {
    return rect;
  }
  let scroll = { scrollLeft: 0, scrollTop: 0 };
  let scale = createCoords(1);
  const offsets = createCoords(0);
  const isOffsetParentAnElement = isHTMLElement(offsetParent);
  if (isOffsetParentAnElement || (!isOffsetParentAnElement && !isFixed)) {
    if (getNodeName(offsetParent) !== 'body' || isOverflowElement(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isHTMLElement(offsetParent)) {
      const offsetRect = getBoundingClientRect(offsetParent);
      scale = getScale(offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    }
  }
  const htmlOffset =
    documentElement && !isOffsetParentAnElement && !isFixed
      ? getHTMLOffset(documentElement, scroll)
      : createCoords(0);
  return {
    width: rect.width * scale.x,
    height: rect.height * scale.y,
    x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
    y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y,
  };
}
function getClientRects(element) {
  return Array.from(element.getClientRects());
}
function getDocumentRect(element) {
  const html = getDocumentElement(element);
  const scroll = getNodeScroll(element);
  const body = element.ownerDocument.body;
  const width = max$1(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
  const height = max$1(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
  let x = -scroll.scrollLeft + getWindowScrollBarX(element);
  const y = -scroll.scrollTop;
  if (getComputedStyle$1(body).direction === 'rtl') {
    x += max$1(html.clientWidth, body.clientWidth) - width;
  }
  return { width, height, x, y };
}
const SCROLLBAR_MAX = 25;
function getViewportRect(element, strategy) {
  const win = getWindow(element);
  const html = getDocumentElement(element);
  const visualViewport = win.visualViewport;
  let width = html.clientWidth;
  let height = html.clientHeight;
  let x = 0;
  let y = 0;
  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    const visualViewportBased = isWebKit();
    if (!visualViewportBased || (visualViewportBased && strategy === 'fixed')) {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }
  const windowScrollbarX = getWindowScrollBarX(html);
  if (windowScrollbarX <= 0) {
    const doc = html.ownerDocument;
    const body = doc.body;
    const bodyStyles = getComputedStyle(body);
    const bodyMarginInline =
      doc.compatMode === 'CSS1Compat'
        ? parseFloat(bodyStyles.marginLeft) + parseFloat(bodyStyles.marginRight) || 0
        : 0;
    const clippingStableScrollbarWidth = Math.abs(
      html.clientWidth - body.clientWidth - bodyMarginInline,
    );
    if (clippingStableScrollbarWidth <= SCROLLBAR_MAX) {
      width -= clippingStableScrollbarWidth;
    }
  } else if (windowScrollbarX <= SCROLLBAR_MAX) {
    width += windowScrollbarX;
  }
  return { width, height, x, y };
}
const absoluteOrFixed = /* @__PURE__ */ new Set(['absolute', 'fixed']);
function getInnerBoundingClientRect(element, strategy) {
  const clientRect = getBoundingClientRect(element, true, strategy === 'fixed');
  const top = clientRect.top + element.clientTop;
  const left = clientRect.left + element.clientLeft;
  const scale = isHTMLElement(element) ? getScale(element) : createCoords(1);
  const width = element.clientWidth * scale.x;
  const height = element.clientHeight * scale.y;
  const x = left * scale.x;
  const y = top * scale.y;
  return { width, height, x, y };
}
function getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
  let rect;
  if (clippingAncestor === 'viewport') {
    rect = getViewportRect(element, strategy);
  } else if (clippingAncestor === 'document') {
    rect = getDocumentRect(getDocumentElement(element));
  } else if (isElement(clippingAncestor)) {
    rect = getInnerBoundingClientRect(clippingAncestor, strategy);
  } else {
    const visualOffsets = getVisualOffsets(element);
    rect = {
      x: clippingAncestor.x - visualOffsets.x,
      y: clippingAncestor.y - visualOffsets.y,
      width: clippingAncestor.width,
      height: clippingAncestor.height,
    };
  }
  return rectToClientRect(rect);
}
function hasFixedPositionAncestor(element, stopNode) {
  const parentNode = getParentNode(element);
  if (parentNode === stopNode || !isElement(parentNode) || isLastTraversableNode(parentNode)) {
    return false;
  }
  return (
    getComputedStyle$1(parentNode).position === 'fixed' ||
    hasFixedPositionAncestor(parentNode, stopNode)
  );
}
function getClippingElementAncestors(element, cache) {
  const cachedResult = cache.get(element);
  if (cachedResult) {
    return cachedResult;
  }
  let result = getOverflowAncestors(element, [], false).filter(
    el => isElement(el) && getNodeName(el) !== 'body',
  );
  let currentContainingBlockComputedStyle = null;
  const elementIsFixed = getComputedStyle$1(element).position === 'fixed';
  let currentNode = elementIsFixed ? getParentNode(element) : element;
  while (isElement(currentNode) && !isLastTraversableNode(currentNode)) {
    const computedStyle = getComputedStyle$1(currentNode);
    const currentNodeIsContaining = isContainingBlock(currentNode);
    if (!currentNodeIsContaining && computedStyle.position === 'fixed') {
      currentContainingBlockComputedStyle = null;
    }
    const shouldDropCurrentNode = elementIsFixed
      ? !currentNodeIsContaining && !currentContainingBlockComputedStyle
      : (!currentNodeIsContaining &&
          computedStyle.position === 'static' &&
          !!currentContainingBlockComputedStyle &&
          absoluteOrFixed.has(currentContainingBlockComputedStyle.position)) ||
        (isOverflowElement(currentNode) &&
          !currentNodeIsContaining &&
          hasFixedPositionAncestor(element, currentNode));
    if (shouldDropCurrentNode) {
      result = result.filter(ancestor => ancestor !== currentNode);
    } else {
      currentContainingBlockComputedStyle = computedStyle;
    }
    currentNode = getParentNode(currentNode);
  }
  cache.set(element, result);
  return result;
}
function getClippingRect(_ref) {
  let { element, boundary, rootBoundary, strategy } = _ref;
  const elementClippingAncestors =
    boundary === 'clippingAncestors'
      ? isTopLayer(element)
        ? []
        : getClippingElementAncestors(element, this._c)
      : [].concat(boundary);
  const clippingAncestors = [...elementClippingAncestors, rootBoundary];
  const firstClippingAncestor = clippingAncestors[0];
  const clippingRect = clippingAncestors.reduce(
    (accRect, clippingAncestor) => {
      const rect = getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
      accRect.top = max$1(rect.top, accRect.top);
      accRect.right = min$1(rect.right, accRect.right);
      accRect.bottom = min$1(rect.bottom, accRect.bottom);
      accRect.left = max$1(rect.left, accRect.left);
      return accRect;
    },
    getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy),
  );
  return {
    width: clippingRect.right - clippingRect.left,
    height: clippingRect.bottom - clippingRect.top,
    x: clippingRect.left,
    y: clippingRect.top,
  };
}
function getDimensions(element) {
  const { width, height } = getCssDimensions(element);
  return { width, height };
}
function getRectRelativeToOffsetParent(element, offsetParent, strategy) {
  const isOffsetParentAnElement = isHTMLElement(offsetParent);
  const documentElement = getDocumentElement(offsetParent);
  const isFixed = strategy === 'fixed';
  const rect = getBoundingClientRect(element, true, isFixed, offsetParent);
  let scroll = { scrollLeft: 0, scrollTop: 0 };
  const offsets = createCoords(0);
  function setLeftRTLScrollbarOffset() {
    offsets.x = getWindowScrollBarX(documentElement);
  }
  if (isOffsetParentAnElement || (!isOffsetParentAnElement && !isFixed)) {
    if (getNodeName(offsetParent) !== 'body' || isOverflowElement(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isOffsetParentAnElement) {
      const offsetRect = getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    } else if (documentElement) {
      setLeftRTLScrollbarOffset();
    }
  }
  if (isFixed && !isOffsetParentAnElement && documentElement) {
    setLeftRTLScrollbarOffset();
  }
  const htmlOffset =
    documentElement && !isOffsetParentAnElement && !isFixed
      ? getHTMLOffset(documentElement, scroll)
      : createCoords(0);
  const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
  const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
  return { x, y, width: rect.width, height: rect.height };
}
function isStaticPositioned(element) {
  return getComputedStyle$1(element).position === 'static';
}
function getTrueOffsetParent(element, polyfill) {
  if (!isHTMLElement(element) || getComputedStyle$1(element).position === 'fixed') {
    return null;
  }
  if (polyfill) {
    return polyfill(element);
  }
  let rawOffsetParent = element.offsetParent;
  if (getDocumentElement(element) === rawOffsetParent) {
    rawOffsetParent = rawOffsetParent.ownerDocument.body;
  }
  return rawOffsetParent;
}
function getOffsetParent(element, polyfill) {
  const win = getWindow(element);
  if (isTopLayer(element)) {
    return win;
  }
  if (!isHTMLElement(element)) {
    let svgOffsetParent = getParentNode(element);
    while (svgOffsetParent && !isLastTraversableNode(svgOffsetParent)) {
      if (isElement(svgOffsetParent) && !isStaticPositioned(svgOffsetParent)) {
        return svgOffsetParent;
      }
      svgOffsetParent = getParentNode(svgOffsetParent);
    }
    return win;
  }
  let offsetParent = getTrueOffsetParent(element, polyfill);
  while (offsetParent && isTableElement(offsetParent) && isStaticPositioned(offsetParent)) {
    offsetParent = getTrueOffsetParent(offsetParent, polyfill);
  }
  if (
    offsetParent &&
    isLastTraversableNode(offsetParent) &&
    isStaticPositioned(offsetParent) &&
    !isContainingBlock(offsetParent)
  ) {
    return win;
  }
  return offsetParent || getContainingBlock(element) || win;
}
const getElementRects = async function (data) {
  const getOffsetParentFn = this.getOffsetParent || getOffsetParent;
  const getDimensionsFn = this.getDimensions;
  const floatingDimensions = await getDimensionsFn(data.floating);
  return {
    reference: getRectRelativeToOffsetParent(
      data.reference,
      await getOffsetParentFn(data.floating),
      data.strategy,
    ),
    floating: { x: 0, y: 0, width: floatingDimensions.width, height: floatingDimensions.height },
  };
};
function isRTL(element) {
  return getComputedStyle$1(element).direction === 'rtl';
}
const platform = {
  convertOffsetParentRelativeRectToViewportRelativeRect,
  getDocumentElement,
  getClippingRect,
  getOffsetParent,
  getElementRects,
  getClientRects,
  getDimensions,
  getScale,
  isElement,
  isRTL,
};
function rectsAreEqual(a, b) {
  return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
}
function observeMove(element, onMove) {
  let io = null;
  let timeoutId;
  const root = getDocumentElement(element);
  function cleanup() {
    var _io;
    clearTimeout(timeoutId);
    (_io = io) == null || _io.disconnect();
    io = null;
  }
  function refresh(skip, threshold) {
    if (skip === void 0) {
      skip = false;
    }
    if (threshold === void 0) {
      threshold = 1;
    }
    cleanup();
    const elementRectForRootMargin = element.getBoundingClientRect();
    const { left, top, width, height } = elementRectForRootMargin;
    if (!skip) {
      onMove();
    }
    if (!width || !height) {
      return;
    }
    const insetTop = floor(top);
    const insetRight = floor(root.clientWidth - (left + width));
    const insetBottom = floor(root.clientHeight - (top + height));
    const insetLeft = floor(left);
    const rootMargin =
      -insetTop + 'px ' + -insetRight + 'px ' + -insetBottom + 'px ' + -insetLeft + 'px';
    const options = { rootMargin, threshold: max$1(0, min$1(1, threshold)) || 1 };
    let isFirstUpdate = true;
    function handleObserve(entries) {
      const ratio = entries[0].intersectionRatio;
      if (ratio !== threshold) {
        if (!isFirstUpdate) {
          return refresh();
        }
        if (!ratio) {
          timeoutId = setTimeout(() => {
            refresh(false, 1e-7);
          }, 1e3);
        } else {
          refresh(false, ratio);
        }
      }
      if (
        ratio === 1 &&
        !rectsAreEqual(elementRectForRootMargin, element.getBoundingClientRect())
      ) {
        refresh();
      }
      isFirstUpdate = false;
    }
    try {
      io = new IntersectionObserver(handleObserve, {
        ...options,
        // Handle <iframe>s
        root: root.ownerDocument,
      });
    } catch (_e) {
      io = new IntersectionObserver(handleObserve, options);
    }
    io.observe(element);
  }
  refresh(true);
  return cleanup;
}
function autoUpdate(reference, floating, update, options) {
  if (options === void 0) {
    options = {};
  }
  const {
    ancestorScroll = true,
    ancestorResize = true,
    elementResize = typeof ResizeObserver === 'function',
    layoutShift = typeof IntersectionObserver === 'function',
    animationFrame = false,
  } = options;
  const referenceEl = unwrapElement(reference);
  const ancestors =
    ancestorScroll || ancestorResize
      ? [
          ...(referenceEl ? getOverflowAncestors(referenceEl) : []),
          ...getOverflowAncestors(floating),
        ]
      : [];
  ancestors.forEach(ancestor => {
    ancestorScroll && ancestor.addEventListener('scroll', update, { passive: true });
    ancestorResize && ancestor.addEventListener('resize', update);
  });
  const cleanupIo = referenceEl && layoutShift ? observeMove(referenceEl, update) : null;
  let reobserveFrame = -1;
  let resizeObserver = null;
  if (elementResize) {
    resizeObserver = new ResizeObserver(_ref => {
      let [firstEntry] = _ref;
      if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
        resizeObserver.unobserve(floating);
        cancelAnimationFrame(reobserveFrame);
        reobserveFrame = requestAnimationFrame(() => {
          var _resizeObserver;
          (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
        });
      }
      update();
    });
    if (referenceEl && !animationFrame) {
      resizeObserver.observe(referenceEl);
    }
    resizeObserver.observe(floating);
  }
  let frameId;
  let prevRefRect = animationFrame ? getBoundingClientRect(reference) : null;
  if (animationFrame) {
    frameLoop();
  }
  function frameLoop() {
    const nextRefRect = getBoundingClientRect(reference);
    if (prevRefRect && !rectsAreEqual(prevRefRect, nextRefRect)) {
      update();
    }
    prevRefRect = nextRefRect;
    frameId = requestAnimationFrame(frameLoop);
  }
  update();
  return () => {
    var _resizeObserver2;
    ancestors.forEach(ancestor => {
      ancestorScroll && ancestor.removeEventListener('scroll', update);
      ancestorResize && ancestor.removeEventListener('resize', update);
    });
    cleanupIo == null || cleanupIo();
    (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
    resizeObserver = null;
    if (animationFrame) {
      cancelAnimationFrame(frameId);
    }
  };
}
const offset$1 = offset$2;
const shift$1 = shift$2;
const flip$1 = flip$2;
const size$1 = size$2;
const hide$1 = hide$2;
const arrow$2 = arrow$3;
const limitShift$1 = limitShift$2;
const computePosition = (reference, floating, options) => {
  const cache = /* @__PURE__ */ new Map();
  const mergedOptions = { platform, ...options };
  const platformWithCache = { ...mergedOptions.platform, _c: cache };
  return computePosition$1(reference, floating, { ...mergedOptions, platform: platformWithCache });
};
var isClient = typeof document !== 'undefined';
var noop$1 = function noop() {};
var index = isClient ? useLayoutEffect : noop$1;
function deepEqual(a, b) {
  if (a === b) {
    return true;
  }
  if (typeof a !== typeof b) {
    return false;
  }
  if (typeof a === 'function' && a.toString() === b.toString()) {
    return true;
  }
  let length;
  let i;
  let keys;
  if (a && b && typeof a === 'object') {
    if (Array.isArray(a)) {
      length = a.length;
      if (length !== b.length) return false;
      for (i = length; i-- !== 0; ) {
        if (!deepEqual(a[i], b[i])) {
          return false;
        }
      }
      return true;
    }
    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) {
      return false;
    }
    for (i = length; i-- !== 0; ) {
      if (!{}.hasOwnProperty.call(b, keys[i])) {
        return false;
      }
    }
    for (i = length; i-- !== 0; ) {
      const key = keys[i];
      if (key === '_owner' && a.$$typeof) {
        continue;
      }
      if (!deepEqual(a[key], b[key])) {
        return false;
      }
    }
    return true;
  }
  return a !== a && b !== b;
}
function getDPR(element) {
  if (typeof window === 'undefined') {
    return 1;
  }
  const win = element.ownerDocument.defaultView || window;
  return win.devicePixelRatio || 1;
}
function roundByDPR(element, value) {
  const dpr = getDPR(element);
  return Math.round(value * dpr) / dpr;
}
function useLatestRef(value) {
  const ref = React.useRef(value);
  index(() => {
    ref.current = value;
  });
  return ref;
}
function useFloating(options) {
  if (options === void 0) {
    options = {};
  }
  const {
    placement = 'bottom',
    strategy = 'absolute',
    middleware = [],
    platform: platform2,
    elements: { reference: externalReference, floating: externalFloating } = {},
    transform = true,
    whileElementsMounted,
    open,
  } = options;
  const [data, setData] = React.useState({
    x: 0,
    y: 0,
    strategy,
    placement,
    middlewareData: {},
    isPositioned: false,
  });
  const [latestMiddleware, setLatestMiddleware] = React.useState(middleware);
  if (!deepEqual(latestMiddleware, middleware)) {
    setLatestMiddleware(middleware);
  }
  const [_reference, _setReference] = React.useState(null);
  const [_floating, _setFloating] = React.useState(null);
  const setReference = React.useCallback(node => {
    if (node !== referenceRef.current) {
      referenceRef.current = node;
      _setReference(node);
    }
  }, []);
  const setFloating = React.useCallback(node => {
    if (node !== floatingRef.current) {
      floatingRef.current = node;
      _setFloating(node);
    }
  }, []);
  const referenceEl = externalReference || _reference;
  const floatingEl = externalFloating || _floating;
  const referenceRef = React.useRef(null);
  const floatingRef = React.useRef(null);
  const dataRef = React.useRef(data);
  const hasWhileElementsMounted = whileElementsMounted != null;
  const whileElementsMountedRef = useLatestRef(whileElementsMounted);
  const platformRef = useLatestRef(platform2);
  const openRef = useLatestRef(open);
  const update = React.useCallback(() => {
    if (!referenceRef.current || !floatingRef.current) {
      return;
    }
    const config2 = { placement, strategy, middleware: latestMiddleware };
    if (platformRef.current) {
      config2.platform = platformRef.current;
    }
    computePosition(referenceRef.current, floatingRef.current, config2).then(data2 => {
      const fullData = {
        ...data2,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: openRef.current !== false,
      };
      if (isMountedRef.current && !deepEqual(dataRef.current, fullData)) {
        dataRef.current = fullData;
        ReactDOM.flushSync(() => {
          setData(fullData);
        });
      }
    });
  }, [latestMiddleware, placement, strategy, platformRef, openRef]);
  index(() => {
    if (open === false && dataRef.current.isPositioned) {
      dataRef.current.isPositioned = false;
      setData(data2 => ({ ...data2, isPositioned: false }));
    }
  }, [open]);
  const isMountedRef = React.useRef(false);
  index(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);
  index(() => {
    if (referenceEl) referenceRef.current = referenceEl;
    if (floatingEl) floatingRef.current = floatingEl;
    if (referenceEl && floatingEl) {
      if (whileElementsMountedRef.current) {
        return whileElementsMountedRef.current(referenceEl, floatingEl, update);
      }
      update();
    }
  }, [referenceEl, floatingEl, update, whileElementsMountedRef, hasWhileElementsMounted]);
  const refs = React.useMemo(
    () => ({ reference: referenceRef, floating: floatingRef, setReference, setFloating }),
    [setReference, setFloating],
  );
  const elements = React.useMemo(
    () => ({ reference: referenceEl, floating: floatingEl }),
    [referenceEl, floatingEl],
  );
  const floatingStyles = React.useMemo(() => {
    const initialStyles = { position: strategy, left: 0, top: 0 };
    if (!elements.floating) {
      return initialStyles;
    }
    const x = roundByDPR(elements.floating, data.x);
    const y = roundByDPR(elements.floating, data.y);
    if (transform) {
      return {
        ...initialStyles,
        transform: 'translate(' + x + 'px, ' + y + 'px)',
        ...(getDPR(elements.floating) >= 1.5 && { willChange: 'transform' }),
      };
    }
    return { position: strategy, left: x, top: y };
  }, [strategy, transform, elements.floating, data.x, data.y]);
  return React.useMemo(
    () => ({ ...data, update, refs, elements, floatingStyles }),
    [data, update, refs, elements, floatingStyles],
  );
}
const arrow$1 = options => {
  function isRef(value) {
    return {}.hasOwnProperty.call(value, 'current');
  }
  return {
    name: 'arrow',
    options,
    fn(state) {
      const { element, padding } = typeof options === 'function' ? options(state) : options;
      if (element && isRef(element)) {
        if (element.current != null) {
          return arrow$2({ element: element.current, padding }).fn(state);
        }
        return {};
      }
      if (element) {
        return arrow$2({ element, padding }).fn(state);
      }
      return {};
    },
  };
};
const offset = (options, deps) => ({ ...offset$1(options), options: [options, deps] });
const shift = (options, deps) => ({ ...shift$1(options), options: [options, deps] });
const limitShift = (options, deps) => ({ ...limitShift$1(options), options: [options, deps] });
const flip = (options, deps) => ({ ...flip$1(options), options: [options, deps] });
const size = (options, deps) => ({ ...size$1(options), options: [options, deps] });
const hide = (options, deps) => ({ ...hide$1(options), options: [options, deps] });
const arrow = (options, deps) => ({ ...arrow$1(options), options: [options, deps] });
var NAME = 'Arrow';
var Arrow$1 = React.forwardRef((props, forwardedRef) => {
  const { children, width = 10, height = 5, ...arrowProps } = props;
  return /* @__PURE__ */ jsx(Primitive.svg, {
    ...arrowProps,
    ref: forwardedRef,
    width,
    height,
    viewBox: '0 0 30 10',
    preserveAspectRatio: 'none',
    children: props.asChild
      ? children
      : /* @__PURE__ */ jsx('polygon', { points: '0,0 30,0 15,10' }),
  });
});
Arrow$1.displayName = NAME;
var Root$1 = Arrow$1;
function useSize(element) {
  const [size2, setSize] = React.useState(void 0);
  useLayoutEffect2(() => {
    if (element) {
      setSize({ width: element.offsetWidth, height: element.offsetHeight });
      const resizeObserver = new ResizeObserver(entries => {
        if (!Array.isArray(entries)) {
          return;
        }
        if (!entries.length) {
          return;
        }
        const entry = entries[0];
        let width;
        let height;
        if ('borderBoxSize' in entry) {
          const borderSizeEntry = entry['borderBoxSize'];
          const borderSize = Array.isArray(borderSizeEntry) ? borderSizeEntry[0] : borderSizeEntry;
          width = borderSize['inlineSize'];
          height = borderSize['blockSize'];
        } else {
          width = element.offsetWidth;
          height = element.offsetHeight;
        }
        setSize({ width, height });
      });
      resizeObserver.observe(element, { box: 'border-box' });
      return () => resizeObserver.unobserve(element);
    } else {
      setSize(void 0);
    }
  }, [element]);
  return size2;
}
var POPPER_NAME = 'Popper';
var [createPopperContext, createPopperScope] = createContextScope(POPPER_NAME);
var [PopperProvider, usePopperContext] = createPopperContext(POPPER_NAME);
var Popper = props => {
  const { __scopePopper, children } = props;
  const [anchor, setAnchor] = React.useState(null);
  return /* @__PURE__ */ jsx(PopperProvider, {
    scope: __scopePopper,
    anchor,
    onAnchorChange: setAnchor,
    children,
  });
};
Popper.displayName = POPPER_NAME;
var ANCHOR_NAME$1 = 'PopperAnchor';
var PopperAnchor = React.forwardRef((props, forwardedRef) => {
  const { __scopePopper, virtualRef, ...anchorProps } = props;
  const context = usePopperContext(ANCHOR_NAME$1, __scopePopper);
  const ref = React.useRef(null);
  const composedRefs = useComposedRefs(forwardedRef, ref);
  const anchorRef = React.useRef(null);
  React.useEffect(() => {
    const previousAnchor = anchorRef.current;
    anchorRef.current = virtualRef?.current || ref.current;
    if (previousAnchor !== anchorRef.current) {
      context.onAnchorChange(anchorRef.current);
    }
  });
  return virtualRef
    ? null
    : /* @__PURE__ */ jsx(Primitive.div, { ...anchorProps, ref: composedRefs });
});
PopperAnchor.displayName = ANCHOR_NAME$1;
var CONTENT_NAME$2 = 'PopperContent';
var [PopperContentProvider, useContentContext] = createPopperContext(CONTENT_NAME$2);
var PopperContent = React.forwardRef((props, forwardedRef) => {
  const {
    __scopePopper,
    side = 'bottom',
    sideOffset = 0,
    align = 'center',
    alignOffset = 0,
    arrowPadding = 0,
    avoidCollisions = true,
    collisionBoundary = [],
    collisionPadding: collisionPaddingProp = 0,
    sticky = 'partial',
    hideWhenDetached = false,
    updatePositionStrategy = 'optimized',
    onPlaced,
    ...contentProps
  } = props;
  const context = usePopperContext(CONTENT_NAME$2, __scopePopper);
  const [content, setContent] = React.useState(null);
  const composedRefs = useComposedRefs(forwardedRef, node => setContent(node));
  const [arrow$12, setArrow] = React.useState(null);
  const arrowSize = useSize(arrow$12);
  const arrowWidth = arrowSize?.width ?? 0;
  const arrowHeight = arrowSize?.height ?? 0;
  const desiredPlacement = side + (align !== 'center' ? '-' + align : '');
  const collisionPadding =
    typeof collisionPaddingProp === 'number'
      ? collisionPaddingProp
      : { top: 0, right: 0, bottom: 0, left: 0, ...collisionPaddingProp };
  const boundary = Array.isArray(collisionBoundary) ? collisionBoundary : [collisionBoundary];
  const hasExplicitBoundaries = boundary.length > 0;
  const detectOverflowOptions = {
    padding: collisionPadding,
    boundary: boundary.filter(isNotNull),
    // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
    altBoundary: hasExplicitBoundaries,
  };
  const { refs, floatingStyles, placement, isPositioned, middlewareData } = useFloating({
    // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
    strategy: 'fixed',
    placement: desiredPlacement,
    whileElementsMounted: (...args) => {
      const cleanup = autoUpdate(...args, { animationFrame: updatePositionStrategy === 'always' });
      return cleanup;
    },
    elements: { reference: context.anchor },
    middleware: [
      offset({ mainAxis: sideOffset + arrowHeight, alignmentAxis: alignOffset }),
      avoidCollisions &&
        shift({
          mainAxis: true,
          crossAxis: false,
          limiter: sticky === 'partial' ? limitShift() : void 0,
          ...detectOverflowOptions,
        }),
      avoidCollisions && flip({ ...detectOverflowOptions }),
      size({
        ...detectOverflowOptions,
        apply: ({ elements, rects, availableWidth, availableHeight }) => {
          const { width: anchorWidth, height: anchorHeight } = rects.reference;
          const contentStyle = elements.floating.style;
          contentStyle.setProperty('--radix-popper-available-width', `${availableWidth}px`);
          contentStyle.setProperty('--radix-popper-available-height', `${availableHeight}px`);
          contentStyle.setProperty('--radix-popper-anchor-width', `${anchorWidth}px`);
          contentStyle.setProperty('--radix-popper-anchor-height', `${anchorHeight}px`);
        },
      }),
      arrow$12 && arrow({ element: arrow$12, padding: arrowPadding }),
      transformOrigin({ arrowWidth, arrowHeight }),
      hideWhenDetached && hide({ strategy: 'referenceHidden', ...detectOverflowOptions }),
    ],
  });
  const [placedSide, placedAlign] = getSideAndAlignFromPlacement(placement);
  const handlePlaced = useCallbackRef$1(onPlaced);
  useLayoutEffect2(() => {
    if (isPositioned) {
      handlePlaced?.();
    }
  }, [isPositioned, handlePlaced]);
  const arrowX = middlewareData.arrow?.x;
  const arrowY = middlewareData.arrow?.y;
  const cannotCenterArrow = middlewareData.arrow?.centerOffset !== 0;
  const [contentZIndex, setContentZIndex] = React.useState();
  useLayoutEffect2(() => {
    if (content) setContentZIndex(window.getComputedStyle(content).zIndex);
  }, [content]);
  return /* @__PURE__ */ jsx('div', {
    ref: refs.setFloating,
    'data-radix-popper-content-wrapper': '',
    style: {
      ...floatingStyles,
      transform: isPositioned ? floatingStyles.transform : 'translate(0, -200%)',
      // keep off the page when measuring
      minWidth: 'max-content',
      zIndex: contentZIndex,
      ['--radix-popper-transform-origin']: [
        middlewareData.transformOrigin?.x,
        middlewareData.transformOrigin?.y,
      ].join(' '),
      // hide the content if using the hide middleware and should be hidden
      // set visibility to hidden and disable pointer events so the UI behaves
      // as if the PopperContent isn't there at all
      ...(middlewareData.hide?.referenceHidden && { visibility: 'hidden', pointerEvents: 'none' }),
    },
    dir: props.dir,
    children: /* @__PURE__ */ jsx(PopperContentProvider, {
      scope: __scopePopper,
      placedSide,
      onArrowChange: setArrow,
      arrowX,
      arrowY,
      shouldHideArrow: cannotCenterArrow,
      children: /* @__PURE__ */ jsx(Primitive.div, {
        'data-side': placedSide,
        'data-align': placedAlign,
        ...contentProps,
        ref: composedRefs,
        style: {
          ...contentProps.style,
          // if the PopperContent hasn't been placed yet (not all measurements done)
          // we prevent animations so that users's animation don't kick in too early referring wrong sides
          animation: !isPositioned ? 'none' : void 0,
        },
      }),
    }),
  });
});
PopperContent.displayName = CONTENT_NAME$2;
var ARROW_NAME$1 = 'PopperArrow';
var OPPOSITE_SIDE = { top: 'bottom', right: 'left', bottom: 'top', left: 'right' };
var PopperArrow = React.forwardRef(function PopperArrow2(props, forwardedRef) {
  const { __scopePopper, ...arrowProps } = props;
  const contentContext = useContentContext(ARROW_NAME$1, __scopePopper);
  const baseSide = OPPOSITE_SIDE[contentContext.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ jsx('span', {
      ref: contentContext.onArrowChange,
      style: {
        position: 'absolute',
        left: contentContext.arrowX,
        top: contentContext.arrowY,
        [baseSide]: 0,
        transformOrigin: { top: '', right: '0 0', bottom: 'center 0', left: '100% 0' }[
          contentContext.placedSide
        ],
        transform: {
          top: 'translateY(100%)',
          right: 'translateY(50%) rotate(90deg) translateX(-50%)',
          bottom: `rotate(180deg)`,
          left: 'translateY(50%) rotate(-90deg) translateX(50%)',
        }[contentContext.placedSide],
        visibility: contentContext.shouldHideArrow ? 'hidden' : void 0,
      },
      children: /* @__PURE__ */ jsx(Root$1, {
        ...arrowProps,
        ref: forwardedRef,
        style: {
          ...arrowProps.style,
          // ensures the element can be measured correctly (mostly for if SVG)
          display: 'block',
        },
      }),
    })
  );
});
PopperArrow.displayName = ARROW_NAME$1;
function isNotNull(value) {
  return value !== null;
}
var transformOrigin = options => ({
  name: 'transformOrigin',
  options,
  fn(data) {
    const { placement, rects, middlewareData } = data;
    const cannotCenterArrow = middlewareData.arrow?.centerOffset !== 0;
    const isArrowHidden = cannotCenterArrow;
    const arrowWidth = isArrowHidden ? 0 : options.arrowWidth;
    const arrowHeight = isArrowHidden ? 0 : options.arrowHeight;
    const [placedSide, placedAlign] = getSideAndAlignFromPlacement(placement);
    const noArrowAlign = { start: '0%', center: '50%', end: '100%' }[placedAlign];
    const arrowXCenter = (middlewareData.arrow?.x ?? 0) + arrowWidth / 2;
    const arrowYCenter = (middlewareData.arrow?.y ?? 0) + arrowHeight / 2;
    let x = '';
    let y = '';
    if (placedSide === 'bottom') {
      x = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
      y = `${-arrowHeight}px`;
    } else if (placedSide === 'top') {
      x = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
      y = `${rects.floating.height + arrowHeight}px`;
    } else if (placedSide === 'right') {
      x = `${-arrowHeight}px`;
      y = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
    } else if (placedSide === 'left') {
      x = `${rects.floating.width + arrowHeight}px`;
      y = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
    }
    return { data: { x, y } };
  },
});
function getSideAndAlignFromPlacement(placement) {
  const [side, align = 'center'] = placement.split('-');
  return [side, align];
}
var Root2$1 = Popper;
var Anchor = PopperAnchor;
var Content$1 = PopperContent;
var Arrow = PopperArrow;
var PORTAL_NAME$2 = 'Portal';
var Portal$2 = React.forwardRef((props, forwardedRef) => {
  const { container: containerProp, ...portalProps } = props;
  const [mounted, setMounted] = React.useState(false);
  useLayoutEffect2(() => setMounted(true), []);
  const container = containerProp || (mounted && globalThis?.document?.body);
  return container
    ? ReactDOM__default.createPortal(
        /* @__PURE__ */ jsx(Primitive.div, { ...portalProps, ref: forwardedRef }),
        container,
      )
    : null;
});
Portal$2.displayName = PORTAL_NAME$2;
function useStateMachine(initialState, machine) {
  return React.useReducer((state, event) => {
    const nextState = machine[state][event];
    return nextState ?? state;
  }, initialState);
}
var Presence = props => {
  const { present, children } = props;
  const presence = usePresence(present);
  const child =
    typeof children === 'function'
      ? children({ present: presence.isPresent })
      : React.Children.only(children);
  const ref = useComposedRefs(presence.ref, getElementRef(child));
  const forceMount = typeof children === 'function';
  return forceMount || presence.isPresent ? React.cloneElement(child, { ref }) : null;
};
Presence.displayName = 'Presence';
function usePresence(present) {
  const [node, setNode] = React.useState();
  const stylesRef = React.useRef(null);
  const prevPresentRef = React.useRef(present);
  const prevAnimationNameRef = React.useRef('none');
  const initialState = present ? 'mounted' : 'unmounted';
  const [state, send] = useStateMachine(initialState, {
    mounted: { UNMOUNT: 'unmounted', ANIMATION_OUT: 'unmountSuspended' },
    unmountSuspended: { MOUNT: 'mounted', ANIMATION_END: 'unmounted' },
    unmounted: { MOUNT: 'mounted' },
  });
  React.useEffect(() => {
    const currentAnimationName = getAnimationName(stylesRef.current);
    prevAnimationNameRef.current = state === 'mounted' ? currentAnimationName : 'none';
  }, [state]);
  useLayoutEffect2(() => {
    const styles = stylesRef.current;
    const wasPresent = prevPresentRef.current;
    const hasPresentChanged = wasPresent !== present;
    if (hasPresentChanged) {
      const prevAnimationName = prevAnimationNameRef.current;
      const currentAnimationName = getAnimationName(styles);
      if (present) {
        send('MOUNT');
      } else if (currentAnimationName === 'none' || styles?.display === 'none') {
        send('UNMOUNT');
      } else {
        const isAnimating = prevAnimationName !== currentAnimationName;
        if (wasPresent && isAnimating) {
          send('ANIMATION_OUT');
        } else {
          send('UNMOUNT');
        }
      }
      prevPresentRef.current = present;
    }
  }, [present, send]);
  useLayoutEffect2(() => {
    if (node) {
      let timeoutId;
      const ownerWindow = node.ownerDocument.defaultView ?? window;
      const handleAnimationEnd = event => {
        const currentAnimationName = getAnimationName(stylesRef.current);
        const isCurrentAnimation = currentAnimationName.includes(CSS.escape(event.animationName));
        if (event.target === node && isCurrentAnimation) {
          send('ANIMATION_END');
          if (!prevPresentRef.current) {
            const currentFillMode = node.style.animationFillMode;
            node.style.animationFillMode = 'forwards';
            timeoutId = ownerWindow.setTimeout(() => {
              if (node.style.animationFillMode === 'forwards') {
                node.style.animationFillMode = currentFillMode;
              }
            });
          }
        }
      };
      const handleAnimationStart = event => {
        if (event.target === node) {
          prevAnimationNameRef.current = getAnimationName(stylesRef.current);
        }
      };
      node.addEventListener('animationstart', handleAnimationStart);
      node.addEventListener('animationcancel', handleAnimationEnd);
      node.addEventListener('animationend', handleAnimationEnd);
      return () => {
        ownerWindow.clearTimeout(timeoutId);
        node.removeEventListener('animationstart', handleAnimationStart);
        node.removeEventListener('animationcancel', handleAnimationEnd);
        node.removeEventListener('animationend', handleAnimationEnd);
      };
    } else {
      send('ANIMATION_END');
    }
  }, [node, send]);
  return {
    isPresent: ['mounted', 'unmountSuspended'].includes(state),
    ref: React.useCallback(node2 => {
      stylesRef.current = node2 ? getComputedStyle(node2) : null;
      setNode(node2);
    }, []),
  };
}
function getAnimationName(styles) {
  return styles?.animationName || 'none';
}
function getElementRef(element) {
  let getter = Object.getOwnPropertyDescriptor(element.props, 'ref')?.get;
  let mayWarn = getter && 'isReactWarning' in getter && getter.isReactWarning;
  if (mayWarn) {
    return element.ref;
  }
  getter = Object.getOwnPropertyDescriptor(element, 'ref')?.get;
  mayWarn = getter && 'isReactWarning' in getter && getter.isReactWarning;
  if (mayWarn) {
    return element.props.ref;
  }
  return element.props.ref || element.ref;
}
var useInsertionEffect = React[' useInsertionEffect '.trim().toString()] || useLayoutEffect2;
function useControllableState({ prop, defaultProp, onChange = () => {}, caller }) {
  const [uncontrolledProp, setUncontrolledProp, onChangeRef] = useUncontrolledState({
    defaultProp,
    onChange,
  });
  const isControlled = prop !== void 0;
  const value = isControlled ? prop : uncontrolledProp;
  {
    const isControlledRef = React.useRef(prop !== void 0);
    React.useEffect(() => {
      const wasControlled = isControlledRef.current;
      if (wasControlled !== isControlled) {
        const from = wasControlled ? 'controlled' : 'uncontrolled';
        const to = isControlled ? 'controlled' : 'uncontrolled';
        console.warn(
          `${caller} is changing from ${from} to ${to}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`,
        );
      }
      isControlledRef.current = isControlled;
    }, [isControlled, caller]);
  }
  const setValue = React.useCallback(
    nextValue => {
      if (isControlled) {
        const value2 = isFunction$1(nextValue) ? nextValue(prop) : nextValue;
        if (value2 !== prop) {
          onChangeRef.current?.(value2);
        }
      } else {
        setUncontrolledProp(nextValue);
      }
    },
    [isControlled, prop, setUncontrolledProp, onChangeRef],
  );
  return [value, setValue];
}
function useUncontrolledState({ defaultProp, onChange }) {
  const [value, setValue] = React.useState(defaultProp);
  const prevValueRef = React.useRef(value);
  const onChangeRef = React.useRef(onChange);
  useInsertionEffect(() => {
    onChangeRef.current = onChange;
  }, [onChange]);
  React.useEffect(() => {
    if (prevValueRef.current !== value) {
      onChangeRef.current?.(value);
      prevValueRef.current = value;
    }
  }, [value, prevValueRef]);
  return [value, setValue, onChangeRef];
}
function isFunction$1(value) {
  return typeof value === 'function';
}
var getDefaultParent = function (originalTarget) {
  if (typeof document === 'undefined') {
    return null;
  }
  var sampleTarget = Array.isArray(originalTarget) ? originalTarget[0] : originalTarget;
  return sampleTarget.ownerDocument.body;
};
var counterMap = /* @__PURE__ */ new WeakMap();
var uncontrolledNodes = /* @__PURE__ */ new WeakMap();
var markerMap = {};
var lockCount = 0;
var unwrapHost = function (node) {
  return node && (node.host || unwrapHost(node.parentNode));
};
var correctTargets = function (parent, targets) {
  return targets
    .map(function (target) {
      if (parent.contains(target)) {
        return target;
      }
      var correctedTarget = unwrapHost(target);
      if (correctedTarget && parent.contains(correctedTarget)) {
        return correctedTarget;
      }
      console.error('aria-hidden', target, 'in not contained inside', parent, '. Doing nothing');
      return null;
    })
    .filter(function (x) {
      return Boolean(x);
    });
};
var applyAttributeToOthers = function (originalTarget, parentNode, markerName, controlAttribute) {
  var targets = correctTargets(
    parentNode,
    Array.isArray(originalTarget) ? originalTarget : [originalTarget],
  );
  if (!markerMap[markerName]) {
    markerMap[markerName] = /* @__PURE__ */ new WeakMap();
  }
  var markerCounter = markerMap[markerName];
  var hiddenNodes = [];
  var elementsToKeep = /* @__PURE__ */ new Set();
  var elementsToStop = new Set(targets);
  var keep = function (el) {
    if (!el || elementsToKeep.has(el)) {
      return;
    }
    elementsToKeep.add(el);
    keep(el.parentNode);
  };
  targets.forEach(keep);
  var deep = function (parent) {
    if (!parent || elementsToStop.has(parent)) {
      return;
    }
    Array.prototype.forEach.call(parent.children, function (node) {
      if (elementsToKeep.has(node)) {
        deep(node);
      } else {
        try {
          var attr = node.getAttribute(controlAttribute);
          var alreadyHidden = attr !== null && attr !== 'false';
          var counterValue = (counterMap.get(node) || 0) + 1;
          var markerValue = (markerCounter.get(node) || 0) + 1;
          counterMap.set(node, counterValue);
          markerCounter.set(node, markerValue);
          hiddenNodes.push(node);
          if (counterValue === 1 && alreadyHidden) {
            uncontrolledNodes.set(node, true);
          }
          if (markerValue === 1) {
            node.setAttribute(markerName, 'true');
          }
          if (!alreadyHidden) {
            node.setAttribute(controlAttribute, 'true');
          }
        } catch (e) {
          console.error('aria-hidden: cannot operate on ', node, e);
        }
      }
    });
  };
  deep(parentNode);
  elementsToKeep.clear();
  lockCount++;
  return function () {
    hiddenNodes.forEach(function (node) {
      var counterValue = counterMap.get(node) - 1;
      var markerValue = markerCounter.get(node) - 1;
      counterMap.set(node, counterValue);
      markerCounter.set(node, markerValue);
      if (!counterValue) {
        if (!uncontrolledNodes.has(node)) {
          node.removeAttribute(controlAttribute);
        }
        uncontrolledNodes.delete(node);
      }
      if (!markerValue) {
        node.removeAttribute(markerName);
      }
    });
    lockCount--;
    if (!lockCount) {
      counterMap = /* @__PURE__ */ new WeakMap();
      counterMap = /* @__PURE__ */ new WeakMap();
      uncontrolledNodes = /* @__PURE__ */ new WeakMap();
      markerMap = {};
    }
  };
};
var hideOthers = function (originalTarget, parentNode, markerName) {
  if (markerName === void 0) {
    markerName = 'data-aria-hidden';
  }
  var targets = Array.from(Array.isArray(originalTarget) ? originalTarget : [originalTarget]);
  var activeParentNode = getDefaultParent(originalTarget);
  if (!activeParentNode) {
    return function () {
      return null;
    };
  }
  targets.push.apply(targets, Array.from(activeParentNode.querySelectorAll('[aria-live], script')));
  return applyAttributeToOthers(targets, activeParentNode, markerName, 'aria-hidden');
};
var __assign = function () {
  __assign =
    Object.assign ||
    function __assign2(t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
      return t;
    };
  return __assign.apply(this, arguments);
};
function __rest(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === 'function')
    for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
      if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
        t[p[i]] = s[p[i]];
    }
  return t;
}
function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2)
    for (var i = 0, l = from.length, ar; i < l; i++) {
      if (ar || !(i in from)) {
        if (!ar) ar = Array.prototype.slice.call(from, 0, i);
        ar[i] = from[i];
      }
    }
  return to.concat(ar || Array.prototype.slice.call(from));
}
typeof SuppressedError === 'function'
  ? SuppressedError
  : function (error, suppressed, message) {
      var e = new Error(message);
      return ((e.name = 'SuppressedError'), (e.error = error), (e.suppressed = suppressed), e);
    };
var zeroRightClassName = 'right-scroll-bar-position';
var fullWidthClassName = 'width-before-scroll-bar';
var noScrollbarsClassName = 'with-scroll-bars-hidden';
var removedBarSizeVariable = '--removed-body-scroll-bar-size';
function assignRef(ref, value) {
  if (typeof ref === 'function') {
    ref(value);
  } else if (ref) {
    ref.current = value;
  }
  return ref;
}
function useCallbackRef(initialValue, callback) {
  var ref = useState(function () {
    return {
      // value
      value: initialValue,
      // last callback
      callback,
      // "memoized" public interface
      facade: {
        get current() {
          return ref.value;
        },
        set current(value) {
          var last = ref.value;
          if (last !== value) {
            ref.value = value;
            ref.callback(value, last);
          }
        },
      },
    };
  })[0];
  ref.callback = callback;
  return ref.facade;
}
var useIsomorphicLayoutEffect =
  typeof window !== 'undefined' ? React.useLayoutEffect : React.useEffect;
var currentValues = /* @__PURE__ */ new WeakMap();
function useMergeRefs(refs, defaultValue) {
  var callbackRef = useCallbackRef(null, function (newValue) {
    return refs.forEach(function (ref) {
      return assignRef(ref, newValue);
    });
  });
  useIsomorphicLayoutEffect(
    function () {
      var oldValue = currentValues.get(callbackRef);
      if (oldValue) {
        var prevRefs_1 = new Set(oldValue);
        var nextRefs_1 = new Set(refs);
        var current_1 = callbackRef.current;
        prevRefs_1.forEach(function (ref) {
          if (!nextRefs_1.has(ref)) {
            assignRef(ref, null);
          }
        });
        nextRefs_1.forEach(function (ref) {
          if (!prevRefs_1.has(ref)) {
            assignRef(ref, current_1);
          }
        });
      }
      currentValues.set(callbackRef, refs);
    },
    [refs],
  );
  return callbackRef;
}
function ItoI(a) {
  return a;
}
function innerCreateMedium(defaults, middleware) {
  if (middleware === void 0) {
    middleware = ItoI;
  }
  var buffer = [];
  var assigned = false;
  var medium = {
    read: function () {
      if (assigned) {
        throw new Error(
          'Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.',
        );
      }
      if (buffer.length) {
        return buffer[buffer.length - 1];
      }
      return defaults;
    },
    useMedium: function (data) {
      var item = middleware(data, assigned);
      buffer.push(item);
      return function () {
        buffer = buffer.filter(function (x) {
          return x !== item;
        });
      };
    },
    assignSyncMedium: function (cb) {
      assigned = true;
      while (buffer.length) {
        var cbs = buffer;
        buffer = [];
        cbs.forEach(cb);
      }
      buffer = {
        push: function (x) {
          return cb(x);
        },
        filter: function () {
          return buffer;
        },
      };
    },
    assignMedium: function (cb) {
      assigned = true;
      var pendingQueue = [];
      if (buffer.length) {
        var cbs = buffer;
        buffer = [];
        cbs.forEach(cb);
        pendingQueue = buffer;
      }
      var executeQueue = function () {
        var cbs2 = pendingQueue;
        pendingQueue = [];
        cbs2.forEach(cb);
      };
      var cycle = function () {
        return Promise.resolve().then(executeQueue);
      };
      cycle();
      buffer = {
        push: function (x) {
          pendingQueue.push(x);
          cycle();
        },
        filter: function (filter) {
          pendingQueue = pendingQueue.filter(filter);
          return buffer;
        },
      };
    },
  };
  return medium;
}
function createSidecarMedium(options) {
  if (options === void 0) {
    options = {};
  }
  var medium = innerCreateMedium(null);
  medium.options = __assign({ async: true, ssr: false }, options);
  return medium;
}
var SideCar$1 = function (_a) {
  var sideCar = _a.sideCar,
    rest = __rest(_a, ['sideCar']);
  if (!sideCar) {
    throw new Error('Sidecar: please provide `sideCar` property to import the right car');
  }
  var Target = sideCar.read();
  if (!Target) {
    throw new Error('Sidecar medium not found');
  }
  return React.createElement(Target, __assign({}, rest));
};
SideCar$1.isSideCarExport = true;
function exportSidecar(medium, exported) {
  medium.useMedium(exported);
  return SideCar$1;
}
var effectCar = createSidecarMedium();
var nothing = function () {
  return;
};
var RemoveScroll = React.forwardRef(function (props, parentRef) {
  var ref = React.useRef(null);
  var _a = React.useState({
      onScrollCapture: nothing,
      onWheelCapture: nothing,
      onTouchMoveCapture: nothing,
    }),
    callbacks = _a[0],
    setCallbacks = _a[1];
  var forwardProps = props.forwardProps,
    children = props.children,
    className = props.className,
    removeScrollBar = props.removeScrollBar,
    enabled = props.enabled,
    shards = props.shards,
    sideCar = props.sideCar,
    noRelative = props.noRelative,
    noIsolation = props.noIsolation,
    inert = props.inert,
    allowPinchZoom = props.allowPinchZoom,
    _b = props.as,
    Container = _b === void 0 ? 'div' : _b,
    gapMode = props.gapMode,
    rest = __rest(props, [
      'forwardProps',
      'children',
      'className',
      'removeScrollBar',
      'enabled',
      'shards',
      'sideCar',
      'noRelative',
      'noIsolation',
      'inert',
      'allowPinchZoom',
      'as',
      'gapMode',
    ]);
  var SideCar2 = sideCar;
  var containerRef = useMergeRefs([ref, parentRef]);
  var containerProps = __assign(__assign({}, rest), callbacks);
  return React.createElement(
    React.Fragment,
    null,
    enabled &&
      React.createElement(SideCar2, {
        sideCar: effectCar,
        removeScrollBar,
        shards,
        noRelative,
        noIsolation,
        inert,
        setCallbacks,
        allowPinchZoom: !!allowPinchZoom,
        lockRef: ref,
        gapMode,
      }),
    forwardProps
      ? React.cloneElement(
          React.Children.only(children),
          __assign(__assign({}, containerProps), { ref: containerRef }),
        )
      : React.createElement(
          Container,
          __assign({}, containerProps, { className, ref: containerRef }),
          children,
        ),
  );
});
RemoveScroll.defaultProps = { enabled: true, removeScrollBar: true, inert: false };
RemoveScroll.classNames = { fullWidth: fullWidthClassName, zeroRight: zeroRightClassName };
var getNonce = function () {
  if (typeof __webpack_nonce__ !== 'undefined') {
    return __webpack_nonce__;
  }
  return void 0;
};
function makeStyleTag() {
  if (!document) return null;
  var tag = document.createElement('style');
  tag.type = 'text/css';
  var nonce = getNonce();
  if (nonce) {
    tag.setAttribute('nonce', nonce);
  }
  return tag;
}
function injectStyles(tag, css) {
  if (tag.styleSheet) {
    tag.styleSheet.cssText = css;
  } else {
    tag.appendChild(document.createTextNode(css));
  }
}
function insertStyleTag(tag) {
  var head = document.head || document.getElementsByTagName('head')[0];
  head.appendChild(tag);
}
var stylesheetSingleton = function () {
  var counter = 0;
  var stylesheet = null;
  return {
    add: function (style) {
      if (counter == 0) {
        if ((stylesheet = makeStyleTag())) {
          injectStyles(stylesheet, style);
          insertStyleTag(stylesheet);
        }
      }
      counter++;
    },
    remove: function () {
      counter--;
      if (!counter && stylesheet) {
        stylesheet.parentNode && stylesheet.parentNode.removeChild(stylesheet);
        stylesheet = null;
      }
    },
  };
};
var styleHookSingleton = function () {
  var sheet = stylesheetSingleton();
  return function (styles, isDynamic) {
    React.useEffect(
      function () {
        sheet.add(styles);
        return function () {
          sheet.remove();
        };
      },
      [styles && isDynamic],
    );
  };
};
var styleSingleton = function () {
  var useStyle = styleHookSingleton();
  var Sheet = function (_a) {
    var styles = _a.styles,
      dynamic = _a.dynamic;
    useStyle(styles, dynamic);
    return null;
  };
  return Sheet;
};
var zeroGap = { left: 0, top: 0, right: 0, gap: 0 };
var parse = function (x) {
  return parseInt(x || '', 10) || 0;
};
var getOffset = function (gapMode) {
  var cs = window.getComputedStyle(document.body);
  var left = cs[gapMode === 'padding' ? 'paddingLeft' : 'marginLeft'];
  var top = cs[gapMode === 'padding' ? 'paddingTop' : 'marginTop'];
  var right = cs[gapMode === 'padding' ? 'paddingRight' : 'marginRight'];
  return [parse(left), parse(top), parse(right)];
};
var getGapWidth = function (gapMode) {
  if (gapMode === void 0) {
    gapMode = 'margin';
  }
  if (typeof window === 'undefined') {
    return zeroGap;
  }
  var offsets = getOffset(gapMode);
  var documentWidth = document.documentElement.clientWidth;
  var windowWidth = window.innerWidth;
  return {
    left: offsets[0],
    top: offsets[1],
    right: offsets[2],
    gap: Math.max(0, windowWidth - documentWidth + offsets[2] - offsets[0]),
  };
};
var Style = styleSingleton();
var lockAttribute = 'data-scroll-locked';
var getStyles = function (_a, allowRelative, gapMode, important) {
  var left = _a.left,
    top = _a.top,
    right = _a.right,
    gap = _a.gap;
  if (gapMode === void 0) {
    gapMode = 'margin';
  }
  return '\n  .'
    .concat(noScrollbarsClassName, ' {\n   overflow: hidden ')
    .concat(important, ';\n   padding-right: ')
    .concat(gap, 'px ')
    .concat(important, ';\n  }\n  body[')
    .concat(lockAttribute, '] {\n    overflow: hidden ')
    .concat(important, ';\n    overscroll-behavior: contain;\n    ')
    .concat(
      [
        allowRelative && 'position: relative '.concat(important, ';'),
        gapMode === 'margin' &&
          '\n    padding-left: '
            .concat(left, 'px;\n    padding-top: ')
            .concat(top, 'px;\n    padding-right: ')
            .concat(right, 'px;\n    margin-left:0;\n    margin-top:0;\n    margin-right: ')
            .concat(gap, 'px ')
            .concat(important, ';\n    '),
        gapMode === 'padding' && 'padding-right: '.concat(gap, 'px ').concat(important, ';'),
      ]
        .filter(Boolean)
        .join(''),
      '\n  }\n  \n  .',
    )
    .concat(zeroRightClassName, ' {\n    right: ')
    .concat(gap, 'px ')
    .concat(important, ';\n  }\n  \n  .')
    .concat(fullWidthClassName, ' {\n    margin-right: ')
    .concat(gap, 'px ')
    .concat(important, ';\n  }\n  \n  .')
    .concat(zeroRightClassName, ' .')
    .concat(zeroRightClassName, ' {\n    right: 0 ')
    .concat(important, ';\n  }\n  \n  .')
    .concat(fullWidthClassName, ' .')
    .concat(fullWidthClassName, ' {\n    margin-right: 0 ')
    .concat(important, ';\n  }\n  \n  body[')
    .concat(lockAttribute, '] {\n    ')
    .concat(removedBarSizeVariable, ': ')
    .concat(gap, 'px;\n  }\n');
};
var getCurrentUseCounter = function () {
  var counter = parseInt(document.body.getAttribute(lockAttribute) || '0', 10);
  return isFinite(counter) ? counter : 0;
};
var useLockAttribute = function () {
  React.useEffect(function () {
    document.body.setAttribute(lockAttribute, (getCurrentUseCounter() + 1).toString());
    return function () {
      var newCounter = getCurrentUseCounter() - 1;
      if (newCounter <= 0) {
        document.body.removeAttribute(lockAttribute);
      } else {
        document.body.setAttribute(lockAttribute, newCounter.toString());
      }
    };
  }, []);
};
var RemoveScrollBar = function (_a) {
  var noRelative = _a.noRelative,
    noImportant = _a.noImportant,
    _b = _a.gapMode,
    gapMode = _b === void 0 ? 'margin' : _b;
  useLockAttribute();
  var gap = React.useMemo(
    function () {
      return getGapWidth(gapMode);
    },
    [gapMode],
  );
  return React.createElement(Style, {
    styles: getStyles(gap, !noRelative, gapMode, !noImportant ? '!important' : ''),
  });
};
var passiveSupported$1 = false;
if (typeof window !== 'undefined') {
  try {
    var options = Object.defineProperty({}, 'passive', {
      get: function () {
        passiveSupported$1 = true;
        return true;
      },
    });
    window.addEventListener('test', options, options);
    window.removeEventListener('test', options, options);
  } catch (err) {
    passiveSupported$1 = false;
  }
}
var nonPassive = passiveSupported$1 ? { passive: false } : false;
var alwaysContainsScroll = function (node) {
  return node.tagName === 'TEXTAREA';
};
var elementCanBeScrolled = function (node, overflow) {
  if (!(node instanceof Element)) {
    return false;
  }
  var styles = window.getComputedStyle(node);
  return (
    // not-not-scrollable
    styles[overflow] !== 'hidden' && // contains scroll inside self
    !(
      styles.overflowY === styles.overflowX &&
      !alwaysContainsScroll(node) &&
      styles[overflow] === 'visible'
    )
  );
};
var elementCouldBeVScrolled = function (node) {
  return elementCanBeScrolled(node, 'overflowY');
};
var elementCouldBeHScrolled = function (node) {
  return elementCanBeScrolled(node, 'overflowX');
};
var locationCouldBeScrolled = function (axis, node) {
  var ownerDocument = node.ownerDocument;
  var current = node;
  do {
    if (typeof ShadowRoot !== 'undefined' && current instanceof ShadowRoot) {
      current = current.host;
    }
    var isScrollable = elementCouldBeScrolled(axis, current);
    if (isScrollable) {
      var _a = getScrollVariables(axis, current),
        scrollHeight = _a[1],
        clientHeight = _a[2];
      if (scrollHeight > clientHeight) {
        return true;
      }
    }
    current = current.parentNode;
  } while (current && current !== ownerDocument.body);
  return false;
};
var getVScrollVariables = function (_a) {
  var scrollTop = _a.scrollTop,
    scrollHeight = _a.scrollHeight,
    clientHeight = _a.clientHeight;
  return [scrollTop, scrollHeight, clientHeight];
};
var getHScrollVariables = function (_a) {
  var scrollLeft2 = _a.scrollLeft,
    scrollWidth = _a.scrollWidth,
    clientWidth = _a.clientWidth;
  return [scrollLeft2, scrollWidth, clientWidth];
};
var elementCouldBeScrolled = function (axis, node) {
  return axis === 'v' ? elementCouldBeVScrolled(node) : elementCouldBeHScrolled(node);
};
var getScrollVariables = function (axis, node) {
  return axis === 'v' ? getVScrollVariables(node) : getHScrollVariables(node);
};
var getDirectionFactor = function (axis, direction) {
  return axis === 'h' && direction === 'rtl' ? -1 : 1;
};
var handleScroll = function (axis, endTarget, event, sourceDelta, noOverscroll) {
  var directionFactor = getDirectionFactor(axis, window.getComputedStyle(endTarget).direction);
  var delta = directionFactor * sourceDelta;
  var target = event.target;
  var targetInLock = endTarget.contains(target);
  var shouldCancelScroll = false;
  var isDeltaPositive = delta > 0;
  var availableScroll = 0;
  var availableScrollTop = 0;
  do {
    if (!target) {
      break;
    }
    var _a = getScrollVariables(axis, target),
      position = _a[0],
      scroll_1 = _a[1],
      capacity = _a[2];
    var elementScroll = scroll_1 - capacity - directionFactor * position;
    if (position || elementScroll) {
      if (elementCouldBeScrolled(axis, target)) {
        availableScroll += elementScroll;
        availableScrollTop += position;
      }
    }
    var parent_1 = target.parentNode;
    target =
      parent_1 && parent_1.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? parent_1.host : parent_1;
  } while (
    // portaled content
    (!targetInLock && target !== document.body) || // self content
    (targetInLock && (endTarget.contains(target) || endTarget === target))
  );
  if (isDeltaPositive && (Math.abs(availableScroll) < 1 || false)) {
    shouldCancelScroll = true;
  } else if (!isDeltaPositive && (Math.abs(availableScrollTop) < 1 || false)) {
    shouldCancelScroll = true;
  }
  return shouldCancelScroll;
};
var getTouchXY = function (event) {
  return 'changedTouches' in event
    ? [event.changedTouches[0].clientX, event.changedTouches[0].clientY]
    : [0, 0];
};
var getDeltaXY = function (event) {
  return [event.deltaX, event.deltaY];
};
var extractRef = function (ref) {
  return ref && 'current' in ref ? ref.current : ref;
};
var deltaCompare = function (x, y) {
  return x[0] === y[0] && x[1] === y[1];
};
var generateStyle = function (id2) {
  return '\n  .block-interactivity-'
    .concat(id2, ' {pointer-events: none;}\n  .allow-interactivity-')
    .concat(id2, ' {pointer-events: all;}\n');
};
var idCounter = 0;
var lockStack = [];
function RemoveScrollSideCar(props) {
  var shouldPreventQueue = React.useRef([]);
  var touchStartRef = React.useRef([0, 0]);
  var activeAxis = React.useRef();
  var id2 = React.useState(idCounter++)[0];
  var Style2 = React.useState(styleSingleton)[0];
  var lastProps = React.useRef(props);
  React.useEffect(
    function () {
      lastProps.current = props;
    },
    [props],
  );
  React.useEffect(
    function () {
      if (props.inert) {
        document.body.classList.add('block-interactivity-'.concat(id2));
        var allow_1 = __spreadArray(
          [props.lockRef.current],
          (props.shards || []).map(extractRef),
          true,
        ).filter(Boolean);
        allow_1.forEach(function (el) {
          return el.classList.add('allow-interactivity-'.concat(id2));
        });
        return function () {
          document.body.classList.remove('block-interactivity-'.concat(id2));
          allow_1.forEach(function (el) {
            return el.classList.remove('allow-interactivity-'.concat(id2));
          });
        };
      }
      return;
    },
    [props.inert, props.lockRef.current, props.shards],
  );
  var shouldCancelEvent = React.useCallback(function (event, parent) {
    if (
      ('touches' in event && event.touches.length === 2) ||
      (event.type === 'wheel' && event.ctrlKey)
    ) {
      return !lastProps.current.allowPinchZoom;
    }
    var touch = getTouchXY(event);
    var touchStart = touchStartRef.current;
    var deltaX = 'deltaX' in event ? event.deltaX : touchStart[0] - touch[0];
    var deltaY = 'deltaY' in event ? event.deltaY : touchStart[1] - touch[1];
    var currentAxis;
    var target = event.target;
    var moveDirection = Math.abs(deltaX) > Math.abs(deltaY) ? 'h' : 'v';
    if ('touches' in event && moveDirection === 'h' && target.type === 'range') {
      return false;
    }
    var selection = window.getSelection();
    var anchorNode = selection && selection.anchorNode;
    var isTouchingSelection = anchorNode
      ? anchorNode === target || anchorNode.contains(target)
      : false;
    if (isTouchingSelection) {
      return false;
    }
    var canBeScrolledInMainDirection = locationCouldBeScrolled(moveDirection, target);
    if (!canBeScrolledInMainDirection) {
      return true;
    }
    if (canBeScrolledInMainDirection) {
      currentAxis = moveDirection;
    } else {
      currentAxis = moveDirection === 'v' ? 'h' : 'v';
      canBeScrolledInMainDirection = locationCouldBeScrolled(moveDirection, target);
    }
    if (!canBeScrolledInMainDirection) {
      return false;
    }
    if (!activeAxis.current && 'changedTouches' in event && (deltaX || deltaY)) {
      activeAxis.current = currentAxis;
    }
    if (!currentAxis) {
      return true;
    }
    var cancelingAxis = activeAxis.current || currentAxis;
    return handleScroll(cancelingAxis, parent, event, cancelingAxis === 'h' ? deltaX : deltaY);
  }, []);
  var shouldPrevent = React.useCallback(function (_event) {
    var event = _event;
    if (!lockStack.length || lockStack[lockStack.length - 1] !== Style2) {
      return;
    }
    var delta = 'deltaY' in event ? getDeltaXY(event) : getTouchXY(event);
    var sourceEvent = shouldPreventQueue.current.filter(function (e) {
      return (
        e.name === event.type &&
        (e.target === event.target || event.target === e.shadowParent) &&
        deltaCompare(e.delta, delta)
      );
    })[0];
    if (sourceEvent && sourceEvent.should) {
      if (event.cancelable) {
        event.preventDefault();
      }
      return;
    }
    if (!sourceEvent) {
      var shardNodes = (lastProps.current.shards || [])
        .map(extractRef)
        .filter(Boolean)
        .filter(function (node) {
          return node.contains(event.target);
        });
      var shouldStop =
        shardNodes.length > 0
          ? shouldCancelEvent(event, shardNodes[0])
          : !lastProps.current.noIsolation;
      if (shouldStop) {
        if (event.cancelable) {
          event.preventDefault();
        }
      }
    }
  }, []);
  var shouldCancel = React.useCallback(function (name, delta, target, should) {
    var event = { name, delta, target, should, shadowParent: getOutermostShadowParent(target) };
    shouldPreventQueue.current.push(event);
    setTimeout(function () {
      shouldPreventQueue.current = shouldPreventQueue.current.filter(function (e) {
        return e !== event;
      });
    }, 1);
  }, []);
  var scrollTouchStart = React.useCallback(function (event) {
    touchStartRef.current = getTouchXY(event);
    activeAxis.current = void 0;
  }, []);
  var scrollWheel = React.useCallback(function (event) {
    shouldCancel(
      event.type,
      getDeltaXY(event),
      event.target,
      shouldCancelEvent(event, props.lockRef.current),
    );
  }, []);
  var scrollTouchMove = React.useCallback(function (event) {
    shouldCancel(
      event.type,
      getTouchXY(event),
      event.target,
      shouldCancelEvent(event, props.lockRef.current),
    );
  }, []);
  React.useEffect(function () {
    lockStack.push(Style2);
    props.setCallbacks({
      onScrollCapture: scrollWheel,
      onWheelCapture: scrollWheel,
      onTouchMoveCapture: scrollTouchMove,
    });
    document.addEventListener('wheel', shouldPrevent, nonPassive);
    document.addEventListener('touchmove', shouldPrevent, nonPassive);
    document.addEventListener('touchstart', scrollTouchStart, nonPassive);
    return function () {
      lockStack = lockStack.filter(function (inst) {
        return inst !== Style2;
      });
      document.removeEventListener('wheel', shouldPrevent, nonPassive);
      document.removeEventListener('touchmove', shouldPrevent, nonPassive);
      document.removeEventListener('touchstart', scrollTouchStart, nonPassive);
    };
  }, []);
  var removeScrollBar = props.removeScrollBar,
    inert = props.inert;
  return React.createElement(
    React.Fragment,
    null,
    inert ? React.createElement(Style2, { styles: generateStyle(id2) }) : null,
    removeScrollBar
      ? React.createElement(RemoveScrollBar, {
          noRelative: props.noRelative,
          gapMode: props.gapMode,
        })
      : null,
  );
}
function getOutermostShadowParent(node) {
  var shadowParent = null;
  while (node !== null) {
    if (node instanceof ShadowRoot) {
      shadowParent = node.host;
      node = node.host;
    }
    node = node.parentNode;
  }
  return shadowParent;
}
const SideCar = exportSidecar(effectCar, RemoveScrollSideCar);
var ReactRemoveScroll = React.forwardRef(function (props, ref) {
  return React.createElement(RemoveScroll, __assign({}, props, { ref, sideCar: SideCar }));
});
ReactRemoveScroll.classNames = RemoveScroll.classNames;
var POPOVER_NAME = 'Popover';
var [createPopoverContext] = createContextScope(POPOVER_NAME, [createPopperScope]);
var usePopperScope = createPopperScope();
var [PopoverProvider, usePopoverContext] = createPopoverContext(POPOVER_NAME);
var Popover$1 = props => {
  const {
    __scopePopover,
    children,
    open: openProp,
    defaultOpen,
    onOpenChange,
    modal = false,
  } = props;
  const popperScope = usePopperScope(__scopePopover);
  const triggerRef = React.useRef(null);
  const [hasCustomAnchor, setHasCustomAnchor] = React.useState(false);
  const [open, setOpen] = useControllableState({
    prop: openProp,
    defaultProp: defaultOpen ?? false,
    onChange: onOpenChange,
    caller: POPOVER_NAME,
  });
  return /* @__PURE__ */ jsx(Root2$1, {
    ...popperScope,
    children: /* @__PURE__ */ jsx(PopoverProvider, {
      scope: __scopePopover,
      contentId: useId$1(),
      triggerRef,
      open,
      onOpenChange: setOpen,
      onOpenToggle: React.useCallback(() => setOpen(prevOpen => !prevOpen), [setOpen]),
      hasCustomAnchor,
      onCustomAnchorAdd: React.useCallback(() => setHasCustomAnchor(true), []),
      onCustomAnchorRemove: React.useCallback(() => setHasCustomAnchor(false), []),
      modal,
      children,
    }),
  });
};
Popover$1.displayName = POPOVER_NAME;
var ANCHOR_NAME = 'PopoverAnchor';
var PopoverAnchor = React.forwardRef((props, forwardedRef) => {
  const { __scopePopover, ...anchorProps } = props;
  const context = usePopoverContext(ANCHOR_NAME, __scopePopover);
  const popperScope = usePopperScope(__scopePopover);
  const { onCustomAnchorAdd, onCustomAnchorRemove } = context;
  React.useEffect(() => {
    onCustomAnchorAdd();
    return () => onCustomAnchorRemove();
  }, [onCustomAnchorAdd, onCustomAnchorRemove]);
  return /* @__PURE__ */ jsx(Anchor, { ...popperScope, ...anchorProps, ref: forwardedRef });
});
PopoverAnchor.displayName = ANCHOR_NAME;
var TRIGGER_NAME$1 = 'PopoverTrigger';
var PopoverTrigger$1 = React.forwardRef((props, forwardedRef) => {
  const { __scopePopover, ...triggerProps } = props;
  const context = usePopoverContext(TRIGGER_NAME$1, __scopePopover);
  const popperScope = usePopperScope(__scopePopover);
  const composedTriggerRef = useComposedRefs(forwardedRef, context.triggerRef);
  const trigger = /* @__PURE__ */ jsx(Primitive.button, {
    type: 'button',
    'aria-haspopup': 'dialog',
    'aria-expanded': context.open,
    'aria-controls': context.contentId,
    'data-state': getState$1(context.open),
    ...triggerProps,
    ref: composedTriggerRef,
    onClick: composeEventHandlers(props.onClick, context.onOpenToggle),
  });
  return context.hasCustomAnchor
    ? trigger
    : /* @__PURE__ */ jsx(Anchor, { asChild: true, ...popperScope, children: trigger });
});
PopoverTrigger$1.displayName = TRIGGER_NAME$1;
var PORTAL_NAME$1 = 'PopoverPortal';
var [PortalProvider$1, usePortalContext$1] = createPopoverContext(PORTAL_NAME$1, {
  forceMount: void 0,
});
var PopoverPortal = props => {
  const { __scopePopover, forceMount, children, container } = props;
  const context = usePopoverContext(PORTAL_NAME$1, __scopePopover);
  return /* @__PURE__ */ jsx(PortalProvider$1, {
    scope: __scopePopover,
    forceMount,
    children: /* @__PURE__ */ jsx(Presence, {
      present: forceMount || context.open,
      children: /* @__PURE__ */ jsx(Portal$2, { asChild: true, container, children }),
    }),
  });
};
PopoverPortal.displayName = PORTAL_NAME$1;
var CONTENT_NAME$1 = 'PopoverContent';
var PopoverContent$1 = React.forwardRef((props, forwardedRef) => {
  const portalContext = usePortalContext$1(CONTENT_NAME$1, props.__scopePopover);
  const { forceMount = portalContext.forceMount, ...contentProps } = props;
  const context = usePopoverContext(CONTENT_NAME$1, props.__scopePopover);
  return /* @__PURE__ */ jsx(Presence, {
    present: forceMount || context.open,
    children: context.modal
      ? /* @__PURE__ */ jsx(PopoverContentModal, { ...contentProps, ref: forwardedRef })
      : /* @__PURE__ */ jsx(PopoverContentNonModal, { ...contentProps, ref: forwardedRef }),
  });
});
PopoverContent$1.displayName = CONTENT_NAME$1;
var Slot$1 = /* @__PURE__ */ createSlot('PopoverContent.RemoveScroll');
var PopoverContentModal = React.forwardRef((props, forwardedRef) => {
  const context = usePopoverContext(CONTENT_NAME$1, props.__scopePopover);
  const contentRef = React.useRef(null);
  const composedRefs = useComposedRefs(forwardedRef, contentRef);
  const isRightClickOutsideRef = React.useRef(false);
  React.useEffect(() => {
    const content = contentRef.current;
    if (content) return hideOthers(content);
  }, []);
  return /* @__PURE__ */ jsx(ReactRemoveScroll, {
    as: Slot$1,
    allowPinchZoom: true,
    children: /* @__PURE__ */ jsx(PopoverContentImpl, {
      ...props,
      ref: composedRefs,
      trapFocus: context.open,
      disableOutsidePointerEvents: true,
      onCloseAutoFocus: composeEventHandlers(props.onCloseAutoFocus, event => {
        event.preventDefault();
        if (!isRightClickOutsideRef.current) context.triggerRef.current?.focus();
      }),
      onPointerDownOutside: composeEventHandlers(
        props.onPointerDownOutside,
        event => {
          const originalEvent = event.detail.originalEvent;
          const ctrlLeftClick = originalEvent.button === 0 && originalEvent.ctrlKey === true;
          const isRightClick = originalEvent.button === 2 || ctrlLeftClick;
          isRightClickOutsideRef.current = isRightClick;
        },
        { checkForDefaultPrevented: false },
      ),
      onFocusOutside: composeEventHandlers(props.onFocusOutside, event => event.preventDefault(), {
        checkForDefaultPrevented: false,
      }),
    }),
  });
});
var PopoverContentNonModal = React.forwardRef((props, forwardedRef) => {
  const context = usePopoverContext(CONTENT_NAME$1, props.__scopePopover);
  const hasInteractedOutsideRef = React.useRef(false);
  const hasPointerDownOutsideRef = React.useRef(false);
  return /* @__PURE__ */ jsx(PopoverContentImpl, {
    ...props,
    ref: forwardedRef,
    trapFocus: false,
    disableOutsidePointerEvents: false,
    onCloseAutoFocus: event => {
      props.onCloseAutoFocus?.(event);
      if (!event.defaultPrevented) {
        if (!hasInteractedOutsideRef.current) context.triggerRef.current?.focus();
        event.preventDefault();
      }
      hasInteractedOutsideRef.current = false;
      hasPointerDownOutsideRef.current = false;
    },
    onInteractOutside: event => {
      props.onInteractOutside?.(event);
      if (!event.defaultPrevented) {
        hasInteractedOutsideRef.current = true;
        if (event.detail.originalEvent.type === 'pointerdown') {
          hasPointerDownOutsideRef.current = true;
        }
      }
      const target = event.target;
      const targetIsTrigger = context.triggerRef.current?.contains(target);
      if (targetIsTrigger) event.preventDefault();
      if (event.detail.originalEvent.type === 'focusin' && hasPointerDownOutsideRef.current) {
        event.preventDefault();
      }
    },
  });
});
var PopoverContentImpl = React.forwardRef((props, forwardedRef) => {
  const {
    __scopePopover,
    trapFocus,
    onOpenAutoFocus,
    onCloseAutoFocus,
    disableOutsidePointerEvents,
    onEscapeKeyDown,
    onPointerDownOutside,
    onFocusOutside,
    onInteractOutside,
    ...contentProps
  } = props;
  const context = usePopoverContext(CONTENT_NAME$1, __scopePopover);
  const popperScope = usePopperScope(__scopePopover);
  useFocusGuards();
  return /* @__PURE__ */ jsx(FocusScope, {
    asChild: true,
    loop: true,
    trapped: trapFocus,
    onMountAutoFocus: onOpenAutoFocus,
    onUnmountAutoFocus: onCloseAutoFocus,
    children: /* @__PURE__ */ jsx(DismissableLayer, {
      asChild: true,
      disableOutsidePointerEvents,
      onInteractOutside,
      onEscapeKeyDown,
      onPointerDownOutside,
      onFocusOutside,
      onDismiss: () => context.onOpenChange(false),
      children: /* @__PURE__ */ jsx(Content$1, {
        'data-state': getState$1(context.open),
        role: 'dialog',
        id: context.contentId,
        ...popperScope,
        ...contentProps,
        ref: forwardedRef,
        style: {
          ...contentProps.style,
          // re-namespace exposed content custom properties
          ...{
            '--radix-popover-content-transform-origin': 'var(--radix-popper-transform-origin)',
            '--radix-popover-content-available-width': 'var(--radix-popper-available-width)',
            '--radix-popover-content-available-height': 'var(--radix-popper-available-height)',
            '--radix-popover-trigger-width': 'var(--radix-popper-anchor-width)',
            '--radix-popover-trigger-height': 'var(--radix-popper-anchor-height)',
          },
        },
      }),
    }),
  });
});
var CLOSE_NAME$1 = 'PopoverClose';
var PopoverClose = React.forwardRef((props, forwardedRef) => {
  const { __scopePopover, ...closeProps } = props;
  const context = usePopoverContext(CLOSE_NAME$1, __scopePopover);
  return /* @__PURE__ */ jsx(Primitive.button, {
    type: 'button',
    ...closeProps,
    ref: forwardedRef,
    onClick: composeEventHandlers(props.onClick, () => context.onOpenChange(false)),
  });
});
PopoverClose.displayName = CLOSE_NAME$1;
var ARROW_NAME = 'PopoverArrow';
var PopoverArrow = React.forwardRef((props, forwardedRef) => {
  const { __scopePopover, ...arrowProps } = props;
  const popperScope = usePopperScope(__scopePopover);
  return /* @__PURE__ */ jsx(Arrow, { ...popperScope, ...arrowProps, ref: forwardedRef });
});
PopoverArrow.displayName = ARROW_NAME;
function getState$1(open) {
  return open ? 'open' : 'closed';
}
var Root2 = Popover$1;
var Trigger = PopoverTrigger$1;
var Portal$1 = PopoverPortal;
var Content2 = PopoverContent$1;
const sides = ['top', 'right', 'bottom', 'left'];
const alignments = ['start', 'center', 'end'];
const Popover = forwardRefWithAs((props, ref) => {
  const {
    as: Component = 'span',
    defaultOpen,
    isOpen,
    onOpenChange,
    className,
    children,
    content,
    forceMount,
    avoidCollisions = true,
    collisionPadding,
    collisionBoundary,
    onOpenAutoFocus,
    onCloseAutoFocus,
    closeOnEscape = true,
    side = 'bottom',
    align = 'center',
    ...htmlProps
  } = props;
  return /* @__PURE__ */ React__default.createElement(
    Component,
    { ref, className: classNames('spot-popover--wrapper', className), ...htmlProps },
    /* @__PURE__ */ React__default.createElement(
      Root2,
      { open: isOpen, defaultOpen, onOpenChange: open => onOpenChange?.(open) },
      /* @__PURE__ */ React__default.createElement(PopoverTrigger$1, { asChild: true }, children),
      /* @__PURE__ */ React__default.createElement(
        Portal$1,
        { forceMount },
        /* @__PURE__ */ React__default.createElement(
          Content2,
          {
            avoidCollisions,
            collisionPadding,
            collisionBoundary,
            onOpenAutoFocus: e => onOpenAutoFocus?.(e),
            onCloseAutoFocus: e => onCloseAutoFocus?.(e),
            onEscapeKeyDown: e => {
              if (!closeOnEscape) {
                e.preventDefault();
              }
            },
            side,
            sideOffset: 5,
            align,
            asChild: true,
          },
          content,
        ),
      ),
    ),
  );
});
const placements = ['left', 'center', 'right'];
const sizes = ['small', 'large', 'medium', 'no-inset'];
const PopoverContent = forwardRefWithAs((props, ref) => {
  const {
    as: Component = 'div',
    children,
    size: size2 = 'medium',
    className,
    'data-side': dataSide,
    'data-align': dataAlign,
    noCaret = false,
    ...htmlProps
  } = props;
  const placement = React__default.useMemo(() => {
    if (dataAlign === 'start') {
      return 'left';
    } else if (dataAlign === 'end') {
      return 'right';
    }
    return 'center';
  }, [dataAlign]);
  const cursorPlacement = React__default.useMemo(() => {
    if (dataAlign === 'start') {
      return 'right';
    } else if (dataAlign === 'end') {
      return 'left';
    }
    return 'center';
  }, [dataAlign]);
  const contentClasses = classNames(
    className,
    'spot-popover',
    'spot-popover--shown',
    `spot-popover--${dataSide}-${cursorPlacement}`,
    `spot-popover--align-${dataSide}-${placement}`,
    `spot-popover--${size2}`,
    { 'spot-popover--no-caret': noCaret },
  );
  return /* @__PURE__ */ React__default.createElement(
    Component,
    {
      'data-side': dataSide,
      'data-align': dataAlign,
      ref,
      className: contentClasses,
      ...htmlProps,
    },
    children,
  );
});
const PopoverTrigger = forwardRef((props, ref) => {
  const { children, asChild = false, ...htmlProps } = props;
  return /* @__PURE__ */ React__default.createElement(
    Trigger,
    { asChild, ref, ...htmlProps },
    children,
  );
});
PopoverTrigger.displayName = 'PopoverTrigger';
const CrossProductNavRoot = forwardRefWithAs((props, ref) => {
  const { as: Component = 'div', className, popoverContent, button, ...htmlProps } = props;
  const cmpClassNames = classNames('spot-crossproduct', className);
  return /* @__PURE__ */ React__default.createElement(
    Popover,
    {
      side: 'bottom',
      align: 'end',
      onOpenAutoFocus: e => e.preventDefault(),
      content: /* @__PURE__ */ React__default.createElement(
        PopoverContent,
        { size: 'no-inset' },
        popoverContent,
      ),
    },
    /* @__PURE__ */ React__default.createElement(
      Component,
      { ref, className: cmpClassNames, ...htmlProps },
      button,
    ),
  );
});
const CrossProductPopover = forwardRefWithAs((props, ref) => {
  const {
    as: Component = 'div',
    affiliatedItems = [],
    unAffiliatedItems = [],
    footerItems = [],
    affiliatedItemsLabel = 'Your IDEXX Products',
    unAffiliatedItemsLabel = 'More IDEXX Products',
    className,
    ...htmlProps
  } = props;
  const cmpClassNames = classNames('spot-crossproduct__content', className);
  return /* @__PURE__ */ React__default.createElement(
    Component,
    { ref, className: cmpClassNames, ...htmlProps },
    affiliatedItems.length > 0
      ? /* @__PURE__ */ React__default.createElement(
          CrossProductItems,
          { label: affiliatedItemsLabel },
          affiliatedItems.map(item =>
            /* @__PURE__ */ React__default.createElement(CrossProductItem, {
              key: item.title,
              ...item,
            }),
          ),
        )
      : null,
    unAffiliatedItems.length > 0
      ? /* @__PURE__ */ React__default.createElement(
          CrossProductItems,
          { label: unAffiliatedItemsLabel, variant: 'unaffiliated' },
          unAffiliatedItems.map(item =>
            /* @__PURE__ */ React__default.createElement(CrossProductItem, {
              key: item.title,
              ...item,
            }),
          ),
        )
      : null,
    /* @__PURE__ */ React__default.createElement(
      CrossProductFooter,
      null,
      footerItems.map(item =>
        /* @__PURE__ */ React__default.createElement(CrossProductFooterItem, {
          key: item.title,
          ...item,
        }),
      ),
    ),
  );
});
const CrossProductNav = forwardRefWithAs(
  (
    {
      className,
      affiliatedItems = [],
      unAffiliatedItems = [],
      footerItems = [],
      color = 'lightteal',
      ...htmlProps
    },
    ref,
  ) => {
    const popoverProps = { affiliatedItems, unAffiliatedItems, footerItems };
    const buttonProps = { color };
    return /* @__PURE__ */ React__default.createElement(CrossProductNavRoot, {
      ref,
      className,
      popoverContent: /* @__PURE__ */ React__default.createElement(CrossProductPopover, {
        ...popoverProps,
      }),
      button: /* @__PURE__ */ React__default.createElement(CrossProductButton, { ...buttonProps }),
      ...htmlProps,
    });
  },
);
function functionalUpdate(updater, input) {
  return typeof updater === 'function' ? updater(input) : updater;
}
function makeStateUpdater(key, instance) {
  return updater => {
    instance.setState(old => {
      return { ...old, [key]: functionalUpdate(updater, old[key]) };
    });
  };
}
function isFunction(d) {
  return d instanceof Function;
}
function isNumberArray(d) {
  return Array.isArray(d) && d.every(val => typeof val === 'number');
}
function flattenBy(arr, getChildren) {
  const flat = [];
  const recurse = subArr => {
    subArr.forEach(item => {
      flat.push(item);
      const children = getChildren(item);
      if (children != null && children.length) {
        recurse(children);
      }
    });
  };
  recurse(arr);
  return flat;
}
function memo(getDeps, fn, opts) {
  let deps = [];
  let result;
  return depArgs => {
    let depTime;
    if (opts.key && opts.debug) depTime = Date.now();
    const newDeps = getDeps(depArgs);
    const depsChanged =
      newDeps.length !== deps.length || newDeps.some((dep, index2) => deps[index2] !== dep);
    if (!depsChanged) {
      return result;
    }
    deps = newDeps;
    let resultTime;
    if (opts.key && opts.debug) resultTime = Date.now();
    result = fn(...newDeps);
    opts == null || opts.onChange == null || opts.onChange(result);
    if (opts.key && opts.debug) {
      if (opts != null && opts.debug()) {
        const depEndTime = Math.round((Date.now() - depTime) * 100) / 100;
        const resultEndTime = Math.round((Date.now() - resultTime) * 100) / 100;
        const resultFpsPercentage = resultEndTime / 16;
        const pad = (str, num) => {
          str = String(str);
          while (str.length < num) {
            str = ' ' + str;
          }
          return str;
        };
        console.info(
          `%c⏱ ${pad(resultEndTime, 5)} /${pad(depEndTime, 5)} ms`,
          `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(0, Math.min(120 - 120 * resultFpsPercentage, 120))}deg 100% 31%);`,
          opts == null ? void 0 : opts.key,
        );
      }
    }
    return result;
  };
}
function getMemoOptions(tableOptions, debugLevel, key, onChange) {
  return {
    debug: () => {
      var _tableOptions$debugAl;
      return (_tableOptions$debugAl = tableOptions == null ? void 0 : tableOptions.debugAll) != null
        ? _tableOptions$debugAl
        : tableOptions[debugLevel];
    },
    key: process.env.NODE_ENV === 'development' && key,
    onChange,
  };
}
function createCell(table, row, column, columnId) {
  const getRenderValue = () => {
    var _cell$getValue;
    return (_cell$getValue = cell.getValue()) != null
      ? _cell$getValue
      : table.options.renderFallbackValue;
  };
  const cell = {
    id: `${row.id}_${column.id}`,
    row,
    column,
    getValue: () => row.getValue(columnId),
    renderValue: getRenderValue,
    getContext: memo(
      () => [table, column, row, cell],
      (table2, column2, row2, cell2) => ({
        table: table2,
        column: column2,
        row: row2,
        cell: cell2,
        getValue: cell2.getValue,
        renderValue: cell2.renderValue,
      }),
      getMemoOptions(table.options, 'debugCells', 'cell.getContext'),
    ),
  };
  table._features.forEach(feature => {
    feature.createCell == null || feature.createCell(cell, column, row, table);
  }, {});
  return cell;
}
function createColumn(table, columnDef, depth, parent) {
  var _ref, _resolvedColumnDef$id;
  const defaultColumn = table._getDefaultColumnDef();
  const resolvedColumnDef = { ...defaultColumn, ...columnDef };
  const accessorKey = resolvedColumnDef.accessorKey;
  let id2 =
    (_ref =
      (_resolvedColumnDef$id = resolvedColumnDef.id) != null
        ? _resolvedColumnDef$id
        : accessorKey
          ? typeof String.prototype.replaceAll === 'function'
            ? accessorKey.replaceAll('.', '_')
            : accessorKey.replace(/\./g, '_')
          : void 0) != null
      ? _ref
      : typeof resolvedColumnDef.header === 'string'
        ? resolvedColumnDef.header
        : void 0;
  let accessorFn;
  if (resolvedColumnDef.accessorFn) {
    accessorFn = resolvedColumnDef.accessorFn;
  } else if (accessorKey) {
    if (accessorKey.includes('.')) {
      accessorFn = originalRow => {
        let result = originalRow;
        for (const key of accessorKey.split('.')) {
          var _result;
          result = (_result = result) == null ? void 0 : _result[key];
          if (process.env.NODE_ENV !== 'production' && result === void 0) {
            console.warn(`"${key}" in deeply nested key "${accessorKey}" returned undefined.`);
          }
        }
        return result;
      };
    } else {
      accessorFn = originalRow => originalRow[resolvedColumnDef.accessorKey];
    }
  }
  if (!id2) {
    if (process.env.NODE_ENV !== 'production') {
      throw new Error(
        resolvedColumnDef.accessorFn
          ? `Columns require an id when using an accessorFn`
          : `Columns require an id when using a non-string header`,
      );
    }
    throw new Error();
  }
  let column = {
    id: `${String(id2)}`,
    accessorFn,
    parent,
    depth,
    columnDef: resolvedColumnDef,
    columns: [],
    getFlatColumns: memo(
      () => [true],
      () => {
        var _column$columns;
        return [
          column,
          ...((_column$columns = column.columns) == null
            ? void 0
            : _column$columns.flatMap(d => d.getFlatColumns())),
        ];
      },
      getMemoOptions(table.options, 'debugColumns', 'column.getFlatColumns'),
    ),
    getLeafColumns: memo(
      () => [table._getOrderColumnsFn()],
      orderColumns2 => {
        var _column$columns2;
        if ((_column$columns2 = column.columns) != null && _column$columns2.length) {
          let leafColumns = column.columns.flatMap(column2 => column2.getLeafColumns());
          return orderColumns2(leafColumns);
        }
        return [column];
      },
      getMemoOptions(table.options, 'debugColumns', 'column.getLeafColumns'),
    ),
  };
  for (const feature of table._features) {
    feature.createColumn == null || feature.createColumn(column, table);
  }
  return column;
}
const debug = 'debugHeaders';
function createHeader(table, column, options) {
  var _options$id;
  const id2 = (_options$id = options.id) != null ? _options$id : column.id;
  let header = {
    id: id2,
    column,
    index: options.index,
    isPlaceholder: !!options.isPlaceholder,
    placeholderId: options.placeholderId,
    depth: options.depth,
    subHeaders: [],
    colSpan: 0,
    rowSpan: 0,
    headerGroup: null,
    getLeafHeaders: () => {
      const leafHeaders = [];
      const recurseHeader = h => {
        if (h.subHeaders && h.subHeaders.length) {
          h.subHeaders.map(recurseHeader);
        }
        leafHeaders.push(h);
      };
      recurseHeader(header);
      return leafHeaders;
    },
    getContext: () => ({ table, header, column }),
  };
  table._features.forEach(feature => {
    feature.createHeader == null || feature.createHeader(header, table);
  });
  return header;
}
const Headers = {
  createTable: table => {
    table.getHeaderGroups = memo(
      () => [
        table.getAllColumns(),
        table.getVisibleLeafColumns(),
        table.getState().columnPinning.left,
        table.getState().columnPinning.right,
      ],
      (allColumns, leafColumns, left, right) => {
        var _left$map$filter, _right$map$filter;
        const leftColumns =
          (_left$map$filter =
            left == null
              ? void 0
              : left.map(columnId => leafColumns.find(d => d.id === columnId)).filter(Boolean)) !=
          null
            ? _left$map$filter
            : [];
        const rightColumns =
          (_right$map$filter =
            right == null
              ? void 0
              : right.map(columnId => leafColumns.find(d => d.id === columnId)).filter(Boolean)) !=
          null
            ? _right$map$filter
            : [];
        const centerColumns = leafColumns.filter(
          column =>
            !(left != null && left.includes(column.id)) &&
            !(right != null && right.includes(column.id)),
        );
        const headerGroups = buildHeaderGroups(
          allColumns,
          [...leftColumns, ...centerColumns, ...rightColumns],
          table,
        );
        return headerGroups;
      },
      getMemoOptions(table.options, debug, 'getHeaderGroups'),
    );
    table.getCenterHeaderGroups = memo(
      () => [
        table.getAllColumns(),
        table.getVisibleLeafColumns(),
        table.getState().columnPinning.left,
        table.getState().columnPinning.right,
      ],
      (allColumns, leafColumns, left, right) => {
        leafColumns = leafColumns.filter(
          column =>
            !(left != null && left.includes(column.id)) &&
            !(right != null && right.includes(column.id)),
        );
        return buildHeaderGroups(allColumns, leafColumns, table, 'center');
      },
      getMemoOptions(table.options, debug, 'getCenterHeaderGroups'),
    );
    table.getLeftHeaderGroups = memo(
      () => [
        table.getAllColumns(),
        table.getVisibleLeafColumns(),
        table.getState().columnPinning.left,
      ],
      (allColumns, leafColumns, left) => {
        var _left$map$filter2;
        const orderedLeafColumns =
          (_left$map$filter2 =
            left == null
              ? void 0
              : left.map(columnId => leafColumns.find(d => d.id === columnId)).filter(Boolean)) !=
          null
            ? _left$map$filter2
            : [];
        return buildHeaderGroups(allColumns, orderedLeafColumns, table, 'left');
      },
      getMemoOptions(table.options, debug, 'getLeftHeaderGroups'),
    );
    table.getRightHeaderGroups = memo(
      () => [
        table.getAllColumns(),
        table.getVisibleLeafColumns(),
        table.getState().columnPinning.right,
      ],
      (allColumns, leafColumns, right) => {
        var _right$map$filter2;
        const orderedLeafColumns =
          (_right$map$filter2 =
            right == null
              ? void 0
              : right.map(columnId => leafColumns.find(d => d.id === columnId)).filter(Boolean)) !=
          null
            ? _right$map$filter2
            : [];
        return buildHeaderGroups(allColumns, orderedLeafColumns, table, 'right');
      },
      getMemoOptions(table.options, debug, 'getRightHeaderGroups'),
    );
    table.getFooterGroups = memo(
      () => [table.getHeaderGroups()],
      headerGroups => {
        return [...headerGroups].reverse();
      },
      getMemoOptions(table.options, debug, 'getFooterGroups'),
    );
    table.getLeftFooterGroups = memo(
      () => [table.getLeftHeaderGroups()],
      headerGroups => {
        return [...headerGroups].reverse();
      },
      getMemoOptions(table.options, debug, 'getLeftFooterGroups'),
    );
    table.getCenterFooterGroups = memo(
      () => [table.getCenterHeaderGroups()],
      headerGroups => {
        return [...headerGroups].reverse();
      },
      getMemoOptions(table.options, debug, 'getCenterFooterGroups'),
    );
    table.getRightFooterGroups = memo(
      () => [table.getRightHeaderGroups()],
      headerGroups => {
        return [...headerGroups].reverse();
      },
      getMemoOptions(table.options, debug, 'getRightFooterGroups'),
    );
    table.getFlatHeaders = memo(
      () => [table.getHeaderGroups()],
      headerGroups => {
        return headerGroups
          .map(headerGroup => {
            return headerGroup.headers;
          })
          .flat();
      },
      getMemoOptions(table.options, debug, 'getFlatHeaders'),
    );
    table.getLeftFlatHeaders = memo(
      () => [table.getLeftHeaderGroups()],
      left => {
        return left
          .map(headerGroup => {
            return headerGroup.headers;
          })
          .flat();
      },
      getMemoOptions(table.options, debug, 'getLeftFlatHeaders'),
    );
    table.getCenterFlatHeaders = memo(
      () => [table.getCenterHeaderGroups()],
      left => {
        return left
          .map(headerGroup => {
            return headerGroup.headers;
          })
          .flat();
      },
      getMemoOptions(table.options, debug, 'getCenterFlatHeaders'),
    );
    table.getRightFlatHeaders = memo(
      () => [table.getRightHeaderGroups()],
      left => {
        return left
          .map(headerGroup => {
            return headerGroup.headers;
          })
          .flat();
      },
      getMemoOptions(table.options, debug, 'getRightFlatHeaders'),
    );
    table.getCenterLeafHeaders = memo(
      () => [table.getCenterFlatHeaders()],
      flatHeaders => {
        return flatHeaders.filter(header => {
          var _header$subHeaders;
          return !((_header$subHeaders = header.subHeaders) != null && _header$subHeaders.length);
        });
      },
      getMemoOptions(table.options, debug, 'getCenterLeafHeaders'),
    );
    table.getLeftLeafHeaders = memo(
      () => [table.getLeftFlatHeaders()],
      flatHeaders => {
        return flatHeaders.filter(header => {
          var _header$subHeaders2;
          return !((_header$subHeaders2 = header.subHeaders) != null && _header$subHeaders2.length);
        });
      },
      getMemoOptions(table.options, debug, 'getLeftLeafHeaders'),
    );
    table.getRightLeafHeaders = memo(
      () => [table.getRightFlatHeaders()],
      flatHeaders => {
        return flatHeaders.filter(header => {
          var _header$subHeaders3;
          return !((_header$subHeaders3 = header.subHeaders) != null && _header$subHeaders3.length);
        });
      },
      getMemoOptions(table.options, debug, 'getRightLeafHeaders'),
    );
    table.getLeafHeaders = memo(
      () => [
        table.getLeftHeaderGroups(),
        table.getCenterHeaderGroups(),
        table.getRightHeaderGroups(),
      ],
      (left, center, right) => {
        var _left$0$headers, _left$, _center$0$headers, _center$, _right$0$headers, _right$;
        return [
          ...((_left$0$headers = (_left$ = left[0]) == null ? void 0 : _left$.headers) != null
            ? _left$0$headers
            : []),
          ...((_center$0$headers = (_center$ = center[0]) == null ? void 0 : _center$.headers) !=
          null
            ? _center$0$headers
            : []),
          ...((_right$0$headers = (_right$ = right[0]) == null ? void 0 : _right$.headers) != null
            ? _right$0$headers
            : []),
        ]
          .map(header => {
            return header.getLeafHeaders();
          })
          .flat();
      },
      getMemoOptions(table.options, debug, 'getLeafHeaders'),
    );
  },
};
function buildHeaderGroups(allColumns, columnsToGroup, table, headerFamily) {
  var _headerGroups$0$heade, _headerGroups$;
  let maxDepth = 0;
  const findMaxDepth = function (columns, depth) {
    if (depth === void 0) {
      depth = 1;
    }
    maxDepth = Math.max(maxDepth, depth);
    columns
      .filter(column => column.getIsVisible())
      .forEach(column => {
        var _column$columns;
        if ((_column$columns = column.columns) != null && _column$columns.length) {
          findMaxDepth(column.columns, depth + 1);
        }
      }, 0);
  };
  findMaxDepth(allColumns);
  let headerGroups = [];
  const createHeaderGroup = (headersToGroup, depth) => {
    const headerGroup = {
      depth,
      id: [headerFamily, `${depth}`].filter(Boolean).join('_'),
      headers: [],
    };
    const pendingParentHeaders = [];
    headersToGroup.forEach(headerToGroup => {
      const latestPendingParentHeader = [...pendingParentHeaders].reverse()[0];
      const isLeafHeader = headerToGroup.column.depth === headerGroup.depth;
      let column;
      let isPlaceholder = false;
      if (isLeafHeader && headerToGroup.column.parent) {
        column = headerToGroup.column.parent;
      } else {
        column = headerToGroup.column;
        isPlaceholder = true;
      }
      if (
        latestPendingParentHeader &&
        (latestPendingParentHeader == null ? void 0 : latestPendingParentHeader.column) === column
      ) {
        latestPendingParentHeader.subHeaders.push(headerToGroup);
      } else {
        const header = createHeader(table, column, {
          id: [headerFamily, depth, column.id, headerToGroup == null ? void 0 : headerToGroup.id]
            .filter(Boolean)
            .join('_'),
          isPlaceholder,
          placeholderId: isPlaceholder
            ? `${pendingParentHeaders.filter(d => d.column === column).length}`
            : void 0,
          depth,
          index: pendingParentHeaders.length,
        });
        header.subHeaders.push(headerToGroup);
        pendingParentHeaders.push(header);
      }
      headerGroup.headers.push(headerToGroup);
      headerToGroup.headerGroup = headerGroup;
    });
    headerGroups.push(headerGroup);
    if (depth > 0) {
      createHeaderGroup(pendingParentHeaders, depth - 1);
    }
  };
  const bottomHeaders = columnsToGroup.map((column, index2) =>
    createHeader(table, column, { depth: maxDepth, index: index2 }),
  );
  createHeaderGroup(bottomHeaders, maxDepth - 1);
  headerGroups.reverse();
  const recurseHeadersForSpans = headers => {
    const filteredHeaders = headers.filter(header => header.column.getIsVisible());
    return filteredHeaders.map(header => {
      let colSpan = 0;
      let rowSpan = 0;
      let childRowSpans = [0];
      if (header.subHeaders && header.subHeaders.length) {
        childRowSpans = [];
        recurseHeadersForSpans(header.subHeaders).forEach(_ref => {
          let { colSpan: childColSpan, rowSpan: childRowSpan } = _ref;
          colSpan += childColSpan;
          childRowSpans.push(childRowSpan);
        });
      } else {
        colSpan = 1;
      }
      const minChildRowSpan = Math.min(...childRowSpans);
      rowSpan = rowSpan + minChildRowSpan;
      header.colSpan = colSpan;
      header.rowSpan = rowSpan;
      return { colSpan, rowSpan };
    });
  };
  recurseHeadersForSpans(
    (_headerGroups$0$heade =
      (_headerGroups$ = headerGroups[0]) == null ? void 0 : _headerGroups$.headers) != null
      ? _headerGroups$0$heade
      : [],
  );
  return headerGroups;
}
const createRow = (table, id2, original, rowIndex, depth, subRows, parentId) => {
  let row = {
    id: id2,
    index: rowIndex,
    original,
    depth,
    parentId,
    _valuesCache: {},
    _uniqueValuesCache: {},
    getValue: columnId => {
      if (row._valuesCache.hasOwnProperty(columnId)) {
        return row._valuesCache[columnId];
      }
      const column = table.getColumn(columnId);
      if (!(column != null && column.accessorFn)) {
        return void 0;
      }
      row._valuesCache[columnId] = column.accessorFn(row.original, rowIndex);
      return row._valuesCache[columnId];
    },
    getUniqueValues: columnId => {
      if (row._uniqueValuesCache.hasOwnProperty(columnId)) {
        return row._uniqueValuesCache[columnId];
      }
      const column = table.getColumn(columnId);
      if (!(column != null && column.accessorFn)) {
        return void 0;
      }
      if (!column.columnDef.getUniqueValues) {
        row._uniqueValuesCache[columnId] = [row.getValue(columnId)];
        return row._uniqueValuesCache[columnId];
      }
      row._uniqueValuesCache[columnId] = column.columnDef.getUniqueValues(row.original, rowIndex);
      return row._uniqueValuesCache[columnId];
    },
    renderValue: columnId => {
      var _row$getValue;
      return (_row$getValue = row.getValue(columnId)) != null
        ? _row$getValue
        : table.options.renderFallbackValue;
    },
    subRows: [],
    getLeafRows: () => flattenBy(row.subRows, d => d.subRows),
    getParentRow: () => (row.parentId ? table.getRow(row.parentId, true) : void 0),
    getParentRows: () => {
      let parentRows = [];
      let currentRow = row;
      while (true) {
        const parentRow = currentRow.getParentRow();
        if (!parentRow) break;
        parentRows.push(parentRow);
        currentRow = parentRow;
      }
      return parentRows.reverse();
    },
    getAllCells: memo(
      () => [table.getAllLeafColumns()],
      leafColumns => {
        return leafColumns.map(column => {
          return createCell(table, row, column, column.id);
        });
      },
      getMemoOptions(table.options, 'debugRows', 'getAllCells'),
    ),
    _getAllCellsByColumnId: memo(
      () => [row.getAllCells()],
      allCells => {
        return allCells.reduce((acc, cell) => {
          acc[cell.column.id] = cell;
          return acc;
        }, {});
      },
      getMemoOptions(table.options, 'debugRows', 'getAllCellsByColumnId'),
    ),
  };
  for (let i = 0; i < table._features.length; i++) {
    const feature = table._features[i];
    feature == null || feature.createRow == null || feature.createRow(row, table);
  }
  return row;
};
const ColumnFaceting = {
  createColumn: (column, table) => {
    column._getFacetedRowModel =
      table.options.getFacetedRowModel && table.options.getFacetedRowModel(table, column.id);
    column.getFacetedRowModel = () => {
      if (!column._getFacetedRowModel) {
        return table.getPreFilteredRowModel();
      }
      return column._getFacetedRowModel();
    };
    column._getFacetedUniqueValues =
      table.options.getFacetedUniqueValues &&
      table.options.getFacetedUniqueValues(table, column.id);
    column.getFacetedUniqueValues = () => {
      if (!column._getFacetedUniqueValues) {
        return /* @__PURE__ */ new Map();
      }
      return column._getFacetedUniqueValues();
    };
    column._getFacetedMinMaxValues =
      table.options.getFacetedMinMaxValues &&
      table.options.getFacetedMinMaxValues(table, column.id);
    column.getFacetedMinMaxValues = () => {
      if (!column._getFacetedMinMaxValues) {
        return void 0;
      }
      return column._getFacetedMinMaxValues();
    };
  },
};
const includesString = (row, columnId, filterValue) => {
  var _filterValue$toString, _row$getValue;
  const search =
    filterValue == null || (_filterValue$toString = filterValue.toString()) == null
      ? void 0
      : _filterValue$toString.toLowerCase();
  return Boolean(
    (_row$getValue = row.getValue(columnId)) == null ||
      (_row$getValue = _row$getValue.toString()) == null ||
      (_row$getValue = _row$getValue.toLowerCase()) == null
      ? void 0
      : _row$getValue.includes(search),
  );
};
includesString.autoRemove = val => testFalsey(val);
const includesStringSensitive = (row, columnId, filterValue) => {
  var _row$getValue2;
  return Boolean(
    (_row$getValue2 = row.getValue(columnId)) == null ||
      (_row$getValue2 = _row$getValue2.toString()) == null
      ? void 0
      : _row$getValue2.includes(filterValue),
  );
};
includesStringSensitive.autoRemove = val => testFalsey(val);
const equalsString = (row, columnId, filterValue) => {
  var _row$getValue3;
  return (
    ((_row$getValue3 = row.getValue(columnId)) == null ||
    (_row$getValue3 = _row$getValue3.toString()) == null
      ? void 0
      : _row$getValue3.toLowerCase()) === (filterValue == null ? void 0 : filterValue.toLowerCase())
  );
};
equalsString.autoRemove = val => testFalsey(val);
const arrIncludes = (row, columnId, filterValue) => {
  var _row$getValue4;
  return (_row$getValue4 = row.getValue(columnId)) == null
    ? void 0
    : _row$getValue4.includes(filterValue);
};
arrIncludes.autoRemove = val => testFalsey(val);
const arrIncludesAll = (row, columnId, filterValue) => {
  return !filterValue.some(val => {
    var _row$getValue5;
    return !((_row$getValue5 = row.getValue(columnId)) != null && _row$getValue5.includes(val));
  });
};
arrIncludesAll.autoRemove = val => testFalsey(val) || !(val != null && val.length);
const arrIncludesSome = (row, columnId, filterValue) => {
  return filterValue.some(val => {
    var _row$getValue6;
    return (_row$getValue6 = row.getValue(columnId)) == null
      ? void 0
      : _row$getValue6.includes(val);
  });
};
arrIncludesSome.autoRemove = val => testFalsey(val) || !(val != null && val.length);
const equals = (row, columnId, filterValue) => {
  return row.getValue(columnId) === filterValue;
};
equals.autoRemove = val => testFalsey(val);
const weakEquals = (row, columnId, filterValue) => {
  return row.getValue(columnId) == filterValue;
};
weakEquals.autoRemove = val => testFalsey(val);
const inNumberRange = (row, columnId, filterValue) => {
  let [min2, max2] = filterValue;
  const rowValue = row.getValue(columnId);
  return rowValue >= min2 && rowValue <= max2;
};
inNumberRange.resolveFilterValue = val => {
  let [unsafeMin, unsafeMax] = val;
  let parsedMin = typeof unsafeMin !== 'number' ? parseFloat(unsafeMin) : unsafeMin;
  let parsedMax = typeof unsafeMax !== 'number' ? parseFloat(unsafeMax) : unsafeMax;
  let min2 = unsafeMin === null || Number.isNaN(parsedMin) ? -Infinity : parsedMin;
  let max2 = unsafeMax === null || Number.isNaN(parsedMax) ? Infinity : parsedMax;
  if (min2 > max2) {
    const temp = min2;
    min2 = max2;
    max2 = temp;
  }
  return [min2, max2];
};
inNumberRange.autoRemove = val => testFalsey(val) || (testFalsey(val[0]) && testFalsey(val[1]));
const filterFns = {
  includesString,
  includesStringSensitive,
  equalsString,
  arrIncludes,
  arrIncludesAll,
  arrIncludesSome,
  equals,
  weakEquals,
  inNumberRange,
};
function testFalsey(val) {
  return val === void 0 || val === null || val === '';
}
const ColumnFiltering = {
  getDefaultColumnDef: () => {
    return { filterFn: 'auto' };
  },
  getInitialState: state => {
    return { columnFilters: [], ...state };
  },
  getDefaultOptions: table => {
    return {
      onColumnFiltersChange: makeStateUpdater('columnFilters', table),
      filterFromLeafRows: false,
      maxLeafRowFilterDepth: 100,
    };
  },
  createColumn: (column, table) => {
    column.getAutoFilterFn = () => {
      const firstRow = table.getCoreRowModel().flatRows[0];
      const value = firstRow == null ? void 0 : firstRow.getValue(column.id);
      if (typeof value === 'string') {
        return filterFns.includesString;
      }
      if (typeof value === 'number') {
        return filterFns.inNumberRange;
      }
      if (typeof value === 'boolean') {
        return filterFns.equals;
      }
      if (value !== null && typeof value === 'object') {
        return filterFns.equals;
      }
      if (Array.isArray(value)) {
        return filterFns.arrIncludes;
      }
      return filterFns.weakEquals;
    };
    column.getFilterFn = () => {
      var _table$options$filter, _table$options$filter2;
      return isFunction(column.columnDef.filterFn)
        ? column.columnDef.filterFn
        : column.columnDef.filterFn === 'auto'
          ? column.getAutoFilterFn()
          : // @ts-ignore
            (_table$options$filter =
                (_table$options$filter2 = table.options.filterFns) == null
                  ? void 0
                  : _table$options$filter2[column.columnDef.filterFn]) != null
            ? _table$options$filter
            : filterFns[column.columnDef.filterFn];
    };
    column.getCanFilter = () => {
      var _column$columnDef$ena, _table$options$enable, _table$options$enable2;
      return (
        ((_column$columnDef$ena = column.columnDef.enableColumnFilter) != null
          ? _column$columnDef$ena
          : true) &&
        ((_table$options$enable = table.options.enableColumnFilters) != null
          ? _table$options$enable
          : true) &&
        ((_table$options$enable2 = table.options.enableFilters) != null
          ? _table$options$enable2
          : true) &&
        !!column.accessorFn
      );
    };
    column.getIsFiltered = () => column.getFilterIndex() > -1;
    column.getFilterValue = () => {
      var _table$getState$colum;
      return (_table$getState$colum = table.getState().columnFilters) == null ||
        (_table$getState$colum = _table$getState$colum.find(d => d.id === column.id)) == null
        ? void 0
        : _table$getState$colum.value;
    };
    column.getFilterIndex = () => {
      var _table$getState$colum2, _table$getState$colum3;
      return (_table$getState$colum2 =
        (_table$getState$colum3 = table.getState().columnFilters) == null
          ? void 0
          : _table$getState$colum3.findIndex(d => d.id === column.id)) != null
        ? _table$getState$colum2
        : -1;
    };
    column.setFilterValue = value => {
      table.setColumnFilters(old => {
        const filterFn = column.getFilterFn();
        const previousFilter = old == null ? void 0 : old.find(d => d.id === column.id);
        const newFilter = functionalUpdate(value, previousFilter ? previousFilter.value : void 0);
        if (shouldAutoRemoveFilter(filterFn, newFilter, column)) {
          var _old$filter;
          return (_old$filter = old == null ? void 0 : old.filter(d => d.id !== column.id)) != null
            ? _old$filter
            : [];
        }
        const newFilterObj = { id: column.id, value: newFilter };
        if (previousFilter) {
          var _old$map;
          return (_old$map =
            old == null
              ? void 0
              : old.map(d => {
                  if (d.id === column.id) {
                    return newFilterObj;
                  }
                  return d;
                })) != null
            ? _old$map
            : [];
        }
        if (old != null && old.length) {
          return [...old, newFilterObj];
        }
        return [newFilterObj];
      });
    };
  },
  createRow: (row, _table) => {
    row.columnFilters = {};
    row.columnFiltersMeta = {};
  },
  createTable: table => {
    table.setColumnFilters = updater => {
      const leafColumns = table.getAllLeafColumns();
      const updateFn = old => {
        var _functionalUpdate;
        return (_functionalUpdate = functionalUpdate(updater, old)) == null
          ? void 0
          : _functionalUpdate.filter(filter => {
              const column = leafColumns.find(d => d.id === filter.id);
              if (column) {
                const filterFn = column.getFilterFn();
                if (shouldAutoRemoveFilter(filterFn, filter.value, column)) {
                  return false;
                }
              }
              return true;
            });
      };
      table.options.onColumnFiltersChange == null || table.options.onColumnFiltersChange(updateFn);
    };
    table.resetColumnFilters = defaultState => {
      var _table$initialState$c, _table$initialState;
      table.setColumnFilters(
        defaultState
          ? []
          : (_table$initialState$c =
                (_table$initialState = table.initialState) == null
                  ? void 0
                  : _table$initialState.columnFilters) != null
            ? _table$initialState$c
            : [],
      );
    };
    table.getPreFilteredRowModel = () => table.getCoreRowModel();
    table.getFilteredRowModel = () => {
      if (!table._getFilteredRowModel && table.options.getFilteredRowModel) {
        table._getFilteredRowModel = table.options.getFilteredRowModel(table);
      }
      if (table.options.manualFiltering || !table._getFilteredRowModel) {
        return table.getPreFilteredRowModel();
      }
      return table._getFilteredRowModel();
    };
  },
};
function shouldAutoRemoveFilter(filterFn, value, column) {
  return (
    (filterFn && filterFn.autoRemove ? filterFn.autoRemove(value, column) : false) ||
    typeof value === 'undefined' ||
    (typeof value === 'string' && !value)
  );
}
const sum = (columnId, _leafRows, childRows) => {
  return childRows.reduce((sum2, next) => {
    const nextValue = next.getValue(columnId);
    return sum2 + (typeof nextValue === 'number' ? nextValue : 0);
  }, 0);
};
const min = (columnId, _leafRows, childRows) => {
  let min2;
  childRows.forEach(row => {
    const value = row.getValue(columnId);
    if (value != null && (min2 > value || (min2 === void 0 && value >= value))) {
      min2 = value;
    }
  });
  return min2;
};
const max = (columnId, _leafRows, childRows) => {
  let max2;
  childRows.forEach(row => {
    const value = row.getValue(columnId);
    if (value != null && (max2 < value || (max2 === void 0 && value >= value))) {
      max2 = value;
    }
  });
  return max2;
};
const extent = (columnId, _leafRows, childRows) => {
  let min2;
  let max2;
  childRows.forEach(row => {
    const value = row.getValue(columnId);
    if (value != null) {
      if (min2 === void 0) {
        if (value >= value) min2 = max2 = value;
      } else {
        if (min2 > value) min2 = value;
        if (max2 < value) max2 = value;
      }
    }
  });
  return [min2, max2];
};
const mean = (columnId, leafRows) => {
  let count2 = 0;
  let sum2 = 0;
  leafRows.forEach(row => {
    let value = row.getValue(columnId);
    if (value != null && (value = +value) >= value) {
      (++count2, (sum2 += value));
    }
  });
  if (count2) return sum2 / count2;
  return;
};
const median = (columnId, leafRows) => {
  if (!leafRows.length) {
    return;
  }
  const values = leafRows.map(row => row.getValue(columnId));
  if (!isNumberArray(values)) {
    return;
  }
  if (values.length === 1) {
    return values[0];
  }
  const mid = Math.floor(values.length / 2);
  const nums = values.sort((a, b) => a - b);
  return values.length % 2 !== 0 ? nums[mid] : (nums[mid - 1] + nums[mid]) / 2;
};
const unique = (columnId, leafRows) => {
  return Array.from(new Set(leafRows.map(d => d.getValue(columnId))).values());
};
const uniqueCount = (columnId, leafRows) => {
  return new Set(leafRows.map(d => d.getValue(columnId))).size;
};
const count = (_columnId, leafRows) => {
  return leafRows.length;
};
const aggregationFns = { sum, min, max, extent, mean, median, unique, uniqueCount, count };
const ColumnGrouping = {
  getDefaultColumnDef: () => {
    return {
      aggregatedCell: props => {
        var _toString, _props$getValue;
        return (_toString =
          (_props$getValue = props.getValue()) == null || _props$getValue.toString == null
            ? void 0
            : _props$getValue.toString()) != null
          ? _toString
          : null;
      },
      aggregationFn: 'auto',
    };
  },
  getInitialState: state => {
    return { grouping: [], ...state };
  },
  getDefaultOptions: table => {
    return { onGroupingChange: makeStateUpdater('grouping', table), groupedColumnMode: 'reorder' };
  },
  createColumn: (column, table) => {
    column.toggleGrouping = () => {
      table.setGrouping(old => {
        if (old != null && old.includes(column.id)) {
          return old.filter(d => d !== column.id);
        }
        return [...(old != null ? old : []), column.id];
      });
    };
    column.getCanGroup = () => {
      var _column$columnDef$ena, _table$options$enable;
      return (
        ((_column$columnDef$ena = column.columnDef.enableGrouping) != null
          ? _column$columnDef$ena
          : true) &&
        ((_table$options$enable = table.options.enableGrouping) != null
          ? _table$options$enable
          : true) &&
        (!!column.accessorFn || !!column.columnDef.getGroupingValue)
      );
    };
    column.getIsGrouped = () => {
      var _table$getState$group;
      return (_table$getState$group = table.getState().grouping) == null
        ? void 0
        : _table$getState$group.includes(column.id);
    };
    column.getGroupedIndex = () => {
      var _table$getState$group2;
      return (_table$getState$group2 = table.getState().grouping) == null
        ? void 0
        : _table$getState$group2.indexOf(column.id);
    };
    column.getToggleGroupingHandler = () => {
      const canGroup = column.getCanGroup();
      return () => {
        if (!canGroup) return;
        column.toggleGrouping();
      };
    };
    column.getAutoAggregationFn = () => {
      const firstRow = table.getCoreRowModel().flatRows[0];
      const value = firstRow == null ? void 0 : firstRow.getValue(column.id);
      if (typeof value === 'number') {
        return aggregationFns.sum;
      }
      if (Object.prototype.toString.call(value) === '[object Date]') {
        return aggregationFns.extent;
      }
    };
    column.getAggregationFn = () => {
      var _table$options$aggreg, _table$options$aggreg2;
      if (!column) {
        throw new Error();
      }
      return isFunction(column.columnDef.aggregationFn)
        ? column.columnDef.aggregationFn
        : column.columnDef.aggregationFn === 'auto'
          ? column.getAutoAggregationFn()
          : (_table$options$aggreg =
                (_table$options$aggreg2 = table.options.aggregationFns) == null
                  ? void 0
                  : _table$options$aggreg2[column.columnDef.aggregationFn]) != null
            ? _table$options$aggreg
            : aggregationFns[column.columnDef.aggregationFn];
    };
  },
  createTable: table => {
    table.setGrouping = updater =>
      table.options.onGroupingChange == null ? void 0 : table.options.onGroupingChange(updater);
    table.resetGrouping = defaultState => {
      var _table$initialState$g, _table$initialState;
      table.setGrouping(
        defaultState
          ? []
          : (_table$initialState$g =
                (_table$initialState = table.initialState) == null
                  ? void 0
                  : _table$initialState.grouping) != null
            ? _table$initialState$g
            : [],
      );
    };
    table.getPreGroupedRowModel = () => table.getFilteredRowModel();
    table.getGroupedRowModel = () => {
      if (!table._getGroupedRowModel && table.options.getGroupedRowModel) {
        table._getGroupedRowModel = table.options.getGroupedRowModel(table);
      }
      if (table.options.manualGrouping || !table._getGroupedRowModel) {
        return table.getPreGroupedRowModel();
      }
      return table._getGroupedRowModel();
    };
  },
  createRow: (row, table) => {
    row.getIsGrouped = () => !!row.groupingColumnId;
    row.getGroupingValue = columnId => {
      if (row._groupingValuesCache.hasOwnProperty(columnId)) {
        return row._groupingValuesCache[columnId];
      }
      const column = table.getColumn(columnId);
      if (!(column != null && column.columnDef.getGroupingValue)) {
        return row.getValue(columnId);
      }
      row._groupingValuesCache[columnId] = column.columnDef.getGroupingValue(row.original);
      return row._groupingValuesCache[columnId];
    };
    row._groupingValuesCache = {};
  },
  createCell: (cell, column, row, table) => {
    cell.getIsGrouped = () => column.getIsGrouped() && column.id === row.groupingColumnId;
    cell.getIsPlaceholder = () => !cell.getIsGrouped() && column.getIsGrouped();
    cell.getIsAggregated = () => {
      var _row$subRows;
      return (
        !cell.getIsGrouped() &&
        !cell.getIsPlaceholder() &&
        !!((_row$subRows = row.subRows) != null && _row$subRows.length)
      );
    };
  },
};
function orderColumns(leafColumns, grouping, groupedColumnMode) {
  if (!(grouping != null && grouping.length) || !groupedColumnMode) {
    return leafColumns;
  }
  const nonGroupingColumns = leafColumns.filter(col => !grouping.includes(col.id));
  if (groupedColumnMode === 'remove') {
    return nonGroupingColumns;
  }
  const groupingColumns = grouping.map(g => leafColumns.find(col => col.id === g)).filter(Boolean);
  return [...groupingColumns, ...nonGroupingColumns];
}
const ColumnOrdering = {
  getInitialState: state => {
    return { columnOrder: [], ...state };
  },
  getDefaultOptions: table => {
    return { onColumnOrderChange: makeStateUpdater('columnOrder', table) };
  },
  createColumn: (column, table) => {
    column.getIndex = memo(
      position => [_getVisibleLeafColumns(table, position)],
      columns => columns.findIndex(d => d.id === column.id),
      getMemoOptions(table.options, 'debugColumns', 'getIndex'),
    );
    column.getIsFirstColumn = position => {
      var _columns$;
      const columns = _getVisibleLeafColumns(table, position);
      return ((_columns$ = columns[0]) == null ? void 0 : _columns$.id) === column.id;
    };
    column.getIsLastColumn = position => {
      var _columns;
      const columns = _getVisibleLeafColumns(table, position);
      return (
        ((_columns = columns[columns.length - 1]) == null ? void 0 : _columns.id) === column.id
      );
    };
  },
  createTable: table => {
    table.setColumnOrder = updater =>
      table.options.onColumnOrderChange == null
        ? void 0
        : table.options.onColumnOrderChange(updater);
    table.resetColumnOrder = defaultState => {
      var _table$initialState$c;
      table.setColumnOrder(
        defaultState
          ? []
          : (_table$initialState$c = table.initialState.columnOrder) != null
            ? _table$initialState$c
            : [],
      );
    };
    table._getOrderColumnsFn = memo(
      () => [
        table.getState().columnOrder,
        table.getState().grouping,
        table.options.groupedColumnMode,
      ],
      (columnOrder, grouping, groupedColumnMode) => columns => {
        let orderedColumns = [];
        if (!(columnOrder != null && columnOrder.length)) {
          orderedColumns = columns;
        } else {
          const columnOrderCopy = [...columnOrder];
          const columnsCopy = [...columns];
          while (columnsCopy.length && columnOrderCopy.length) {
            const targetColumnId = columnOrderCopy.shift();
            const foundIndex = columnsCopy.findIndex(d => d.id === targetColumnId);
            if (foundIndex > -1) {
              orderedColumns.push(columnsCopy.splice(foundIndex, 1)[0]);
            }
          }
          orderedColumns = [...orderedColumns, ...columnsCopy];
        }
        return orderColumns(orderedColumns, grouping, groupedColumnMode);
      },
      getMemoOptions(table.options, 'debugTable', '_getOrderColumnsFn'),
    );
  },
};
const getDefaultColumnPinningState = () => ({ left: [], right: [] });
const ColumnPinning = {
  getInitialState: state => {
    return { columnPinning: getDefaultColumnPinningState(), ...state };
  },
  getDefaultOptions: table => {
    return { onColumnPinningChange: makeStateUpdater('columnPinning', table) };
  },
  createColumn: (column, table) => {
    column.pin = position => {
      const columnIds = column
        .getLeafColumns()
        .map(d => d.id)
        .filter(Boolean);
      table.setColumnPinning(old => {
        var _old$left3, _old$right3;
        if (position === 'right') {
          var _old$left, _old$right;
          return {
            left: ((_old$left = old == null ? void 0 : old.left) != null ? _old$left : []).filter(
              d => !(columnIds != null && columnIds.includes(d)),
            ),
            right: [
              ...((_old$right = old == null ? void 0 : old.right) != null ? _old$right : []).filter(
                d => !(columnIds != null && columnIds.includes(d)),
              ),
              ...columnIds,
            ],
          };
        }
        if (position === 'left') {
          var _old$left2, _old$right2;
          return {
            left: [
              ...((_old$left2 = old == null ? void 0 : old.left) != null ? _old$left2 : []).filter(
                d => !(columnIds != null && columnIds.includes(d)),
              ),
              ...columnIds,
            ],
            right: ((_old$right2 = old == null ? void 0 : old.right) != null
              ? _old$right2
              : []
            ).filter(d => !(columnIds != null && columnIds.includes(d))),
          };
        }
        return {
          left: ((_old$left3 = old == null ? void 0 : old.left) != null ? _old$left3 : []).filter(
            d => !(columnIds != null && columnIds.includes(d)),
          ),
          right: ((_old$right3 = old == null ? void 0 : old.right) != null
            ? _old$right3
            : []
          ).filter(d => !(columnIds != null && columnIds.includes(d))),
        };
      });
    };
    column.getCanPin = () => {
      const leafColumns = column.getLeafColumns();
      return leafColumns.some(d => {
        var _d$columnDef$enablePi, _ref, _table$options$enable;
        return (
          ((_d$columnDef$enablePi = d.columnDef.enablePinning) != null
            ? _d$columnDef$enablePi
            : true) &&
          ((_ref =
            (_table$options$enable = table.options.enableColumnPinning) != null
              ? _table$options$enable
              : table.options.enablePinning) != null
            ? _ref
            : true)
        );
      });
    };
    column.getIsPinned = () => {
      const leafColumnIds = column.getLeafColumns().map(d => d.id);
      const { left, right } = table.getState().columnPinning;
      const isLeft = leafColumnIds.some(d => (left == null ? void 0 : left.includes(d)));
      const isRight = leafColumnIds.some(d => (right == null ? void 0 : right.includes(d)));
      return isLeft ? 'left' : isRight ? 'right' : false;
    };
    column.getPinnedIndex = () => {
      var _table$getState$colum, _table$getState$colum2;
      const position = column.getIsPinned();
      return position
        ? (_table$getState$colum =
            (_table$getState$colum2 = table.getState().columnPinning) == null ||
            (_table$getState$colum2 = _table$getState$colum2[position]) == null
              ? void 0
              : _table$getState$colum2.indexOf(column.id)) != null
          ? _table$getState$colum
          : -1
        : 0;
    };
  },
  createRow: (row, table) => {
    row.getCenterVisibleCells = memo(
      () => [
        row._getAllVisibleCells(),
        table.getState().columnPinning.left,
        table.getState().columnPinning.right,
      ],
      (allCells, left, right) => {
        const leftAndRight = [...(left != null ? left : []), ...(right != null ? right : [])];
        return allCells.filter(d => !leftAndRight.includes(d.column.id));
      },
      getMemoOptions(table.options, 'debugRows', 'getCenterVisibleCells'),
    );
    row.getLeftVisibleCells = memo(
      () => [row._getAllVisibleCells(), table.getState().columnPinning.left],
      (allCells, left) => {
        const cells = (left != null ? left : [])
          .map(columnId => allCells.find(cell => cell.column.id === columnId))
          .filter(Boolean)
          .map(d => ({ ...d, position: 'left' }));
        return cells;
      },
      getMemoOptions(table.options, 'debugRows', 'getLeftVisibleCells'),
    );
    row.getRightVisibleCells = memo(
      () => [row._getAllVisibleCells(), table.getState().columnPinning.right],
      (allCells, right) => {
        const cells = (right != null ? right : [])
          .map(columnId => allCells.find(cell => cell.column.id === columnId))
          .filter(Boolean)
          .map(d => ({ ...d, position: 'right' }));
        return cells;
      },
      getMemoOptions(table.options, 'debugRows', 'getRightVisibleCells'),
    );
  },
  createTable: table => {
    table.setColumnPinning = updater =>
      table.options.onColumnPinningChange == null
        ? void 0
        : table.options.onColumnPinningChange(updater);
    table.resetColumnPinning = defaultState => {
      var _table$initialState$c, _table$initialState;
      return table.setColumnPinning(
        defaultState
          ? getDefaultColumnPinningState()
          : (_table$initialState$c =
                (_table$initialState = table.initialState) == null
                  ? void 0
                  : _table$initialState.columnPinning) != null
            ? _table$initialState$c
            : getDefaultColumnPinningState(),
      );
    };
    table.getIsSomeColumnsPinned = position => {
      var _pinningState$positio;
      const pinningState = table.getState().columnPinning;
      if (!position) {
        var _pinningState$left, _pinningState$right;
        return Boolean(
          ((_pinningState$left = pinningState.left) == null ? void 0 : _pinningState$left.length) ||
          ((_pinningState$right = pinningState.right) == null
            ? void 0
            : _pinningState$right.length),
        );
      }
      return Boolean(
        (_pinningState$positio = pinningState[position]) == null
          ? void 0
          : _pinningState$positio.length,
      );
    };
    table.getLeftLeafColumns = memo(
      () => [table.getAllLeafColumns(), table.getState().columnPinning.left],
      (allColumns, left) => {
        return (left != null ? left : [])
          .map(columnId => allColumns.find(column => column.id === columnId))
          .filter(Boolean);
      },
      getMemoOptions(table.options, 'debugColumns', 'getLeftLeafColumns'),
    );
    table.getRightLeafColumns = memo(
      () => [table.getAllLeafColumns(), table.getState().columnPinning.right],
      (allColumns, right) => {
        return (right != null ? right : [])
          .map(columnId => allColumns.find(column => column.id === columnId))
          .filter(Boolean);
      },
      getMemoOptions(table.options, 'debugColumns', 'getRightLeafColumns'),
    );
    table.getCenterLeafColumns = memo(
      () => [
        table.getAllLeafColumns(),
        table.getState().columnPinning.left,
        table.getState().columnPinning.right,
      ],
      (allColumns, left, right) => {
        const leftAndRight = [...(left != null ? left : []), ...(right != null ? right : [])];
        return allColumns.filter(d => !leftAndRight.includes(d.id));
      },
      getMemoOptions(table.options, 'debugColumns', 'getCenterLeafColumns'),
    );
  },
};
function safelyAccessDocument(_document) {
  return _document || (typeof document !== 'undefined' ? document : null);
}
const defaultColumnSizing = { size: 150, minSize: 20, maxSize: Number.MAX_SAFE_INTEGER };
const getDefaultColumnSizingInfoState = () => ({
  startOffset: null,
  startSize: null,
  deltaOffset: null,
  deltaPercentage: null,
  isResizingColumn: false,
  columnSizingStart: [],
});
const ColumnSizing = {
  getDefaultColumnDef: () => {
    return defaultColumnSizing;
  },
  getInitialState: state => {
    return { columnSizing: {}, columnSizingInfo: getDefaultColumnSizingInfoState(), ...state };
  },
  getDefaultOptions: table => {
    return {
      columnResizeMode: 'onEnd',
      columnResizeDirection: 'ltr',
      onColumnSizingChange: makeStateUpdater('columnSizing', table),
      onColumnSizingInfoChange: makeStateUpdater('columnSizingInfo', table),
    };
  },
  createColumn: (column, table) => {
    column.getSize = () => {
      var _column$columnDef$min, _ref, _column$columnDef$max;
      const columnSize = table.getState().columnSizing[column.id];
      return Math.min(
        Math.max(
          (_column$columnDef$min = column.columnDef.minSize) != null
            ? _column$columnDef$min
            : defaultColumnSizing.minSize,
          (_ref = columnSize != null ? columnSize : column.columnDef.size) != null
            ? _ref
            : defaultColumnSizing.size,
        ),
        (_column$columnDef$max = column.columnDef.maxSize) != null
          ? _column$columnDef$max
          : defaultColumnSizing.maxSize,
      );
    };
    column.getStart = memo(
      position => [
        position,
        _getVisibleLeafColumns(table, position),
        table.getState().columnSizing,
      ],
      (position, columns) =>
        columns
          .slice(0, column.getIndex(position))
          .reduce((sum2, column2) => sum2 + column2.getSize(), 0),
      getMemoOptions(table.options, 'debugColumns', 'getStart'),
    );
    column.getAfter = memo(
      position => [
        position,
        _getVisibleLeafColumns(table, position),
        table.getState().columnSizing,
      ],
      (position, columns) =>
        columns
          .slice(column.getIndex(position) + 1)
          .reduce((sum2, column2) => sum2 + column2.getSize(), 0),
      getMemoOptions(table.options, 'debugColumns', 'getAfter'),
    );
    column.resetSize = () => {
      table.setColumnSizing(_ref2 => {
        let { [column.id]: _, ...rest } = _ref2;
        return rest;
      });
    };
    column.getCanResize = () => {
      var _column$columnDef$ena, _table$options$enable;
      return (
        ((_column$columnDef$ena = column.columnDef.enableResizing) != null
          ? _column$columnDef$ena
          : true) &&
        ((_table$options$enable = table.options.enableColumnResizing) != null
          ? _table$options$enable
          : true)
      );
    };
    column.getIsResizing = () => {
      return table.getState().columnSizingInfo.isResizingColumn === column.id;
    };
  },
  createHeader: (header, table) => {
    header.getSize = () => {
      let sum2 = 0;
      const recurse = header2 => {
        if (header2.subHeaders.length) {
          header2.subHeaders.forEach(recurse);
        } else {
          var _header$column$getSiz;
          sum2 +=
            (_header$column$getSiz = header2.column.getSize()) != null ? _header$column$getSiz : 0;
        }
      };
      recurse(header);
      return sum2;
    };
    header.getStart = () => {
      if (header.index > 0) {
        const prevSiblingHeader = header.headerGroup.headers[header.index - 1];
        return prevSiblingHeader.getStart() + prevSiblingHeader.getSize();
      }
      return 0;
    };
    header.getResizeHandler = _contextDocument => {
      const column = table.getColumn(header.column.id);
      const canResize = column == null ? void 0 : column.getCanResize();
      return e => {
        if (!column || !canResize) {
          return;
        }
        e.persist == null || e.persist();
        if (isTouchStartEvent(e)) {
          if (e.touches && e.touches.length > 1) {
            return;
          }
        }
        const startSize = header.getSize();
        const columnSizingStart = header
          ? header.getLeafHeaders().map(d => [d.column.id, d.column.getSize()])
          : [[column.id, column.getSize()]];
        const clientX = isTouchStartEvent(e) ? Math.round(e.touches[0].clientX) : e.clientX;
        const newColumnSizing = {};
        const updateOffset = (eventType, clientXPos) => {
          if (typeof clientXPos !== 'number') {
            return;
          }
          table.setColumnSizingInfo(old => {
            var _old$startOffset, _old$startSize;
            const deltaDirection = table.options.columnResizeDirection === 'rtl' ? -1 : 1;
            const deltaOffset =
              (clientXPos -
                ((_old$startOffset = old == null ? void 0 : old.startOffset) != null
                  ? _old$startOffset
                  : 0)) *
              deltaDirection;
            const deltaPercentage = Math.max(
              deltaOffset /
                ((_old$startSize = old == null ? void 0 : old.startSize) != null
                  ? _old$startSize
                  : 0),
              -0.999999,
            );
            old.columnSizingStart.forEach(_ref3 => {
              let [columnId, headerSize] = _ref3;
              newColumnSizing[columnId] =
                Math.round(Math.max(headerSize + headerSize * deltaPercentage, 0) * 100) / 100;
            });
            return { ...old, deltaOffset, deltaPercentage };
          });
          if (table.options.columnResizeMode === 'onChange' || eventType === 'end') {
            table.setColumnSizing(old => ({ ...old, ...newColumnSizing }));
          }
        };
        const onMove = clientXPos => updateOffset('move', clientXPos);
        const onEnd = clientXPos => {
          updateOffset('end', clientXPos);
          table.setColumnSizingInfo(old => ({
            ...old,
            isResizingColumn: false,
            startOffset: null,
            startSize: null,
            deltaOffset: null,
            deltaPercentage: null,
            columnSizingStart: [],
          }));
        };
        const contextDocument = safelyAccessDocument(_contextDocument);
        const mouseEvents = {
          moveHandler: e2 => onMove(e2.clientX),
          upHandler: e2 => {
            contextDocument == null ||
              contextDocument.removeEventListener('mousemove', mouseEvents.moveHandler);
            contextDocument == null ||
              contextDocument.removeEventListener('mouseup', mouseEvents.upHandler);
            onEnd(e2.clientX);
          },
        };
        const touchEvents = {
          moveHandler: e2 => {
            if (e2.cancelable) {
              e2.preventDefault();
              e2.stopPropagation();
            }
            onMove(e2.touches[0].clientX);
            return false;
          },
          upHandler: e2 => {
            var _e$touches$;
            contextDocument == null ||
              contextDocument.removeEventListener('touchmove', touchEvents.moveHandler);
            contextDocument == null ||
              contextDocument.removeEventListener('touchend', touchEvents.upHandler);
            if (e2.cancelable) {
              e2.preventDefault();
              e2.stopPropagation();
            }
            onEnd((_e$touches$ = e2.touches[0]) == null ? void 0 : _e$touches$.clientX);
          },
        };
        const passiveIfSupported = passiveEventSupported() ? { passive: false } : false;
        if (isTouchStartEvent(e)) {
          contextDocument == null ||
            contextDocument.addEventListener(
              'touchmove',
              touchEvents.moveHandler,
              passiveIfSupported,
            );
          contextDocument == null ||
            contextDocument.addEventListener('touchend', touchEvents.upHandler, passiveIfSupported);
        } else {
          contextDocument == null ||
            contextDocument.addEventListener(
              'mousemove',
              mouseEvents.moveHandler,
              passiveIfSupported,
            );
          contextDocument == null ||
            contextDocument.addEventListener('mouseup', mouseEvents.upHandler, passiveIfSupported);
        }
        table.setColumnSizingInfo(old => ({
          ...old,
          startOffset: clientX,
          startSize,
          deltaOffset: 0,
          deltaPercentage: 0,
          columnSizingStart,
          isResizingColumn: column.id,
        }));
      };
    };
  },
  createTable: table => {
    table.setColumnSizing = updater =>
      table.options.onColumnSizingChange == null
        ? void 0
        : table.options.onColumnSizingChange(updater);
    table.setColumnSizingInfo = updater =>
      table.options.onColumnSizingInfoChange == null
        ? void 0
        : table.options.onColumnSizingInfoChange(updater);
    table.resetColumnSizing = defaultState => {
      var _table$initialState$c;
      table.setColumnSizing(
        defaultState
          ? {}
          : (_table$initialState$c = table.initialState.columnSizing) != null
            ? _table$initialState$c
            : {},
      );
    };
    table.resetHeaderSizeInfo = defaultState => {
      var _table$initialState$c2;
      table.setColumnSizingInfo(
        defaultState
          ? getDefaultColumnSizingInfoState()
          : (_table$initialState$c2 = table.initialState.columnSizingInfo) != null
            ? _table$initialState$c2
            : getDefaultColumnSizingInfoState(),
      );
    };
    table.getTotalSize = () => {
      var _table$getHeaderGroup, _table$getHeaderGroup2;
      return (_table$getHeaderGroup =
        (_table$getHeaderGroup2 = table.getHeaderGroups()[0]) == null
          ? void 0
          : _table$getHeaderGroup2.headers.reduce((sum2, header) => {
              return sum2 + header.getSize();
            }, 0)) != null
        ? _table$getHeaderGroup
        : 0;
    };
    table.getLeftTotalSize = () => {
      var _table$getLeftHeaderG, _table$getLeftHeaderG2;
      return (_table$getLeftHeaderG =
        (_table$getLeftHeaderG2 = table.getLeftHeaderGroups()[0]) == null
          ? void 0
          : _table$getLeftHeaderG2.headers.reduce((sum2, header) => {
              return sum2 + header.getSize();
            }, 0)) != null
        ? _table$getLeftHeaderG
        : 0;
    };
    table.getCenterTotalSize = () => {
      var _table$getCenterHeade, _table$getCenterHeade2;
      return (_table$getCenterHeade =
        (_table$getCenterHeade2 = table.getCenterHeaderGroups()[0]) == null
          ? void 0
          : _table$getCenterHeade2.headers.reduce((sum2, header) => {
              return sum2 + header.getSize();
            }, 0)) != null
        ? _table$getCenterHeade
        : 0;
    };
    table.getRightTotalSize = () => {
      var _table$getRightHeader, _table$getRightHeader2;
      return (_table$getRightHeader =
        (_table$getRightHeader2 = table.getRightHeaderGroups()[0]) == null
          ? void 0
          : _table$getRightHeader2.headers.reduce((sum2, header) => {
              return sum2 + header.getSize();
            }, 0)) != null
        ? _table$getRightHeader
        : 0;
    };
  },
};
let passiveSupported = null;
function passiveEventSupported() {
  if (typeof passiveSupported === 'boolean') return passiveSupported;
  let supported = false;
  try {
    const options = {
      get passive() {
        supported = true;
        return false;
      },
    };
    const noop3 = () => {};
    window.addEventListener('test', noop3, options);
    window.removeEventListener('test', noop3);
  } catch (err) {
    supported = false;
  }
  passiveSupported = supported;
  return passiveSupported;
}
function isTouchStartEvent(e) {
  return e.type === 'touchstart';
}
const ColumnVisibility = {
  getInitialState: state => {
    return { columnVisibility: {}, ...state };
  },
  getDefaultOptions: table => {
    return { onColumnVisibilityChange: makeStateUpdater('columnVisibility', table) };
  },
  createColumn: (column, table) => {
    column.toggleVisibility = value => {
      if (column.getCanHide()) {
        table.setColumnVisibility(old => ({
          ...old,
          [column.id]: value != null ? value : !column.getIsVisible(),
        }));
      }
    };
    column.getIsVisible = () => {
      var _ref, _table$getState$colum;
      const childColumns = column.columns;
      return (_ref = childColumns.length
        ? childColumns.some(c => c.getIsVisible())
        : (_table$getState$colum = table.getState().columnVisibility) == null
          ? void 0
          : _table$getState$colum[column.id]) != null
        ? _ref
        : true;
    };
    column.getCanHide = () => {
      var _column$columnDef$ena, _table$options$enable;
      return (
        ((_column$columnDef$ena = column.columnDef.enableHiding) != null
          ? _column$columnDef$ena
          : true) &&
        ((_table$options$enable = table.options.enableHiding) != null
          ? _table$options$enable
          : true)
      );
    };
    column.getToggleVisibilityHandler = () => {
      return e => {
        column.toggleVisibility == null || column.toggleVisibility(e.target.checked);
      };
    };
  },
  createRow: (row, table) => {
    row._getAllVisibleCells = memo(
      () => [row.getAllCells(), table.getState().columnVisibility],
      cells => {
        return cells.filter(cell => cell.column.getIsVisible());
      },
      getMemoOptions(table.options, 'debugRows', '_getAllVisibleCells'),
    );
    row.getVisibleCells = memo(
      () => [row.getLeftVisibleCells(), row.getCenterVisibleCells(), row.getRightVisibleCells()],
      (left, center, right) => [...left, ...center, ...right],
      getMemoOptions(table.options, 'debugRows', 'getVisibleCells'),
    );
  },
  createTable: table => {
    const makeVisibleColumnsMethod = (key, getColumns) => {
      return memo(
        () => [
          getColumns(),
          getColumns()
            .filter(d => d.getIsVisible())
            .map(d => d.id)
            .join('_'),
        ],
        columns => {
          return columns.filter(d => (d.getIsVisible == null ? void 0 : d.getIsVisible()));
        },
        getMemoOptions(table.options, 'debugColumns', key),
      );
    };
    table.getVisibleFlatColumns = makeVisibleColumnsMethod('getVisibleFlatColumns', () =>
      table.getAllFlatColumns(),
    );
    table.getVisibleLeafColumns = makeVisibleColumnsMethod('getVisibleLeafColumns', () =>
      table.getAllLeafColumns(),
    );
    table.getLeftVisibleLeafColumns = makeVisibleColumnsMethod('getLeftVisibleLeafColumns', () =>
      table.getLeftLeafColumns(),
    );
    table.getRightVisibleLeafColumns = makeVisibleColumnsMethod('getRightVisibleLeafColumns', () =>
      table.getRightLeafColumns(),
    );
    table.getCenterVisibleLeafColumns = makeVisibleColumnsMethod(
      'getCenterVisibleLeafColumns',
      () => table.getCenterLeafColumns(),
    );
    table.setColumnVisibility = updater =>
      table.options.onColumnVisibilityChange == null
        ? void 0
        : table.options.onColumnVisibilityChange(updater);
    table.resetColumnVisibility = defaultState => {
      var _table$initialState$c;
      table.setColumnVisibility(
        defaultState
          ? {}
          : (_table$initialState$c = table.initialState.columnVisibility) != null
            ? _table$initialState$c
            : {},
      );
    };
    table.toggleAllColumnsVisible = value => {
      var _value;
      value = (_value = value) != null ? _value : !table.getIsAllColumnsVisible();
      table.setColumnVisibility(
        table
          .getAllLeafColumns()
          .reduce(
            (obj, column) => ({
              ...obj,
              [column.id]: !value ? !(column.getCanHide != null && column.getCanHide()) : value,
            }),
            {},
          ),
      );
    };
    table.getIsAllColumnsVisible = () =>
      !table
        .getAllLeafColumns()
        .some(column => !(column.getIsVisible != null && column.getIsVisible()));
    table.getIsSomeColumnsVisible = () =>
      table
        .getAllLeafColumns()
        .some(column => (column.getIsVisible == null ? void 0 : column.getIsVisible()));
    table.getToggleAllColumnsVisibilityHandler = () => {
      return e => {
        var _target;
        table.toggleAllColumnsVisible((_target = e.target) == null ? void 0 : _target.checked);
      };
    };
  },
};
function _getVisibleLeafColumns(table, position) {
  return !position
    ? table.getVisibleLeafColumns()
    : position === 'center'
      ? table.getCenterVisibleLeafColumns()
      : position === 'left'
        ? table.getLeftVisibleLeafColumns()
        : table.getRightVisibleLeafColumns();
}
const GlobalFaceting = {
  createTable: table => {
    table._getGlobalFacetedRowModel =
      table.options.getFacetedRowModel && table.options.getFacetedRowModel(table, '__global__');
    table.getGlobalFacetedRowModel = () => {
      if (table.options.manualFiltering || !table._getGlobalFacetedRowModel) {
        return table.getPreFilteredRowModel();
      }
      return table._getGlobalFacetedRowModel();
    };
    table._getGlobalFacetedUniqueValues =
      table.options.getFacetedUniqueValues &&
      table.options.getFacetedUniqueValues(table, '__global__');
    table.getGlobalFacetedUniqueValues = () => {
      if (!table._getGlobalFacetedUniqueValues) {
        return /* @__PURE__ */ new Map();
      }
      return table._getGlobalFacetedUniqueValues();
    };
    table._getGlobalFacetedMinMaxValues =
      table.options.getFacetedMinMaxValues &&
      table.options.getFacetedMinMaxValues(table, '__global__');
    table.getGlobalFacetedMinMaxValues = () => {
      if (!table._getGlobalFacetedMinMaxValues) {
        return;
      }
      return table._getGlobalFacetedMinMaxValues();
    };
  },
};
const GlobalFiltering = {
  getInitialState: state => {
    return { globalFilter: void 0, ...state };
  },
  getDefaultOptions: table => {
    return {
      onGlobalFilterChange: makeStateUpdater('globalFilter', table),
      globalFilterFn: 'auto',
      getColumnCanGlobalFilter: column => {
        var _table$getCoreRowMode;
        const value =
          (_table$getCoreRowMode = table.getCoreRowModel().flatRows[0]) == null ||
          (_table$getCoreRowMode = _table$getCoreRowMode._getAllCellsByColumnId()[column.id]) ==
            null
            ? void 0
            : _table$getCoreRowMode.getValue();
        return typeof value === 'string' || typeof value === 'number';
      },
    };
  },
  createColumn: (column, table) => {
    column.getCanGlobalFilter = () => {
      var _column$columnDef$ena,
        _table$options$enable,
        _table$options$enable2,
        _table$options$getCol;
      return (
        ((_column$columnDef$ena = column.columnDef.enableGlobalFilter) != null
          ? _column$columnDef$ena
          : true) &&
        ((_table$options$enable = table.options.enableGlobalFilter) != null
          ? _table$options$enable
          : true) &&
        ((_table$options$enable2 = table.options.enableFilters) != null
          ? _table$options$enable2
          : true) &&
        ((_table$options$getCol =
          table.options.getColumnCanGlobalFilter == null
            ? void 0
            : table.options.getColumnCanGlobalFilter(column)) != null
          ? _table$options$getCol
          : true) &&
        !!column.accessorFn
      );
    };
  },
  createTable: table => {
    table.getGlobalAutoFilterFn = () => {
      return filterFns.includesString;
    };
    table.getGlobalFilterFn = () => {
      var _table$options$filter, _table$options$filter2;
      const { globalFilterFn } = table.options;
      return isFunction(globalFilterFn)
        ? globalFilterFn
        : globalFilterFn === 'auto'
          ? table.getGlobalAutoFilterFn()
          : (_table$options$filter =
                (_table$options$filter2 = table.options.filterFns) == null
                  ? void 0
                  : _table$options$filter2[globalFilterFn]) != null
            ? _table$options$filter
            : filterFns[globalFilterFn];
    };
    table.setGlobalFilter = updater => {
      table.options.onGlobalFilterChange == null || table.options.onGlobalFilterChange(updater);
    };
    table.resetGlobalFilter = defaultState => {
      table.setGlobalFilter(defaultState ? void 0 : table.initialState.globalFilter);
    };
  },
};
const RowExpanding = {
  getInitialState: state => {
    return { expanded: {}, ...state };
  },
  getDefaultOptions: table => {
    return { onExpandedChange: makeStateUpdater('expanded', table), paginateExpandedRows: true };
  },
  createTable: table => {
    let registered = false;
    let queued = false;
    table._autoResetExpanded = () => {
      var _ref, _table$options$autoRe;
      if (!registered) {
        table._queue(() => {
          registered = true;
        });
        return;
      }
      if (
        (_ref =
          (_table$options$autoRe = table.options.autoResetAll) != null
            ? _table$options$autoRe
            : table.options.autoResetExpanded) != null
          ? _ref
          : !table.options.manualExpanding
      ) {
        if (queued) return;
        queued = true;
        table._queue(() => {
          table.resetExpanded();
          queued = false;
        });
      }
    };
    table.setExpanded = updater =>
      table.options.onExpandedChange == null ? void 0 : table.options.onExpandedChange(updater);
    table.toggleAllRowsExpanded = expanded => {
      if (expanded != null ? expanded : !table.getIsAllRowsExpanded()) {
        table.setExpanded(true);
      } else {
        table.setExpanded({});
      }
    };
    table.resetExpanded = defaultState => {
      var _table$initialState$e, _table$initialState;
      table.setExpanded(
        defaultState
          ? {}
          : (_table$initialState$e =
                (_table$initialState = table.initialState) == null
                  ? void 0
                  : _table$initialState.expanded) != null
            ? _table$initialState$e
            : {},
      );
    };
    table.getCanSomeRowsExpand = () => {
      return table.getPrePaginationRowModel().flatRows.some(row => row.getCanExpand());
    };
    table.getToggleAllRowsExpandedHandler = () => {
      return e => {
        e.persist == null || e.persist();
        table.toggleAllRowsExpanded();
      };
    };
    table.getIsSomeRowsExpanded = () => {
      const expanded = table.getState().expanded;
      return expanded === true || Object.values(expanded).some(Boolean);
    };
    table.getIsAllRowsExpanded = () => {
      const expanded = table.getState().expanded;
      if (typeof expanded === 'boolean') {
        return expanded === true;
      }
      if (!Object.keys(expanded).length) {
        return false;
      }
      if (table.getRowModel().flatRows.some(row => !row.getIsExpanded())) {
        return false;
      }
      return true;
    };
    table.getExpandedDepth = () => {
      let maxDepth = 0;
      const rowIds =
        table.getState().expanded === true
          ? Object.keys(table.getRowModel().rowsById)
          : Object.keys(table.getState().expanded);
      rowIds.forEach(id2 => {
        const splitId = id2.split('.');
        maxDepth = Math.max(maxDepth, splitId.length);
      });
      return maxDepth;
    };
    table.getPreExpandedRowModel = () => table.getSortedRowModel();
    table.getExpandedRowModel = () => {
      if (!table._getExpandedRowModel && table.options.getExpandedRowModel) {
        table._getExpandedRowModel = table.options.getExpandedRowModel(table);
      }
      if (table.options.manualExpanding || !table._getExpandedRowModel) {
        return table.getPreExpandedRowModel();
      }
      return table._getExpandedRowModel();
    };
  },
  createRow: (row, table) => {
    row.toggleExpanded = expanded => {
      table.setExpanded(old => {
        var _expanded;
        const exists = old === true ? true : !!(old != null && old[row.id]);
        let oldExpanded = {};
        if (old === true) {
          Object.keys(table.getRowModel().rowsById).forEach(rowId => {
            oldExpanded[rowId] = true;
          });
        } else {
          oldExpanded = old;
        }
        expanded = (_expanded = expanded) != null ? _expanded : !exists;
        if (!exists && expanded) {
          return { ...oldExpanded, [row.id]: true };
        }
        if (exists && !expanded) {
          const { [row.id]: _, ...rest } = oldExpanded;
          return rest;
        }
        return old;
      });
    };
    row.getIsExpanded = () => {
      var _table$options$getIsR;
      const expanded = table.getState().expanded;
      return !!((_table$options$getIsR =
        table.options.getIsRowExpanded == null ? void 0 : table.options.getIsRowExpanded(row)) !=
      null
        ? _table$options$getIsR
        : expanded === true || (expanded == null ? void 0 : expanded[row.id]));
    };
    row.getCanExpand = () => {
      var _table$options$getRow, _table$options$enable, _row$subRows;
      return (_table$options$getRow =
        table.options.getRowCanExpand == null ? void 0 : table.options.getRowCanExpand(row)) != null
        ? _table$options$getRow
        : ((_table$options$enable = table.options.enableExpanding) != null
            ? _table$options$enable
            : true) && !!((_row$subRows = row.subRows) != null && _row$subRows.length);
    };
    row.getIsAllParentsExpanded = () => {
      let isFullyExpanded = true;
      let currentRow = row;
      while (isFullyExpanded && currentRow.parentId) {
        currentRow = table.getRow(currentRow.parentId, true);
        isFullyExpanded = currentRow.getIsExpanded();
      }
      return isFullyExpanded;
    };
    row.getToggleExpandedHandler = () => {
      const canExpand = row.getCanExpand();
      return () => {
        if (!canExpand) return;
        row.toggleExpanded();
      };
    };
  },
};
const defaultPageIndex = 0;
const defaultPageSize = 10;
const getDefaultPaginationState = () => ({
  pageIndex: defaultPageIndex,
  pageSize: defaultPageSize,
});
const RowPagination = {
  getInitialState: state => {
    return {
      ...state,
      pagination: {
        ...getDefaultPaginationState(),
        ...(state == null ? void 0 : state.pagination),
      },
    };
  },
  getDefaultOptions: table => {
    return { onPaginationChange: makeStateUpdater('pagination', table) };
  },
  createTable: table => {
    let registered = false;
    let queued = false;
    table._autoResetPageIndex = () => {
      var _ref, _table$options$autoRe;
      if (!registered) {
        table._queue(() => {
          registered = true;
        });
        return;
      }
      if (
        (_ref =
          (_table$options$autoRe = table.options.autoResetAll) != null
            ? _table$options$autoRe
            : table.options.autoResetPageIndex) != null
          ? _ref
          : !table.options.manualPagination
      ) {
        if (queued) return;
        queued = true;
        table._queue(() => {
          table.resetPageIndex();
          queued = false;
        });
      }
    };
    table.setPagination = updater => {
      const safeUpdater = old => {
        let newState = functionalUpdate(updater, old);
        return newState;
      };
      return table.options.onPaginationChange == null
        ? void 0
        : table.options.onPaginationChange(safeUpdater);
    };
    table.resetPagination = defaultState => {
      var _table$initialState$p;
      table.setPagination(
        defaultState
          ? getDefaultPaginationState()
          : (_table$initialState$p = table.initialState.pagination) != null
            ? _table$initialState$p
            : getDefaultPaginationState(),
      );
    };
    table.setPageIndex = updater => {
      table.setPagination(old => {
        let pageIndex = functionalUpdate(updater, old.pageIndex);
        const maxPageIndex =
          typeof table.options.pageCount === 'undefined' || table.options.pageCount === -1
            ? Number.MAX_SAFE_INTEGER
            : table.options.pageCount - 1;
        pageIndex = Math.max(0, Math.min(pageIndex, maxPageIndex));
        return { ...old, pageIndex };
      });
    };
    table.resetPageIndex = defaultState => {
      var _table$initialState$p2, _table$initialState;
      table.setPageIndex(
        defaultState
          ? defaultPageIndex
          : (_table$initialState$p2 =
                (_table$initialState = table.initialState) == null ||
                (_table$initialState = _table$initialState.pagination) == null
                  ? void 0
                  : _table$initialState.pageIndex) != null
            ? _table$initialState$p2
            : defaultPageIndex,
      );
    };
    table.resetPageSize = defaultState => {
      var _table$initialState$p3, _table$initialState2;
      table.setPageSize(
        defaultState
          ? defaultPageSize
          : (_table$initialState$p3 =
                (_table$initialState2 = table.initialState) == null ||
                (_table$initialState2 = _table$initialState2.pagination) == null
                  ? void 0
                  : _table$initialState2.pageSize) != null
            ? _table$initialState$p3
            : defaultPageSize,
      );
    };
    table.setPageSize = updater => {
      table.setPagination(old => {
        const pageSize = Math.max(1, functionalUpdate(updater, old.pageSize));
        const topRowIndex = old.pageSize * old.pageIndex;
        const pageIndex = Math.floor(topRowIndex / pageSize);
        return { ...old, pageIndex, pageSize };
      });
    };
    table.setPageCount = updater =>
      table.setPagination(old => {
        var _table$options$pageCo;
        let newPageCount = functionalUpdate(
          updater,
          (_table$options$pageCo = table.options.pageCount) != null ? _table$options$pageCo : -1,
        );
        if (typeof newPageCount === 'number') {
          newPageCount = Math.max(-1, newPageCount);
        }
        return { ...old, pageCount: newPageCount };
      });
    table.getPageOptions = memo(
      () => [table.getPageCount()],
      pageCount => {
        let pageOptions = [];
        if (pageCount && pageCount > 0) {
          pageOptions = [...new Array(pageCount)].fill(null).map((_, i) => i);
        }
        return pageOptions;
      },
      getMemoOptions(table.options, 'debugTable', 'getPageOptions'),
    );
    table.getCanPreviousPage = () => table.getState().pagination.pageIndex > 0;
    table.getCanNextPage = () => {
      const { pageIndex } = table.getState().pagination;
      const pageCount = table.getPageCount();
      if (pageCount === -1) {
        return true;
      }
      if (pageCount === 0) {
        return false;
      }
      return pageIndex < pageCount - 1;
    };
    table.previousPage = () => {
      return table.setPageIndex(old => old - 1);
    };
    table.nextPage = () => {
      return table.setPageIndex(old => {
        return old + 1;
      });
    };
    table.firstPage = () => {
      return table.setPageIndex(0);
    };
    table.lastPage = () => {
      return table.setPageIndex(table.getPageCount() - 1);
    };
    table.getPrePaginationRowModel = () => table.getExpandedRowModel();
    table.getPaginationRowModel = () => {
      if (!table._getPaginationRowModel && table.options.getPaginationRowModel) {
        table._getPaginationRowModel = table.options.getPaginationRowModel(table);
      }
      if (table.options.manualPagination || !table._getPaginationRowModel) {
        return table.getPrePaginationRowModel();
      }
      return table._getPaginationRowModel();
    };
    table.getPageCount = () => {
      var _table$options$pageCo2;
      return (_table$options$pageCo2 = table.options.pageCount) != null
        ? _table$options$pageCo2
        : Math.ceil(table.getRowCount() / table.getState().pagination.pageSize);
    };
    table.getRowCount = () => {
      var _table$options$rowCou;
      return (_table$options$rowCou = table.options.rowCount) != null
        ? _table$options$rowCou
        : table.getPrePaginationRowModel().rows.length;
    };
  },
};
const getDefaultRowPinningState = () => ({ top: [], bottom: [] });
const RowPinning = {
  getInitialState: state => {
    return { rowPinning: getDefaultRowPinningState(), ...state };
  },
  getDefaultOptions: table => {
    return { onRowPinningChange: makeStateUpdater('rowPinning', table) };
  },
  createRow: (row, table) => {
    row.pin = (position, includeLeafRows, includeParentRows) => {
      const leafRowIds = includeLeafRows
        ? row.getLeafRows().map(_ref => {
            let { id: id2 } = _ref;
            return id2;
          })
        : [];
      const parentRowIds = includeParentRows
        ? row.getParentRows().map(_ref2 => {
            let { id: id2 } = _ref2;
            return id2;
          })
        : [];
      const rowIds = /* @__PURE__ */ new Set([...parentRowIds, row.id, ...leafRowIds]);
      table.setRowPinning(old => {
        var _old$top3, _old$bottom3;
        if (position === 'bottom') {
          var _old$top, _old$bottom;
          return {
            top: ((_old$top = old == null ? void 0 : old.top) != null ? _old$top : []).filter(
              d => !(rowIds != null && rowIds.has(d)),
            ),
            bottom: [
              ...((_old$bottom = old == null ? void 0 : old.bottom) != null
                ? _old$bottom
                : []
              ).filter(d => !(rowIds != null && rowIds.has(d))),
              ...Array.from(rowIds),
            ],
          };
        }
        if (position === 'top') {
          var _old$top2, _old$bottom2;
          return {
            top: [
              ...((_old$top2 = old == null ? void 0 : old.top) != null ? _old$top2 : []).filter(
                d => !(rowIds != null && rowIds.has(d)),
              ),
              ...Array.from(rowIds),
            ],
            bottom: ((_old$bottom2 = old == null ? void 0 : old.bottom) != null
              ? _old$bottom2
              : []
            ).filter(d => !(rowIds != null && rowIds.has(d))),
          };
        }
        return {
          top: ((_old$top3 = old == null ? void 0 : old.top) != null ? _old$top3 : []).filter(
            d => !(rowIds != null && rowIds.has(d)),
          ),
          bottom: ((_old$bottom3 = old == null ? void 0 : old.bottom) != null
            ? _old$bottom3
            : []
          ).filter(d => !(rowIds != null && rowIds.has(d))),
        };
      });
    };
    row.getCanPin = () => {
      var _ref3;
      const { enableRowPinning, enablePinning } = table.options;
      if (typeof enableRowPinning === 'function') {
        return enableRowPinning(row);
      }
      return (_ref3 = enableRowPinning != null ? enableRowPinning : enablePinning) != null
        ? _ref3
        : true;
    };
    row.getIsPinned = () => {
      const rowIds = [row.id];
      const { top, bottom } = table.getState().rowPinning;
      const isTop = rowIds.some(d => (top == null ? void 0 : top.includes(d)));
      const isBottom = rowIds.some(d => (bottom == null ? void 0 : bottom.includes(d)));
      return isTop ? 'top' : isBottom ? 'bottom' : false;
    };
    row.getPinnedIndex = () => {
      var _ref4, _visiblePinnedRowIds$;
      const position = row.getIsPinned();
      if (!position) return -1;
      const visiblePinnedRowIds =
        (_ref4 = position === 'top' ? table.getTopRows() : table.getBottomRows()) == null
          ? void 0
          : _ref4.map(_ref5 => {
              let { id: id2 } = _ref5;
              return id2;
            });
      return (_visiblePinnedRowIds$ =
        visiblePinnedRowIds == null ? void 0 : visiblePinnedRowIds.indexOf(row.id)) != null
        ? _visiblePinnedRowIds$
        : -1;
    };
  },
  createTable: table => {
    table.setRowPinning = updater =>
      table.options.onRowPinningChange == null ? void 0 : table.options.onRowPinningChange(updater);
    table.resetRowPinning = defaultState => {
      var _table$initialState$r, _table$initialState;
      return table.setRowPinning(
        defaultState
          ? getDefaultRowPinningState()
          : (_table$initialState$r =
                (_table$initialState = table.initialState) == null
                  ? void 0
                  : _table$initialState.rowPinning) != null
            ? _table$initialState$r
            : getDefaultRowPinningState(),
      );
    };
    table.getIsSomeRowsPinned = position => {
      var _pinningState$positio;
      const pinningState = table.getState().rowPinning;
      if (!position) {
        var _pinningState$top, _pinningState$bottom;
        return Boolean(
          ((_pinningState$top = pinningState.top) == null ? void 0 : _pinningState$top.length) ||
          ((_pinningState$bottom = pinningState.bottom) == null
            ? void 0
            : _pinningState$bottom.length),
        );
      }
      return Boolean(
        (_pinningState$positio = pinningState[position]) == null
          ? void 0
          : _pinningState$positio.length,
      );
    };
    table._getPinnedRows = (visibleRows, pinnedRowIds, position) => {
      var _table$options$keepPi;
      const rows = (
        (_table$options$keepPi = table.options.keepPinnedRows) != null
          ? _table$options$keepPi
          : true
      )
        ? //get all rows that are pinned even if they would not be otherwise visible
          //account for expanded parent rows, but not pagination or filtering
          (pinnedRowIds != null ? pinnedRowIds : []).map(rowId => {
            const row = table.getRow(rowId, true);
            return row.getIsAllParentsExpanded() ? row : null;
          })
        : //else get only visible rows that are pinned
          (pinnedRowIds != null ? pinnedRowIds : []).map(rowId =>
            visibleRows.find(row => row.id === rowId),
          );
      return rows.filter(Boolean).map(d => ({ ...d, position }));
    };
    table.getTopRows = memo(
      () => [table.getRowModel().rows, table.getState().rowPinning.top],
      (allRows, topPinnedRowIds) => table._getPinnedRows(allRows, topPinnedRowIds, 'top'),
      getMemoOptions(table.options, 'debugRows', 'getTopRows'),
    );
    table.getBottomRows = memo(
      () => [table.getRowModel().rows, table.getState().rowPinning.bottom],
      (allRows, bottomPinnedRowIds) => table._getPinnedRows(allRows, bottomPinnedRowIds, 'bottom'),
      getMemoOptions(table.options, 'debugRows', 'getBottomRows'),
    );
    table.getCenterRows = memo(
      () => [
        table.getRowModel().rows,
        table.getState().rowPinning.top,
        table.getState().rowPinning.bottom,
      ],
      (allRows, top, bottom) => {
        const topAndBottom = /* @__PURE__ */ new Set([
          ...(top != null ? top : []),
          ...(bottom != null ? bottom : []),
        ]);
        return allRows.filter(d => !topAndBottom.has(d.id));
      },
      getMemoOptions(table.options, 'debugRows', 'getCenterRows'),
    );
  },
};
const RowSelection = {
  getInitialState: state => {
    return { rowSelection: {}, ...state };
  },
  getDefaultOptions: table => {
    return {
      onRowSelectionChange: makeStateUpdater('rowSelection', table),
      enableRowSelection: true,
      enableMultiRowSelection: true,
      enableSubRowSelection: true,
      // enableGroupingRowSelection: false,
      // isAdditiveSelectEvent: (e: unknown) => !!e.metaKey,
      // isInclusiveSelectEvent: (e: unknown) => !!e.shiftKey,
    };
  },
  createTable: table => {
    table.setRowSelection = updater =>
      table.options.onRowSelectionChange == null
        ? void 0
        : table.options.onRowSelectionChange(updater);
    table.resetRowSelection = defaultState => {
      var _table$initialState$r;
      return table.setRowSelection(
        defaultState
          ? {}
          : (_table$initialState$r = table.initialState.rowSelection) != null
            ? _table$initialState$r
            : {},
      );
    };
    table.toggleAllRowsSelected = value => {
      table.setRowSelection(old => {
        value = typeof value !== 'undefined' ? value : !table.getIsAllRowsSelected();
        const rowSelection = { ...old };
        const preGroupedFlatRows = table.getPreGroupedRowModel().flatRows;
        if (value) {
          preGroupedFlatRows.forEach(row => {
            if (!row.getCanSelect()) {
              return;
            }
            rowSelection[row.id] = true;
          });
        } else {
          preGroupedFlatRows.forEach(row => {
            delete rowSelection[row.id];
          });
        }
        return rowSelection;
      });
    };
    table.toggleAllPageRowsSelected = value =>
      table.setRowSelection(old => {
        const resolvedValue =
          typeof value !== 'undefined' ? value : !table.getIsAllPageRowsSelected();
        const rowSelection = { ...old };
        table.getRowModel().rows.forEach(row => {
          mutateRowIsSelected(rowSelection, row.id, resolvedValue, true, table);
        });
        return rowSelection;
      });
    table.getPreSelectedRowModel = () => table.getCoreRowModel();
    table.getSelectedRowModel = memo(
      () => [table.getState().rowSelection, table.getCoreRowModel()],
      (rowSelection, rowModel) => {
        if (!Object.keys(rowSelection).length) {
          return { rows: [], flatRows: [], rowsById: {} };
        }
        return selectRowsFn(table, rowModel);
      },
      getMemoOptions(table.options, 'debugTable', 'getSelectedRowModel'),
    );
    table.getFilteredSelectedRowModel = memo(
      () => [table.getState().rowSelection, table.getFilteredRowModel()],
      (rowSelection, rowModel) => {
        if (!Object.keys(rowSelection).length) {
          return { rows: [], flatRows: [], rowsById: {} };
        }
        return selectRowsFn(table, rowModel);
      },
      getMemoOptions(table.options, 'debugTable', 'getFilteredSelectedRowModel'),
    );
    table.getGroupedSelectedRowModel = memo(
      () => [table.getState().rowSelection, table.getSortedRowModel()],
      (rowSelection, rowModel) => {
        if (!Object.keys(rowSelection).length) {
          return { rows: [], flatRows: [], rowsById: {} };
        }
        return selectRowsFn(table, rowModel);
      },
      getMemoOptions(table.options, 'debugTable', 'getGroupedSelectedRowModel'),
    );
    table.getIsAllRowsSelected = () => {
      const preGroupedFlatRows = table.getFilteredRowModel().flatRows;
      const { rowSelection } = table.getState();
      let isAllRowsSelected = Boolean(
        preGroupedFlatRows.length && Object.keys(rowSelection).length,
      );
      if (isAllRowsSelected) {
        if (preGroupedFlatRows.some(row => row.getCanSelect() && !rowSelection[row.id])) {
          isAllRowsSelected = false;
        }
      }
      return isAllRowsSelected;
    };
    table.getIsAllPageRowsSelected = () => {
      const paginationFlatRows = table
        .getPaginationRowModel()
        .flatRows.filter(row => row.getCanSelect());
      const { rowSelection } = table.getState();
      let isAllPageRowsSelected = !!paginationFlatRows.length;
      if (isAllPageRowsSelected && paginationFlatRows.some(row => !rowSelection[row.id])) {
        isAllPageRowsSelected = false;
      }
      return isAllPageRowsSelected;
    };
    table.getIsSomeRowsSelected = () => {
      var _table$getState$rowSe;
      const totalSelected = Object.keys(
        (_table$getState$rowSe = table.getState().rowSelection) != null
          ? _table$getState$rowSe
          : {},
      ).length;
      return totalSelected > 0 && totalSelected < table.getFilteredRowModel().flatRows.length;
    };
    table.getIsSomePageRowsSelected = () => {
      const paginationFlatRows = table.getPaginationRowModel().flatRows;
      return table.getIsAllPageRowsSelected()
        ? false
        : paginationFlatRows
            .filter(row => row.getCanSelect())
            .some(d => d.getIsSelected() || d.getIsSomeSelected());
    };
    table.getToggleAllRowsSelectedHandler = () => {
      return e => {
        table.toggleAllRowsSelected(e.target.checked);
      };
    };
    table.getToggleAllPageRowsSelectedHandler = () => {
      return e => {
        table.toggleAllPageRowsSelected(e.target.checked);
      };
    };
  },
  createRow: (row, table) => {
    row.toggleSelected = (value, opts) => {
      const isSelected = row.getIsSelected();
      table.setRowSelection(old => {
        var _opts$selectChildren;
        value = typeof value !== 'undefined' ? value : !isSelected;
        if (row.getCanSelect() && isSelected === value) {
          return old;
        }
        const selectedRowIds = { ...old };
        mutateRowIsSelected(
          selectedRowIds,
          row.id,
          value,
          (_opts$selectChildren = opts == null ? void 0 : opts.selectChildren) != null
            ? _opts$selectChildren
            : true,
          table,
        );
        return selectedRowIds;
      });
    };
    row.getIsSelected = () => {
      const { rowSelection } = table.getState();
      return isRowSelected(row, rowSelection);
    };
    row.getIsSomeSelected = () => {
      const { rowSelection } = table.getState();
      return isSubRowSelected(row, rowSelection) === 'some';
    };
    row.getIsAllSubRowsSelected = () => {
      const { rowSelection } = table.getState();
      return isSubRowSelected(row, rowSelection) === 'all';
    };
    row.getCanSelect = () => {
      var _table$options$enable;
      if (typeof table.options.enableRowSelection === 'function') {
        return table.options.enableRowSelection(row);
      }
      return (_table$options$enable = table.options.enableRowSelection) != null
        ? _table$options$enable
        : true;
    };
    row.getCanSelectSubRows = () => {
      var _table$options$enable2;
      if (typeof table.options.enableSubRowSelection === 'function') {
        return table.options.enableSubRowSelection(row);
      }
      return (_table$options$enable2 = table.options.enableSubRowSelection) != null
        ? _table$options$enable2
        : true;
    };
    row.getCanMultiSelect = () => {
      var _table$options$enable3;
      if (typeof table.options.enableMultiRowSelection === 'function') {
        return table.options.enableMultiRowSelection(row);
      }
      return (_table$options$enable3 = table.options.enableMultiRowSelection) != null
        ? _table$options$enable3
        : true;
    };
    row.getToggleSelectedHandler = () => {
      const canSelect = row.getCanSelect();
      return e => {
        var _target;
        if (!canSelect) return;
        row.toggleSelected((_target = e.target) == null ? void 0 : _target.checked);
      };
    };
  },
};
const mutateRowIsSelected = (selectedRowIds, id2, value, includeChildren, table) => {
  var _row$subRows;
  const row = table.getRow(id2, true);
  if (value) {
    if (!row.getCanMultiSelect()) {
      Object.keys(selectedRowIds).forEach(key => delete selectedRowIds[key]);
    }
    if (row.getCanSelect()) {
      selectedRowIds[id2] = true;
    }
  } else {
    delete selectedRowIds[id2];
  }
  if (
    includeChildren &&
    (_row$subRows = row.subRows) != null &&
    _row$subRows.length &&
    row.getCanSelectSubRows()
  ) {
    row.subRows.forEach(row2 =>
      mutateRowIsSelected(selectedRowIds, row2.id, value, includeChildren, table),
    );
  }
};
function selectRowsFn(table, rowModel) {
  const rowSelection = table.getState().rowSelection;
  const newSelectedFlatRows = [];
  const newSelectedRowsById = {};
  const recurseRows = function (rows, depth) {
    return rows
      .map(row => {
        var _row$subRows2;
        const isSelected = isRowSelected(row, rowSelection);
        if (isSelected) {
          newSelectedFlatRows.push(row);
          newSelectedRowsById[row.id] = row;
        }
        if ((_row$subRows2 = row.subRows) != null && _row$subRows2.length) {
          row = { ...row, subRows: recurseRows(row.subRows) };
        }
        if (isSelected) {
          return row;
        }
      })
      .filter(Boolean);
  };
  return {
    rows: recurseRows(rowModel.rows),
    flatRows: newSelectedFlatRows,
    rowsById: newSelectedRowsById,
  };
}
function isRowSelected(row, selection) {
  var _selection$row$id;
  return (_selection$row$id = selection[row.id]) != null ? _selection$row$id : false;
}
function isSubRowSelected(row, selection, table) {
  var _row$subRows3;
  if (!((_row$subRows3 = row.subRows) != null && _row$subRows3.length)) return false;
  let allChildrenSelected = true;
  let someSelected = false;
  row.subRows.forEach(subRow => {
    if (someSelected && !allChildrenSelected) {
      return;
    }
    if (subRow.getCanSelect()) {
      if (isRowSelected(subRow, selection)) {
        someSelected = true;
      } else {
        allChildrenSelected = false;
      }
    }
    if (subRow.subRows && subRow.subRows.length) {
      const subRowChildrenSelected = isSubRowSelected(subRow, selection);
      if (subRowChildrenSelected === 'all') {
        someSelected = true;
      } else if (subRowChildrenSelected === 'some') {
        someSelected = true;
        allChildrenSelected = false;
      } else {
        allChildrenSelected = false;
      }
    }
  });
  return allChildrenSelected ? 'all' : someSelected ? 'some' : false;
}
const reSplitAlphaNumeric = /([0-9]+)/gm;
const alphanumeric = (rowA, rowB, columnId) => {
  return compareAlphanumeric(
    toString(rowA.getValue(columnId)).toLowerCase(),
    toString(rowB.getValue(columnId)).toLowerCase(),
  );
};
const alphanumericCaseSensitive = (rowA, rowB, columnId) => {
  return compareAlphanumeric(toString(rowA.getValue(columnId)), toString(rowB.getValue(columnId)));
};
const text = (rowA, rowB, columnId) => {
  return compareBasic(
    toString(rowA.getValue(columnId)).toLowerCase(),
    toString(rowB.getValue(columnId)).toLowerCase(),
  );
};
const textCaseSensitive = (rowA, rowB, columnId) => {
  return compareBasic(toString(rowA.getValue(columnId)), toString(rowB.getValue(columnId)));
};
const datetime = (rowA, rowB, columnId) => {
  const a = rowA.getValue(columnId);
  const b = rowB.getValue(columnId);
  return a > b ? 1 : a < b ? -1 : 0;
};
const basic = (rowA, rowB, columnId) => {
  return compareBasic(rowA.getValue(columnId), rowB.getValue(columnId));
};
function compareBasic(a, b) {
  return a === b ? 0 : a > b ? 1 : -1;
}
function toString(a) {
  if (typeof a === 'number') {
    if (isNaN(a) || a === Infinity || a === -Infinity) {
      return '';
    }
    return String(a);
  }
  if (typeof a === 'string') {
    return a;
  }
  return '';
}
function compareAlphanumeric(aStr, bStr) {
  const a = aStr.split(reSplitAlphaNumeric).filter(Boolean);
  const b = bStr.split(reSplitAlphaNumeric).filter(Boolean);
  while (a.length && b.length) {
    const aa = a.shift();
    const bb = b.shift();
    const an = parseInt(aa, 10);
    const bn = parseInt(bb, 10);
    const combo = [an, bn].sort();
    if (isNaN(combo[0])) {
      if (aa > bb) {
        return 1;
      }
      if (bb > aa) {
        return -1;
      }
      continue;
    }
    if (isNaN(combo[1])) {
      return isNaN(an) ? -1 : 1;
    }
    if (an > bn) {
      return 1;
    }
    if (bn > an) {
      return -1;
    }
  }
  return a.length - b.length;
}
const sortingFns = {
  alphanumeric,
  alphanumericCaseSensitive,
  text,
  textCaseSensitive,
  datetime,
  basic,
};
const RowSorting = {
  getInitialState: state => {
    return { sorting: [], ...state };
  },
  getDefaultColumnDef: () => {
    return { sortingFn: 'auto', sortUndefined: 1 };
  },
  getDefaultOptions: table => {
    return {
      onSortingChange: makeStateUpdater('sorting', table),
      isMultiSortEvent: e => {
        return e.shiftKey;
      },
    };
  },
  createColumn: (column, table) => {
    column.getAutoSortingFn = () => {
      const firstRows = table.getFilteredRowModel().flatRows.slice(10);
      let isString = false;
      for (const row of firstRows) {
        const value = row == null ? void 0 : row.getValue(column.id);
        if (Object.prototype.toString.call(value) === '[object Date]') {
          return sortingFns.datetime;
        }
        if (typeof value === 'string') {
          isString = true;
          if (value.split(reSplitAlphaNumeric).length > 1) {
            return sortingFns.alphanumeric;
          }
        }
      }
      if (isString) {
        return sortingFns.text;
      }
      return sortingFns.basic;
    };
    column.getAutoSortDir = () => {
      const firstRow = table.getFilteredRowModel().flatRows[0];
      const value = firstRow == null ? void 0 : firstRow.getValue(column.id);
      if (typeof value === 'string') {
        return 'asc';
      }
      return 'desc';
    };
    column.getSortingFn = () => {
      var _table$options$sortin, _table$options$sortin2;
      if (!column) {
        throw new Error();
      }
      return isFunction(column.columnDef.sortingFn)
        ? column.columnDef.sortingFn
        : column.columnDef.sortingFn === 'auto'
          ? column.getAutoSortingFn()
          : (_table$options$sortin =
                (_table$options$sortin2 = table.options.sortingFns) == null
                  ? void 0
                  : _table$options$sortin2[column.columnDef.sortingFn]) != null
            ? _table$options$sortin
            : sortingFns[column.columnDef.sortingFn];
    };
    column.toggleSorting = (desc, multi) => {
      const nextSortingOrder = column.getNextSortingOrder();
      const hasManualValue = typeof desc !== 'undefined' && desc !== null;
      table.setSorting(old => {
        const existingSorting = old == null ? void 0 : old.find(d => d.id === column.id);
        const existingIndex = old == null ? void 0 : old.findIndex(d => d.id === column.id);
        let newSorting = [];
        let sortAction;
        let nextDesc = hasManualValue ? desc : nextSortingOrder === 'desc';
        if (old != null && old.length && column.getCanMultiSort() && multi) {
          if (existingSorting) {
            sortAction = 'toggle';
          } else {
            sortAction = 'add';
          }
        } else {
          if (old != null && old.length && existingIndex !== old.length - 1) {
            sortAction = 'replace';
          } else if (existingSorting) {
            sortAction = 'toggle';
          } else {
            sortAction = 'replace';
          }
        }
        if (sortAction === 'toggle') {
          if (!hasManualValue) {
            if (!nextSortingOrder) {
              sortAction = 'remove';
            }
          }
        }
        if (sortAction === 'add') {
          var _table$options$maxMul;
          newSorting = [...old, { id: column.id, desc: nextDesc }];
          newSorting.splice(
            0,
            newSorting.length -
              ((_table$options$maxMul = table.options.maxMultiSortColCount) != null
                ? _table$options$maxMul
                : Number.MAX_SAFE_INTEGER),
          );
        } else if (sortAction === 'toggle') {
          newSorting = old.map(d => {
            if (d.id === column.id) {
              return { ...d, desc: nextDesc };
            }
            return d;
          });
        } else if (sortAction === 'remove') {
          newSorting = old.filter(d => d.id !== column.id);
        } else {
          newSorting = [{ id: column.id, desc: nextDesc }];
        }
        return newSorting;
      });
    };
    column.getFirstSortDir = () => {
      var _ref, _column$columnDef$sor;
      const sortDescFirst =
        (_ref =
          (_column$columnDef$sor = column.columnDef.sortDescFirst) != null
            ? _column$columnDef$sor
            : table.options.sortDescFirst) != null
          ? _ref
          : column.getAutoSortDir() === 'desc';
      return sortDescFirst ? 'desc' : 'asc';
    };
    column.getNextSortingOrder = multi => {
      var _table$options$enable, _table$options$enable2;
      const firstSortDirection = column.getFirstSortDir();
      const isSorted = column.getIsSorted();
      if (!isSorted) {
        return firstSortDirection;
      }
      if (
        isSorted !== firstSortDirection &&
        ((_table$options$enable = table.options.enableSortingRemoval) != null
          ? _table$options$enable
          : true) && // If enableSortRemove, enable in general
        (multi
          ? (_table$options$enable2 = table.options.enableMultiRemove) != null
            ? _table$options$enable2
            : true
          : true)
      ) {
        return false;
      }
      return isSorted === 'desc' ? 'asc' : 'desc';
    };
    column.getCanSort = () => {
      var _column$columnDef$ena, _table$options$enable3;
      return (
        ((_column$columnDef$ena = column.columnDef.enableSorting) != null
          ? _column$columnDef$ena
          : true) &&
        ((_table$options$enable3 = table.options.enableSorting) != null
          ? _table$options$enable3
          : true) &&
        !!column.accessorFn
      );
    };
    column.getCanMultiSort = () => {
      var _ref2, _column$columnDef$ena2;
      return (_ref2 =
        (_column$columnDef$ena2 = column.columnDef.enableMultiSort) != null
          ? _column$columnDef$ena2
          : table.options.enableMultiSort) != null
        ? _ref2
        : !!column.accessorFn;
    };
    column.getIsSorted = () => {
      var _table$getState$sorti;
      const columnSort =
        (_table$getState$sorti = table.getState().sorting) == null
          ? void 0
          : _table$getState$sorti.find(d => d.id === column.id);
      return !columnSort ? false : columnSort.desc ? 'desc' : 'asc';
    };
    column.getSortIndex = () => {
      var _table$getState$sorti2, _table$getState$sorti3;
      return (_table$getState$sorti2 =
        (_table$getState$sorti3 = table.getState().sorting) == null
          ? void 0
          : _table$getState$sorti3.findIndex(d => d.id === column.id)) != null
        ? _table$getState$sorti2
        : -1;
    };
    column.clearSorting = () => {
      table.setSorting(old =>
        old != null && old.length ? old.filter(d => d.id !== column.id) : [],
      );
    };
    column.getToggleSortingHandler = () => {
      const canSort = column.getCanSort();
      return e => {
        if (!canSort) return;
        e.persist == null || e.persist();
        column.toggleSorting == null ||
          column.toggleSorting(
            void 0,
            column.getCanMultiSort()
              ? table.options.isMultiSortEvent == null
                ? void 0
                : table.options.isMultiSortEvent(e)
              : false,
          );
      };
    };
  },
  createTable: table => {
    table.setSorting = updater =>
      table.options.onSortingChange == null ? void 0 : table.options.onSortingChange(updater);
    table.resetSorting = defaultState => {
      var _table$initialState$s, _table$initialState;
      table.setSorting(
        defaultState
          ? []
          : (_table$initialState$s =
                (_table$initialState = table.initialState) == null
                  ? void 0
                  : _table$initialState.sorting) != null
            ? _table$initialState$s
            : [],
      );
    };
    table.getPreSortedRowModel = () => table.getGroupedRowModel();
    table.getSortedRowModel = () => {
      if (!table._getSortedRowModel && table.options.getSortedRowModel) {
        table._getSortedRowModel = table.options.getSortedRowModel(table);
      }
      if (table.options.manualSorting || !table._getSortedRowModel) {
        return table.getPreSortedRowModel();
      }
      return table._getSortedRowModel();
    };
  },
};
const builtInFeatures = [
  Headers,
  ColumnVisibility,
  ColumnOrdering,
  ColumnPinning,
  ColumnFaceting,
  ColumnFiltering,
  GlobalFaceting,
  //depends on ColumnFaceting
  GlobalFiltering,
  //depends on ColumnFiltering
  RowSorting,
  ColumnGrouping,
  //depends on RowSorting
  RowExpanding,
  RowPagination,
  RowPinning,
  RowSelection,
  ColumnSizing,
];
function createTable(options) {
  var _options$_features, _options$initialState;
  if (process.env.NODE_ENV !== 'production' && (options.debugAll || options.debugTable)) {
    console.info('Creating Table Instance...');
  }
  const _features = [
    ...builtInFeatures,
    ...((_options$_features = options._features) != null ? _options$_features : []),
  ];
  let table = { _features };
  const defaultOptions = table._features.reduce((obj, feature) => {
    return Object.assign(
      obj,
      feature.getDefaultOptions == null ? void 0 : feature.getDefaultOptions(table),
    );
  }, {});
  const mergeOptions = options2 => {
    if (table.options.mergeOptions) {
      return table.options.mergeOptions(defaultOptions, options2);
    }
    return { ...defaultOptions, ...options2 };
  };
  const coreInitialState = {};
  let initialState = {
    ...coreInitialState,
    ...((_options$initialState = options.initialState) != null ? _options$initialState : {}),
  };
  table._features.forEach(feature => {
    var _feature$getInitialSt;
    initialState =
      (_feature$getInitialSt =
        feature.getInitialState == null ? void 0 : feature.getInitialState(initialState)) != null
        ? _feature$getInitialSt
        : initialState;
  });
  const queued = [];
  let queuedTimeout = false;
  const coreInstance = {
    _features,
    options: { ...defaultOptions, ...options },
    initialState,
    _queue: cb => {
      queued.push(cb);
      if (!queuedTimeout) {
        queuedTimeout = true;
        Promise.resolve()
          .then(() => {
            while (queued.length) {
              queued.shift()();
            }
            queuedTimeout = false;
          })
          .catch(error =>
            setTimeout(() => {
              throw error;
            }),
          );
      }
    },
    reset: () => {
      table.setState(table.initialState);
    },
    setOptions: updater => {
      const newOptions = functionalUpdate(updater, table.options);
      table.options = mergeOptions(newOptions);
    },
    getState: () => {
      return table.options.state;
    },
    setState: updater => {
      table.options.onStateChange == null || table.options.onStateChange(updater);
    },
    _getRowId: (row, index2, parent) => {
      var _table$options$getRow;
      return (_table$options$getRow =
        table.options.getRowId == null ? void 0 : table.options.getRowId(row, index2, parent)) !=
        null
        ? _table$options$getRow
        : `${parent ? [parent.id, index2].join('.') : index2}`;
    },
    getCoreRowModel: () => {
      if (!table._getCoreRowModel) {
        table._getCoreRowModel = table.options.getCoreRowModel(table);
      }
      return table._getCoreRowModel();
    },
    // The final calls start at the bottom of the model,
    // expanded rows, which then work their way up
    getRowModel: () => {
      return table.getPaginationRowModel();
    },
    //in next version, we should just pass in the row model as the optional 2nd arg
    getRow: (id2, searchAll) => {
      let row = (searchAll ? table.getPrePaginationRowModel() : table.getRowModel()).rowsById[id2];
      if (!row) {
        row = table.getCoreRowModel().rowsById[id2];
        if (!row) {
          if (process.env.NODE_ENV !== 'production') {
            throw new Error(`getRow could not find row with ID: ${id2}`);
          }
          throw new Error();
        }
      }
      return row;
    },
    _getDefaultColumnDef: memo(
      () => [table.options.defaultColumn],
      defaultColumn => {
        var _defaultColumn;
        defaultColumn = (_defaultColumn = defaultColumn) != null ? _defaultColumn : {};
        return {
          header: props => {
            const resolvedColumnDef = props.header.column.columnDef;
            if (resolvedColumnDef.accessorKey) {
              return resolvedColumnDef.accessorKey;
            }
            if (resolvedColumnDef.accessorFn) {
              return resolvedColumnDef.id;
            }
            return null;
          },
          // footer: props => props.header.column.id,
          cell: props => {
            var _props$renderValue$to, _props$renderValue;
            return (_props$renderValue$to =
              (_props$renderValue = props.renderValue()) == null ||
              _props$renderValue.toString == null
                ? void 0
                : _props$renderValue.toString()) != null
              ? _props$renderValue$to
              : null;
          },
          ...table._features.reduce((obj, feature) => {
            return Object.assign(
              obj,
              feature.getDefaultColumnDef == null ? void 0 : feature.getDefaultColumnDef(),
            );
          }, {}),
          ...defaultColumn,
        };
      },
      getMemoOptions(options, 'debugColumns', '_getDefaultColumnDef'),
    ),
    _getColumnDefs: () => table.options.columns,
    getAllColumns: memo(
      () => [table._getColumnDefs()],
      columnDefs => {
        const recurseColumns = function (columnDefs2, parent, depth) {
          if (depth === void 0) {
            depth = 0;
          }
          return columnDefs2.map(columnDef => {
            const column = createColumn(table, columnDef, depth, parent);
            const groupingColumnDef = columnDef;
            column.columns = groupingColumnDef.columns
              ? recurseColumns(groupingColumnDef.columns, column, depth + 1)
              : [];
            return column;
          });
        };
        return recurseColumns(columnDefs);
      },
      getMemoOptions(options, 'debugColumns', 'getAllColumns'),
    ),
    getAllFlatColumns: memo(
      () => [table.getAllColumns()],
      allColumns => {
        return allColumns.flatMap(column => {
          return column.getFlatColumns();
        });
      },
      getMemoOptions(options, 'debugColumns', 'getAllFlatColumns'),
    ),
    _getAllFlatColumnsById: memo(
      () => [table.getAllFlatColumns()],
      flatColumns => {
        return flatColumns.reduce((acc, column) => {
          acc[column.id] = column;
          return acc;
        }, {});
      },
      getMemoOptions(options, 'debugColumns', 'getAllFlatColumnsById'),
    ),
    getAllLeafColumns: memo(
      () => [table.getAllColumns(), table._getOrderColumnsFn()],
      (allColumns, orderColumns2) => {
        let leafColumns = allColumns.flatMap(column => column.getLeafColumns());
        return orderColumns2(leafColumns);
      },
      getMemoOptions(options, 'debugColumns', 'getAllLeafColumns'),
    ),
    getColumn: columnId => {
      const column = table._getAllFlatColumnsById()[columnId];
      if (process.env.NODE_ENV !== 'production' && !column) {
        console.error(`[Table] Column with id '${columnId}' does not exist.`);
      }
      return column;
    },
  };
  Object.assign(table, coreInstance);
  for (let index2 = 0; index2 < table._features.length; index2++) {
    const feature = table._features[index2];
    feature == null || feature.createTable == null || feature.createTable(table);
  }
  return table;
}
function getCoreRowModel() {
  return table =>
    memo(
      () => [table.options.data],
      data => {
        const rowModel = { rows: [], flatRows: [], rowsById: {} };
        const accessRows = function (originalRows, depth, parentRow) {
          if (depth === void 0) {
            depth = 0;
          }
          const rows = [];
          for (let i = 0; i < originalRows.length; i++) {
            const row = createRow(
              table,
              table._getRowId(originalRows[i], i, parentRow),
              originalRows[i],
              i,
              depth,
              void 0,
              parentRow == null ? void 0 : parentRow.id,
            );
            rowModel.flatRows.push(row);
            rowModel.rowsById[row.id] = row;
            rows.push(row);
            if (table.options.getSubRows) {
              var _row$originalSubRows;
              row.originalSubRows = table.options.getSubRows(originalRows[i], i);
              if (
                (_row$originalSubRows = row.originalSubRows) != null &&
                _row$originalSubRows.length
              ) {
                row.subRows = accessRows(row.originalSubRows, depth + 1, row);
              }
            }
          }
          return rows;
        };
        rowModel.rows = accessRows(data);
        return rowModel;
      },
      getMemoOptions(table.options, 'debugTable', 'getRowModel', () => table._autoResetPageIndex()),
    );
}
function expandRows(rowModel) {
  const expandedRows = [];
  const handleRow = row => {
    var _row$subRows;
    expandedRows.push(row);
    if ((_row$subRows = row.subRows) != null && _row$subRows.length && row.getIsExpanded()) {
      row.subRows.forEach(handleRow);
    }
  };
  rowModel.rows.forEach(handleRow);
  return { rows: expandedRows, flatRows: rowModel.flatRows, rowsById: rowModel.rowsById };
}
function getPaginationRowModel(opts) {
  return table =>
    memo(
      () => [
        table.getState().pagination,
        table.getPrePaginationRowModel(),
        table.options.paginateExpandedRows ? void 0 : table.getState().expanded,
      ],
      (pagination, rowModel) => {
        if (!rowModel.rows.length) {
          return rowModel;
        }
        const { pageSize, pageIndex } = pagination;
        let { rows, flatRows, rowsById } = rowModel;
        const pageStart = pageSize * pageIndex;
        const pageEnd = pageStart + pageSize;
        rows = rows.slice(pageStart, pageEnd);
        let paginatedRowModel;
        if (!table.options.paginateExpandedRows) {
          paginatedRowModel = expandRows({ rows, flatRows, rowsById });
        } else {
          paginatedRowModel = { rows, flatRows, rowsById };
        }
        paginatedRowModel.flatRows = [];
        const handleRow = row => {
          paginatedRowModel.flatRows.push(row);
          if (row.subRows.length) {
            row.subRows.forEach(handleRow);
          }
        };
        paginatedRowModel.rows.forEach(handleRow);
        return paginatedRowModel;
      },
      getMemoOptions(table.options, 'debugTable', 'getPaginationRowModel'),
    );
}
function getSortedRowModel() {
  return table =>
    memo(
      () => [table.getState().sorting, table.getPreSortedRowModel()],
      (sorting, rowModel) => {
        if (!rowModel.rows.length || !(sorting != null && sorting.length)) {
          return rowModel;
        }
        const sortingState = table.getState().sorting;
        const sortedFlatRows = [];
        const availableSorting = sortingState.filter(sort => {
          var _table$getColumn;
          return (_table$getColumn = table.getColumn(sort.id)) == null
            ? void 0
            : _table$getColumn.getCanSort();
        });
        const columnInfoById = {};
        availableSorting.forEach(sortEntry => {
          const column = table.getColumn(sortEntry.id);
          if (!column) return;
          columnInfoById[sortEntry.id] = {
            sortUndefined: column.columnDef.sortUndefined,
            invertSorting: column.columnDef.invertSorting,
            sortingFn: column.getSortingFn(),
          };
        });
        const sortData = rows => {
          const sortedData = rows.map(row => ({ ...row }));
          sortedData.sort((rowA, rowB) => {
            for (let i = 0; i < availableSorting.length; i += 1) {
              var _sortEntry$desc;
              const sortEntry = availableSorting[i];
              const columnInfo = columnInfoById[sortEntry.id];
              const sortUndefined = columnInfo.sortUndefined;
              const isDesc =
                (_sortEntry$desc = sortEntry == null ? void 0 : sortEntry.desc) != null
                  ? _sortEntry$desc
                  : false;
              let sortInt = 0;
              if (sortUndefined) {
                const aValue = rowA.getValue(sortEntry.id);
                const bValue = rowB.getValue(sortEntry.id);
                const aUndefined = aValue === void 0;
                const bUndefined = bValue === void 0;
                if (aUndefined || bUndefined) {
                  if (sortUndefined === 'first') return aUndefined ? -1 : 1;
                  if (sortUndefined === 'last') return aUndefined ? 1 : -1;
                  sortInt =
                    aUndefined && bUndefined ? 0 : aUndefined ? sortUndefined : -sortUndefined;
                }
              }
              if (sortInt === 0) {
                sortInt = columnInfo.sortingFn(rowA, rowB, sortEntry.id);
              }
              if (sortInt !== 0) {
                if (isDesc) {
                  sortInt *= -1;
                }
                if (columnInfo.invertSorting) {
                  sortInt *= -1;
                }
                return sortInt;
              }
            }
            return rowA.index - rowB.index;
          });
          sortedData.forEach(row => {
            var _row$subRows;
            sortedFlatRows.push(row);
            if ((_row$subRows = row.subRows) != null && _row$subRows.length) {
              row.subRows = sortData(row.subRows);
            }
          });
          return sortedData;
        };
        return {
          rows: sortData(rowModel.rows),
          flatRows: sortedFlatRows,
          rowsById: rowModel.rowsById,
        };
      },
      getMemoOptions(table.options, 'debugTable', 'getSortedRowModel', () =>
        table._autoResetPageIndex(),
      ),
    );
}
function flexRender(Comp, props) {
  return !Comp
    ? null
    : isReactComponent(Comp)
      ? /* @__PURE__ */ React.createElement(Comp, props)
      : Comp;
}
function isReactComponent(component) {
  return (
    isClassComponent(component) || typeof component === 'function' || isExoticComponent(component)
  );
}
function isClassComponent(component) {
  return (
    typeof component === 'function' &&
    (() => {
      const proto = Object.getPrototypeOf(component);
      return proto.prototype && proto.prototype.isReactComponent;
    })()
  );
}
function isExoticComponent(component) {
  return (
    typeof component === 'object' &&
    typeof component.$$typeof === 'symbol' &&
    ['react.memo', 'react.forward_ref'].includes(component.$$typeof.description)
  );
}
function useReactTable(options) {
  const resolvedOptions = {
    state: {},
    // Dummy state
    onStateChange: () => {},
    // noop
    renderFallbackValue: null,
    ...options,
  };
  const [tableRef] = React.useState(() => ({ current: createTable(resolvedOptions) }));
  const [state, setState] = React.useState(() => tableRef.current.initialState);
  tableRef.current.setOptions(prev => ({
    ...prev,
    ...options,
    state: { ...state, ...options.state },
    // Similarly, we'll maintain both our internal state and any user-provided
    // state.
    onStateChange: updater => {
      setState(updater);
      options.onStateChange == null || options.onStateChange(updater);
    },
  }));
  return tableRef.current;
}
const Table = forwardRef(
  (
    {
      className,
      size: size2 = 'default',
      textAlign = 'default',
      sortable = false,
      clickable,
      ...props
    },
    ref,
  ) => {
    return /* @__PURE__ */ React__default.createElement('table', {
      className: classNames('spot-data-table', className, {
        'spot-data-table--small-spacing': size2 === 'small',
        'spot-data-table--large-spacing': size2 === 'large',
        'spot-data-table--center-aligned': textAlign === 'center',
        'spot-data-table--right-aligned': textAlign === 'right',
        'spot-data-table--sortable': sortable,
        'spot-data-table--clickable': clickable === 'default' || clickable === true,
        'spot-data-table--multi-clickable': clickable === 'multi',
      }),
      ...props,
      ref,
    });
  },
);
Table.displayName = 'Table';
const TableHeaderCell = forwardRef(
  ({ className, sortDirection, sortDisabled = false, ...props }, ref) => {
    return /* @__PURE__ */ React__default.createElement('th', {
      className: classNames(className, {
        'spot-data-table__col--sort-ascending': sortDirection === 'asc',
        'spot-data-table__col--sort-descending': sortDirection === 'desc',
        'spot-data-table__col--active': sortDirection !== void 0,
        'spot-data-table__col--sort-disabled': sortDisabled,
      }),
      ...props,
      ref,
    });
  },
);
TableHeaderCell.displayName = 'TableHeaderCell';
const TableRow = forwardRef(({ rowInRange, className, clicked, ...props }, ref) => {
  return /* @__PURE__ */ React__default.createElement('tr', {
    className: classNames(className, {
      'spot-data-table__row--in-range': rowInRange === true,
      'spot-data-table__row--out-of-range': rowInRange === false,
      'spot-data-table__row--clicked': clicked === true,
    }),
    ...props,
    ref,
  });
});
TableRow.displayName = 'TableRow';
function DataTableInner(
  {
    data: dataProp,
    size: size2 = 'default',
    enableSorting = false,
    rowValidation,
    onRowClick,
    clickable,
    columns,
    getRowId,
    ...props
  },
  ref,
) {
  const [data, setData] = React__default.useState(dataProp);
  const [sorting, setSorting] = React__default.useState([]);
  const [rowSelection, setRowSelection] = React__default.useState({});
  const table = useReactTable({
    columns,
    data,
    onSortingChange: setSorting,
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getRowId,
    onRowSelectionChange: getNewState => {
      const newState = typeof getNewState === 'function' ? getNewState(rowSelection) : getNewState;
      const newlySelectedId = Object.keys(newState).find(
        id2 => newState[id2] && !rowSelection[id2],
      );
      setRowSelection(newState);
      if (newlySelectedId) {
        const row = table.getRow(newlySelectedId);
        onRowClick?.(row?.original, Object.keys(newState));
      }
    },
    enableSorting,
    enableRowSelection: clickable !== void 0,
    enableMultiRowSelection: clickable === 'multi',
    state: { sorting, rowSelection },
  });
  React__default.useEffect(() => {
    setData(dataProp);
  }, [dataProp]);
  return /* @__PURE__ */ React__default.createElement(
    Table,
    { ref, sortable: enableSorting, size: size2, clickable, ...props },
    /* @__PURE__ */ React__default.createElement(
      'thead',
      null,
      table.getHeaderGroups().map(headerGroup =>
        /* @__PURE__ */ React__default.createElement(
          'tr',
          { key: headerGroup.id },
          headerGroup.headers.map(header => {
            const sortDirection = header.column.getIsSorted();
            return /* @__PURE__ */ React__default.createElement(
              TableHeaderCell,
              {
                key: header.id,
                onClick: header.column.getToggleSortingHandler(),
                colSpan: header.colSpan,
                sortDisabled: !header.column.getCanSort(),
                sortDirection:
                  sortDirection === false ? void 0 : sortDirection === 'asc' ? 'asc' : 'desc',
                title: header.column.getCanSort()
                  ? header.column.getNextSortingOrder() === 'asc'
                    ? 'Sort ascending'
                    : header.column.getNextSortingOrder() === 'desc'
                      ? 'Sort descending'
                      : 'Clear sort'
                  : void 0,
              },
              header.isPlaceholder
                ? null
                : /* @__PURE__ */ React__default.createElement(
                    React__default.Fragment,
                    null,
                    flexRender(header.column.columnDef.header, header.getContext()),
                  ),
            );
          }),
        ),
      ),
    ),
    /* @__PURE__ */ React__default.createElement(
      'tbody',
      null,
      table.getRowModel().rows.map(row =>
        /* @__PURE__ */ React__default.createElement(
          TableRow,
          {
            key: row.id,
            clicked: clickable && row.getIsSelected(),
            rowInRange: rowValidation?.(row.original),
            onClick: row.getToggleSelectedHandler(),
          },
          row
            .getVisibleCells()
            .map(cell =>
              /* @__PURE__ */ React__default.createElement(
                'td',
                { key: cell.id },
                flexRender(cell.column.columnDef.cell, cell.getContext()),
              ),
            ),
        ),
      ),
    ),
  );
}
const DataTable = forwardRef(DataTableInner);
DataTable.displayName = 'DataTable';
const DIHeader = forwardRefWithAs((props, ref) => {
  const {
    as: Component = 'div',
    username,
    location,
    showDropdownCaret = false,
    className,
    profileUrl,
    ...htmlProps
  } = props;
  const cmpClassNames = classNames('spot-di__header', className);
  const linkValue = !showDropdownCaret ? profileUrl : void 0;
  return /* @__PURE__ */ React__default.createElement(
    Component,
    { ref, className: cmpClassNames, ...htmlProps },
    /* @__PURE__ */ React__default.createElement(
      'a',
      { className: 'spot-di__header-userinfo', href: linkValue },
      /* @__PURE__ */ React__default.createElement(
        'span',
        { className: 'spot-link--bold' },
        username,
      ),
      /* @__PURE__ */ React__default.createElement(
        'span',
        { className: 'spot-link--small spot-link--ellipsis' },
        location,
      ),
    ),
    showDropdownCaret &&
      /* @__PURE__ */ React__default.createElement(
        'div',
        { className: 'spot-di__header-icon' },
        /* @__PURE__ */ React__default.createElement(
          'svg',
          null,
          /* @__PURE__ */ React__default.createElement(Icon, { title: 'caret-down' }),
        ),
      ),
  );
});
const DILocation = ({ title, isCurrent = false, url, ...props }) => {
  const linkClassnames = classNames('spot-link--ellipsis', {
    'spot-link spot-link-selected': isCurrent,
    'spot-link': !isCurrent,
  });
  return /* @__PURE__ */ React__default.createElement(
    'div',
    { className: 'spot-di__content-item', ...props },
    /* @__PURE__ */ React__default.createElement(
      'a',
      { className: linkClassnames, href: url },
      title,
    ),
  );
};
const DILocations = ({ locations = [], label = 'My Location' }) => {
  return /* @__PURE__ */ React__default.createElement(
    React__default.Fragment,
    null,
    /* @__PURE__ */ React__default.createElement(
      'div',
      { className: 'spot-di__content-mylocation' },
      label,
    ),
    /* @__PURE__ */ React__default.createElement(
      'div',
      { className: 'spot-di__content-items' },
      locations.map(({ name, ...locationProps }) =>
        /* @__PURE__ */ React__default.createElement(DILocation, {
          key: name,
          title: name,
          ...locationProps,
        }),
      ),
    ),
  );
};
const DIProfileLink = ({ label = 'My Profile', href = '#', ...props }) => {
  return /* @__PURE__ */ React__default.createElement(
    'div',
    { className: 'spot-di__content-profile' },
    /* @__PURE__ */ React__default.createElement(
      'a',
      { className: 'spot-link', href, ...props },
      label,
    ),
  );
};
const DIPopover = ({ locations = [], ...props }) => {
  return /* @__PURE__ */ React__default.createElement(
    'div',
    { className: 'spot-di__content' },
    /* @__PURE__ */ React__default.createElement(DIProfileLink, { ...props }),
    /* @__PURE__ */ React__default.createElement(DILocations, { locations }),
  );
};
const DIRoot = forwardRefWithAs((props, ref) => {
  const {
    as: Component = 'div',
    className,
    withPopover = false,
    popoverContent,
    children,
    ...htmlProps
  } = props;
  const cmpClassNames = classNames('spot-di', className);
  return /* @__PURE__ */ React__default.createElement(
    Component,
    { ref, className: cmpClassNames, ...htmlProps },
    !withPopover &&
      /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, children),
    withPopover &&
      /* @__PURE__ */ React__default.createElement(
        Popover,
        {
          align: 'end',
          side: 'bottom',
          onOpenAutoFocus: e => e.preventDefault(),
          content: /* @__PURE__ */ React__default.createElement(
            PopoverContent,
            { size: 'no-inset', placement: 'left' },
            popoverContent,
          ),
        },
        children,
      ),
  );
});
const DigitalIdentity = forwardRefWithAs(
  ({ as, profileUrl, username, location = '', children, ...htmlProps }, ref) => {
    const hasPopover = !!children;
    return /* @__PURE__ */ React__default.createElement(
      React__default.Fragment,
      null,
      /* @__PURE__ */ React__default.createElement(
        DIRoot,
        { ref, as, withPopover: hasPopover, popoverContent: children, ...htmlProps },
        /* @__PURE__ */ React__default.createElement(DIHeader, {
          username,
          location,
          profileUrl,
          showDropdownCaret: hasPopover,
        }),
      ),
    );
  },
);
const FilterSelection = forwardRefWithAs(
  (
    { children, as, className, variant = 'default', size: size2 = 'default', onCancel, ...props },
    ref,
  ) => {
    const Component = as || 'div';
    return /* @__PURE__ */ React__default.createElement(
      Component,
      {
        ref,
        className: classNames('spot-filter', className, {
          [`spot-filter--${variant}`]: variant !== 'default',
          'spot-filter--small': size2 === 'small',
        }),
        tabIndex: 0,
        ...props,
        onKeyDown: e => {
          if (e.key === 'Enter' || e.key === 'Space') {
            onCancel?.(e);
          }
        },
        role: 'button',
      },
      /* @__PURE__ */ React__default.createElement('button', {
        onClick: e => onCancel?.(e),
        className: 'spot-filter__cancel',
        title: 'Remove',
      }),
      children,
    );
  },
);
const TextBoxTypes = ['text', 'password', 'email', 'number', 'tel', 'url'];
const TextBox = forwardRef(({ className, type = 'text', ...rest }, ref) => {
  const safeTextType = TextBoxTypes.includes(type) ? type : 'text';
  return /* @__PURE__ */ React__default.createElement('input', {
    className: classNames('spot-form__input', className),
    type: safeTextType,
    ...rest,
    ref,
  });
});
TextBox.displayName = 'TextBox';
const Label = forwardRef(({ className, ...rest }, ref) => {
  return /* @__PURE__ */ React__default.createElement('label', {
    className: classNames('spot-form__label', className),
    ...rest,
    ref,
  });
});
Label.displayName = 'Label';
const TextArea = forwardRef(({ className, ...rest }, ref) => {
  return /* @__PURE__ */ React__default.createElement('textarea', {
    className: classNames('spot-form__textarea', className),
    ...rest,
    ref,
  });
});
TextArea.displayName = 'TextArea';
const SelectBox = forwardRef(({ className, ...rest }, ref) => {
  return /* @__PURE__ */ React__default.createElement(
    'div',
    { className: 'spot-form__select' },
    /* @__PURE__ */ React__default.createElement('select', {
      className: classNames('spot-form__select-input', className),
      ...rest,
      ref,
    }),
    /* @__PURE__ */ React__default.createElement('div', { className: 'spot-form__select-inner' }),
    /* @__PURE__ */ React__default.createElement(
      'span',
      { className: 'spot-form__select-open-indicator' },
      /* @__PURE__ */ React__default.createElement(Icon, {
        title: 'caret-down',
        className: 'spot-form__select-open-icon',
      }),
    ),
  );
});
SelectBox.displayName = 'SelectBox';
const Option = forwardRef(({ className, ...rest }, ref) => {
  return /* @__PURE__ */ React__default.createElement('option', {
    className: classNames('spot-form__select-option', className),
    ...rest,
    ref,
  });
});
Option.displayName = 'Option';
const CheckBox = forwardRef(
  ({ className, variant = 'default', label: labelProp, id: id2, size: size2, ...rest }, ref) => {
    return /* @__PURE__ */ React__default.createElement(
      'label',
      {
        className: classNames('spot-form__checkbox', {
          'spot-form__checkbox--small': size2 === 'small',
          'spot-form__checkbox--filled': variant === 'filled',
        }),
        htmlFor: id2,
      },
      /* @__PURE__ */ React__default.createElement('input', {
        className: classNames('spot-form__checkbox-input', className),
        ...rest,
        id: id2,
        ref,
        type: 'checkbox',
      }),
      /* @__PURE__ */ React__default.createElement(
        'span',
        { className: 'spot-form__checkbox-inner' },
        /* @__PURE__ */ React__default.createElement(
          'span',
          { className: 'spot-form__checkbox-visual' },
          /* @__PURE__ */ React__default.createElement(Icon, {
            title: 'checkmark',
            className: 'spot-form__checkbox-checked-icon',
          }),
          /* @__PURE__ */ React__default.createElement(Icon, {
            title: 'checkbox-indeterminate',
            className: 'spot-form__checkbox-indeterminate-icon',
          }),
        ),
        labelProp &&
          /* @__PURE__ */ React__default.createElement(
            'span',
            { className: 'spot-form__checkbox-label' },
            labelProp,
          ),
      ),
    );
  },
);
CheckBox.displayName = 'CheckBox';
const CheckBoxGroup = forwardRef(
  ({ children, className, label, isRequired = false, variant, ...rest }, ref) => {
    return /* @__PURE__ */ React__default.createElement(
      'fieldset',
      {
        className: classNames('spot-form__checkbox-group', className, {
          'spot-form__field-group--horizontal': variant === 'horizontal',
        }),
        ...rest,
        ref,
        role: 'group',
      },
      /* @__PURE__ */ React__default.createElement(
        'legend',
        { className: 'spot-form__checkbox-group-label' },
        isRequired &&
          /* @__PURE__ */ React__default.createElement(
            React__default.Fragment,
            null,
            /* @__PURE__ */ React__default.createElement(
              'abbr',
              {
                className: 'spot-form__label-required-indicator',
                title: 'Please select at least one option.',
                'aria-hidden': 'true',
              },
              '*',
            ),
            ' ',
            /* @__PURE__ */ React__default.createElement(
              'span',
              { className: 'spot--screenreader-only' },
              'Required Field.',
            ),
          ),
        label,
      ),
      /* @__PURE__ */ React__default.createElement(
        'div',
        { className: 'spot-form__checkbox-group-inner' },
        children,
      ),
    );
  },
);
CheckBoxGroup.displayName = 'CheckBoxGroup';
const RadioButton = forwardRef(({ className, label, id: id2, size: size2, ...rest }, ref) => {
  return /* @__PURE__ */ React__default.createElement(
    'label',
    {
      className: classNames('spot-form__radio', { 'spot-form__radio--small': size2 === 'small' }),
      htmlFor: id2,
    },
    /* @__PURE__ */ React__default.createElement('input', {
      className: classNames('spot-form__radio-input', className),
      ...rest,
      id: id2,
      ref,
      type: 'radio',
    }),
    /* @__PURE__ */ React__default.createElement(
      'span',
      { className: 'spot-form__radio-inner' },
      /* @__PURE__ */ React__default.createElement('span', {
        className: 'spot-form__radio-visual',
      }),
      /* @__PURE__ */ React__default.createElement(
        'span',
        { className: 'spot-form__radio-label' },
        label,
      ),
    ),
  );
});
RadioButton.displayName = 'RadioButton';
const RadioButtonGroup = forwardRef(
  ({ children, className, label, isRequired = false, variant, ...rest }, ref) => {
    return /* @__PURE__ */ React__default.createElement(
      'fieldset',
      {
        className: classNames('spot-form__radio-group', className, {
          'spot-form__field-group--horizontal': variant === 'horizontal',
        }),
        ...rest,
        ref,
        role: 'group',
      },
      /* @__PURE__ */ React__default.createElement(
        'legend',
        { className: 'spot-form__radio-group-label' },
        isRequired &&
          /* @__PURE__ */ React__default.createElement(
            React__default.Fragment,
            null,
            /* @__PURE__ */ React__default.createElement(
              'abbr',
              {
                className: 'spot-form__label-required-indicator',
                title: 'Please select at least one option.',
                'aria-hidden': 'true',
              },
              '*',
            ),
            ' ',
            /* @__PURE__ */ React__default.createElement(
              'span',
              { className: 'spot--screenreader-only' },
              'Required Field.',
            ),
          ),
        label,
      ),
      /* @__PURE__ */ React__default.createElement(
        'div',
        { className: 'spot-form__radio-group-inner' },
        children,
      ),
    );
  },
);
RadioButtonGroup.displayName = 'RadioButtonGroup';
const FieldError = forwardRefWithAs(({ as, className, children, ...rest }, ref) => {
  const Component = as ?? 'span';
  return /* @__PURE__ */ React__default.createElement(
    Component,
    { className: classNames('spot-form__field-error', className), role: 'alert', ref, ...rest },
    /* @__PURE__ */ React__default.createElement(
      'span',
      { className: 'spot-form__field-error-text' },
      children,
    ),
  );
});
FieldError.displayName = 'FieldError';
const FieldGroup = forwardRefWithAs(
  (
    {
      as,
      children,
      className,
      label,
      microText,
      errorText,
      htmlFor,
      'aria-describedby': ariaDescribedBy,
      'aria-labelledby': ariaLabelledBy,
      isRequired = false,
      ...rest
    },
    ref,
  ) => {
    const Component = as ?? 'div';
    return /* @__PURE__ */ React__default.createElement(
      Component,
      {
        className: classNames('spot-form__field-group', className, {
          'spot-form--error': errorText,
        }),
        ...rest,
        ref,
      },
      /* @__PURE__ */ React__default.createElement(
        Label,
        { htmlFor, 'aria-labelledby': ariaLabelledBy, 'aria-describedby': ariaDescribedBy },
        isRequired &&
          /* @__PURE__ */ React__default.createElement(
            React__default.Fragment,
            null,
            /* @__PURE__ */ React__default.createElement(
              'abbr',
              {
                className: 'spot-form__label-required-indicator',
                title: 'Please select at least one option.',
                'aria-hidden': 'true',
              },
              '*',
            ),
            ' ',
            /* @__PURE__ */ React__default.createElement(
              'span',
              { className: 'spot--screenreader-only' },
              'Required Field.',
            ),
          ),
        label,
      ),
      microText
        ? /* @__PURE__ */ React__default.createElement(
            'span',
            { className: 'spot-form__microcopy' },
            microText,
          )
        : null,
      children,
      errorText ? /* @__PURE__ */ React__default.createElement(FieldError, null, errorText) : null,
    );
  },
);
FieldGroup.displayName = 'FieldGroup';
const Fieldset = forwardRef(({ children, className, legend, ...rest }, ref) => {
  return /* @__PURE__ */ React__default.createElement(
    'fieldset',
    { className: classNames('spot-form__fieldset', className), ...rest, ref },
    legend
      ? /* @__PURE__ */ React__default.createElement(
          'legend',
          { className: 'spot-form__legend' },
          legend,
        )
      : null,
    children,
  );
});
Fieldset.displayName = 'Fieldset';
const LINK_SIZE_LIST = ['small', 'default', 'large'];
const Link = forwardRefWithAs(function Link2(
  {
    as,
    size: size2 = 'default',
    isDisabled = false,
    iconLeft,
    iconRight,
    className,
    children,
    ...rest
  },
  ref,
) {
  const Component = as ?? 'a';
  return /* @__PURE__ */ React__default.createElement(
    Component,
    {
      className: classNames('spot-link', className, {
        [`spot-link--${size2}`]: size2 && size2 !== 'default',
        'spot-link--disabled': isDisabled,
      }),
      ...rest,
      ref,
    },
    /* @__PURE__ */ React__default.createElement(
      React__default.Fragment,
      null,
      renderIcon(iconLeft, 'spot-link__icon spot-link__icon--left'),
      iconLeft || iconRight
        ? /* @__PURE__ */ React__default.createElement(
            'span',
            { className: 'spot-link__text' },
            children,
          )
        : children,
      renderIcon(iconRight, 'spot-link__icon spot-link__icon--right'),
    ),
  );
});
const ListGroup = forwardRef(({ as, className, children, variant, heading, ...rest }, ref) => {
  const Component = as ?? 'ul';
  return /* @__PURE__ */ React__default.createElement(
    Component,
    {
      className: classNames('spot-list-group', className, {
        'spot-list-group__sublist': variant === 'sublist',
        'spot-list-group--interactive': variant === 'interactive',
      }),
      ...rest,
      ref,
      role: 'list',
    },
    heading
      ? /* @__PURE__ */ React__default.createElement(
          'li',
          { className: 'spot-list-group__item spot-list-group__item--header' },
          /* @__PURE__ */ React__default.createElement(
            'span',
            { className: 'spot-list-group__header' },
            heading,
          ),
        )
      : null,
    Children.toArray(children)
      .filter(child => React__default.isValidElement(child))
      .map(child => {
        const childElement = child;
        return cloneElement(childElement, {
          className: classNames(childElement.props.className, {
            'spot-list-group__item--sublist': variant === 'sublist',
          }),
        });
      }),
  );
});
ListGroup.displayName = 'ListGroup';
const ListGroupItem = forwardRef(
  (
    { className, label, active = false, icon, href, variant = 'default', children, ...rest },
    ref,
  ) => {
    return /* @__PURE__ */ React__default.createElement(
      'li',
      {
        className: classNames('spot-list-group__item', className, {
          'spot-list-group__item--active': active,
        }),
        ...rest,
        ref,
      },
      /* @__PURE__ */ React__default.createElement(
        'a',
        { href, className: 'spot-list-group__link' },
        icon ? renderIcon(icon, 'spot-list-group__item-icon') : null,
        /* @__PURE__ */ React__default.createElement(
          'span',
          {
            className: classNames('spot-list-group__item-label', {
              'variant--bold': variant === 'bold',
            }),
          },
          label,
        ),
      ),
      children,
    );
  },
);
ListGroupItem.displayName = 'ListGroupItem';
const LoadingSpinner = forwardRef(({ size: size2 = 'default' }, ref) => {
  return /* @__PURE__ */ React__default.createElement(Icon, {
    ref,
    title: 'spinner',
    className: classNames('spot-loading-spinner', {
      [`spot-loading-spinner--${size2}`]: size2 !== 'default',
    }),
  });
});
LoadingSpinner.displayName = 'LoadingSpinner';
var DIALOG_NAME = 'Dialog';
var [createDialogContext] = createContextScope(DIALOG_NAME);
var [DialogProvider, useDialogContext] = createDialogContext(DIALOG_NAME);
var Dialog = props => {
  const {
    __scopeDialog,
    children,
    open: openProp,
    defaultOpen,
    onOpenChange,
    modal = true,
  } = props;
  const triggerRef = React.useRef(null);
  const contentRef = React.useRef(null);
  const [open, setOpen] = useControllableState({
    prop: openProp,
    defaultProp: defaultOpen ?? false,
    onChange: onOpenChange,
    caller: DIALOG_NAME,
  });
  return /* @__PURE__ */ jsx(DialogProvider, {
    scope: __scopeDialog,
    triggerRef,
    contentRef,
    contentId: useId$1(),
    titleId: useId$1(),
    descriptionId: useId$1(),
    open,
    onOpenChange: setOpen,
    onOpenToggle: React.useCallback(() => setOpen(prevOpen => !prevOpen), [setOpen]),
    modal,
    children,
  });
};
Dialog.displayName = DIALOG_NAME;
var TRIGGER_NAME = 'DialogTrigger';
var DialogTrigger = React.forwardRef((props, forwardedRef) => {
  const { __scopeDialog, ...triggerProps } = props;
  const context = useDialogContext(TRIGGER_NAME, __scopeDialog);
  const composedTriggerRef = useComposedRefs(forwardedRef, context.triggerRef);
  return /* @__PURE__ */ jsx(Primitive.button, {
    type: 'button',
    'aria-haspopup': 'dialog',
    'aria-expanded': context.open,
    'aria-controls': context.contentId,
    'data-state': getState(context.open),
    ...triggerProps,
    ref: composedTriggerRef,
    onClick: composeEventHandlers(props.onClick, context.onOpenToggle),
  });
});
DialogTrigger.displayName = TRIGGER_NAME;
var PORTAL_NAME = 'DialogPortal';
var [PortalProvider, usePortalContext] = createDialogContext(PORTAL_NAME, { forceMount: void 0 });
var DialogPortal = props => {
  const { __scopeDialog, forceMount, children, container } = props;
  const context = useDialogContext(PORTAL_NAME, __scopeDialog);
  return /* @__PURE__ */ jsx(PortalProvider, {
    scope: __scopeDialog,
    forceMount,
    children: React.Children.map(children, child =>
      /* @__PURE__ */ jsx(Presence, {
        present: forceMount || context.open,
        children: /* @__PURE__ */ jsx(Portal$2, { asChild: true, container, children: child }),
      }),
    ),
  });
};
DialogPortal.displayName = PORTAL_NAME;
var OVERLAY_NAME = 'DialogOverlay';
var DialogOverlay = React.forwardRef((props, forwardedRef) => {
  const portalContext = usePortalContext(OVERLAY_NAME, props.__scopeDialog);
  const { forceMount = portalContext.forceMount, ...overlayProps } = props;
  const context = useDialogContext(OVERLAY_NAME, props.__scopeDialog);
  return context.modal
    ? /* @__PURE__ */ jsx(Presence, {
        present: forceMount || context.open,
        children: /* @__PURE__ */ jsx(DialogOverlayImpl, { ...overlayProps, ref: forwardedRef }),
      })
    : null;
});
DialogOverlay.displayName = OVERLAY_NAME;
var Slot = /* @__PURE__ */ createSlot('DialogOverlay.RemoveScroll');
var DialogOverlayImpl = React.forwardRef((props, forwardedRef) => {
  const { __scopeDialog, ...overlayProps } = props;
  const context = useDialogContext(OVERLAY_NAME, __scopeDialog);
  return (
    // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
    // ie. when `Overlay` and `Content` are siblings
    /* @__PURE__ */ jsx(ReactRemoveScroll, {
      as: Slot,
      allowPinchZoom: true,
      shards: [context.contentRef],
      children: /* @__PURE__ */ jsx(Primitive.div, {
        'data-state': getState(context.open),
        ...overlayProps,
        ref: forwardedRef,
        style: { pointerEvents: 'auto', ...overlayProps.style },
      }),
    })
  );
});
var CONTENT_NAME = 'DialogContent';
var DialogContent = React.forwardRef((props, forwardedRef) => {
  const portalContext = usePortalContext(CONTENT_NAME, props.__scopeDialog);
  const { forceMount = portalContext.forceMount, ...contentProps } = props;
  const context = useDialogContext(CONTENT_NAME, props.__scopeDialog);
  return /* @__PURE__ */ jsx(Presence, {
    present: forceMount || context.open,
    children: context.modal
      ? /* @__PURE__ */ jsx(DialogContentModal, { ...contentProps, ref: forwardedRef })
      : /* @__PURE__ */ jsx(DialogContentNonModal, { ...contentProps, ref: forwardedRef }),
  });
});
DialogContent.displayName = CONTENT_NAME;
var DialogContentModal = React.forwardRef((props, forwardedRef) => {
  const context = useDialogContext(CONTENT_NAME, props.__scopeDialog);
  const contentRef = React.useRef(null);
  const composedRefs = useComposedRefs(forwardedRef, context.contentRef, contentRef);
  React.useEffect(() => {
    const content = contentRef.current;
    if (content) return hideOthers(content);
  }, []);
  return /* @__PURE__ */ jsx(DialogContentImpl, {
    ...props,
    ref: composedRefs,
    trapFocus: context.open,
    disableOutsidePointerEvents: true,
    onCloseAutoFocus: composeEventHandlers(props.onCloseAutoFocus, event => {
      event.preventDefault();
      context.triggerRef.current?.focus();
    }),
    onPointerDownOutside: composeEventHandlers(props.onPointerDownOutside, event => {
      const originalEvent = event.detail.originalEvent;
      const ctrlLeftClick = originalEvent.button === 0 && originalEvent.ctrlKey === true;
      const isRightClick = originalEvent.button === 2 || ctrlLeftClick;
      if (isRightClick) event.preventDefault();
    }),
    onFocusOutside: composeEventHandlers(props.onFocusOutside, event => event.preventDefault()),
  });
});
var DialogContentNonModal = React.forwardRef((props, forwardedRef) => {
  const context = useDialogContext(CONTENT_NAME, props.__scopeDialog);
  const hasInteractedOutsideRef = React.useRef(false);
  const hasPointerDownOutsideRef = React.useRef(false);
  return /* @__PURE__ */ jsx(DialogContentImpl, {
    ...props,
    ref: forwardedRef,
    trapFocus: false,
    disableOutsidePointerEvents: false,
    onCloseAutoFocus: event => {
      props.onCloseAutoFocus?.(event);
      if (!event.defaultPrevented) {
        if (!hasInteractedOutsideRef.current) context.triggerRef.current?.focus();
        event.preventDefault();
      }
      hasInteractedOutsideRef.current = false;
      hasPointerDownOutsideRef.current = false;
    },
    onInteractOutside: event => {
      props.onInteractOutside?.(event);
      if (!event.defaultPrevented) {
        hasInteractedOutsideRef.current = true;
        if (event.detail.originalEvent.type === 'pointerdown') {
          hasPointerDownOutsideRef.current = true;
        }
      }
      const target = event.target;
      const targetIsTrigger = context.triggerRef.current?.contains(target);
      if (targetIsTrigger) event.preventDefault();
      if (event.detail.originalEvent.type === 'focusin' && hasPointerDownOutsideRef.current) {
        event.preventDefault();
      }
    },
  });
});
var DialogContentImpl = React.forwardRef((props, forwardedRef) => {
  const { __scopeDialog, trapFocus, onOpenAutoFocus, onCloseAutoFocus, ...contentProps } = props;
  const context = useDialogContext(CONTENT_NAME, __scopeDialog);
  const contentRef = React.useRef(null);
  const composedRefs = useComposedRefs(forwardedRef, contentRef);
  useFocusGuards();
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [
      /* @__PURE__ */ jsx(FocusScope, {
        asChild: true,
        loop: true,
        trapped: trapFocus,
        onMountAutoFocus: onOpenAutoFocus,
        onUnmountAutoFocus: onCloseAutoFocus,
        children: /* @__PURE__ */ jsx(DismissableLayer, {
          role: 'dialog',
          id: context.contentId,
          'aria-describedby': context.descriptionId,
          'aria-labelledby': context.titleId,
          'data-state': getState(context.open),
          ...contentProps,
          ref: composedRefs,
          onDismiss: () => context.onOpenChange(false),
        }),
      }),
      /* @__PURE__ */ jsxs(Fragment, {
        children: [
          /* @__PURE__ */ jsx(TitleWarning, { titleId: context.titleId }),
          /* @__PURE__ */ jsx(DescriptionWarning, {
            contentRef,
            descriptionId: context.descriptionId,
          }),
        ],
      }),
    ],
  });
});
var TITLE_NAME = 'DialogTitle';
var DialogTitle = React.forwardRef((props, forwardedRef) => {
  const { __scopeDialog, ...titleProps } = props;
  const context = useDialogContext(TITLE_NAME, __scopeDialog);
  return /* @__PURE__ */ jsx(Primitive.h2, {
    id: context.titleId,
    ...titleProps,
    ref: forwardedRef,
  });
});
DialogTitle.displayName = TITLE_NAME;
var DESCRIPTION_NAME = 'DialogDescription';
var DialogDescription = React.forwardRef((props, forwardedRef) => {
  const { __scopeDialog, ...descriptionProps } = props;
  const context = useDialogContext(DESCRIPTION_NAME, __scopeDialog);
  return /* @__PURE__ */ jsx(Primitive.p, {
    id: context.descriptionId,
    ...descriptionProps,
    ref: forwardedRef,
  });
});
DialogDescription.displayName = DESCRIPTION_NAME;
var CLOSE_NAME = 'DialogClose';
var DialogClose = React.forwardRef((props, forwardedRef) => {
  const { __scopeDialog, ...closeProps } = props;
  const context = useDialogContext(CLOSE_NAME, __scopeDialog);
  return /* @__PURE__ */ jsx(Primitive.button, {
    type: 'button',
    ...closeProps,
    ref: forwardedRef,
    onClick: composeEventHandlers(props.onClick, () => context.onOpenChange(false)),
  });
});
DialogClose.displayName = CLOSE_NAME;
function getState(open) {
  return open ? 'open' : 'closed';
}
var TITLE_WARNING_NAME = 'DialogTitleWarning';
var [WarningProvider, useWarningContext] = createContext2(TITLE_WARNING_NAME, {
  contentName: CONTENT_NAME,
  titleName: TITLE_NAME,
  docsSlug: 'dialog',
});
var TitleWarning = ({ titleId }) => {
  const titleWarningContext = useWarningContext(TITLE_WARNING_NAME);
  const MESSAGE = `\`${titleWarningContext.contentName}\` requires a \`${titleWarningContext.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${titleWarningContext.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${titleWarningContext.docsSlug}`;
  React.useEffect(() => {
    if (titleId) {
      const hasTitle = document.getElementById(titleId);
      if (!hasTitle) console.error(MESSAGE);
    }
  }, [MESSAGE, titleId]);
  return null;
};
var DESCRIPTION_WARNING_NAME = 'DialogDescriptionWarning';
var DescriptionWarning = ({ contentRef, descriptionId }) => {
  const descriptionWarningContext = useWarningContext(DESCRIPTION_WARNING_NAME);
  const MESSAGE = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${descriptionWarningContext.contentName}}.`;
  React.useEffect(() => {
    const describedById = contentRef.current?.getAttribute('aria-describedby');
    if (descriptionId && describedById) {
      const hasDescription = document.getElementById(descriptionId);
      if (!hasDescription) console.warn(MESSAGE);
    }
  }, [MESSAGE, contentRef, descriptionId]);
  return null;
};
var Root = Dialog;
var Portal = DialogPortal;
var Overlay = DialogOverlay;
var Content = DialogContent;
var Title = DialogTitle;
var Close = DialogClose;
function createContext(options = {}) {
  const {
    name,
    strict = true,
    hookName = 'useContext',
    providerName = 'Provider',
    errorMessage,
    defaultValue,
  } = options;
  const Context = React__default.createContext(defaultValue);
  Context.displayName = name;
  function Provider(props) {
    const { children, ...context } = props;
    const value = React__default.useMemo(() => context, [context]);
    return /* @__PURE__ */ React__default.createElement(Context.Provider, { value }, children);
  }
  function useContext() {
    const context = React__default.useContext(Context);
    if (!context && strict) {
      const error = new Error(
        errorMessage ??
          `${hookName} returned 'undefined'. Seems you forgot to wrap component within ${providerName}`,
      );
      error.name = 'ContextError';
      throw error;
    }
    return context;
  }
  Provider.displayName = providerName;
  return [Provider, useContext];
}
const [ModalContextProvider, useModalContext] = createContext({
  name: 'ModalContext',
  strict: true,
  hookName: 'useModalContext',
  providerName: 'ModalContextProvider',
});
var $458b0a5536c1a7cf$var$_React_useInsertionEffect;
const $458b0a5536c1a7cf$var$useEarlyEffect =
  typeof document !== 'undefined'
    ? ($458b0a5536c1a7cf$var$_React_useInsertionEffect = React__default['useInsertionEffect']) !==
        null && $458b0a5536c1a7cf$var$_React_useInsertionEffect !== void 0
      ? $458b0a5536c1a7cf$var$_React_useInsertionEffect
      : React__default.useLayoutEffect
    : () => {};
function $458b0a5536c1a7cf$export$40bfa8c7b0832715(value, defaultValue, onChange) {
  let [stateValue, setStateValue] = useState(value || defaultValue);
  let valueRef = useRef(stateValue);
  let isControlledRef = useRef(value !== void 0);
  let isControlled = value !== void 0;
  useEffect(() => {
    let wasControlled = isControlledRef.current;
    if (wasControlled !== isControlled && process.env.NODE_ENV !== 'production')
      console.warn(
        `WARN: A component changed from ${wasControlled ? 'controlled' : 'uncontrolled'} to ${isControlled ? 'controlled' : 'uncontrolled'}.`,
      );
    isControlledRef.current = isControlled;
  }, [isControlled]);
  let currentValue = isControlled ? value : stateValue;
  $458b0a5536c1a7cf$var$useEarlyEffect(() => {
    valueRef.current = currentValue;
  });
  let [, forceUpdate] = useReducer(() => ({}), {});
  let setValue = useCallback(
    (value2, ...args) => {
      let newValue = typeof value2 === 'function' ? value2(valueRef.current) : value2;
      if (!Object.is(valueRef.current, newValue)) {
        valueRef.current = newValue;
        setStateValue(newValue);
        forceUpdate();
        onChange === null || onChange === void 0 ? void 0 : onChange(newValue, ...args);
      }
    },
    [onChange],
  );
  return [currentValue, setValue];
}
const Modal = forwardRefWithAs((props, ref) => {
  const {
    onOpenChange,
    isOpen = true,
    children,
    defaultOpen = false,
    closeOnOverlayClick = true,
    closeOnEscape = true,
    asChild = false,
    className,
    forceMount,
    onOpenAutoFocus,
    onCloseAutoFocus,
    ...htmlProps
  } = props;
  const onChange = open => {
    onOpenChange?.(open);
  };
  const [isOpenValue, setIsOpenValue] = $458b0a5536c1a7cf$export$40bfa8c7b0832715(
    isOpen,
    defaultOpen,
    onChange,
  );
  return /* @__PURE__ */ React__default.createElement(
    ModalContextProvider,
    { onDismiss: () => setIsOpenValue(false) },
    /* @__PURE__ */ React__default.createElement(
      Root,
      { open: isOpenValue, onOpenChange: open => setIsOpenValue(open) },
      /* @__PURE__ */ React__default.createElement(
        Portal,
        { forceMount },
        /* @__PURE__ */ React__default.createElement(
          Overlay,
          {
            className: classNames('spot-modal__overlay', {
              'spot-modal__overlay--visible': isOpen,
              'spot-modal__overlay--disable': !closeOnOverlayClick,
            }),
          },
          /* @__PURE__ */ React__default.createElement(
            Content,
            {
              ref,
              asChild,
              className: classNames('spot-modal', className),
              onEscapeKeyDown: e => {
                if (!closeOnEscape) {
                  e.preventDefault();
                }
              },
              onPointerDownOutside: e => {
                if (!closeOnOverlayClick) {
                  e.preventDefault();
                }
              },
              onOpenAutoFocus: e => onOpenAutoFocus?.(e),
              onCloseAutoFocus: e => onCloseAutoFocus?.(e),
              ...htmlProps,
            },
            children,
          ),
        ),
      ),
    ),
  );
});
const ModalHeading = forwardRef((props, ref) => {
  const { title, secondaryTitle, className, ...htmlProps } = props;
  return /* @__PURE__ */ React__default.createElement(
    Title,
    { ref, asChild: true },
    /* @__PURE__ */ React__default.createElement(
      'div',
      { className: classNames('spot-modal__header', className), ...htmlProps },
      title || secondaryTitle
        ? /* @__PURE__ */ React__default.createElement(
            'div',
            { className: 'spot-modal__titles' },
            secondaryTitle
              ? /* @__PURE__ */ React__default.createElement(
                  'h3',
                  { className: 'spot-modal__secondary-title' },
                  secondaryTitle,
                )
              : null,
            title
              ? /* @__PURE__ */ React__default.createElement(
                  'h2',
                  { className: 'spot-modal__title' },
                  title,
                )
              : null,
          )
        : null,
    ),
  );
});
ModalHeading.displayName = 'ModalHeading';
const ModalContent = forwardRefWithAs((props, ref) => {
  const { children, as: Comp = 'div', className, ...htmlProps } = props;
  return /* @__PURE__ */ React__default.createElement(
    Comp,
    { ref, className: classNames('spot-modal__content', className), ...htmlProps },
    /* @__PURE__ */ React__default.createElement('div', {
      className:
        'spot-modal__content-scroll-shadow-mask spot-modal__content-scroll-shadow-mask--top',
    }),
    /* @__PURE__ */ React__default.createElement(
      'div',
      { className: 'spot-modal__content-wrapper' },
      /* @__PURE__ */ React__default.createElement(
        'div',
        { className: 'spot-modal__copy' },
        children,
      ),
    ),
    /* @__PURE__ */ React__default.createElement('div', {
      className:
        'spot-modal__content-scroll-shadow-mask spot-modal__content-scroll-shadow-mask--bottom',
    }),
  );
});
const ModalFooter = forwardRefWithAs((props, ref) => {
  const {
    as: Comp = 'div',
    children,
    cancelLink,
    className,
    showCancelLink = true,
    ...htmlProps
  } = props;
  const ctx = useModalContext();
  const handleCancelClick = () => {
    cancelLink?.onClick?.();
    ctx?.onDismiss?.();
  };
  return /* @__PURE__ */ React__default.createElement(
    Comp,
    { ref, className: classNames('spot-modal__footer', className), ...htmlProps },
    showCancelLink &&
      /* @__PURE__ */ React__default.createElement(
        'button',
        { onClick: handleCancelClick, className: 'spot-modal__footer-cancel-button' },
        cancelLink?.text ?? 'Cancel',
      ),
    children,
  );
});
const ModalClose = forwardRef((props, ref) => {
  const { ...htmlProps } = props;
  return /* @__PURE__ */ React__default.createElement(
    Close,
    { asChild: true },
    /* @__PURE__ */ React__default.createElement(
      'button',
      { ...htmlProps, ref, 'aria-label': 'close', className: 'spot-modal__header-cancel-button' },
      /* @__PURE__ */ React__default.createElement(Icon, {
        title: 'cancel',
        className: 'spot-modal__header-cancel-button-icon',
      }),
    ),
  );
});
ModalClose.displayName = 'ModalClose';
const BasicModal = forwardRefWithAs(
  (
    {
      onDismiss,
      title,
      secondaryTitle,
      footer,
      cancelLink,
      disableOverlay = false,
      children,
      isOpen = false,
    },
    _ref,
  ) => {
    return /* @__PURE__ */ React__default.createElement(
      Modal,
      { isOpen, onOpenChange: onDismiss, closeOnOverlayClick: !disableOverlay },
      /* @__PURE__ */ React__default.createElement(ModalHeading, { title, secondaryTitle }),
      /* @__PURE__ */ React__default.createElement(ModalContent, null, children),
      /* @__PURE__ */ React__default.createElement(ModalFooter, { cancelLink }, footer),
      /* @__PURE__ */ React__default.createElement(ModalClose, null),
    );
  },
);
const MultiStepModal = forwardRefWithAs(({ steps, onStepChange, ...props }, ref) => {
  const [currentStep, setCurrentStep] = useState(0);
  const changeStep = useCallback(
    directon => {
      setCurrentStep(currentStep2 => {
        const newStep = directon === 'next' ? currentStep2 + 1 : currentStep2 - 1;
        onStepChange?.(newStep);
        return newStep;
      });
    },
    [onStepChange],
  );
  const {
    title,
    secondaryTitle,
    primaryButtonText,
    secondaryButtonText,
    onPrimaryButtonClick,
    content,
  } = steps[currentStep];
  return /* @__PURE__ */ React__default.createElement(
    BasicModal,
    {
      ...props,
      title,
      secondaryTitle,
      ref,
      footer: /* @__PURE__ */ React__default.createElement(
        React__default.Fragment,
        null,
        currentStep > 0
          ? /* @__PURE__ */ React__default.createElement(
              Button,
              {
                onClick: () => {
                  changeStep('prev');
                },
                variant: 'secondary',
              },
              secondaryButtonText ?? 'Previous',
            )
          : null,
        /* @__PURE__ */ React__default.createElement(
          Button,
          {
            onClick: () => {
              if (currentStep < steps.length - 1) {
                changeStep('next');
              }
              onPrimaryButtonClick?.();
            },
          },
          primaryButtonText,
        ),
      ),
    },
    content,
  );
});
const Paging = forwardRefWithAs(
  (
    {
      as,
      size: size2 = 'default',
      defaultPage = 0,
      count: count2 = 0,
      disabled = false,
      children,
      variant = 'default',
      currentPage,
      onPageChange,
      ...props
    },
    ref,
  ) => {
    const [selected, setSelected] = $458b0a5536c1a7cf$export$40bfa8c7b0832715(
      currentPage,
      defaultPage,
      onPageChange,
    );
    const handleSelect = useCallback(
      index2 => {
        setSelected(index2);
        onPageChange?.(index2);
      },
      [onPageChange, setSelected],
    );
    const Component = as ?? 'nav';
    return /* @__PURE__ */ React__default.createElement(
      Component,
      {
        ref,
        className: classNames('spot-paging', {
          [`spot-paging--${size2}`]: size2 !== 'default',
          'spot-paging--disabled': disabled,
        }),
        role: 'navigation',
        'aria-label': 'Pagination Navigation',
        ...props,
      },
      variant === 'complex'
        ? /* @__PURE__ */ React__default.createElement(
            'button',
            {
              disabled: disabled || selected === 0,
              onClick: () => handleSelect(0),
              'aria-label': `First page of ${count2}`,
              className: classNames('spot-paging__button spot-paging__button--first', {
                'spot-paging__button--disabled': selected === 0,
              }),
              title: 'First',
            },
            /* @__PURE__ */ React__default.createElement(Icon, { title: 'double-left' }),
          )
        : null,
      /* @__PURE__ */ React__default.createElement(
        'div',
        { className: 'spot-paging__group' },
        /* @__PURE__ */ React__default.createElement(
          'button',
          {
            disabled: disabled || selected === 0,
            onClick: () => handleSelect(Math.max(0, selected - 1)),
            'aria-label': `Previous page of ${count2}`,
            className: classNames('spot-paging__button spot-paging__button--previous', {
              'spot-paging__button--disabled': selected === 0,
            }),
            title: 'Previous',
          },
          /* @__PURE__ */ React__default.createElement(Icon, { title: 'previous' }),
        ),
        count2 > 0
          ? Array.from(Array(count2).keys()).map(index2 => {
              const isSelected = selected === index2;
              return /* @__PURE__ */ React__default.createElement(
                'button',
                {
                  disabled,
                  key: index2,
                  'aria-current': isSelected ? 'page' : void 0,
                  'aria-label': `Page ${index2 + 1} of ${count2}${isSelected ? ' (current page)' : ''}`,
                  onClick: () => handleSelect(index2),
                  className: classNames('spot-paging__button', {
                    'spot-paging__button--selected': isSelected,
                  }),
                },
                index2 + 1,
              );
            })
          : null,
        /* @__PURE__ */ React__default.createElement(
          'button',
          {
            disabled: disabled || selected === count2 - 1,
            onClick: () => handleSelect((selected + 1) % count2),
            className: classNames('spot-paging__button spot-paging__button--next', {
              'spot-paging__button--disabled': selected === count2 - 1,
            }),
            title: 'Next',
          },
          /* @__PURE__ */ React__default.createElement(Icon, { title: 'next' }),
        ),
      ),
      variant === 'complex'
        ? /* @__PURE__ */ React__default.createElement(
            'button',
            {
              disabled: disabled || selected === count2 - 1,
              onClick: () => handleSelect(count2 - 1),
              'aria-label': `Last page of ${count2}`,
              className: classNames('spot-paging__button spot-paging__button--last', {
                'spot-paging__button--disabled': selected === count2 - 1,
              }),
              title: 'Last',
            },
            /* @__PURE__ */ React__default.createElement(Icon, { title: 'double-right' }),
          )
        : null,
      children,
    );
  },
);
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r)
    if ({}.hasOwnProperty.call(r, n)) {
      if (-1 !== e.indexOf(n)) continue;
      t[n] = r[n];
    }
  return t;
}
function _setPrototypeOf(t, e) {
  return (
    (_setPrototypeOf = Object.setPrototypeOf
      ? Object.setPrototypeOf.bind()
      : function (t2, e2) {
          return ((t2.__proto__ = e2), t2);
        }),
    _setPrototypeOf(t, e)
  );
}
function _inheritsLoose(t, o) {
  ((t.prototype = Object.create(o.prototype)),
    (t.prototype.constructor = t),
    _setPrototypeOf(t, o));
}
function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}
var propTypes = { exports: {} };
var reactIs = { exports: {} };
var reactIs_production_min = {};
var hasRequiredReactIs_production_min;
function requireReactIs_production_min() {
  if (hasRequiredReactIs_production_min) return reactIs_production_min;
  hasRequiredReactIs_production_min = 1;
  var b = 'function' === typeof Symbol && Symbol.for,
    c = b ? /* @__PURE__ */ Symbol.for('react.element') : 60103,
    d = b ? /* @__PURE__ */ Symbol.for('react.portal') : 60106,
    e = b ? /* @__PURE__ */ Symbol.for('react.fragment') : 60107,
    f = b ? /* @__PURE__ */ Symbol.for('react.strict_mode') : 60108,
    g = b ? /* @__PURE__ */ Symbol.for('react.profiler') : 60114,
    h = b ? /* @__PURE__ */ Symbol.for('react.provider') : 60109,
    k = b ? /* @__PURE__ */ Symbol.for('react.context') : 60110,
    l = b ? /* @__PURE__ */ Symbol.for('react.async_mode') : 60111,
    m = b ? /* @__PURE__ */ Symbol.for('react.concurrent_mode') : 60111,
    n = b ? /* @__PURE__ */ Symbol.for('react.forward_ref') : 60112,
    p = b ? /* @__PURE__ */ Symbol.for('react.suspense') : 60113,
    q = b ? /* @__PURE__ */ Symbol.for('react.suspense_list') : 60120,
    r = b ? /* @__PURE__ */ Symbol.for('react.memo') : 60115,
    t = b ? /* @__PURE__ */ Symbol.for('react.lazy') : 60116,
    v = b ? /* @__PURE__ */ Symbol.for('react.block') : 60121,
    w = b ? /* @__PURE__ */ Symbol.for('react.fundamental') : 60117,
    x = b ? /* @__PURE__ */ Symbol.for('react.responder') : 60118,
    y = b ? /* @__PURE__ */ Symbol.for('react.scope') : 60119;
  function z(a) {
    if ('object' === typeof a && null !== a) {
      var u = a.$$typeof;
      switch (u) {
        case c:
          switch (((a = a.type), a)) {
            case l:
            case m:
            case e:
            case g:
            case f:
            case p:
              return a;
            default:
              switch (((a = a && a.$$typeof), a)) {
                case k:
                case n:
                case t:
                case r:
                case h:
                  return a;
                default:
                  return u;
              }
          }
        case d:
          return u;
      }
    }
  }
  function A(a) {
    return z(a) === m;
  }
  reactIs_production_min.AsyncMode = l;
  reactIs_production_min.ConcurrentMode = m;
  reactIs_production_min.ContextConsumer = k;
  reactIs_production_min.ContextProvider = h;
  reactIs_production_min.Element = c;
  reactIs_production_min.ForwardRef = n;
  reactIs_production_min.Fragment = e;
  reactIs_production_min.Lazy = t;
  reactIs_production_min.Memo = r;
  reactIs_production_min.Portal = d;
  reactIs_production_min.Profiler = g;
  reactIs_production_min.StrictMode = f;
  reactIs_production_min.Suspense = p;
  reactIs_production_min.isAsyncMode = function (a) {
    return A(a) || z(a) === l;
  };
  reactIs_production_min.isConcurrentMode = A;
  reactIs_production_min.isContextConsumer = function (a) {
    return z(a) === k;
  };
  reactIs_production_min.isContextProvider = function (a) {
    return z(a) === h;
  };
  reactIs_production_min.isElement = function (a) {
    return 'object' === typeof a && null !== a && a.$$typeof === c;
  };
  reactIs_production_min.isForwardRef = function (a) {
    return z(a) === n;
  };
  reactIs_production_min.isFragment = function (a) {
    return z(a) === e;
  };
  reactIs_production_min.isLazy = function (a) {
    return z(a) === t;
  };
  reactIs_production_min.isMemo = function (a) {
    return z(a) === r;
  };
  reactIs_production_min.isPortal = function (a) {
    return z(a) === d;
  };
  reactIs_production_min.isProfiler = function (a) {
    return z(a) === g;
  };
  reactIs_production_min.isStrictMode = function (a) {
    return z(a) === f;
  };
  reactIs_production_min.isSuspense = function (a) {
    return z(a) === p;
  };
  reactIs_production_min.isValidElementType = function (a) {
    return (
      'string' === typeof a ||
      'function' === typeof a ||
      a === e ||
      a === m ||
      a === g ||
      a === f ||
      a === p ||
      a === q ||
      ('object' === typeof a &&
        null !== a &&
        (a.$$typeof === t ||
          a.$$typeof === r ||
          a.$$typeof === h ||
          a.$$typeof === k ||
          a.$$typeof === n ||
          a.$$typeof === w ||
          a.$$typeof === x ||
          a.$$typeof === y ||
          a.$$typeof === v))
    );
  };
  reactIs_production_min.typeOf = z;
  return reactIs_production_min;
}
var reactIs_development = {};
var hasRequiredReactIs_development;
function requireReactIs_development() {
  if (hasRequiredReactIs_development) return reactIs_development;
  hasRequiredReactIs_development = 1;
  if (process.env.NODE_ENV !== 'production') {
    (function () {
      var hasSymbol = typeof Symbol === 'function' && Symbol.for;
      var REACT_ELEMENT_TYPE = hasSymbol ? /* @__PURE__ */ Symbol.for('react.element') : 60103;
      var REACT_PORTAL_TYPE = hasSymbol ? /* @__PURE__ */ Symbol.for('react.portal') : 60106;
      var REACT_FRAGMENT_TYPE = hasSymbol ? /* @__PURE__ */ Symbol.for('react.fragment') : 60107;
      var REACT_STRICT_MODE_TYPE = hasSymbol
        ? /* @__PURE__ */ Symbol.for('react.strict_mode')
        : 60108;
      var REACT_PROFILER_TYPE = hasSymbol ? /* @__PURE__ */ Symbol.for('react.profiler') : 60114;
      var REACT_PROVIDER_TYPE = hasSymbol ? /* @__PURE__ */ Symbol.for('react.provider') : 60109;
      var REACT_CONTEXT_TYPE = hasSymbol ? /* @__PURE__ */ Symbol.for('react.context') : 60110;
      var REACT_ASYNC_MODE_TYPE = hasSymbol
        ? /* @__PURE__ */ Symbol.for('react.async_mode')
        : 60111;
      var REACT_CONCURRENT_MODE_TYPE = hasSymbol
        ? /* @__PURE__ */ Symbol.for('react.concurrent_mode')
        : 60111;
      var REACT_FORWARD_REF_TYPE = hasSymbol
        ? /* @__PURE__ */ Symbol.for('react.forward_ref')
        : 60112;
      var REACT_SUSPENSE_TYPE = hasSymbol ? /* @__PURE__ */ Symbol.for('react.suspense') : 60113;
      var REACT_SUSPENSE_LIST_TYPE = hasSymbol
        ? /* @__PURE__ */ Symbol.for('react.suspense_list')
        : 60120;
      var REACT_MEMO_TYPE = hasSymbol ? /* @__PURE__ */ Symbol.for('react.memo') : 60115;
      var REACT_LAZY_TYPE = hasSymbol ? /* @__PURE__ */ Symbol.for('react.lazy') : 60116;
      var REACT_BLOCK_TYPE = hasSymbol ? /* @__PURE__ */ Symbol.for('react.block') : 60121;
      var REACT_FUNDAMENTAL_TYPE = hasSymbol
        ? /* @__PURE__ */ Symbol.for('react.fundamental')
        : 60117;
      var REACT_RESPONDER_TYPE = hasSymbol ? /* @__PURE__ */ Symbol.for('react.responder') : 60118;
      var REACT_SCOPE_TYPE = hasSymbol ? /* @__PURE__ */ Symbol.for('react.scope') : 60119;
      function isValidElementType(type) {
        return (
          typeof type === 'string' ||
          typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
          type === REACT_FRAGMENT_TYPE ||
          type === REACT_CONCURRENT_MODE_TYPE ||
          type === REACT_PROFILER_TYPE ||
          type === REACT_STRICT_MODE_TYPE ||
          type === REACT_SUSPENSE_TYPE ||
          type === REACT_SUSPENSE_LIST_TYPE ||
          (typeof type === 'object' &&
            type !== null &&
            (type.$$typeof === REACT_LAZY_TYPE ||
              type.$$typeof === REACT_MEMO_TYPE ||
              type.$$typeof === REACT_PROVIDER_TYPE ||
              type.$$typeof === REACT_CONTEXT_TYPE ||
              type.$$typeof === REACT_FORWARD_REF_TYPE ||
              type.$$typeof === REACT_FUNDAMENTAL_TYPE ||
              type.$$typeof === REACT_RESPONDER_TYPE ||
              type.$$typeof === REACT_SCOPE_TYPE ||
              type.$$typeof === REACT_BLOCK_TYPE))
        );
      }
      function typeOf(object) {
        if (typeof object === 'object' && object !== null) {
          var $$typeof = object.$$typeof;
          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              var type = object.type;
              switch (type) {
                case REACT_ASYNC_MODE_TYPE:
                case REACT_CONCURRENT_MODE_TYPE:
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                  return type;
                default:
                  var $$typeofType = type && type.$$typeof;
                  switch ($$typeofType) {
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;
                    default:
                      return $$typeof;
                  }
              }
            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }
        return void 0;
      }
      var AsyncMode = REACT_ASYNC_MODE_TYPE;
      var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element2 = REACT_ELEMENT_TYPE;
      var ForwardRef2 = REACT_FORWARD_REF_TYPE;
      var Fragment2 = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal2 = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false;
      function isAsyncMode(object) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true;
            console['warn'](
              'The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.',
            );
          }
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
      }
      function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
      }
      function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
      }
      function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
      }
      function isElement2(object) {
        return (
          typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE
        );
      }
      function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
      }
      function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
      }
      function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
      }
      function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
      }
      function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
      }
      function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
      }
      function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
      }
      function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
      }
      reactIs_development.AsyncMode = AsyncMode;
      reactIs_development.ConcurrentMode = ConcurrentMode;
      reactIs_development.ContextConsumer = ContextConsumer;
      reactIs_development.ContextProvider = ContextProvider;
      reactIs_development.Element = Element2;
      reactIs_development.ForwardRef = ForwardRef2;
      reactIs_development.Fragment = Fragment2;
      reactIs_development.Lazy = Lazy;
      reactIs_development.Memo = Memo;
      reactIs_development.Portal = Portal2;
      reactIs_development.Profiler = Profiler;
      reactIs_development.StrictMode = StrictMode;
      reactIs_development.Suspense = Suspense;
      reactIs_development.isAsyncMode = isAsyncMode;
      reactIs_development.isConcurrentMode = isConcurrentMode;
      reactIs_development.isContextConsumer = isContextConsumer;
      reactIs_development.isContextProvider = isContextProvider;
      reactIs_development.isElement = isElement2;
      reactIs_development.isForwardRef = isForwardRef;
      reactIs_development.isFragment = isFragment;
      reactIs_development.isLazy = isLazy;
      reactIs_development.isMemo = isMemo;
      reactIs_development.isPortal = isPortal;
      reactIs_development.isProfiler = isProfiler;
      reactIs_development.isStrictMode = isStrictMode;
      reactIs_development.isSuspense = isSuspense;
      reactIs_development.isValidElementType = isValidElementType;
      reactIs_development.typeOf = typeOf;
    })();
  }
  return reactIs_development;
}
var hasRequiredReactIs;
function requireReactIs() {
  if (hasRequiredReactIs) return reactIs.exports;
  hasRequiredReactIs = 1;
  if (process.env.NODE_ENV === 'production') {
    reactIs.exports = requireReactIs_production_min();
  } else {
    reactIs.exports = requireReactIs_development();
  }
  return reactIs.exports;
}
var objectAssign;
var hasRequiredObjectAssign;
function requireObjectAssign() {
  if (hasRequiredObjectAssign) return objectAssign;
  hasRequiredObjectAssign = 1;
  var getOwnPropertySymbols = Object.getOwnPropertySymbols;
  var hasOwnProperty = Object.prototype.hasOwnProperty;
  var propIsEnumerable = Object.prototype.propertyIsEnumerable;
  function toObject(val) {
    if (val === null || val === void 0) {
      throw new TypeError('Object.assign cannot be called with null or undefined');
    }
    return Object(val);
  }
  function shouldUseNative() {
    try {
      if (!Object.assign) {
        return false;
      }
      var test1 = new String('abc');
      test1[5] = 'de';
      if (Object.getOwnPropertyNames(test1)[0] === '5') {
        return false;
      }
      var test2 = {};
      for (var i = 0; i < 10; i++) {
        test2['_' + String.fromCharCode(i)] = i;
      }
      var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
        return test2[n];
      });
      if (order2.join('') !== '0123456789') {
        return false;
      }
      var test3 = {};
      'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
        test3[letter] = letter;
      });
      if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
        return false;
      }
      return true;
    } catch (err) {
      return false;
    }
  }
  objectAssign = shouldUseNative()
    ? Object.assign
    : function (target, source) {
        var from;
        var to = toObject(target);
        var symbols;
        for (var s = 1; s < arguments.length; s++) {
          from = Object(arguments[s]);
          for (var key in from) {
            if (hasOwnProperty.call(from, key)) {
              to[key] = from[key];
            }
          }
          if (getOwnPropertySymbols) {
            symbols = getOwnPropertySymbols(from);
            for (var i = 0; i < symbols.length; i++) {
              if (propIsEnumerable.call(from, symbols[i])) {
                to[symbols[i]] = from[symbols[i]];
              }
            }
          }
        }
        return to;
      };
  return objectAssign;
}
var ReactPropTypesSecret_1;
var hasRequiredReactPropTypesSecret;
function requireReactPropTypesSecret() {
  if (hasRequiredReactPropTypesSecret) return ReactPropTypesSecret_1;
  hasRequiredReactPropTypesSecret = 1;
  var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
  ReactPropTypesSecret_1 = ReactPropTypesSecret;
  return ReactPropTypesSecret_1;
}
var has;
var hasRequiredHas;
function requireHas() {
  if (hasRequiredHas) return has;
  hasRequiredHas = 1;
  has = Function.call.bind(Object.prototype.hasOwnProperty);
  return has;
}
var checkPropTypes_1;
var hasRequiredCheckPropTypes;
function requireCheckPropTypes() {
  if (hasRequiredCheckPropTypes) return checkPropTypes_1;
  hasRequiredCheckPropTypes = 1;
  var printWarning = function () {};
  if (process.env.NODE_ENV !== 'production') {
    var ReactPropTypesSecret = /* @__PURE__ */ requireReactPropTypesSecret();
    var loggedTypeFailures = {};
    var has2 = /* @__PURE__ */ requireHas();
    printWarning = function (text2) {
      var message = 'Warning: ' + text2;
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        throw new Error(message);
      } catch (x) {}
    };
  }
  function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
    if (process.env.NODE_ENV !== 'production') {
      for (var typeSpecName in typeSpecs) {
        if (has2(typeSpecs, typeSpecName)) {
          var error;
          try {
            if (typeof typeSpecs[typeSpecName] !== 'function') {
              var err = Error(
                (componentName || 'React class') +
                  ': ' +
                  location +
                  ' type `' +
                  typeSpecName +
                  '` is invalid; it must be a function, usually from the `prop-types` package, but received `' +
                  typeof typeSpecs[typeSpecName] +
                  '`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.',
              );
              err.name = 'Invariant Violation';
              throw err;
            }
            error = typeSpecs[typeSpecName](
              values,
              typeSpecName,
              componentName,
              location,
              null,
              ReactPropTypesSecret,
            );
          } catch (ex) {
            error = ex;
          }
          if (error && !(error instanceof Error)) {
            printWarning(
              (componentName || 'React class') +
                ': type specification of ' +
                location +
                ' `' +
                typeSpecName +
                '` is invalid; the type checker function must return `null` or an `Error` but returned a ' +
                typeof error +
                '. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).',
            );
          }
          if (error instanceof Error && !(error.message in loggedTypeFailures)) {
            loggedTypeFailures[error.message] = true;
            var stack = getStack ? getStack() : '';
            printWarning(
              'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : ''),
            );
          }
        }
      }
    }
  }
  checkPropTypes.resetWarningCache = function () {
    if (process.env.NODE_ENV !== 'production') {
      loggedTypeFailures = {};
    }
  };
  checkPropTypes_1 = checkPropTypes;
  return checkPropTypes_1;
}
var factoryWithTypeCheckers;
var hasRequiredFactoryWithTypeCheckers;
function requireFactoryWithTypeCheckers() {
  if (hasRequiredFactoryWithTypeCheckers) return factoryWithTypeCheckers;
  hasRequiredFactoryWithTypeCheckers = 1;
  var ReactIs = requireReactIs();
  var assign = requireObjectAssign();
  var ReactPropTypesSecret = /* @__PURE__ */ requireReactPropTypesSecret();
  var has2 = /* @__PURE__ */ requireHas();
  var checkPropTypes = /* @__PURE__ */ requireCheckPropTypes();
  var printWarning = function () {};
  if (process.env.NODE_ENV !== 'production') {
    printWarning = function (text2) {
      var message = 'Warning: ' + text2;
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        throw new Error(message);
      } catch (x) {}
    };
  }
  function emptyFunctionThatReturnsNull() {
    return null;
  }
  factoryWithTypeCheckers = function (isValidElement2, throwOnDirectAccess) {
    var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = '@@iterator';
    function getIteratorFn(maybeIterable) {
      var iteratorFn =
        maybeIterable &&
        ((ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL]) ||
          maybeIterable[FAUX_ITERATOR_SYMBOL]);
      if (typeof iteratorFn === 'function') {
        return iteratorFn;
      }
    }
    var ANONYMOUS = '<<anonymous>>';
    var ReactPropTypes = {
      array: createPrimitiveTypeChecker('array'),
      bigint: createPrimitiveTypeChecker('bigint'),
      bool: createPrimitiveTypeChecker('boolean'),
      func: createPrimitiveTypeChecker('function'),
      number: createPrimitiveTypeChecker('number'),
      object: createPrimitiveTypeChecker('object'),
      string: createPrimitiveTypeChecker('string'),
      symbol: createPrimitiveTypeChecker('symbol'),
      any: createAnyTypeChecker(),
      arrayOf: createArrayOfTypeChecker,
      element: createElementTypeChecker(),
      elementType: createElementTypeTypeChecker(),
      instanceOf: createInstanceTypeChecker,
      node: createNodeChecker(),
      objectOf: createObjectOfTypeChecker,
      oneOf: createEnumTypeChecker,
      oneOfType: createUnionTypeChecker,
      shape: createShapeTypeChecker,
      exact: createStrictShapeTypeChecker,
    };
    function is(x, y) {
      if (x === y) {
        return x !== 0 || 1 / x === 1 / y;
      } else {
        return x !== x && y !== y;
      }
    }
    function PropTypeError(message, data) {
      this.message = message;
      this.data = data && typeof data === 'object' ? data : {};
      this.stack = '';
    }
    PropTypeError.prototype = Error.prototype;
    function createChainableTypeChecker(validate) {
      if (process.env.NODE_ENV !== 'production') {
        var manualPropTypeCallCache = {};
        var manualPropTypeWarningCount = 0;
      }
      function checkType(
        isRequired,
        props,
        propName,
        componentName,
        location,
        propFullName,
        secret,
      ) {
        componentName = componentName || ANONYMOUS;
        propFullName = propFullName || propName;
        if (secret !== ReactPropTypesSecret) {
          if (throwOnDirectAccess) {
            var err = new Error(
              'Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types',
            );
            err.name = 'Invariant Violation';
            throw err;
          } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
            var cacheKey = componentName + ':' + propName;
            if (
              !manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
              manualPropTypeWarningCount < 3
            ) {
              printWarning(
                'You are manually calling a React.PropTypes validation function for the `' +
                  propFullName +
                  '` prop on `' +
                  componentName +
                  '`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details.',
              );
              manualPropTypeCallCache[cacheKey] = true;
              manualPropTypeWarningCount++;
            }
          }
        }
        if (props[propName] == null) {
          if (isRequired) {
            if (props[propName] === null) {
              return new PropTypeError(
                'The ' +
                  location +
                  ' `' +
                  propFullName +
                  '` is marked as required ' +
                  ('in `' + componentName + '`, but its value is `null`.'),
              );
            }
            return new PropTypeError(
              'The ' +
                location +
                ' `' +
                propFullName +
                '` is marked as required in ' +
                ('`' + componentName + '`, but its value is `undefined`.'),
            );
          }
          return null;
        } else {
          return validate(props, propName, componentName, location, propFullName);
        }
      }
      var chainedCheckType = checkType.bind(null, false);
      chainedCheckType.isRequired = checkType.bind(null, true);
      return chainedCheckType;
    }
    function createPrimitiveTypeChecker(expectedType) {
      function validate(props, propName, componentName, location, propFullName, secret) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== expectedType) {
          var preciseType = getPreciseType(propValue);
          return new PropTypeError(
            'Invalid ' +
              location +
              ' `' +
              propFullName +
              '` of type ' +
              ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') +
              ('`' + expectedType + '`.'),
            { expectedType },
          );
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createAnyTypeChecker() {
      return createChainableTypeChecker(emptyFunctionThatReturnsNull);
    }
    function createArrayOfTypeChecker(typeChecker) {
      function validate(props, propName, componentName, location, propFullName) {
        if (typeof typeChecker !== 'function') {
          return new PropTypeError(
            'Property `' +
              propFullName +
              '` of component `' +
              componentName +
              '` has invalid PropType notation inside arrayOf.',
          );
        }
        var propValue = props[propName];
        if (!Array.isArray(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError(
            'Invalid ' +
              location +
              ' `' +
              propFullName +
              '` of type ' +
              ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'),
          );
        }
        for (var i = 0; i < propValue.length; i++) {
          var error = typeChecker(
            propValue,
            i,
            componentName,
            location,
            propFullName + '[' + i + ']',
            ReactPropTypesSecret,
          );
          if (error instanceof Error) {
            return error;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createElementTypeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        if (!isValidElement2(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError(
            'Invalid ' +
              location +
              ' `' +
              propFullName +
              '` of type ' +
              ('`' +
                propType +
                '` supplied to `' +
                componentName +
                '`, expected a single ReactElement.'),
          );
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createElementTypeTypeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        if (!ReactIs.isValidElementType(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError(
            'Invalid ' +
              location +
              ' `' +
              propFullName +
              '` of type ' +
              ('`' +
                propType +
                '` supplied to `' +
                componentName +
                '`, expected a single ReactElement type.'),
          );
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createInstanceTypeChecker(expectedClass) {
      function validate(props, propName, componentName, location, propFullName) {
        if (!(props[propName] instanceof expectedClass)) {
          var expectedClassName = expectedClass.name || ANONYMOUS;
          var actualClassName = getClassName(props[propName]);
          return new PropTypeError(
            'Invalid ' +
              location +
              ' `' +
              propFullName +
              '` of type ' +
              ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') +
              ('instance of `' + expectedClassName + '`.'),
          );
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createEnumTypeChecker(expectedValues) {
      if (!Array.isArray(expectedValues)) {
        if (process.env.NODE_ENV !== 'production') {
          if (arguments.length > 1) {
            printWarning(
              'Invalid arguments supplied to oneOf, expected an array, got ' +
                arguments.length +
                ' arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).',
            );
          } else {
            printWarning('Invalid argument supplied to oneOf, expected an array.');
          }
        }
        return emptyFunctionThatReturnsNull;
      }
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        for (var i = 0; i < expectedValues.length; i++) {
          if (is(propValue, expectedValues[i])) {
            return null;
          }
        }
        var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
          var type = getPreciseType(value);
          if (type === 'symbol') {
            return String(value);
          }
          return value;
        });
        return new PropTypeError(
          'Invalid ' +
            location +
            ' `' +
            propFullName +
            '` of value `' +
            String(propValue) +
            '` ' +
            ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'),
        );
      }
      return createChainableTypeChecker(validate);
    }
    function createObjectOfTypeChecker(typeChecker) {
      function validate(props, propName, componentName, location, propFullName) {
        if (typeof typeChecker !== 'function') {
          return new PropTypeError(
            'Property `' +
              propFullName +
              '` of component `' +
              componentName +
              '` has invalid PropType notation inside objectOf.',
          );
        }
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== 'object') {
          return new PropTypeError(
            'Invalid ' +
              location +
              ' `' +
              propFullName +
              '` of type ' +
              ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'),
          );
        }
        for (var key in propValue) {
          if (has2(propValue, key)) {
            var error = typeChecker(
              propValue,
              key,
              componentName,
              location,
              propFullName + '.' + key,
              ReactPropTypesSecret,
            );
            if (error instanceof Error) {
              return error;
            }
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createUnionTypeChecker(arrayOfTypeCheckers) {
      if (!Array.isArray(arrayOfTypeCheckers)) {
        process.env.NODE_ENV !== 'production'
          ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.')
          : void 0;
        return emptyFunctionThatReturnsNull;
      }
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (typeof checker !== 'function') {
          printWarning(
            'Invalid argument supplied to oneOfType. Expected an array of check functions, but received ' +
              getPostfixForTypeWarning(checker) +
              ' at index ' +
              i +
              '.',
          );
          return emptyFunctionThatReturnsNull;
        }
      }
      function validate(props, propName, componentName, location, propFullName) {
        var expectedTypes = [];
        for (var i2 = 0; i2 < arrayOfTypeCheckers.length; i2++) {
          var checker2 = arrayOfTypeCheckers[i2];
          var checkerResult = checker2(
            props,
            propName,
            componentName,
            location,
            propFullName,
            ReactPropTypesSecret,
          );
          if (checkerResult == null) {
            return null;
          }
          if (checkerResult.data && has2(checkerResult.data, 'expectedType')) {
            expectedTypes.push(checkerResult.data.expectedType);
          }
        }
        var expectedTypesMessage =
          expectedTypes.length > 0
            ? ', expected one of type [' + expectedTypes.join(', ') + ']'
            : '';
        return new PropTypeError(
          'Invalid ' +
            location +
            ' `' +
            propFullName +
            '` supplied to ' +
            ('`' + componentName + '`' + expectedTypesMessage + '.'),
        );
      }
      return createChainableTypeChecker(validate);
    }
    function createNodeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        if (!isNode2(props[propName])) {
          return new PropTypeError(
            'Invalid ' +
              location +
              ' `' +
              propFullName +
              '` supplied to ' +
              ('`' + componentName + '`, expected a ReactNode.'),
          );
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function invalidValidatorError(componentName, location, propFullName, key, type) {
      return new PropTypeError(
        (componentName || 'React class') +
          ': ' +
          location +
          ' type `' +
          propFullName +
          '.' +
          key +
          '` is invalid; it must be a function, usually from the `prop-types` package, but received `' +
          type +
          '`.',
      );
    }
    function createShapeTypeChecker(shapeTypes) {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== 'object') {
          return new PropTypeError(
            'Invalid ' +
              location +
              ' `' +
              propFullName +
              '` of type `' +
              propType +
              '` ' +
              ('supplied to `' + componentName + '`, expected `object`.'),
          );
        }
        for (var key in shapeTypes) {
          var checker = shapeTypes[key];
          if (typeof checker !== 'function') {
            return invalidValidatorError(
              componentName,
              location,
              propFullName,
              key,
              getPreciseType(checker),
            );
          }
          var error = checker(
            propValue,
            key,
            componentName,
            location,
            propFullName + '.' + key,
            ReactPropTypesSecret,
          );
          if (error) {
            return error;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createStrictShapeTypeChecker(shapeTypes) {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== 'object') {
          return new PropTypeError(
            'Invalid ' +
              location +
              ' `' +
              propFullName +
              '` of type `' +
              propType +
              '` ' +
              ('supplied to `' + componentName + '`, expected `object`.'),
          );
        }
        var allKeys = assign({}, props[propName], shapeTypes);
        for (var key in allKeys) {
          var checker = shapeTypes[key];
          if (has2(shapeTypes, key) && typeof checker !== 'function') {
            return invalidValidatorError(
              componentName,
              location,
              propFullName,
              key,
              getPreciseType(checker),
            );
          }
          if (!checker) {
            return new PropTypeError(
              'Invalid ' +
                location +
                ' `' +
                propFullName +
                '` key `' +
                key +
                '` supplied to `' +
                componentName +
                '`.\nBad object: ' +
                JSON.stringify(props[propName], null, '  ') +
                '\nValid keys: ' +
                JSON.stringify(Object.keys(shapeTypes), null, '  '),
            );
          }
          var error = checker(
            propValue,
            key,
            componentName,
            location,
            propFullName + '.' + key,
            ReactPropTypesSecret,
          );
          if (error) {
            return error;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function isNode2(propValue) {
      switch (typeof propValue) {
        case 'number':
        case 'string':
        case 'undefined':
          return true;
        case 'boolean':
          return !propValue;
        case 'object':
          if (Array.isArray(propValue)) {
            return propValue.every(isNode2);
          }
          if (propValue === null || isValidElement2(propValue)) {
            return true;
          }
          var iteratorFn = getIteratorFn(propValue);
          if (iteratorFn) {
            var iterator = iteratorFn.call(propValue);
            var step;
            if (iteratorFn !== propValue.entries) {
              while (!(step = iterator.next()).done) {
                if (!isNode2(step.value)) {
                  return false;
                }
              }
            } else {
              while (!(step = iterator.next()).done) {
                var entry = step.value;
                if (entry) {
                  if (!isNode2(entry[1])) {
                    return false;
                  }
                }
              }
            }
          } else {
            return false;
          }
          return true;
        default:
          return false;
      }
    }
    function isSymbol(propType, propValue) {
      if (propType === 'symbol') {
        return true;
      }
      if (!propValue) {
        return false;
      }
      if (propValue['@@toStringTag'] === 'Symbol') {
        return true;
      }
      if (typeof Symbol === 'function' && propValue instanceof Symbol) {
        return true;
      }
      return false;
    }
    function getPropType(propValue) {
      var propType = typeof propValue;
      if (Array.isArray(propValue)) {
        return 'array';
      }
      if (propValue instanceof RegExp) {
        return 'object';
      }
      if (isSymbol(propType, propValue)) {
        return 'symbol';
      }
      return propType;
    }
    function getPreciseType(propValue) {
      if (typeof propValue === 'undefined' || propValue === null) {
        return '' + propValue;
      }
      var propType = getPropType(propValue);
      if (propType === 'object') {
        if (propValue instanceof Date) {
          return 'date';
        } else if (propValue instanceof RegExp) {
          return 'regexp';
        }
      }
      return propType;
    }
    function getPostfixForTypeWarning(value) {
      var type = getPreciseType(value);
      switch (type) {
        case 'array':
        case 'object':
          return 'an ' + type;
        case 'boolean':
        case 'date':
        case 'regexp':
          return 'a ' + type;
        default:
          return type;
      }
    }
    function getClassName(propValue) {
      if (!propValue.constructor || !propValue.constructor.name) {
        return ANONYMOUS;
      }
      return propValue.constructor.name;
    }
    ReactPropTypes.checkPropTypes = checkPropTypes;
    ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
  };
  return factoryWithTypeCheckers;
}
var factoryWithThrowingShims;
var hasRequiredFactoryWithThrowingShims;
function requireFactoryWithThrowingShims() {
  if (hasRequiredFactoryWithThrowingShims) return factoryWithThrowingShims;
  hasRequiredFactoryWithThrowingShims = 1;
  var ReactPropTypesSecret = /* @__PURE__ */ requireReactPropTypesSecret();
  function emptyFunction() {}
  function emptyFunctionWithReset() {}
  emptyFunctionWithReset.resetWarningCache = emptyFunction;
  factoryWithThrowingShims = function () {
    function shim(props, propName, componentName, location, propFullName, secret) {
      if (secret === ReactPropTypesSecret) {
        return;
      }
      var err = new Error(
        'Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types',
      );
      err.name = 'Invariant Violation';
      throw err;
    }
    shim.isRequired = shim;
    function getShim() {
      return shim;
    }
    var ReactPropTypes = {
      array: shim,
      bigint: shim,
      bool: shim,
      func: shim,
      number: shim,
      object: shim,
      string: shim,
      symbol: shim,
      any: shim,
      arrayOf: getShim,
      element: shim,
      elementType: shim,
      instanceOf: getShim,
      node: shim,
      objectOf: getShim,
      oneOf: getShim,
      oneOfType: getShim,
      shape: getShim,
      exact: getShim,
      checkPropTypes: emptyFunctionWithReset,
      resetWarningCache: emptyFunction,
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
  };
  return factoryWithThrowingShims;
}
var hasRequiredPropTypes;
function requirePropTypes() {
  if (hasRequiredPropTypes) return propTypes.exports;
  hasRequiredPropTypes = 1;
  if (process.env.NODE_ENV !== 'production') {
    var ReactIs = requireReactIs();
    var throwOnDirectAccess = true;
    propTypes.exports = /* @__PURE__ */ requireFactoryWithTypeCheckers()(
      ReactIs.isElement,
      throwOnDirectAccess,
    );
  } else {
    propTypes.exports = /* @__PURE__ */ requireFactoryWithThrowingShims()();
  }
  return propTypes.exports;
}
var propTypesExports = /* @__PURE__ */ requirePropTypes();
const PropTypes = /* @__PURE__ */ getDefaultExportFromCjs(propTypesExports);
const config = { disabled: false };
var timeoutsShape =
  process.env.NODE_ENV !== 'production'
    ? PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.shape({
          enter: PropTypes.number,
          exit: PropTypes.number,
          appear: PropTypes.number,
        }).isRequired,
      ])
    : null;
process.env.NODE_ENV !== 'production'
  ? PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({
        enter: PropTypes.string,
        exit: PropTypes.string,
        active: PropTypes.string,
      }),
      PropTypes.shape({
        enter: PropTypes.string,
        enterDone: PropTypes.string,
        enterActive: PropTypes.string,
        exit: PropTypes.string,
        exitDone: PropTypes.string,
        exitActive: PropTypes.string,
      }),
    ])
  : null;
const TransitionGroupContext = React__default.createContext(null);
var forceReflow = function forceReflow2(node) {
  return node.scrollTop;
};
var UNMOUNTED = 'unmounted';
var EXITED = 'exited';
var ENTERING = 'entering';
var ENTERED = 'entered';
var EXITING = 'exiting';
var Transition = /* @__PURE__ */ (function (_React$Component) {
  _inheritsLoose(Transition2, _React$Component);
  function Transition2(props, context) {
    var _this;
    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context;
    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;
    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }
    _this.state = { status: initialStatus };
    _this.nextCallback = null;
    return _this;
  }
  Transition2.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;
    if (nextIn && prevState.status === UNMOUNTED) {
      return { status: EXITED };
    }
    return null;
  };
  var _proto = Transition2.prototype;
  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };
  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;
    if (prevProps !== this.props) {
      var status = this.state.status;
      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }
    this.updateStatus(false, nextStatus);
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };
  _proto.getTimeouts = function getTimeouts() {
    var timeout2 = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout2;
    if (timeout2 != null && typeof timeout2 !== 'number') {
      exit = timeout2.exit;
      enter = timeout2.enter;
      appear = timeout2.appear !== void 0 ? timeout2.appear : enter;
    }
    return { exit, enter, appear };
  };
  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }
    if (nextStatus !== null) {
      this.cancelNextCallback();
      if (nextStatus === ENTERING) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var node = this.props.nodeRef
            ? this.props.nodeRef.current
            : ReactDOM__default.findDOMNode(this);
          if (node) forceReflow(node);
        }
        this.performEnter(mounting);
      } else {
        this.performExit();
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({ status: UNMOUNTED });
    }
  };
  _proto.performEnter = function performEnter(mounting) {
    var _this2 = this;
    var enter = this.props.enter;
    var appearing = this.context ? this.context.isMounting : mounting;
    var _ref2 = this.props.nodeRef ? [appearing] : [ReactDOM__default.findDOMNode(this), appearing],
      maybeNode = _ref2[0],
      maybeAppearing = _ref2[1];
    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter;
    if ((!mounting && !enter) || config.disabled) {
      this.safeSetState({ status: ENTERED }, function () {
        _this2.props.onEntered(maybeNode);
      });
      return;
    }
    this.props.onEnter(maybeNode, maybeAppearing);
    this.safeSetState({ status: ENTERING }, function () {
      _this2.props.onEntering(maybeNode, maybeAppearing);
      _this2.onTransitionEnd(enterTimeout, function () {
        _this2.safeSetState({ status: ENTERED }, function () {
          _this2.props.onEntered(maybeNode, maybeAppearing);
        });
      });
    });
  };
  _proto.performExit = function performExit() {
    var _this3 = this;
    var exit = this.props.exit;
    var timeouts = this.getTimeouts();
    var maybeNode = this.props.nodeRef ? void 0 : ReactDOM__default.findDOMNode(this);
    if (!exit || config.disabled) {
      this.safeSetState({ status: EXITED }, function () {
        _this3.props.onExited(maybeNode);
      });
      return;
    }
    this.props.onExit(maybeNode);
    this.safeSetState({ status: EXITING }, function () {
      _this3.props.onExiting(maybeNode);
      _this3.onTransitionEnd(timeouts.exit, function () {
        _this3.safeSetState({ status: EXITED }, function () {
          _this3.props.onExited(maybeNode);
        });
      });
    });
  };
  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };
  _proto.safeSetState = function safeSetState(nextState, callback) {
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };
  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;
    var active = true;
    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };
    this.nextCallback.cancel = function () {
      active = false;
    };
    return this.nextCallback;
  };
  _proto.onTransitionEnd = function onTransitionEnd(timeout2, handler) {
    this.setNextCallback(handler);
    var node = this.props.nodeRef
      ? this.props.nodeRef.current
      : ReactDOM__default.findDOMNode(this);
    var doesNotHaveTimeoutOrListener = timeout2 == null && !this.props.addEndListener;
    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }
    if (this.props.addEndListener) {
      var _ref3 = this.props.nodeRef ? [this.nextCallback] : [node, this.nextCallback],
        maybeNode = _ref3[0],
        maybeNextCallback = _ref3[1];
      this.props.addEndListener(maybeNode, maybeNextCallback);
    }
    if (timeout2 != null) {
      setTimeout(this.nextCallback, timeout2);
    }
  };
  _proto.render = function render() {
    var status = this.state.status;
    if (status === UNMOUNTED) {
      return null;
    }
    var _this$props = this.props,
      children = _this$props.children;
    _this$props.in;
    _this$props.mountOnEnter;
    _this$props.unmountOnExit;
    _this$props.appear;
    _this$props.enter;
    _this$props.exit;
    _this$props.timeout;
    _this$props.addEndListener;
    _this$props.onEnter;
    _this$props.onEntering;
    _this$props.onEntered;
    _this$props.onExit;
    _this$props.onExiting;
    _this$props.onExited;
    _this$props.nodeRef;
    var childProps = _objectWithoutPropertiesLoose(_this$props, [
      'children',
      'in',
      'mountOnEnter',
      'unmountOnExit',
      'appear',
      'enter',
      'exit',
      'timeout',
      'addEndListener',
      'onEnter',
      'onEntering',
      'onEntered',
      'onExit',
      'onExiting',
      'onExited',
      'nodeRef',
    ]);
    return (
      // allows for nested Transitions
      /* @__PURE__ */ React__default.createElement(
        TransitionGroupContext.Provider,
        { value: null },
        typeof children === 'function'
          ? children(status, childProps)
          : React__default.cloneElement(React__default.Children.only(children), childProps),
      )
    );
  };
  return Transition2;
})(React__default.Component);
Transition.contextType = TransitionGroupContext;
Transition.propTypes =
  process.env.NODE_ENV !== 'production'
    ? {
        /**
         * A React reference to DOM element that need to transition:
         * https://stackoverflow.com/a/51127130/4671932
         *
         *   - When `nodeRef` prop is used, `node` is not passed to callback functions
         *      (e.g. `onEnter`) because user already has direct access to the node.
         *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
         *     `nodeRef` need to be provided to `Transition` with changed `key` prop
         *     (see
         *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
         */
        nodeRef: PropTypes.shape({
          current:
            typeof Element === 'undefined'
              ? PropTypes.any
              : function (propValue, key, componentName, location, propFullName, secret) {
                  var value = propValue[key];
                  return PropTypes.instanceOf(
                    value && 'ownerDocument' in value
                      ? value.ownerDocument.defaultView.Element
                      : Element,
                  )(propValue, key, componentName, location, propFullName, secret);
                },
        }),
        /**
         * A `function` child can be used instead of a React element. This function is
         * called with the current transition status (`'entering'`, `'entered'`,
         * `'exiting'`, `'exited'`), which can be used to apply context
         * specific props to a component.
         *
         * ```jsx
         * <Transition in={this.state.in} timeout={150}>
         *   {state => (
         *     <MyComponent className={`fade fade-${state}`} />
         *   )}
         * </Transition>
         * ```
         */
        children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired])
          .isRequired,
        /**
         * Show the component; triggers the enter or exit states
         */
        in: PropTypes.bool,
        /**
         * By default the child component is mounted immediately along with
         * the parent `Transition` component. If you want to "lazy mount" the component on the
         * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
         * mounted, even on "exited", unless you also specify `unmountOnExit`.
         */
        mountOnEnter: PropTypes.bool,
        /**
         * By default the child component stays mounted after it reaches the `'exited'` state.
         * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
         */
        unmountOnExit: PropTypes.bool,
        /**
         * By default the child component does not perform the enter transition when
         * it first mounts, regardless of the value of `in`. If you want this
         * behavior, set both `appear` and `in` to `true`.
         *
         * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
         * > only adds an additional enter transition. However, in the
         * > `<CSSTransition>` component that first enter transition does result in
         * > additional `.appear-*` classes, that way you can choose to style it
         * > differently.
         */
        appear: PropTypes.bool,
        /**
         * Enable or disable enter transitions.
         */
        enter: PropTypes.bool,
        /**
         * Enable or disable exit transitions.
         */
        exit: PropTypes.bool,
        /**
         * The duration of the transition, in milliseconds.
         * Required unless `addEndListener` is provided.
         *
         * You may specify a single timeout for all transitions:
         *
         * ```jsx
         * timeout={500}
         * ```
         *
         * or individually:
         *
         * ```jsx
         * timeout={{
         *  appear: 500,
         *  enter: 300,
         *  exit: 500,
         * }}
         * ```
         *
         * - `appear` defaults to the value of `enter`
         * - `enter` defaults to `0`
         * - `exit` defaults to `0`
         *
         * @type {number | { enter?: number, exit?: number, appear?: number }}
         */
        timeout: function timeout(props) {
          var pt = timeoutsShape;
          if (!props.addEndListener) pt = pt.isRequired;
          for (
            var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1;
            _key < _len;
            _key++
          ) {
            args[_key - 1] = arguments[_key];
          }
          return pt.apply(void 0, [props].concat(args));
        },
        /**
         * Add a custom transition end trigger. Called with the transitioning
         * DOM node and a `done` callback. Allows for more fine grained transition end
         * logic. Timeouts are still used as a fallback if provided.
         *
         * **Note**: when `nodeRef` prop is passed, `node` is not passed.
         *
         * ```jsx
         * addEndListener={(node, done) => {
         *   // use the css transitionend event to mark the finish of a transition
         *   node.addEventListener('transitionend', done, false);
         * }}
         * ```
         */
        addEndListener: PropTypes.func,
        /**
         * Callback fired before the "entering" status is applied. An extra parameter
         * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
         *
         * **Note**: when `nodeRef` prop is passed, `node` is not passed.
         *
         * @type Function(node: HtmlElement, isAppearing: bool) -> void
         */
        onEnter: PropTypes.func,
        /**
         * Callback fired after the "entering" status is applied. An extra parameter
         * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
         *
         * **Note**: when `nodeRef` prop is passed, `node` is not passed.
         *
         * @type Function(node: HtmlElement, isAppearing: bool)
         */
        onEntering: PropTypes.func,
        /**
         * Callback fired after the "entered" status is applied. An extra parameter
         * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
         *
         * **Note**: when `nodeRef` prop is passed, `node` is not passed.
         *
         * @type Function(node: HtmlElement, isAppearing: bool) -> void
         */
        onEntered: PropTypes.func,
        /**
         * Callback fired before the "exiting" status is applied.
         *
         * **Note**: when `nodeRef` prop is passed, `node` is not passed.
         *
         * @type Function(node: HtmlElement) -> void
         */
        onExit: PropTypes.func,
        /**
         * Callback fired after the "exiting" status is applied.
         *
         * **Note**: when `nodeRef` prop is passed, `node` is not passed.
         *
         * @type Function(node: HtmlElement) -> void
         */
        onExiting: PropTypes.func,
        /**
         * Callback fired after the "exited" status is applied.
         *
         * **Note**: when `nodeRef` prop is passed, `node` is not passed
         *
         * @type Function(node: HtmlElement) -> void
         */
        onExited: PropTypes.func,
      }
    : {};
function noop2() {}
Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop2,
  onEntering: noop2,
  onEntered: noop2,
  onExit: noop2,
  onExiting: noop2,
  onExited: noop2,
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;
const mergeRefs = (...refs) => {
  return value => {
    refs.forEach(ref => {
      if (typeof ref === 'function') {
        ref(value);
      } else if (ref) {
        ref.current = value;
      }
    });
  };
};
const PANEL_SIZE_LIST = ['xsmall', 'default', 'large'];
const PANEL_PLACEMENT_LIST = ['left', 'right', 'bottom'];
const animationPlacementInMap$1 = {
  left: 'slideInLeft',
  right: 'slideInRight',
  bottom: 'slideInUp',
};
const animationPlacementOutMap$1 = {
  left: 'slideOutLeft',
  right: 'slideOutRight',
  bottom: 'slideOutDown',
};
const Panel = forwardRefWithAs((props, ref) => {
  const {
    as: Component = 'div',
    className,
    children,
    headerTitle,
    panelState,
    onStateChange,
    defaultState = 'closed',
    overlay = 'default',
    size: size2 = 'default',
    placement = 'left',
    forceMount,
    closeOnEscape = true,
    onOpenAutoFocus,
    onCloseAutoFocus,
    onClose,
    ...htmlProps
  } = props;
  const onChange = useCallback(
    panelState2 => {
      onStateChange?.(panelState2);
    },
    [onStateChange],
  );
  const [controlledPanelState, setControlledPanelState] = $458b0a5536c1a7cf$export$40bfa8c7b0832715(
    panelState,
    defaultState,
    onChange,
  );
  const isOpen = controlledPanelState === 'open';
  const handleOpenChange = useCallback(
    open => {
      setControlledPanelState(open ? 'open' : 'closed');
    },
    [setControlledPanelState],
  );
  const localRef = useRef(null);
  const mergedRefs = mergeRefs(localRef, ref);
  return /* @__PURE__ */ React__default.createElement(
    Transition,
    {
      as: Component,
      nodeRef: mergedRefs,
      in: isOpen,
      timeout: 1e3,
      mountOnEnter: true,
      unmountOnExit: true,
    },
    state => {
      return /* @__PURE__ */ React__default.createElement(
        Root,
        { open: isOpen, onOpenChange: handleOpenChange },
        /* @__PURE__ */ React__default.createElement(
          Portal,
          { forceMount },
          /* @__PURE__ */ React__default.createElement(
            Overlay,
            {
              forceMount: true,
              className: classNames('spot-panel', {
                'spot-panel__overlay': overlay !== 'none',
                'spot-panel--visible': controlledPanelState === 'open',
                'spot-panel--overlay--disable': overlay === 'disabled',
                [`spot-panel--open-${placement}`]: placement,
                [`spot-panel--${size2}`]: size2,
              }),
            },
            /* @__PURE__ */ React__default.createElement(
              Content,
              {
                forceMount: true,
                ref: mergedRefs,
                className: classNames(
                  'spot-panel__content',
                  {
                    animated: true,
                    [animationPlacementInMap$1[placement]]: state === 'entering',
                    [animationPlacementOutMap$1[placement]]: state === 'exiting',
                  },
                  className,
                ),
                onEscapeKeyDown: e => {
                  if (!closeOnEscape) {
                    e.preventDefault();
                  }
                },
                onPointerDownOutside: e => {
                  if (overlay === 'disabled') {
                    e.preventDefault();
                  }
                },
                onOpenAutoFocus,
                onCloseAutoFocus,
                ...htmlProps,
              },
              /* @__PURE__ */ React__default.createElement(
                'div',
                { className: 'spot-panel__header' },
                /* @__PURE__ */ React__default.createElement(
                  Title,
                  { asChild: true },
                  /* @__PURE__ */ React__default.createElement(
                    'div',
                    { className: 'spot-panel__titles' },
                    /* @__PURE__ */ React__default.createElement(
                      'h2',
                      { className: 'spot-panel__title' },
                      headerTitle,
                    ),
                  ),
                ),
                /* @__PURE__ */ React__default.createElement(
                  Close,
                  { className: 'spot-panel__header__close-button', onClick: () => onClose?.() },
                  /* @__PURE__ */ React__default.createElement(Icon, {
                    title: 'cancel',
                    className: 'spot-panel__header__close-button-icon',
                  }),
                ),
              ),
              children,
            ),
          ),
        ),
      );
    },
  );
});
const PanelContent = forwardRefWithAs((props, ref) => {
  const { children, as: Comp = 'div', className, ...htmlProps } = props;
  return /* @__PURE__ */ React__default.createElement(
    Comp,
    { ref, className: classNames('spot-panel__body', className), ...htmlProps },
    /* @__PURE__ */ React__default.createElement('div', {
      className: 'spot-panel__body--scroll-shadow-mask spot-panel__body--scroll-shadow-mask--top',
    }),
    /* @__PURE__ */ React__default.createElement(
      'div',
      { className: 'spot-panel__body-wrapper' },
      children,
    ),
    /* @__PURE__ */ React__default.createElement('div', {
      className:
        'spot-panel__body--scroll-shadow-mask spot-panel__body--scroll-shadow-mask--bottom',
    }),
  );
});
const PanelFooter = forwardRefWithAs(({ as: Comp = 'div', className, ...htmlProps }, ref) => {
  return /* @__PURE__ */ React__default.createElement(Comp, {
    ref,
    className: classNames('spot-panel__footer', className),
    ...htmlProps,
  });
});
const PanelInteractiveLinks = forwardRefWithAs(
  ({ as: Comp = 'div', className, ...htmlProps }, ref) => {
    return /* @__PURE__ */ React__default.createElement(Comp, {
      ref,
      className: classNames('spot-panel__interactive-links', className),
      ...htmlProps,
    });
  },
);
const PanelBodyCopy = forwardRefWithAs(({ as: Comp = 'div', className, ...htmlProps }, ref) => {
  return /* @__PURE__ */ React__default.createElement(Comp, {
    ref,
    className: classNames('spot-panel__copy', className),
    ...htmlProps,
  });
});
function useEffectEventPolyfill(fn) {
  const cbRef = React__default.useRef(fn);
  useLayoutEffect(() => {
    cbRef.current = fn;
  }, [fn]);
  const callback = React__default.useCallback((...args) => {
    cbRef.current(...args);
  }, []);
  return callback;
}
const useEffectEvent =
  // @ts-expect-error hide not found prop
  React__default.experimental_useEffectEvent ?? useEffectEventPolyfill;
const animationPlacementInMap = { left: 'slideInLeft', right: 'slideInRight', bottom: 'slideInUp' };
const animationPlacementOutMap = {
  left: 'slideOutLeft',
  right: 'slideOutRight',
  bottom: 'slideOutDown',
};
const InlinePanel = forwardRefWithAs((props, ref) => {
  const {
    as: Component = 'div',
    className,
    children,
    variant,
    headerTitle,
    inlineContainer,
    panelState,
    onStateChange,
    defaultState = 'closed',
    overlay = 'default',
    size: size2 = 'default',
    placement = 'left',
    onClose,
    ...htmlProps
  } = props;
  const onCloseStableRef = useEffectEvent(() => onClose?.());
  const localRef = useRef(null);
  const mergedRefs = mergeRefs(localRef, ref);
  const onChange = useCallback(
    panelState2 => {
      onStateChange?.(panelState2);
    },
    [onStateChange],
  );
  const [controlledPanelState, setControlledPanelState] = $458b0a5536c1a7cf$export$40bfa8c7b0832715(
    panelState,
    defaultState,
    onChange,
  );
  const isOpen = controlledPanelState === 'open';
  const handleOpenChange = useCallback(() => {
    const newState = controlledPanelState === 'open' ? 'closed' : 'open';
    setControlledPanelState(newState);
    if (newState === 'closed') {
      onCloseStableRef();
    }
  }, [controlledPanelState, setControlledPanelState]);
  return /* @__PURE__ */ React__default.createElement(
    Component,
    {
      className: classNames('spot-panel spot-panel--display-inline', {
        'spot-panel__overlay': overlay !== 'none',
        'spot-panel--visible': controlledPanelState === 'open',
        'spot-panel--overlay--disable': overlay === 'disabled',
        [`spot-panel--open-${placement}`]: placement,
        [`spot-panel--${size2}`]: size2,
      }),
    },
    /* @__PURE__ */ React__default.createElement(
      Transition,
      { nodeRef: mergedRefs, in: isOpen, timeout: controlledPanelState === 'open' ? 1e3 : 0 },
      state => {
        return /* @__PURE__ */ React__default.createElement(
          'div',
          {
            ref: mergedRefs,
            className: classNames(
              'spot-panel__content',
              {
                animated: true,
                [animationPlacementInMap[placement]]: state === 'entering',
                [animationPlacementOutMap[placement]]: state === 'exiting',
              },
              className,
            ),
            ...htmlProps,
          },
          /* @__PURE__ */ React__default.createElement(
            'div',
            { className: 'spot-panel__header' },
            /* @__PURE__ */ React__default.createElement(
              'div',
              { className: 'spot-panel__titles' },
              /* @__PURE__ */ React__default.createElement(
                'h2',
                { className: 'spot-panel__title' },
                headerTitle,
              ),
            ),
            variant === 'tabbed'
              ? /* @__PURE__ */ React__default.createElement(
                  'button',
                  {
                    onClick: handleOpenChange,
                    className: 'spot-panel__header__drawer-tab-button',
                    'data-spot-trigger-panel': 'drawer-tab-button',
                  },
                  /* @__PURE__ */ React__default.createElement(Icon, {
                    title: 'drawer-open',
                    className: 'spot-panel__header__drawer-tab-button-icon',
                    'aria-labelledby': 'title',
                  }),
                )
              : /* @__PURE__ */ React__default.createElement(
                  'button',
                  { onClick: handleOpenChange, className: 'spot-panel__header__close-button' },
                  /* @__PURE__ */ React__default.createElement(Icon, {
                    title: 'cancel',
                    className: 'spot-panel__header__close-button-icon',
                  }),
                ),
          ),
          children,
        );
      },
    ),
    /* @__PURE__ */ React__default.createElement(
      'div',
      { className: 'spot-panel__inline-container' },
      inlineContainer,
    ),
  );
});
const PatientSignalment = forwardRefWithAs(
  (
    {
      as,
      className,
      name,
      accountNumber,
      details,
      avatar,
      avatarVariant = 'default',
      withCamera = false,
      size: size2 = 'medium',
      ...props
    },
    ref,
  ) => {
    const Component = as ?? 'div';
    return /* @__PURE__ */ React__default.createElement(
      Component,
      {
        ...props,
        className: classNames('spot-patient-display', className, {
          [`spot-patient-display--${size2 === 'xsmall' ? 'xs' : size2}`]: size2,
        }),
        ref,
      },
      /* @__PURE__ */ React__default.createElement(
        'div',
        { className: 'spot-patient-display__icon' },
        /* @__PURE__ */ React__default.createElement(
          'div',
          {
            className: classNames('spot-patient-display__avatar', {
              'spot-patient-display__avatar--pet': typeof avatar === 'object',
              [`spot-patient-display__avatar--${avatarVariant}`]: avatarVariant !== 'default',
            }),
          },
          typeof avatar === 'string'
            ? /* @__PURE__ */ React__default.createElement(Icon, {
                title: avatar,
                className: 'spot-patient-display__svg',
              })
            : null,
          typeof avatar === 'object'
            ? /* @__PURE__ */ React__default.createElement('img', {
                className: 'spot-patient-display__img',
                src: avatar.src,
                alt: avatar.alt,
              })
            : null,
        ),
        withCamera
          ? /* @__PURE__ */ React__default.createElement(
              'div',
              { className: 'spot-patient-display__camera' },
              /* @__PURE__ */ React__default.createElement(Icon, { title: 'camera' }),
            )
          : null,
      ),
      /* @__PURE__ */ React__default.createElement(
        'div',
        { className: 'spot-patient-display__patient-info' },
        /* @__PURE__ */ React__default.createElement(
          'div',
          { className: 'spot-patient-display__title' },
          name
            ? /* @__PURE__ */ React__default.createElement(
                'span',
                { className: 'spot-patient-display__pet-name' },
                name,
              )
            : null,
          accountNumber
            ? /* @__PURE__ */ React__default.createElement(
                'span',
                { className: 'spot-patient-display__account' },
                accountNumber,
              )
            : null,
        ),
        /* @__PURE__ */ React__default.createElement(
          'div',
          { className: 'spot-patient-display__pet-info' },
          details &&
            details.map((detail, index2) =>
              /* @__PURE__ */ React__default.createElement(
                Fragment$1,
                { key: index2 },
                detail,
                ' ',
                index2 < details.length - 1
                  ? /* @__PURE__ */ React__default.createElement(
                      React__default.Fragment,
                      null,
                      /* @__PURE__ */ React__default.createElement('span', null, '|'),
                      ' ',
                    )
                  : null,
              ),
            ),
        ),
      ),
    );
  },
);
const PILL_COLOR_LIST = ['primary', 'secondary', 'positive', 'negative', 'warning', 'info'];
const Pill = forwardRefWithAs(
  (
    {
      as,
      label,
      variant,
      size: size2,
      color = 'primary',
      iconLeft,
      iconRight,
      interactive = false,
      className,
      ...rest
    },
    ref,
  ) => {
    const Component = as ?? 'span';
    return /* @__PURE__ */ React__default.createElement(
      Component,
      {
        className: classNames('spot-pill', className, [`spot-pill--${color}`], {
          'spot-pill--outline': variant === 'outlined',
          'spot-pill--small': size2 === 'small',
          'spot-pill--interactive': interactive,
        }),
        ...rest,
        ref,
      },
      renderIcon(iconLeft, 'spot-pill__icon spot-pill__icon--left'),
      label,
      renderIcon(iconRight, 'spot-pill__icon spot-pill__icon--right'),
    );
  },
);
Pill.displayName = 'Pill';
const PillSet = forwardRef(
  ({ as, direction = 'horizontal', className, children, ...rest }, ref) => {
    const Component = as ?? 'ul';
    return /* @__PURE__ */ React__default.createElement(
      Component,
      {
        role: 'list',
        className: classNames(className, [`spot-pill__${direction}-set`]),
        ...rest,
        ref,
      },
      Children.map(children, child => {
        return /* @__PURE__ */ React__default.createElement(
          'li',
          { className: classNames([`spot-pill__${direction}-set-item`]) },
          child,
        );
      }),
    );
  },
);
PillSet.displayName = 'PillSet';
const PROGRESS_COLOR_LIST = ['primary', 'secondary', 'success'];
const PROGRESS_SIZE_LIST = ['small', 'medium', 'large'];
const ProgressBar = ({
  progress,
  isIndeterminate = false,
  color = 'primary',
  size: size2 = 'medium',
  ...rest
}) => {
  const PROGRESS_STRING = `${progress}%`;
  return /* @__PURE__ */ React__default.createElement(
    'div',
    {
      className: classNames('spot-progress-bar', {
        [`spot-progress-bar--${color}`]: color && color !== 'primary',
        [`spot-progress-bar--indeterminate`]: isIndeterminate,
        [`spot-progress-bar--${size2}`]: size2 && size2 !== 'medium',
      }),
      ...rest,
      'aria-valuemin': 0,
      'aria-valuemax': 100,
      'aria-valuenow': progress,
    },
    /* @__PURE__ */ React__default.createElement('div', {
      className: `spot-progress-bar__value`,
      style: { width: !isIndeterminate ? `${PROGRESS_STRING}` : void 0 },
    }),
  );
};
const SearchBar = forwardRefWithAs(
  (
    {
      as,
      className,
      showDateRange,
      dateRangeTitle,
      showErrorState,
      onSearchSubmit,
      onRangeClick,
      variant,
      ...props
    },
    ref,
  ) => {
    const Component = as ?? 'div';
    return /* @__PURE__ */ React__default.createElement(
      Component,
      {
        className: classNames('spot-form spot-search-bar', className, {
          'spot-search-bar--low-priority': variant === 'lowpriority',
          'spot-search-bar--error': showErrorState === true,
        }),
      },
      /* @__PURE__ */ React__default.createElement(TextBox, {
        className: classNames('spot-search-bar__input', className),
        ref,
        ...props,
      }),
      showDateRange
        ? /* @__PURE__ */ React__default.createElement(
            'button',
            { type: 'button', className: 'spot-search-bar__date-button', onClick: onRangeClick },
            /* @__PURE__ */ React__default.createElement(
              'span',
              { className: 'spot-search-bar__date-button__text' },
              dateRangeTitle,
            ),
            /* @__PURE__ */ React__default.createElement(Icon, { title: 'calendar' }),
          )
        : null,
      /* @__PURE__ */ React__default.createElement(
        'button',
        { type: 'submit', className: 'spot-search-bar__search-button', onClick: onSearchSubmit },
        /* @__PURE__ */ React__default.createElement(Icon, { title: 'search' }),
      ),
    );
  },
);
let serverHandoffComplete = false;
let id = 0;
function genId() {
  return `id-${id++}`;
}
const maybeReactUseId = React.useId ?? void 0;
function useId(providedId, forceFallback = false) {
  if (maybeReactUseId !== void 0 && forceFallback === false) {
    const generatedId = maybeReactUseId();
    return providedId ?? generatedId;
  }
  const initialId = providedId ?? (serverHandoffComplete ? genId() : void 0);
  const [id2, setId] = React.useState(initialId);
  React.useLayoutEffect(() => {
    if (id2 === void 0) {
      setId(genId());
    }
  }, [id2]);
  React.useEffect(() => {
    if (serverHandoffComplete === false) {
      serverHandoffComplete = true;
    }
  }, []);
  return providedId ?? id2;
}
const SvgIdexxLogo = ({ title, titleId, ...props }, ref) =>
  /* @__PURE__ */ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      viewBox: '0 0 186 32',
      ref,
      'aria-labelledby': titleId,
      ...props,
    },
    title ? /* @__PURE__ */ React.createElement('title', { id: titleId }, title) : null,
    /* @__PURE__ */ React.createElement(
      'g',
      { fill: 'none' },
      /* @__PURE__ */ React.createElement('path', {
        fill: '#97999B',
        d: 'M0 0h11v32H0zm64 32h37v-7.61H74.404V18H64zm-22.103-7.784H25.302V19H15v13h28.578C53.879 32 60 27.796 60 20.323V19H49.698c-.129 4.126-3.491 5.216-7.801 5.216M25.345 7.713H41.94c4.31 0 7.629 1.113 7.758 5.287H60v-1.073C60 4.254 53.88 0 43.578 0H15v13h10.302V7.713zM101 7.178V0H64v13h10.404V7.178z',
      }),
      /* @__PURE__ */ React.createElement('path', { fill: '#F9423A', d: 'M78 13h23v5H78z' }),
      /* @__PURE__ */ React.createElement('path', {
        fill: '#97999B',
        d: 'M172.412 19h-18.406l-10.158 9.925L133.69 19h-18.406L102 32h13.631l8.856-9.341L133.386 32h20.924l8.899-9.341L172.065 32H186zM144 3.15l9.89 9.85h19.039L186 0h-13.68l-8.888 9.571L154.544 0H133.5l-8.932 9.571L115.68 0H102l13.071 13h19.039z',
      }),
    ),
  );
const ForwardRef = forwardRef(SvgIdexxLogo);
const SigninBox = forwardRefWithAs(
  (
    { as, className, logo, headingLabel, contentIntro, errorMessage, footer, form = {}, ...props },
    ref,
  ) => {
    const [showPassword, setShowPassword] = useState(false);
    const { userName, password, rememberMe, ...formProps } = form;
    const rememberMeProps = typeof rememberMe === 'boolean' ? {} : rememberMe;
    const userNameId = useId(userName?.id);
    const passwordId = useId(password?.id);
    const rememberMeId = useId(rememberMeProps?.id);
    const { allowShow, ...passwordProps } = password ?? {};
    const Component = as ?? 'div';
    return /* @__PURE__ */ React__default.createElement(
      Component,
      { ref, className: classNames('spot-signin', className), ...props },
      /* @__PURE__ */ React__default.createElement(
        'div',
        { className: 'spot-signin__header' },
        headingLabel
          ? /* @__PURE__ */ React__default.createElement(
              'div',
              { className: 'spot-signin__header-label' },
              /* @__PURE__ */ React__default.createElement(
                'div',
                { className: 'spot-typography__heading--level-3' },
                headingLabel,
              ),
            )
          : /* @__PURE__ */ React__default.createElement(
              'div',
              { className: 'spot-signin__header-image' },
              logo
                ? logo
                : /* @__PURE__ */ React__default.createElement(ForwardRef, {
                    title: 'IDEXX',
                    className: 'spot-signin__header-image--index',
                  }),
            ),
      ),
      /* @__PURE__ */ React__default.createElement(
        'div',
        { className: 'spot-signin__content' },
        contentIntro
          ? /* @__PURE__ */ React__default.createElement(
              'span',
              { className: 'spot-signin__content-intro' },
              contentIntro,
            )
          : null,
        errorMessage
          ? /* @__PURE__ */ React__default.createElement(
              'div',
              { className: 'spot-signin__content-error-message' },
              /* @__PURE__ */ React__default.createElement(Icon, {
                className: 'spot-signin__content-error-message-icon',
                title: 'alert-notification',
              }),
              /* @__PURE__ */ React__default.createElement(
                'span',
                { className: 'spot-signin__content-error-message-label' },
                errorMessage,
              ),
            )
          : null,
        /* @__PURE__ */ React__default.createElement(
          'form',
          { ...formProps, className: classNames('spot-form', form.className) },
          /* @__PURE__ */ React__default.createElement(
            FieldGroup,
            { htmlFor: userNameId, label: userName?.label ?? 'Username' },
            /* @__PURE__ */ React__default.createElement(TextBox, { id: userNameId, ...userName }),
          ),
          /* @__PURE__ */ React__default.createElement(
            FieldGroup,
            { htmlFor: passwordId, label: password?.label ?? 'Password' },
            /* @__PURE__ */ React__default.createElement(TextBox, {
              type: showPassword ? 'text' : 'password',
              id: passwordId,
              ...passwordProps,
            }),
            allowShow || rememberMe
              ? /* @__PURE__ */ React__default.createElement(
                  'div',
                  { className: 'spot-signin__content-fieldgroup' },
                  password?.allowShow
                    ? /* @__PURE__ */ React__default.createElement(
                        'span',
                        { className: 'spot-signin__content--showpassword' },
                        /* @__PURE__ */ React__default.createElement(
                          Button,
                          {
                            type: 'button',
                            onClick: () => {
                              setShowPassword(current => !current);
                            },
                            variant: 'link',
                          },
                          showPassword ? 'hide' : 'show',
                        ),
                      )
                    : null,
                  rememberMe
                    ? /* @__PURE__ */ React__default.createElement(
                        'span',
                        { className: 'spot-signin__content--rememberme' },
                        /* @__PURE__ */ React__default.createElement(CheckBox, {
                          ...rememberMeProps,
                          label: rememberMeProps?.label ?? 'Remember me',
                          id: rememberMeId,
                          ...rememberMeProps,
                        }),
                      )
                    : null,
                )
              : null,
          ),
          /* @__PURE__ */ React__default.createElement(Button, { type: 'submit' }, 'Sign in'),
        ),
      ),
      footer
        ? /* @__PURE__ */ React__default.createElement(
            'div',
            { className: 'spot-signin__footer' },
            Children.toArray(footer).map((child, i, { length }) => {
              return /* @__PURE__ */ React__default.createElement(
                Fragment$1,
                { key: i },
                child,
                i < length - 1
                  ? /* @__PURE__ */ React__default.createElement('span', {
                      className: 'spot-signin__footer-item-separator',
                    })
                  : null,
              );
            }),
          )
        : null,
    );
  },
);
const SystemMessage = forwardRefWithAs(
  (
    {
      as,
      size: size2 = 'default',
      children,
      onDismiss,
      alertLevel = 'default',
      header,
      icon,
      className,
      progressRef,
      ...props
    },
    ref,
  ) => {
    const Component = as ?? 'div';
    return /* @__PURE__ */ React__default.createElement(
      Component,
      {
        ref,
        className: classNames('spot-message', className, {
          dismissible: onDismiss,
          'spot-message--large': size2 === 'large',
          [`spot-message--${alertLevel}`]: true,
          'spot-message--with-icon-tab': icon,
        }),
        ...props,
      },
      /* @__PURE__ */ React__default.createElement(
        'div',
        { className: classNames('spot-message--content') },
        header
          ? /* @__PURE__ */ React__default.createElement(
              'div',
              { className: 'spot-message--header' },
              header,
            )
          : null,
        /* @__PURE__ */ React__default.createElement(
          'div',
          { className: 'spot-message--body' },
          children,
        ),
      ),
      icon
        ? /* @__PURE__ */ React__default.createElement(
            'div',
            { className: 'icon-tab' },
            renderIcon(icon),
          )
        : null,
      progressRef
        ? /* @__PURE__ */ React__default.createElement('div', {
            ref: progressRef,
            className: 'progress',
            style: { width: 0 },
          })
        : null,
      onDismiss
        ? /* @__PURE__ */ React__default.createElement(
            'button',
            { className: 'dismiss', onClick: () => onDismiss() },
            /* @__PURE__ */ React__default.createElement(Icon, { title: 'cancel' }),
          )
        : null,
    );
  },
);
SystemMessage.displayName = 'SystemMessage';
const SystemMessageToast = ({
  timer,
  onDismiss,
  animationIn,
  animationOut,
  className,
  ...props
}) => {
  const progressRef = React__default.useRef(null);
  const [endTimestamp, setEndTimestamp] = React__default.useState();
  const [dismissed, setDismissed] = React__default.useState(false);
  const previousDismissedRef = React__default.useRef(false);
  const animationClass = React__default.useMemo(() => {
    return dismissed ? animationOut : animationIn;
  }, [dismissed, animationIn, animationOut]);
  const triggerDismissal = useCallback(() => setDismissed(true), []);
  useEffect(() => {
    if (dismissed && !previousDismissedRef.current) {
      previousDismissedRef.current = true;
      const handleDismiss = async () => {
        if (animationOut) {
          await new Promise(resolve => setTimeout(resolve, 1e3));
        }
        onDismiss?.();
      };
      handleDismiss();
    }
  }, [dismissed, animationOut, onDismiss]);
  useEffect(() => {
    const { current: progress } = progressRef;
    if (timer != null) {
      let progressBarAnimation2 = function (timestamp) {
        if (!dismissed) {
          if (!endTimestamp) {
            setEndTimestamp(timestamp + duration);
          } else {
            const width = 100 * Math.max(0, (endTimestamp - timestamp) / duration);
            if (progress) {
              progress.style.width = `${width}%`;
            }
            if (width > 0) {
              requestAnimationFrame(progressBarAnimation2);
            } else {
              triggerDismissal();
            }
          }
        }
      };
      const duration = timer;
      requestAnimationFrame(progressBarAnimation2);
    }
  }, [timer, endTimestamp, dismissed, triggerDismissal]);
  return /* @__PURE__ */ React__default.createElement(SystemMessage, {
    className: classNames(className, {
      animated: animationIn || animationOut,
      [animationClass ?? '']: animationClass,
    }),
    onDismiss: triggerDismissal,
    progressRef,
    ...props,
  });
};
const locationStringMap = {
  topLeft: 'top-left',
  topRight: 'top-right',
  bottomLeft: 'bottom-left',
  bottomRight: 'bottom-right',
  topCenter: 'top-center',
  bottomCenter: 'bottom-center',
  centerCenter: 'center-center',
};
const ToastContext = createContext$1({ addToast: () => {}, removeToast: () => {} });
const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState({
    topRight: {},
    topLeft: {},
    bottomRight: {},
    bottomLeft: {},
    topCenter: {},
    bottomCenter: {},
    centerCenter: {},
  });
  const addToast = useCallback((props, location) => {
    setToasts(prevToasts => ({
      ...prevToasts,
      [location]: { ...prevToasts[location], [props.id]: props },
    }));
  }, []);
  const removeToast = useCallback((id2, location) => {
    setToasts(prevToasts => {
      const newToastEntries = Object.entries(prevToasts[location]).filter(
        ([toadId]) => toadId !== id2,
      );
      return { ...prevToasts, [location]: { ...Object.fromEntries(newToastEntries) } };
    });
  }, []);
  return /* @__PURE__ */ React__default.createElement(
    ToastContext.Provider,
    { value: { addToast, removeToast } },
    children,
    Object.entries(toasts).map(([location, toastList]) => {
      if (Object.keys(toastList).length === 0) return null;
      const locationString = location;
      const isCenter = locationString.includes('Center');
      const Container = isCenter ? Fragment$1 : 'div';
      const relativeStyleslocationString = isCenter ? {} : { position: 'relative' };
      const containerProps = isCenter
        ? {}
        : { className: `toast-container--${locationStringMap[locationString]}` };
      return /* @__PURE__ */ React__default.createElement(
        Container,
        { key: location, ...containerProps },
        Object.entries(toastList).map(([id2, { content, onDismiss, ...props }]) => {
          return /* @__PURE__ */ React__default.createElement(
            SystemMessageToast,
            {
              role: 'status',
              'aria-live': 'off',
              'aria-atomic': 'true',
              key: id2,
              className: `spot-message--toast ${locationStringMap[locationString]}`,
              style: { ...relativeStyleslocationString, pointerEvents: 'auto' },
              ...props,
              onDismiss: () => {
                removeToast(id2, locationString);
                onDismiss?.();
              },
            },
            content,
          );
        }),
      );
    }),
  );
};
const generateId = (function* () {
  let i = 0;
  while (true) {
    yield `toast-${i++}`;
  }
})();
const useToast = () => {
  const { addToast: addToastWithLocation } = React__default.useContext(ToastContext);
  const addToast = useCallback(
    ({ location, ...props }) => {
      const id2 = props.id ?? generateId.next().value;
      addToastWithLocation({ ...props, id: id2 }, location);
      return id2;
    },
    [addToastWithLocation],
  );
  return { addToast };
};
const Banner = forwardRef(
  (
    {
      className,
      animationIn,
      animationOut,
      onDismiss,
      location = 'bottom',
      variant = 'default',
      alertLevel,
      ...props
    },
    ref,
  ) => {
    const [animationClass, setAnimationClass] = useState(animationIn);
    const dismissFn = useCallback(async () => {
      setAnimationClass(animationOut);
      if (animationOut) {
        await new Promise(resolve => setTimeout(resolve, 1e3));
      }
      onDismiss?.();
    }, [animationOut, onDismiss]);
    return /* @__PURE__ */ React__default.createElement(SystemMessage, {
      ref,
      className: classNames(className, 'spot-message--banner', {
        [`spot-message--cookie`]: variant === 'cookie',
        [`${location}-full`]: location,
        animated: animationIn ?? animationOut,
        [animationClass ?? '']: animationClass,
      }),
      onDismiss: dismissFn,
      alertLevel: variant === 'default' ? alertLevel : void 0,
      ...props,
    });
  },
);
Banner.displayName = 'Banner';
function createKeyCrawler(hotkeys) {
  let index2 = 0;
  const lastKey = hotkeys.length - 1;
  return key => {
    if (key !== hotkeys[index2]) {
      index2 = 0;
      return false;
    }
    if (index2 === lastKey) {
      index2 = 0;
      return true;
    }
    index2++;
    return false;
  };
}
function useHotKeys(hotKeys, onMatch) {
  const onMatchRef = useRef(onMatch);
  const currentHotKeys = useMemo(() => [].concat(hotKeys), [hotKeys]);
  useLayoutEffect(() => {
    onMatchRef.current = onMatch;
  });
  useEffect(() => {
    const keyCrawler = createKeyCrawler(currentHotKeys);
    const listen = ({ key }) => {
      if (keyCrawler(key)) {
        onMatchRef.current();
      }
    };
    window.addEventListener('keydown', listen);
    return () => window.removeEventListener('keydown', listen);
  }, [currentHotKeys]);
}
let observer;
const callBackMap = /* @__PURE__ */ new WeakMap();
function init() {
  if (observer) return observer;
  return (observer = new ResizeObserver(entries => {
    return entries.map(entry => {
      const maybeCallBacks = callBackMap.get(entry.target);
      const safeCallBacks = maybeCallBacks ?? [];
      if (safeCallBacks.length === 0) return entry;
      requestAnimationFrame(() => {
        return safeCallBacks.map(callback => {
          const safeCallback = typeof callback === 'function' ? callback : callback.current;
          safeCallback(entry);
          return callback;
        });
      });
      return entry;
    });
  }));
}
function registerCallback(node, cb) {
  if (observer === void 0) {
    return () => void 0;
  }
  const callbacks = callBackMap.get(node) ?? [];
  callBackMap.set(node, callbacks.concat(cb));
  observer?.observe(node);
  return () => {
    const maybeCallBacks = callBackMap.get(node);
    const safeCallBacks = maybeCallBacks ?? [];
    const newCallbacks = safeCallBacks.filter(ref => ref !== cb);
    callBackMap.set(node, newCallbacks);
    if (newCallbacks.length === 0) {
      observer?.unobserve(node);
      callBackMap.delete(node);
    }
  };
}
function useStatefulRef(initialVal) {
  let [cur, setCur] = React__default.useState(initialVal);
  const refObject = {
    get current() {
      return cur;
    },
    set current(value) {
      if (!Object.is(cur, value)) {
        cur = value;
        setCur(value);
      }
    },
  };
  return refObject;
}
function useResizeObserver(callback, node) {
  const callbackRef = useRef(callback);
  const nodeRef = useStatefulRef();
  useLayoutEffect(() => {
    callbackRef.current = callback;
  });
  useEffect(() => {
    init();
    const currentNode = nodeRef.current ?? node;
    const cleanup = currentNode && registerCallback(currentNode, callbackRef);
    return () => {
      cleanup?.();
    };
  }, [node, nodeRef]);
  return nodeRef;
}
const TabsContext = createContext$1({
  selectedTab: 0,
  scrollable: false,
  idMap: {},
  onSelect: () => void 0,
  registerTab: () => void 0,
  registerTabPanel: () => void 0,
  forceUpdate: () => void 0,
});
const useTabsContext = () => {
  const context = React__default.useContext(TabsContext);
  if (!context) {
    throw new Error('TabsContext must be used within a Tabs component');
  }
  return context;
};
const useForceUpdate = () => {
  const [, updateState] = React__default.useState({});
  const forceUpdate = React__default.useCallback(() => updateState({}), []);
  return forceUpdate;
};
const Tabs = forwardRefWithAs(
  (
    {
      as,
      className,
      activeTab,
      defaultActive = 0,
      iconOnly = false,
      scrollable = false,
      variant = 'default',
      justify = 'default',
      onTabChange,
      children,
      withBorder = false,
    },
    ref,
  ) => {
    const idMapRef = useStatefulRef({});
    const activeIndex =
      typeof activeTab === 'number' ? activeTab : idMapRef.current[activeTab ?? ''];
    const defaultActiveIndex =
      typeof defaultActive === 'number' ? defaultActive : idMapRef.current[defaultActive ?? ''];
    const onTabChangeEffect = useEffectEvent(i => onTabChange?.(i, idMapRef.current[i]?.tabId));
    const [selectedTab, setSelectedTab] = $458b0a5536c1a7cf$export$40bfa8c7b0832715(
      activeIndex,
      defaultActiveIndex,
      onTabChangeEffect,
    );
    const [useKeyboard, setUseKeyboard] = useState(false);
    const [isResponsive, setIsResponsive] = useState(false);
    const [hideButtons, setHideButtons] = useState({
      hideNextButton: false,
      hidePreviousButton: false,
    });
    const forceUpdate = useForceUpdate();
    const componentRef = useResizeObserver(entry => {
      const rawWidth = entry.target.getAttribute('data-spot-tab-labels-width') ?? '0';
      const width = parseInt(rawWidth);
      const currentTabsWidth = Array.from(entry.target.querySelectorAll('.spot-tabs__tab')).reduce(
        (state, tab) => {
          return state + tab.getBoundingClientRect().width;
        },
        0,
      );
      const finalWidth = Math.max(width, currentTabsWidth);
      if (width !== finalWidth) {
        entry.target.setAttribute('data-spot-tab-labels-width', finalWidth.toString());
      }
      const isResponsive2 = entry.contentRect.width < finalWidth;
      setIsResponsive(isResponsive2);
    });
    const onSelect = useCallback(
      index2 => {
        if (activeTab !== index2) {
          onTabChangeEffect(index2);
        }
        setSelectedTab(index2);
      },
      [setSelectedTab, activeTab],
    );
    const registerTab = useCallback(
      (index2, tabId) => {
        const prev = idMapRef.current[index2] ?? {};
        idMapRef.current[index2] = { ...prev, tabId };
        idMapRef.current[tabId] = index2;
      },
      [idMapRef],
    );
    const registerTabPanel = useCallback(
      (index2, tabPanelId) => {
        const prev = idMapRef.current[index2] ?? {};
        idMapRef.current[index2] = { ...prev, tabPanelId };
      },
      [idMapRef],
    );
    const { current: component } = componentRef;
    useEffect(() => {
      if (component === null || component === void 0) {
        return;
      }
      const onFocusIn = () => {
        setUseKeyboard(true);
      };
      const onFocusOut = () => {
        setUseKeyboard(false);
      };
      component.addEventListener('focusin', onFocusIn);
      component.addEventListener('focusout', onFocusOut);
      return () => {
        component.removeEventListener('focusin', onFocusIn);
        component.removeEventListener('focusout', onFocusOut);
      };
    }, [component]);
    useHotKeys('ArrowLeft', () => {
      if (!useKeyboard) return;
      const tabIds = Object.keys(idMapRef.current).map(key => parseInt(key));
      const newTab = selectedTab === 0 ? tabIds[tabIds.length - 1] : selectedTab - 1;
      onSelect(newTab);
      const tabToFocus = document.getElementById(idMapRef.current[newTab].tabId);
      if (tabToFocus) {
        tabToFocus.focus();
      }
    });
    useHotKeys('ArrowRight', () => {
      if (!useKeyboard) return;
      const tabIds = Object.keys(idMapRef.current).map(key => parseInt(key));
      const newTab = (selectedTab + 1) % tabIds.length;
      onSelect(newTab);
      const tabToFocus = document.getElementById(idMapRef.current[newTab].tabId);
      if (tabToFocus) {
        tabToFocus.focus();
      }
    });
    useHotKeys('Home', () => {
      if (!useKeyboard) return;
      const newTab = 0;
      onSelect(newTab);
      const tabToFocus = document.getElementById(idMapRef.current[newTab].tabId);
      if (tabToFocus) {
        tabToFocus.focus();
      }
    });
    useHotKeys('End', () => {
      if (!useKeyboard) return;
      const newTab = Object.keys(idMapRef.current).length - 1;
      onSelect(newTab);
      const tabToFocus = document.getElementById(idMapRef.current[newTab].tabId);
      if (tabToFocus) {
        tabToFocus.focus();
      }
    });
    useEffect(() => {
      const maybeTabList = component?.querySelector('.spot-tabs__list');
      if (maybeTabList === null || maybeTabList === void 0) return;
      const hidePreviousButton = maybeTabList.scrollLeft === 0;
      const hideNextButton =
        maybeTabList.scrollLeft === maybeTabList.scrollWidth - maybeTabList.clientWidth;
      if (
        hidePreviousButton !== hideButtons.hidePreviousButton ||
        hideNextButton !== hideButtons.hideNextButton
      ) {
        setHideButtons({ hideNextButton, hidePreviousButton });
      }
    });
    useImperativeHandle(ref, () => componentRef.current, [componentRef]);
    const Component = as ?? 'div';
    return /* @__PURE__ */ React__default.createElement(
      TabsContext.Provider,
      {
        value: {
          selectedTab,
          scrollable,
          idMap: idMapRef.current,
          onSelect,
          registerTab,
          registerTabPanel,
          forceUpdate,
        },
      },
      /* @__PURE__ */ React__default.createElement(
        Component,
        {
          className: classNames('spot-tabs', className, {
            'spot-tabs--responsive': isResponsive,
            'spot-tabs--icon-only': iconOnly,
            'spot-tabs--scrollable': scrollable,
            'spot-tabs--large': variant === 'large',
            'spot-tabs--fill': justify === 'fill',
            'spot-tabs--next-scroll-hidden': scrollable && hideButtons.hideNextButton,
            'spot-tabs--previous-scroll-hidden': scrollable && hideButtons.hidePreviousButton,
            'spot-tabs--with-border': withBorder,
          }),
          role: 'tablist',
          ref: componentRef,
        },
        children,
      ),
    );
  },
);
Tabs.displayName = 'Tabs';
const NUMBER_OF_FRAMES = (60 / 1e3) * 200;
const scrollRight =
  ({ node, endPosition, scrollAmount, onUpdate }) =>
  () => {
    const newScroll = node.scrollLeft + scrollAmount;
    node.scrollLeft = newScroll;
    onUpdate();
    if (newScroll < endPosition) {
      requestAnimationFrame(scrollRight({ node, endPosition, scrollAmount, onUpdate }));
    }
  };
const scrollLeft =
  ({ node, endPosition, scrollAmount, onUpdate }) =>
  () => {
    const currentScroll = node.scrollLeft;
    const newScroll = currentScroll - scrollAmount;
    node.scrollLeft = newScroll;
    onUpdate();
    if (newScroll > endPosition) {
      requestAnimationFrame(scrollLeft({ node, endPosition, scrollAmount, onUpdate }));
    }
  };
const TabList = forwardRefWithAs(({ as, className, children, ...restProps }, ref) => {
  const { onSelect, scrollable, forceUpdate } = useTabsContext();
  const tabListRef = useRef(null);
  const handledPreviousClick = useCallback(() => {
    const maybeTabList = tabListRef.current;
    if (maybeTabList === null || maybeTabList === void 0) return;
    const endPosition = Math.max(maybeTabList.scrollLeft - maybeTabList.clientWidth, 0);
    const distancePerFrame = Math.abs(maybeTabList.scrollLeft - endPosition) / NUMBER_OF_FRAMES;
    requestAnimationFrame(
      scrollLeft({
        node: maybeTabList,
        endPosition,
        scrollAmount: distancePerFrame,
        onUpdate: forceUpdate,
      }),
    );
  }, [forceUpdate]);
  const handledNextClick = useCallback(() => {
    const maybeTabList = tabListRef.current;
    if (maybeTabList === null || maybeTabList === void 0) return;
    const endPosition = Math.min(
      maybeTabList.scrollLeft + maybeTabList.clientWidth,
      maybeTabList.scrollWidth - maybeTabList.clientWidth,
    );
    const distancePerFrame = Math.abs(maybeTabList.scrollLeft - endPosition) / NUMBER_OF_FRAMES;
    requestAnimationFrame(
      scrollRight({
        node: maybeTabList,
        endPosition,
        scrollAmount: distancePerFrame,
        onUpdate: forceUpdate,
      }),
    );
  }, [forceUpdate]);
  const Component = as ?? 'div';
  return /* @__PURE__ */ React__default.createElement(
    Component,
    {
      className: classNames('spot-tabs__list-wrap', className),
      role: 'tablist',
      ref,
      ...restProps,
    },
    scrollable
      ? /* @__PURE__ */ React__default.createElement(
          'button',
          {
            onClick: handledPreviousClick,
            className: 'spot-tabs__scroll-button spot-tabs__scroll-button--previous',
          },
          /* @__PURE__ */ React__default.createElement(Icon, {
            className: 'spot-tabs__scroll-button-icon',
            title: 'previous',
          }),
        )
      : null,
    /* @__PURE__ */ React__default.createElement(
      'ul',
      { ref: tabListRef, className: 'spot-tabs__list' },
      Children.toArray(children).map((child, i) => {
        if (isValidElement(child) && child.type === Tab) {
          return cloneElement(child, { onTabSelect: onSelect, index: i, key: i });
        }
        return null;
      }),
    ),
    scrollable
      ? /* @__PURE__ */ React__default.createElement(
          'button',
          {
            onClick: handledNextClick,
            className: 'spot-tabs__scroll-button spot-tabs__scroll-button--next',
          },
          /* @__PURE__ */ React__default.createElement(Icon, {
            className: 'spot-tabs__scroll-button-icon',
            title: 'next',
          }),
        )
      : null,
  );
});
TabList.displayName = 'TabList';
const Tab = forwardRef(
  ({ children, className, index: index2, id: id2, icon, onTabSelect, onClick, ...rest }, ref) => {
    const tabId = useId(id2);
    const { selectedTab, idMap, registerTab } = useTabsContext();
    const handleClick = useCallback(
      e => {
        onTabSelect?.(index2 ?? 0);
        onClick?.(e);
      },
      [index2, onClick, onTabSelect],
    );
    useEffect(() => {
      if (index2 !== void 0 && tabId && idMap[index2]?.tabId !== tabId) {
        registerTab(index2, tabId);
      }
    }, [index2, tabId, idMap, registerTab]);
    return /* @__PURE__ */ React__default.createElement(
      'li',
      {
        className: 'spot-tabs__tab',
        tabIndex: index2 === selectedTab ? 0 : -1,
        role: 'tab',
        id: tabId,
        'aria-selected': index2 === selectedTab,
        'aria-controls': index2 ? idMap[index2]?.tabPanelId : void 0,
      },
      /* @__PURE__ */ React__default.createElement(
        'button',
        {
          ref,
          className: classNames('spot-tabs__link', className, {
            'spot-tabs__link--active': index2 === selectedTab,
            'spot-tabs__link--with-icon': icon,
          }),
          ...rest,
          onClick: handleClick,
        },
        icon
          ? /* @__PURE__ */ React__default.createElement(Icon, {
              className: 'spot-tabs__icon',
              title: icon,
            })
          : null,
        /* @__PURE__ */ React__default.createElement(
          'span',
          { className: 'spot-tabs__link-text' },
          ' ',
          children,
        ),
      ),
    );
  },
);
Tab.displayName = 'Tab';
const TabPanels = forwardRefWithAs(({ as, className, children, ...rest }, ref) => {
  const Component = as ?? 'div';
  return /* @__PURE__ */ React__default.createElement(
    Component,
    { className: classNames('spot-tabs__content-wrap', className), ...rest, ref },
    Children.toArray(children).map((child, i) => {
      if (isValidElement(child) && child.type === TabPanel) {
        return cloneElement(child, { index: i });
      }
      return null;
    }),
  );
});
const TabPanel = forwardRefWithAs(({ as, children, index: index2, id: id2, ...rest }, ref) => {
  const tabPanelId = useId(id2);
  const { selectedTab, idMap, registerTabPanel } = useTabsContext();
  useEffect(() => {
    if (index2 !== void 0 && tabPanelId && idMap[index2]?.tabPanelId !== tabPanelId) {
      registerTabPanel(index2, tabPanelId);
    }
  }, [index2, tabPanelId, idMap, registerTabPanel]);
  if (index2 !== selectedTab) return null;
  const Component = as ?? 'div';
  return /* @__PURE__ */ React__default.createElement(
    Component,
    {
      ...rest,
      className: classNames('spot-tabs__content', {
        'spot-tabs__content--hidden': index2 !== selectedTab,
      }),
      ref,
      role: 'tabpanel',
      'aria-labelledby': index2 ? idMap[index2]?.tabId : void 0,
      'aria-hidden': index2 !== selectedTab,
      id: tabPanelId,
      tabIndex: 0,
    },
    children,
  );
});
const Toggle = forwardRef(({ label, className, id: id2, ...props }, ref) => {
  const safeId = useId(id2);
  return /* @__PURE__ */ React__default.createElement(
    React__default.Fragment,
    null,
    /* @__PURE__ */ React__default.createElement('input', {
      ref,
      type: 'checkbox',
      className: classNames('spot-toggle', className, {
        'spot-toggle--alert': props.variant === 'alert',
      }),
      id: safeId,
      ...props,
    }),
    /* @__PURE__ */ React__default.createElement(
      'label',
      { className: 'spot-toggle-label', htmlFor: safeId },
      label,
    ),
  );
});
Toggle.displayName = 'Toggle';
const ToggleSet = forwardRef(
  ({ className, direction = 'horizontal', expanded = false, children, ...props }, ref) => {
    return /* @__PURE__ */ React__default.createElement(
      'ul',
      {
        ref,
        className: classNames('spot-toggle-set', className, {
          [`spot-toggle__${direction}-set`]: direction,
          'spot-toggle__vertical-set--expanded': direction === 'vertical' && expanded,
        }),
        ...props,
      },
      Children.map(children, child => {
        return /* @__PURE__ */ React__default.createElement(
          'li',
          { className: classNames({ [`spot-toggle__${direction}-set-item`]: direction }) },
          child,
        );
      }),
    );
  },
);
ToggleSet.displayName = 'ToggleSet';
function dispatchStorageEvent(key, newValue) {
  window.dispatchEvent(new StorageEvent('storage', { key, newValue }));
}
function setItem(key, value) {
  window.localStorage.setItem(key, value);
  dispatchStorageEvent(key, value);
}
function getItem(key) {
  return window.localStorage.getItem(key);
}
function subscribe(callback) {
  window.addEventListener('storage', callback);
  return () => window.removeEventListener('storage', callback);
}
function useLocalStorage(key) {
  const getSnapshot = () => getItem(key) ?? void 0;
  const state = useSyncExternalStore(subscribe, getSnapshot);
  const setState = useCallback(
    v => {
      const nextState = typeof v === 'function' ? v(state) : v;
      if (typeof nextState === 'string') setItem(key, nextState);
    },
    [key, state],
  );
  return [state, setState];
}
function useMediaQuery(query) {
  const getSnapShot = useCallback(() => {
    return window.matchMedia(query).matches;
  }, [query]);
  const subscribe2 = useCallback(
    fn => {
      const media = window.matchMedia(query);
      media.addEventListener('change', fn);
      return () => {
        media.removeEventListener('change', fn);
      };
    },
    [query],
  );
  return useSyncExternalStore(subscribe2, getSnapShot);
}
const COLOR_SCHEME_KEY = 'spot-preferred-color-scheme';
function usePreferredColorScheme() {
  const [maybeColorScheme, setColorScheme] = useLocalStorage(COLOR_SCHEME_KEY);
  const prefersDark = useMediaQuery('(prefers-color-scheme: dark)');
  useEffect(() => {
    if (maybeColorScheme === void 0) {
      setColorScheme(prefersDark ? 'dark' : 'light');
    }
  }, [prefersDark, maybeColorScheme, setColorScheme]);
  const safePreferredColorScheme = maybeColorScheme ?? 'light';
  const setPreferredColorScheme = setColorScheme;
  return [safePreferredColorScheme, setPreferredColorScheme];
}
function useDarkMode() {
  const [preferredColorScheme, setPreferredColorScheme] = usePreferredColorScheme();
  const togglePreferredColorScheme = useCallback(
    () =>
      setPreferredColorScheme(prevPreferredColorScheme =>
        prevPreferredColorScheme === 'light' ? 'dark' : 'light',
      ),
    [setPreferredColorScheme],
  );
  return { preferredColorScheme, togglePreferredColorScheme, setPreferredColorScheme };
}
function DarkModeToggle({ className, ...props }) {
  const { preferredColorScheme, togglePreferredColorScheme } = useDarkMode();
  return /* @__PURE__ */ React__default.createElement(Toggle, {
    className: classNames('spot-light-dark-toggle spot-light-dark-toggle__switch', className),
    checked: preferredColorScheme === 'dark',
    onChange: togglePreferredColorScheme,
    label: preferredColorScheme === 'light' ? 'Light Mode' : 'Dark Mode',
    ...props,
  });
}
const DarkModeToggleIcon = forwardRef(({ disabled, ...props }, ref) => {
  const { preferredColorScheme, togglePreferredColorScheme } = useDarkMode();
  return /* @__PURE__ */ React__default.createElement(
    Label,
    {
      className: classNames('spot-light-dark-toggle spot-light-dark-toggle__icon', {
        'spot-light-dark-toggle--disabled': disabled,
      }),
      title: `Toggle to ${preferredColorScheme === 'light' ? 'Dark' : 'Light'} mode`,
      tabIndex: 0,
    },
    /* @__PURE__ */ React__default.createElement('input', {
      ref,
      type: 'checkbox',
      onChange: togglePreferredColorScheme,
      checked: preferredColorScheme === 'dark',
      ...props,
    }),
    /* @__PURE__ */ React__default.createElement(Icon, {
      title: 'moon',
      className: 'light_dark_toggle__icon-moon',
      'aria-labelledby': 'title',
    }),
    /* @__PURE__ */ React__default.createElement(Icon, {
      title: 'sun',
      className: 'light_dark_toggle__icon-sun',
      'aria-labelledby': 'title',
    }),
    /* @__PURE__ */ React__default.createElement(
      'span',
      { className: 'spot--screenreader-only' },
      preferredColorScheme === 'light' ? 'Light Mode' : 'Dark Mode',
    ),
  );
});
DarkModeToggleIcon.displayName = 'DarkModeToggleIcon';
const DarkModeContainer = forwardRefWithAs(
  ({ className, as: Component = 'div', variant = 'primary', ...props }, ref) => {
    const { preferredColorScheme } = useDarkMode();
    return /* @__PURE__ */ React__default.createElement(Component, {
      ref,
      className: classNames(
        'spot-container',
        `spot-container--${preferredColorScheme}-${variant}`,
        className,
      ),
      ...props,
    });
  },
);
export {
  ALIGNMENT_OPTIONS,
  BADGE_COLOR_LIST,
  BADGE_PLACEMENT_LIST,
  BUTTON_SIZE_LIST,
  BUTTON_VARIANT_LIST,
  Badge,
  Banner,
  BasicModal,
  Button,
  ButtonGroup,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  CardImage,
  CheckBox,
  CheckBoxGroup,
  CommonHeader,
  CommonHeaderNavItem,
  CommonHeaderNavLink,
  CommonHeaderOptionalItems,
  CommonHeaderProductIdentity,
  CommonHeaderResponsiveMenu,
  CommonHeaderSignOut,
  CrossProductButton,
  CrossProductFooter,
  CrossProductFooterItem,
  CrossProductItem,
  CrossProductItems,
  CrossProductNav,
  CrossProductNavRoot,
  CrossProductPopover,
  DIHeader,
  DILocation,
  DILocations,
  DIPopover,
  DIProfileLink,
  DIRoot,
  DarkModeContainer,
  DarkModeToggle,
  DarkModeToggleIcon,
  DataTable,
  DigitalIdentity,
  FieldError,
  FieldGroup,
  Fieldset,
  FilterSelection,
  ICON_CLASSNAME,
  ICON_NAMES_LIST,
  Icon,
  InlinePanel,
  InteractiveIcon,
  LINK_SIZE_LIST,
  Label,
  Link,
  ListGroup,
  ListGroupItem,
  LoadingSpinner,
  Modal,
  ModalClose,
  ModalContent,
  ModalContextProvider,
  ModalFooter,
  ModalHeading,
  MultiStepModal,
  Option,
  PANEL_PLACEMENT_LIST,
  PANEL_SIZE_LIST,
  PILL_COLOR_LIST,
  PROGRESS_COLOR_LIST,
  PROGRESS_SIZE_LIST,
  Paging,
  Panel,
  PanelBodyCopy,
  PanelContent,
  PanelFooter,
  PanelInteractiveLinks,
  PatientSignalment,
  Pill,
  PillSet,
  Popover,
  PopoverContent,
  PopoverTrigger,
  ProgressBar,
  RadioButton,
  RadioButtonGroup,
  SearchBar,
  SelectBox,
  SigninBox,
  SystemMessage,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  TextArea,
  TextBox,
  ToastProvider,
  Toggle,
  ToggleSet,
  alignments,
  iconSizes,
  placements,
  renderIcon,
  sides,
  sizes,
  useDarkMode,
  useModalContext,
  useTabsContext,
  useToast,
};
